import { a as e, c as t, d as n, f as r, i, l as a, n as o, o as s, r as c, s as l, t as u, u as d } from "./styles-BtQZqITL.js";
import * as f from "react";
import { Children as p, cloneElement as m, createContext as h, forwardRef as g, isValidElement as _, memo as v, useCallback as y, useContext as b, useEffect as x, useId as S, useLayoutEffect as C, useMemo as w, useRef as T, useState as E } from "react";
import { Locale as D, formatDateUTC as ee, fromString as te, getClickedOnScrollbar as ne, handleKeyDownEvent as O, hexToRgbA as k, isDefined as A, openFileDialog as re, useOnClickOutside as ie, useOnEscapeKeydown as ae, useResizeObserver as oe, useScrollToHashElement as se, useToggle as ce } from "@taxfix/scouts-helpers";
import { Fragment as j, jsx as M, jsxs as N } from "react/jsx-runtime";
import le, { StyleSheetManager as ue, css as de, keyframes as fe, styled as P } from "styled-components";
import pe from "@emotion/is-prop-valid";
import { CSSTransition as me, Transition as he, TransitionGroup as ge } from "react-transition-group";
import _e from "react-focus-lock";
import { isMobile as ve } from "react-device-detect";
import { ReactMultiEmail as ye } from "react-multi-email";
import { createPortal as be, flushSync as xe } from "react-dom";
import { Link as Se, NavLink as Ce, useHistory as we, useRouteMatch as Te } from "react-router-dom";
import { FloatingFocusManager as Ee, FloatingOverlay as De, FloatingPortal as Oe, autoUpdate as ke, shift as Ae, size as je, useClick as Me, useDismiss as Ne, useFloating as Pe, useId as Fe, useInteractions as Ie, useMergeRefs as Le, useRole as Re } from "@floating-ui/react";
import { Toaster as ze, toast as Be } from "sonner";
import "react-hint/css/index.css";
import * as F from "prop-types";
import Ve from "react-hint";
//#region src/hooks/use-file-drag-and-drop.ts
var He = ({ onDropHandler: e }) => {
	let [t, n] = E(0);
	return {
		isDragging: t > 0,
		onDragOver: (e) => {
			e.preventDefault();
		},
		onDragEnter: () => {
			n((e) => e + 1);
		},
		onDragLeave: () => {
			n((e) => e - 1);
		},
		onDrop: (t) => {
			t.preventDefault(), n(0);
			let { files: r } = t.dataTransfer;
			e(Array.from(r));
		}
	};
}, Ue = (e) => typeof window > "u" ? !1 : window.matchMedia(e).matches, We = (e) => {
	let [t, n] = E(!1);
	return x(() => {
		typeof window < "u" && n(Ue(e));
	}, [e]), x(() => {
		let t = () => {
			n(Ue(e));
		};
		return window.addEventListener("resize", t, { passive: !0 }), () => {
			window.removeEventListener("resize", t);
		};
	}, [e]), t;
}, Ge = () => We(`(min-width: ${r.tablet}px)`), Ke = () => We(`(min-width: ${r.desktop}px)`), qe = () => We(`(min-width: ${r.desktopLarge}px)`), I = {
	small: "4px",
	medium: "8px",
	large: "16px",
	xlarge: "24px",
	xxlarge: "48px",
	full: "9999px",
	buttonMedium: "8px",
	buttonLarge: "10px"
}, L = {
	low: "0px 0px 2px rgba(0, 0, 0, 0.08), 1px 2px 8px rgba(0, 0, 0, 0.08)",
	medium: "0px 0px 2px rgba(0, 0, 0, 0.08), 2px 4px 16px rgba(0, 0, 0, 0.08)",
	high: "0px 0px 2px rgba(0, 0, 0, 0.08), 2px 4px 24px rgba(0, 0, 0, 0.08)",
	higher: "0px 0px 2px rgba(0, 0, 0, 0.08), 4px 8px 40px rgba(0, 0, 0, 0.08)"
}, R = {
	tablet: `@media (min-width: ${r.tablet}px)`,
	desktop: `@media (min-width: ${r.desktop}px)`,
	desktopLarge: `@media (min-width: ${r.desktopLarge}px)`,
	pointer: "@media (pointer: fine)"
}, Je = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 5c0-1.657-5.03-3-10-3S2 3.343 2 5m20 0v14c0 1.5-3 3-7 3V8c4 0 7-1.694 7-3ZM2 5v14c0 1.5 4 3 7 3V8C5.5 8 2 6.306 2 5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ye = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12h4l3 7 6-14 3 7h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xe = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 12h2l2 3 4-6 2 3h2m-6.4 10h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ze = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17.5 18h.5v0a4 4 0 0 0 4-4v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4a4 4 0 0 0 4 4v0h.5m7.403-.097-.206-.206c-.594-.594-.891-.891-1.233-1.002a1.5 1.5 0 0 0-.928 0c-.342.111-.639.408-1.233 1.002l-.206.206c-1.285 1.285-1.928 1.928-1.971 2.48a1.5 1.5 0 0 0 .521 1.258c.42.359 1.33.359 3.147.359h.412c1.817 0 2.726 0 3.147-.36a1.5 1.5 0 0 0 .521-1.258c-.043-.551-.686-1.194-1.971-2.48Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qe = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 13V7m.5 9.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $e = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 13V7m.5 9.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-7.625 1.375 2.25 2.25c.692.692 1.038 1.038 1.442 1.286a4 4 0 0 0 1.156.479c.46.11.95.11 1.928.11h2.698c.978 0 1.468 0 1.928-.11.408-.099.798-.26 1.156-.48.404-.247.75-.593 1.442-1.285l2.25-2.25c.692-.692 1.038-1.038 1.286-1.442.219-.358.38-.748.479-1.156.11-.46.11-.95.11-1.928v-2.698c0-.978 0-1.468-.11-1.928a4 4 0 0 0-.48-1.156c-.247-.404-.593-.75-1.285-1.442l-2.25-2.25c-.692-.692-1.038-1.038-1.442-1.286a3.998 3.998 0 0 0-1.156-.478C14.817 2 14.327 2 13.349 2h-2.698c-.978 0-1.468 0-1.928.11a4 4 0 0 0-1.156.48c-.404.247-.75.593-1.442 1.285l-2.25 2.25c-.692.692-1.038 1.038-1.286 1.442a4 4 0 0 0-.478 1.156C2 9.183 2 9.673 2 10.651v2.698c0 .978 0 1.468.11 1.928.099.408.26.798.48 1.156.247.404.593.75 1.285 1.442Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), et = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 13V9m.5 7.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7.831-6.409-.351-.627c-2.281-4.073-3.422-6.11-4.922-6.788a5 5 0 0 0-4.116 0c-1.5.678-2.64 2.715-4.922 6.788l-.351.627c-2.193 3.916-3.29 5.874-3.106 7.477a5 5 0 0 0 2.045 3.489C4.917 22 7.16 22 11.649 22h.702c4.488 0 6.732 0 8.041-.943a5 5 0 0 0 2.045-3.489c.183-1.603-.913-3.561-3.106-7.477Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 22h18m-9.2-4h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C17 15.72 17 14.88 17 13.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 2 13.88 2 12.2 2h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C7 4.28 7 5.12 7 6.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C9.28 18 10.12 18 11.8 18Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6v8m0 0-2.5-2.5M12 14l2.461-2.461M7 18h10m-7 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3v13m0 0-4-4m4 4 4-4M3 21h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), it = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 17h10m-8-5h6M7 7h10m-7 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), at = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 20h18M7 12h10M3 4h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ot = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 18h6m-9-4h12M8 10h8M6 6h12m-8 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), st = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 21h8M6 9h12M3 15h18M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ct = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v5m0 10v5m-4.2-5h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 14.72 21 13.88 21 12.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 7 17.88 7 16.2 7H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 9.28 3 10.12 3 11.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 17 6.12 17 7.8 17Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 17h10M7 12h10M7 7h10m-7 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ut = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 20h18M3 12h18M3 4h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12M6 14h12M6 10h12M6 6h12m-8 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ft = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21h18M3 15h18M3 9h18M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 17h10M7 12h6M7 7h10m-7 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 20h18M3 12h10M3 4h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ht = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 3v18m8.8-4h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.72 22 13.88 22 12.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 7 18.88 7 17.2 7h-6.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C6 9.28 6 10.12 6 11.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C8.28 17 9.12 17 10.8 17Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h6m-6-4h10M6 10h8M6 6h12m-8 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _t = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21h8m-8-6h14M3 9h12M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 4.5V9m0 0-2-2m2 2 2-2m-2 12.5V15m0 0-2 2m2-2 2 2m-8-5h12m-8 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v7m0 0L9 6m3 3 3-3m-3 16v-7m0 0-3 3m3-3 3 3M3 12h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 17h10m-6-5h6M7 7h10m-7 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 20h18m-10-8h10M3 4h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), St = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 3v18M6.8 17h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C18 14.72 18 13.88 18 12.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C15.72 7 14.88 7 13.2 7H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.28 2 10.12 2 11.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 17 5.12 17 6.8 17Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ct = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 18h6M8 14h10m-8-4h8M6 6h12m-8 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13 21h8M7 15h14M9 9h12M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 2h18m-9.2 20h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C17 19.72 17 18.88 17 17.2v-6.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 6 13.88 6 12.2 6h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C7 8.28 7 9.12 7 10.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C9.28 22 10.12 22 11.8 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Et = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 18v-8m0 0-2.5 2.5M12 10l2.461 2.461M7 6h10m-7 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 21V8m0 0-4 4m4-4 4 4M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ot = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 12h5M2 12h5m4.8 9h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C17 18.72 17 17.88 17 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 3 13.88 3 12.2 3h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C7 5.28 7 6.12 7 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C9.28 21 10.12 21 11.8 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 0v7m0 0a5 5 0 0 0 5-5h-1.875M12 17a5 5 0 0 1-5-5h1.875M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), At = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0 0v14m0 0a8 8 0 0 0 8-8h-3m-5 8a8 8 0 0 1-8-8h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 19h-.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C5 17.48 5 16.92 5 15.8V10m4 9v3m0-3h6m0 0h.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 17.48 19 16.92 19 15.8V10m-4 9v3M5 10h14M5 10a7 7 0 0 1 14 0M2 10v6m20-6v6M5.5 1.5 8 4m9.5-2.5-2 2M10 7a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H9m6 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 16H3m7 0L3.5 7.5m17 9L14 8m-4 13.5 7-9.5M7 12l7-9.5M21 8H10m12 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16.362 12.318c0-1.522.723-2.633 2.127-3.497-.808-1.11-2-1.686-3.574-1.81-1.532-.123-3.192.823-3.787.823-.639 0-2.085-.782-3.234-.782C5.51 7.093 3 8.862 3 12.524c0 1.07.17 2.18.596 3.332.553 1.522 2.51 5.225 4.553 5.143 1.064 0 1.83-.74 3.234-.74 1.362 0 2.043.74 3.234.74 2.085 0 3.872-3.374 4.383-4.896-2.766-1.275-2.638-3.703-2.638-3.785ZM14.996 1c0 .41.127 1.53-1.018 2.724-.848.858-1.865 1.343-2.967 1.268-.085-1.007.339-1.94 1.102-2.686.678-.672 1.865-1.231 2.883-1.306Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15.663 14.105H18m-2.337 0L17.4 17m-1.737-2.895L13.5 10.5M6 14.105h2.337m0 0H13m-4.663 0L12 8m-5.4 9 .6-1M12 8l1.2-2M12 8l-1.2-2M2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ft = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 6v9.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C16.96 22 15.84 22 13.6 22h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 18.96 4 17.84 4 15.6V6m5 4h6M4 6h16a2 2 0 0 0 2-2v0a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), It = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8v8m0 0 3-3m-3 3-3-3m13-1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 9-6 6m0 0v-4.5M9 15h4.5m8.5-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m16 8-8 8m0 0v-6m0 6h6m-4 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 4 4 20m0 0V9m0 11h11",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m16 13-4 4m0 0-4-4m4 4V7m-2 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 9 6 6m0 0v-4.5m0 4.5h-4.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ht = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 8 8 8m0 0v-6m0 6h-6m0 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ut = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m4 4 16 16m0 0V9m0 11H9",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3v18m0 0 7-7m-7 7-7-7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 17-3-3m3 3 3-3m-3 3v-3.5c0-2.33 0-3.495.38-4.413a5 5 0 0 1 2.707-2.706C13.005 6 14.17 6 16.5 6v0h.5m-7 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 21-5-5m5 5 5-5m-5 5V9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 3 12.16 3 14.4 3H21",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 9 3-3M6 9l3 3M6 9h3.5c2.33 0 3.495 0 4.413.38a5 5 0 0 1 2.706 2.707C17 13.005 17 14.17 17 16.5v.5M10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 8 5-5M3 8l5 5M3 8h11.605c2.237 0 3.355 0 4.211.436a4 4 0 0 1 1.748 1.748C21 11.04 21 12.16 21 14.4V21",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m18 15-3 3m3-3-3-3m3 3h-3.5c-2.33 0-3.495 0-4.413-.38a5 5 0 0 1-2.706-2.707C7 10.995 7 9.83 7 7.5v0V7m3 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m21 16-5 5m5-5-5-5m5 5H9.399c-2.24 0-3.36 0-4.215-.436a4 4 0 0 1-1.748-1.748C3 12.96 3 11.84 3 9.6V3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 6 3 3m-3-3-3 3m3-3v3.5c0 2.33 0 3.495-.38 4.414a5 5 0 0 1-2.706 2.705C10.994 17 9.83 17 7.5 17v0H7m3 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qt = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m16 3 5 5m-5-5-5 5m5-5v11.601c0 2.24 0 3.36-.436 4.215a4 4 0 0 1-1.748 1.748C12.96 21 11.84 21 9.6 21H3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $t = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 15 3 3m-3-3 3-3m-3 3h3.5c2.33 0 3.495 0 4.414-.38a5 5 0 0 0 2.705-2.706C18 10.994 18 9.83 18 7.5v0V7m-8 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), en = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 16 5 5m-5-5 5-5m-5 5h11.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C21 12.96 21 11.84 21 9.6V3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 6 6 9m3-3 3 3M9 6v3.5c0 2.33 0 3.495.38 4.413a5 5 0 0 0 2.707 2.706C13.005 17 14.17 17 16.5 17v0h.5m-7 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 3 3 8m5-5 5 5M8 3v11.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C11.04 21 12.16 21 14.4 21H21",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 17 3-3m-3 3-3-3m3 3v-3.5c0-2.33 0-3.495-.38-4.413a5 5 0 0 0-2.706-2.706C10.994 6 9.83 6 7.5 6v0H7m3 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), an = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m16 21 5-5m-5 5-5-5m5 5V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C12.96 3 11.84 3 9.6 3H3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), on = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m18 9-3-3m3 3-3 3m3-3h-3.5c-2.33 0-3.495 0-4.413.38a5 5 0 0 0-2.706 2.707C7 13.005 7 14.17 7 16.5v.5m3-15h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m21 8-5-5m5 5-5 5m5-5H9.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 11.04 3 12.16 3 14.4V21",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m11 9-3 3m0 0 3 3m-3-3h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ln = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 16h2a3 3 0 1 0 0-6H8l2-2m12 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), un = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m11 8-4 4m0 0 4 4m-4-4h10m-7 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10 5-7 7m0 0 7 7m-7-7h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h8m0 0-3-3m3 3-3 3m9-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13 16h-2a3 3 0 1 1 0-6h5l-2-2m8 4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m13 8 4 4m0 0-4 4m4-4H7m3 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 12h18m0 0-7-7m7 7-7 7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.5 6 6 8.5m0 0L8.5 11M6 8.5h8m1.5 4.5 2.5 2.5m0 0L15.5 18m2.5-2.5h-8m0 6.5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _n = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 2 2 6m0 0 4 4M2 6h14m2 8 4 4m0 0-4 4m4-4H8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 16V8m0 0-3 3m3-3 3 3m7 1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 15 9 9m0 0v4.5M9 9h4.5m8.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 16 8 8m0 0v6m0-6h6m-4 14h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 20 4 4m0 0v11M4 4h11",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 11 4-4m0 0 4 4m-4-4v10m-2 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 15 6-6m0 0v4.5M15 9h-4.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 16 8-8m0 0v6m0-6h-6m0 14h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 20 20 4m0 0v11m0-11H9",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), En = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 21V3m0 0 7 7m-7-7-7 7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18v-3m0 3h3m-3 0L18 6m0 0h-3m3 0v3M6 6v3m0-3h3M6 6l12 12m0 0h-3m3 0v-3m-8 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), On = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21v-5.625M3 21h5.625M3 21 21 3m0 0h-5.625M21 3v5.625M3 3v5.625M3 3h5.625M3 3l18 18m0 0h-5.625M21 21v-5.625",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 6v4m0-4h4M6 6l4 4m8 8v-4m0 4h-4m4 0-4-4m4-8v4m0-4h-4m4 0-4 4m-8 8v-4m0 4h4m-4 0 4-4m0 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), An = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21v-4m0 4h4m-4 0 6-6M21 3h-4m4 0v4m0-4-6 6M3 3v4m0-4h4M3 3l6 6m12 12h-4m4 0v-4m0 4-6-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m12 19-2-2m2 2 2-2m-2 2V5m0 0-2 2m2-2 2 2m-9 5 2-2m-2 2 2 2m-2-2h14m0 0-2-2m2 2-2 2m-7 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 12 3-3m-3 3 3 3m-3-3h10m0 0h10m-10 0v10m0-10V2m10 10-3-3m3 3-3 3M12 2 9 5m3-3 3 3m-3 17-3-3m3 3 3-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 12h4m0 0-2-2m2 2-2 2m-8-2H5m0 0 2-2m-2 2 2 2m5-5V5m0 0-2 2m2-2 2 2m-2 8v4m0 0-2-2m2 2 2-2m-4 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 12h6m0 0-3-3m3 3-3 3M8 12H2m0 0 3-3m-3 3 3 3m7-7V2m0 0L9 5m3-3 3 3m-3 11v6m0 0-3-3m3 3 3-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm0 0v1.167c0 .633.3 1.533 1.2 1.533 1.2 0 1.8-1.38 1.8-2.7a6 6 0 1 0-3.333 5.376M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), In = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm0 0V8m0 4v1.945c0 1.055.5 2.555 2 2.555 2 0 3-2.299 3-4.5 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a9.958 9.958 0 0 0 4.444-1.04",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ln = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 12h.01m4.233-4.243c4.686 4.686 6.585 10.385 4.242 12.728s-8.041.444-12.728-4.243C3.071 11.556 1.172 5.858 3.515 3.514c2.343-2.343 8.041-.443 12.728 4.243Zm0 8.485c-4.687 4.687-10.385 6.586-12.728 4.243S3.07 12.443 7.757 7.757c4.687-4.686 10.385-6.586 12.728-4.242 2.343 2.343.444 8.041-4.242 12.727ZM12.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 16.5 6 22c1.982-.33 3.984-.78 6-.78 2.015 0 4.018.45 6 .78l-1-5.5M12 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M1 1h.5v0a2.883 2.883 0 0 1 2.854 2.475l.861 6.03c.278 1.948.418 2.923.888 3.655a4 4 0 0 0 1.704 1.478C8.598 15 9.583 15 11.55 15h4.87c1.046 0 1.569 0 2.016-.104a4 4 0 0 0 2.823-2.448c.166-.428.24-.946.387-1.98v0c.085-.595.128-.892.148-1.188a8 8 0 0 0-.226-2.503c-.072-.287-.167-.572-.357-1.142l-.144-.432c-.368-1.104-.552-1.656-.883-2.071a3 3 0 0 0-1.317-.95C18.369 2 17.788 2 16.624 2H15.46c-1.245 0-1.867 0-2.396.208a3 3 0 0 0-1.203.868c-.365.436-.562 1.026-.955 2.206L10 8M5.5 8h16M11 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8v8m5-5v5m5-7v7m-5.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 10v4m13-5 .643.257a2.954 2.954 0 0 1 0 5.486L20 15M8.4 19h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 15.96 20 14.84 20 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 5 15.84 5 13.6 5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 8.04 2 9.16 2 11.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 19 6.16 19 8.4 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 10v4m4-4v4m9-5 .643.257a2.954 2.954 0 0 1 0 5.486L20 15M8.4 19h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 15.96 20 14.84 20 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 5 15.84 5 13.6 5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 8.04 2 9.16 2 11.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 19 6.16 19 8.4 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Un = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 10v4m4-4v4m4-4v4m5-5 .643.257a2.954 2.954 0 0 1 0 5.486L20 15M8.4 19h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 15.96 20 14.84 20 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 5 15.84 5 13.6 5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 8.04 2 9.16 2 11.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 19 6.16 19 8.4 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 5h-.5v0c-.464 0-.697 0-.892.02a4 4 0 0 0-3.589 3.588C2 8.803 2 9.036 2 9.5v5c0 .464 0 .697.02.892a4 4 0 0 0 3.588 3.589c.195.019.428.019.892.019v0H7m8-14h.5v0c.464 0 .697 0 .892.02a4 4 0 0 1 3.589 3.588c.019.195.019.428.019.892V15m0 0v0a4 4 0 0 1-4 4h-1m5-4 .643-.257a2.954 2.954 0 0 0 0-5.486L20 9m-9-3-2 6h4l-2 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 5h6.029A4 4 0 0 1 20 9.037v5.27c0 .332.335.559.643.436v0a2.954 2.954 0 0 0 0-5.486L20 9M2 2l3 3m16 16-2-2m0 0H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 15.96 2 14.84 2 12.6V8a3 3 0 0 1 3-3v0m14 14L5 5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m20 9 .643.257a2.954 2.954 0 0 1 0 5.486L20 15M8.4 19h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 15.96 20 14.84 20 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 5 15.84 5 13.6 5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 8.04 2 9.16 2 11.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 19 6.16 19 8.4 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8h2.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 9.52 18 10.08 18 11.2v.8m-6-4v4m0-4H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 9.52 6 10.08 6 11.2v.8m-4 0h20m-11.022 5h2.044c.718 0 1.077 0 1.394.11a2 2 0 0 1 .747.461c.24.235.4.556.721 1.198l.262.523c.291.583.437.874.648 1.094a2 2 0 0 0 .848.524c.29.09.616.09 1.268.09v0c1.017 0 1.525 0 1.92-.18a2 2 0 0 0 .99-.99c.18-.395.18-.903.18-1.92V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 3 17.84 3 15.6 3H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 6.04 2 7.16 2 9.4v8.51c0 1.017 0 1.525.18 1.92a2 2 0 0 0 .99.99c.395.18.904.18 1.92.18v0c.652 0 .978 0 1.268-.09.323-.1.614-.28.848-.524.21-.22.357-.511.648-1.094l.262-.523c.32-.642.481-.963.72-1.198a2 2 0 0 1 .748-.462C9.9 17 10.26 17 10.978 17Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 12V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 3 15.84 3 13.6 3h-3.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 6.04 4 7.16 4 9.4V12m-2 3v6m20-6v6m-6-9v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 9.52 8 10.08 8 11.2v.8m14 7v-3.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 12 19.92 12 18.8 12H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 13.52 2 14.08 2 15.2V19h20Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13.5 13c0 2 1 3 2.5 3s2.25-1 2.25-1m-4.75-2a2.5 2.5 0 0 1 5 0h-5Zm1-5h3M6 11.5h2.25a1.75 1.75 0 1 0 0-3.5H6v3.5Zm0 0h2.75a2.25 2.25 0 0 1 0 4.5H6v-4.5ZM2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 19.546C8.659 21.027 10.378 22 12 22c1.622 0 3.341-.973 4-2.454M9.5 12.5 11 14l3.5-3.5m3.5.69V8a6 6 0 0 0-6-6v0a6 6 0 0 0-6 6v3.19c0 .834-.354 1.629-.974 2.186l-1.107.997c-1.323 1.19-.901 3.36.771 3.969l.211.077a20.773 20.773 0 0 0 14.198 0l.21-.077c1.673-.608 2.095-2.778.772-3.969l-1.107-.997A2.941 2.941 0 0 1 18 11.19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 19.546C8.659 21.027 10.378 22 12 22c1.622 0 3.341-.973 4-2.454M9.5 11h5m3.5.19V8a6 6 0 0 0-6-6v0a6 6 0 0 0-6 6v3.19c0 .834-.354 1.629-.974 2.186l-1.107.997c-1.323 1.19-.901 3.36.771 3.969l.211.077a20.773 20.773 0 0 0 14.198 0l.21-.077c1.673-.608 2.095-2.778.772-3.969l-1.107-.997A2.941 2.941 0 0 1 18 11.19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qn = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 19.546C8.659 21.027 10.378 22 12 22c1.622 0 3.341-.973 4-2.454M12 8.5V11m0 0v2.5m0-2.5H9.5m2.5 0h2.5m3.5.19V8a6 6 0 0 0-6-6v0a6 6 0 0 0-6 6v3.19c0 .834-.354 1.629-.974 2.186l-1.107.997c-1.323 1.19-.901 3.36.771 3.969l.211.077a20.773 20.773 0 0 0 14.198 0l.21-.077c1.673-.608 2.095-2.778.772-3.969l-1.107-.997A2.941 2.941 0 0 1 18 11.19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $n = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 19.546C8.659 21.027 10.378 22 12 22c1.622 0 3.341-.973 4-2.454m4-5.046-1.026-1.124A2.94 2.94 0 0 1 18 11.19V8a6 6 0 0 0-9.318-5M3 2l3.53 3.53M22 21l-2.667-2.667M6.53 5.53C6.19 6.283 6 7.12 6 8v3.19c0 .834-.354 1.629-.974 2.186l-1.107.997c-1.323 1.19-.901 3.36.771 3.969l.211.077a20.773 20.773 0 0 0 14.198 0l.234-.086M6.53 5.53l12.803 12.803",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), er = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 19.546C8.659 21.027 10.378 22 12 22c1.622 0 3.341-.973 4-2.454m2-8.356V8a6 6 0 0 0-6-6v0a6 6 0 0 0-6 6v3.19c0 .834-.354 1.629-.974 2.186l-1.107.997c-1.323 1.19-.901 3.36.771 3.969l.211.077a20.773 20.773 0 0 0 14.198 0l.21-.077c1.673-.608 2.095-2.778.772-3.969l-1.107-.997A2.941 2.941 0 0 1 18 11.19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10.846 12V7.75c0-.903 0-1.355.19-1.617a1 1 0 0 1 .701-.408c.322-.035.715.188 1.5.635l.095.054c1.201.683 1.802 1.025 2.003 1.472a1.5 1.5 0 0 1 0 1.228c-.201.447-.802.789-2.003 1.472L10.846 12Zm0 0v4.25c0 .903 0 1.355.19 1.617a1 1 0 0 0 .701.408c.322.035.715-.188 1.5-.635l.095-.054c1.201-.683 1.802-1.025 2.003-1.472a1.5 1.5 0 0 0 0-1.228c-.201-.447-.802-.789-2.003-1.472L10.846 12Zm0 0L7 10.09M10.846 12 7 14.546M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 12V4.042c0-.986 0-1.479.205-1.748a1 1 0 0 1 .745-.392c.338-.017.744.263 1.556.821l2.617 1.8c.966.663 1.449.995 1.618 1.41a1.5 1.5 0 0 1 0 1.134c-.17.415-.652.747-1.618 1.41L10 12Zm0 0v7.958c0 .986 0 1.479.205 1.748a1 1 0 0 0 .745.392c.338.017.744-.263 1.556-.821l2.617-1.8c.966-.663 1.449-.995 1.618-1.41a1.5 1.5 0 0 0 0-1.134c-.17-.415-.652-.747-1.618-1.41L10 12Zm0 0L5 9m5 3-5 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 6v0a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3v0M19 6v0a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3v0M9 7h6m-6 4h6m-6 4h2m.4 7h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C19 18.96 19 17.84 19 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C15.96 2 14.84 2 12.6 2h-1.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C5 5.04 5 6.16 5 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.04 22 9.16 22 11.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ir = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 18c2.427-1.56 4.265-1.984 6.8-2.1 1.17-.053 1.756-.08 2.164-.304.37-.204.644-.49.83-.869.206-.418.206-.968.206-2.07V2c-4.444 0-6.667 0-10 2.143M12 18c-2.427-1.56-4.265-1.984-6.8-2.1-1.17-.053-1.756-.08-2.164-.304a1.944 1.944 0 0 1-.83-.869C2 14.31 2 13.76 2 12.657V2c4.444 0 6.667 0 10 2.143M12 18V4.143M21 19.5c-4 0-6 .5-9 2.5-3-2-5-2.5-9-2.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ar = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 10.5v5.1c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C14.96 22 13.84 22 11.6 22h-1.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C4 18.96 4 17.84 4 15.6v-5.2c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 4 8.16 4 10.4 4h1.1M18 1v3m0 0v3m0-3h-3m3 0h3M8 8h6m-6 4h4m-4 4h2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), or = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 7h6m-6 4h6m-6 4h2m11-9v12m3-10v8M8.4 22h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C16 18.96 16 17.84 16 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C12.96 2 11.84 2 9.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 19.5V8.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C7.04 2 8.16 2 10.4 2h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C20 5.04 20 6.16 20 8.4v9.1M9 7h6m5 10H6.5A2.5 2.5 0 0 0 4 19.5v0A2.5 2.5 0 0 0 6.5 22H15c.93 0 1.394 0 1.78-.077a4 4 0 0 0 3.143-3.143C20 18.394 20 17.93 20 17v0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 10.5 2 2L15.5 8M20 22V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 2 14.8 2 12 2v0c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 4.73C4 5.8 4 7.2 4 10v12l2.276-1.138c2.099-1.05 3.148-1.574 4.249-1.78a7.997 7.997 0 0 1 2.95 0c1.101.206 2.15.73 4.25 1.78L20 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 11h6m5 11V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 2 14.8 2 12 2v0c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 4.73C4 5.8 4 7.2 4 10v12l2.276-1.138c2.099-1.05 3.148-1.574 4.249-1.78a7.997 7.997 0 0 1 2.95 0c1.101.206 2.15.73 4.25 1.78L20 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ur = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 11h3m0 0h3m-3 0V8m0 3v3m8 8V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 2 14.8 2 12 2v0c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 4.73C4 5.8 4 7.2 4 10v12l2.276-1.138c2.099-1.05 3.148-1.574 4.249-1.78a7.997 7.997 0 0 1 2.95 0c1.101.206 2.15.73 4.25 1.78L20 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6.73 2.545C7.8 2 9.2 2 12 2c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C20 5.8 20 7.2 20 10v4M2 4l2.198 1.758M22 20l-2-1.6m0 0V22l-.845-.422c-3.51-1.756-5.267-2.634-7.155-2.634-1.889 0-3.644.878-7.155 2.634L4 22V10c0-1.997 0-3.281.198-4.242M20 18.4 4.198 5.758",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 22V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 2 14.8 2 12 2c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 4.73C4 5.8 4 7.2 4 10v12l2.276-1.138h0c2.099-1.05 3.148-1.574 4.249-1.78a7.997 7.997 0 0 1 2.95 0c1.101.206 2.15.73 4.25 1.78h0L20 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 19V8c0-.929 0-1.393-.051-1.783a6 6 0 0 0-5.166-5.166C15.393 1 14.93 1 14 1h-4a3 3 0 0 0-3 3v0m11 18V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C14.96 4 13.84 4 11.6 4h-1.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4V22l2.237-1.278c1.736-.992 2.604-1.488 3.526-1.683a5.999 5.999 0 0 1 2.474 0c.922.195 1.79.69 3.526 1.683L18 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 21h20M3.5 11.5a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m19 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1M8 11.5a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0H7m10 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-3.5 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1M3.5 7a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m19 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-8 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-8 9a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m19 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-8 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-8-13a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m19 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1M8 3a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0H7m10 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-3.5 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11.5 20.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 12.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-10a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 3.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m-4.5 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m9 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m-13 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1M3 16a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1M3 7a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 3.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m17.5 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 12.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-10a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 3.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 22h3.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6V12M12 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V12m10 10V2M2 12V8.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C5.04 2 6.16 2 8.4 2H12M2 12h20m0 0V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H12",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _r = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12h20M3.5 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-17 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19-4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 21a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M12.5 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 18a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1-13.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v20M2 12h20M3.5 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-17 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19-4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 21a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 22.25v-20m9.5 18.5a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0-19a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0 12.5a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0-10a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0 3.5a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m4.5 8a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0-19a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0 8a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m-9 8a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0-19a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0 8a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m13 8a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0-19a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0 12.5a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0-10a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1m0 3.5a.5.5 0 0 1 0 1m0-1a.5.5 0 0 0 0 1m0-1v1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), br = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0H7m10 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m-3.5 0a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m1-4.5a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1m1 9a.5.5 0 0 0-1 0m1 0a.5.5 0 0 1-1 0m1 0h-1M12 22h3.6c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22H12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 22.25v-20m-9.5 18.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 12.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-10a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 3.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m-4.5 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m9 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m-13 8a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-19a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 12.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0-10a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1m0 3.5a.5.5 0 0 0 0 1m0-1a.5.5 0 0 1 0 1m0-1v1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 3h20M3.5 12.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 12.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-3.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8-9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8 13a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 21a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-3.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v20M3.5 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-17 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m19-4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M8 21a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m10 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5-9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-17 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M17 12a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7.5 9.5 9-5.5M12 12.5 21 7m-9 5.5L3 7m9 5.5v10M2 9.718v4.564c0 .991 0 1.487.142 1.932a3 3 0 0 0 .605 1.068c.309.351.734.606 1.583 1.116l5.2 3.12c.898.539 1.347.808 1.827.914a3 3 0 0 0 1.287 0c.479-.106.928-.375 1.826-.914l5.2-3.12c.85-.51 1.274-.765 1.583-1.116a3 3 0 0 0 .605-1.068c.142-.445.142-.94.142-1.932V9.718c0-.991 0-1.487-.142-1.932a3 3 0 0 0-.605-1.068c-.309-.351-.734-.606-1.583-1.116l-5.2-3.12c-.898-.539-1.347-.808-1.827-.914a3 3 0 0 0-1.287 0c-.479.106-.928.375-1.826.914l-5.2 3.12c-.85.51-1.274.765-1.583 1.116a3 3 0 0 0-.605 1.068C2 8.23 2 8.726 2 9.718Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 12.5 21 7m-9 5.5L3 7m9 5.5v10M2 9.718v4.564c0 .991 0 1.487.142 1.932a3 3 0 0 0 .605 1.068c.309.351.734.606 1.583 1.116l5.2 3.12c.898.539 1.347.808 1.827.914a3 3 0 0 0 1.287 0c.479-.106.928-.375 1.826-.914l5.2-3.12c.85-.51 1.274-.765 1.583-1.116a3 3 0 0 0 .605-1.068c.142-.445.142-.94.142-1.932V9.718c0-.991 0-1.487-.142-1.932a3 3 0 0 0-.605-1.068c-.309-.351-.734-.606-1.583-1.116l-5.2-3.12c-.898-.539-1.347-.808-1.827-.914a3 3 0 0 0-1.287 0c-.479.106-.928.375-1.826.914l-5.2 3.12c-.85.51-1.274.765-1.583 1.116a3 3 0 0 0-.605 1.068C2 8.23 2 8.726 2 9.718Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Er = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 6h.5v0A2.5 2.5 0 0 1 18 8.5v7a2.5 2.5 0 0 1-2.5 2.5v0H15m-6 0h-.5v0A2.5 2.5 0 0 1 6 15.5v-7A2.5 2.5 0 0 1 8.5 6v0H9m3.5 2.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 7a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1-3.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m.1 10h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 22H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 20.48 4 19.92 4 18.8v-1.149c0-.978 0-1.468-.11-1.928a4 4 0 0 0-.48-1.156c-.247-.404-.593-.75-1.285-1.441L1 12l1.125-1.126c.692-.691 1.038-1.037 1.285-1.44a4 4 0 0 0 .48-1.157c.11-.46.11-.95.11-1.928V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 2 6.08 2 7.2 2H9m6 0h1.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C20 3.52 20 4.08 20 5.2v1.149c0 .978 0 1.468.11 1.928a4 4 0 0 0 .48 1.156c.247.404.593.75 1.285 1.441L23 12l-1.125 1.126c-.692.691-1.038 1.037-1.285 1.44a4 4 0 0 0-.48 1.157c-.11.46-.11.95-.11 1.928V18.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C18.48 22 17.92 22 16.8 22H15M12.5 7a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Or = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 6a4 4 0 0 0-8 0m0 4.5v3m8-3v3m5-1.5v3.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 22 16.84 22 14.6 22H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 18.96 3 17.84 3 15.6V12m2 0h14c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C22 10.398 22 9.932 22 9v0c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C20.398 6 19.932 6 19 6H5c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C2 7.602 2 8.068 2 9v0c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C3.602 12 4.068 12 5 12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.5 11s2.33 1.036 5.5 1.616m0 0c1.235.227 2.598.384 4 .384 1.402 0 2.765-.157 4-.384m-8 0V11m0 1.616V14m8-1.384c3.17-.58 5.5-1.616 5.5-1.616M16 12.616V11m0 1.616V14m0-8a4 4 0 0 0-8 0m.4 16h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 6 17.84 6 15.6 6H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 9.04 2 10.16 2 12.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ar = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15.5 6c2.074 1.096 3.5 3.37 3.5 6s-1.426 4.904-3.5 6m-7-12C6.426 7.096 5 9.37 5 12s1.426 4.904 3.5 6m6.167-9c.81.684 1.333 1.773 1.333 3s-.524 2.316-1.333 3M9.333 9C8.523 9.684 8 10.773 8 12s.524 2.316 1.333 3m3.167-3a.5.5 0 0 1-1 0m1 0a.5.5 0 1 0-1 0m1 0h-1m.1 10h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 4c2.963 1.46 5 4.495 5 8s-2.037 6.54-5 8M7 4c-2.963 1.46-5 4.495-5 8s2.037 6.54 5 8m9-12c1.215.912 2 2.364 2 4a4.992 4.992 0 0 1-2 4M8 8a4.992 4.992 0 0 0-2 4c0 1.636.785 3.088 2 4m6-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 2v4m4-4v2M4 9s3.5 2 8 2 8-2 8-2m-8 13v0c1.57 0 2.765-1.41 2.507-2.96l-.188-1.124a2.63 2.63 0 0 1 1.419-2.785l2.113-1.057A3.887 3.887 0 0 0 20 10.598v-5.43A3.168 3.168 0 0 0 16.832 2H7.168A3.168 3.168 0 0 0 4 5.168v5.43c0 1.472.832 2.818 2.149 3.476l2.113 1.057a2.63 2.63 0 0 1 1.419 2.785l-.188 1.125A2.541 2.541 0 0 0 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m19 9 1.594-1.594c.519-.519.778-.778.964-1.081a3 3 0 0 0 .36-.867C22 5.112 22 4.746 22 4.012V3m-3 13 1.594 1.594c.519.519.778.778.964 1.081.164.269.286.561.36.867.082.346.082.712.082 1.446V22M5 9 3.406 7.406c-.519-.519-.778-.778-.964-1.081a3 3 0 0 1-.36-.867C2 5.112 2 4.746 2 4.012V3m3 13-1.594 1.594c-.519.519-.778.778-.964 1.081a3.001 3.001 0 0 0-.36.867C2 19.888 2 20.254 2 20.988V22M15 5.5V5a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v.5m3 9.5v7m0 0v0a7 7 0 0 0 7-7v-3a7 7 0 0 0-7-7v0a7 7 0 0 0-7 7v3a7 7 0 0 0 7 7Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 3 2.432 2.432M20 20l-3.563-3.563m0 0a13.3 13.3 0 0 1-.124.105c-.778.643-1.313 1.575-1.313 2.585v0A2.873 2.873 0 0 1 12.127 22h-.24A2.888 2.888 0 0 1 9 19.112v0c0-1.002-.524-1.928-1.292-2.571C6.226 15.3 4 12.948 4 10c0-1.698.53-3.273 1.432-4.568m11.005 11.005L5.432 5.432M7.5 3.385A8 8 0 0 1 20 10c0 1.525-.574 2.878-1.334 4M9 18s1 .5 3 .5 3-.5 3-.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 18s1 .5 3 .5m0 0c2 0 3-.5 3-.5m-3 .5V14m8-4a8 8 0 1 0-16 0c0 2.948 2.226 5.301 3.708 6.54C8.476 17.185 9 18.11 9 19.113v0A2.888 2.888 0 0 0 11.888 22h.239A2.873 2.873 0 0 0 15 19.127v0c0-1.01.534-1.94 1.312-2.584C17.793 15.317 20 12.99 20 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ir = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m0 8H8m8 0-3-3m3 3-3 3m-1.4 7h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3M9 15l3-3m0 0 3-3m-3 3L9 9m3 3 3 3m-3.4 7h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m1.5 4h-11M8 12.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m5.5-4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5-4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m1 4H7m10 9h-2m-3.4 5h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Br = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m-8 8h8m-4.4 10h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 8H7m6 4H7m3 4H7M8 1v3m8-3v3m-4.4 18h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3M9 9h6l-4.5 7m1.1 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ur = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m-2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-5 8h6a1 1 0 0 0 1-1v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0a1 1 0 0 0 1 1Zm2.6 5h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m-8 8h4m0 0h4m-4 0V8m0 4v4m-.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m8-3v3m1 4H7m4.6 14h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM17 4v3m0 0v3m0-3h-3m3 0h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM14 7c.723 0 1.445.464 2 1.057.597.638 1 1.425 1 1.943m-3-6a6 6 0 0 1 6 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 7.629c1.807.565 3.646 1.524 5.402 2.936.383.307.575.461.743.709a2.16 2.16 0 0 1 .302 1.54c-.062.293-.205.55-.49 1.064v0c-.402.723-.603 1.085-.865 1.314a2 2 0 0 1-1.743.45c-.34-.074-.69-.293-1.392-.731l-.162-.102c-.43-.268-.645-.403-.813-.576a2 2 0 0 1-.466-.768c-.076-.23-.096-.482-.135-.988L16 7.63Zm0 0A13.426 13.426 0 0 0 12 7c-1.283 0-2.632.201-4 .629m0 0c-1.807.565-3.646 1.524-5.402 2.936-.383.307-.575.461-.743.709a2.16 2.16 0 0 0-.302 1.54c.062.293.205.55.49 1.064v0c.402.723.603 1.085.865 1.314a2 2 0 0 0 1.743.45c.34-.074.69-.293 1.392-.732l.162-.1c.43-.27.645-.404.813-.577a2 2 0 0 0 .466-.768c.076-.23.096-.482.135-.988L8 7.63Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 5.629c1.836.574 3.705 1.556 5.488 3.005.156.127.235.191.338.305.514.569.647 1.557.302 2.241-.07.137-.15.251-.313.479v0c-.208.29-.312.436-.42.546a2 2 0 0 1-2.218.44c-.142-.06-.293-.155-.596-.344l-.738-.461c-.493-.308-.74-.462-.926-.668a2 2 0 0 1-.384-.623c-.1-.258-.127-.548-.18-1.126l-.354-3.794Zm0 0A13.426 13.426 0 0 0 12 5c-1.283 0-2.633.201-4 .629m0 0c-1.837.574-3.706 1.556-5.488 3.005-.157.127-.236.19-.339.305-.514.569-.647 1.556-.302 2.241.07.137.15.251.313.479v0c.208.29.312.436.42.546a2 2 0 0 0 2.219.44c.14-.06.292-.155.595-.344l.738-.461c.493-.308.74-.462.926-.668a2 2 0 0 0 .384-.623c.1-.258.126-.548.18-1.126L8 5.629ZM12 12v8m0 0-3-3m3 3 3-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM21 3l-6 6m0 0V4m0 5h5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 12.629c1.837.574 3.706 1.556 5.488 3.005.157.127.235.191.338.305.514.569.647 1.557.302 2.241-.069.137-.15.251-.313.479v0c-.208.29-.311.436-.419.546a2 2 0 0 1-2.219.44c-.141-.06-.293-.155-.596-.344l-.738-.461c-.492-.308-.739-.462-.925-.668a2 2 0 0 1-.384-.623c-.1-.258-.127-.548-.18-1.126L16 12.629Zm0 0A13.426 13.426 0 0 0 12 12c-1.283 0-2.632.201-4 .629m0 0c-1.837.574-3.706 1.556-5.488 3.005-.157.127-.235.19-.338.305-.514.569-.647 1.556-.302 2.241.069.137.15.251.313.479v0c.208.29.311.436.419.546a2 2 0 0 0 2.219.44c.141-.06.293-.155.596-.344l.738-.461c.492-.308.739-.462.925-.668a2 2 0 0 0 .384-.623c.1-.258.127-.548.18-1.126L8 12.629ZM7 4l2.737 2.737c.792.792 1.188 1.188 1.645 1.337a2 2 0 0 0 1.236 0c.457-.149.853-.545 1.645-1.337L16.5 4.5M7 4v4m0-4h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qr = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM15 9l2.5-2.5m0 0L20 4m-2.5 2.5L15 4m2.5 2.5L20 9",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $r = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM16 4v4m4-4v4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ei = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM15 9l6-6m0 0v5m0-5h-5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ti = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM14 6l2 2 5-5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ni = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM14 6h8m0 0-3 3m3-3-3-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ri = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19ZM14 7h6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ii = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0c.202.342.414.675.635 1m5.23 5c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19Zm0 0A17.518 17.518 0 0 1 7.5 16.5M3 21l4.5-4.5M19 5 7.5 16.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ai = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.333 5.333c.988-.197 1.98-.804 2.54-1.642A3.798 3.798 0 0 1 11.033 2h1.934c1.27 0 2.456.634 3.16 1.69.595.893 1.513 1.438 2.551 1.645A4.132 4.132 0 0 1 22 9.387v3.82c0 3.552 0 5.328-.861 6.598-.178.263-.38.507-.604.73M5.333 5.333 2 2m3.333 3.333 15.202 15.202M22.5 22.5l-1.965-1.965M17 21.925c-.988.075-2.215.075-3.792.075h-2.416c-3.551 0-5.327 0-6.597-.861a5 5 0 0 1-1.334-1.334C2 18.535 2 16.76 2 13.208v-3.82c0-.882.279-1.71.76-2.388m6.956 2.716a4 4 0 0 1 5.568 5.568M8.126 12A4 4 0 0 0 13 16.874",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oi = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 9.387c0-1.97 1.39-3.665 3.322-4.051l.135-.027A3.798 3.798 0 0 0 7.873 3.69v0A3.798 3.798 0 0 1 11.033 2h1.934c1.27 0 2.456.635 3.16 1.691v0a3.798 3.798 0 0 0 2.416 1.618l.135.027A4.132 4.132 0 0 1 22 9.387V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14V9.387Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), si = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10.5 13.5A1.5 1.5 0 0 1 9 15h-.1c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.656-.655c-.163-.32-.163-.74-.163-1.581v-1.2c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656C7.639 9 8.059 9 8.9 9H9a1.5 1.5 0 0 1 1.5 1.5m7 3A1.5 1.5 0 0 1 16 15h-.1c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.655-.655c-.164-.32-.164-.74-.164-1.581v-1.2c0-.84 0-1.26.164-1.581a1.5 1.5 0 0 1 .655-.656C14.639 9 15.059 9 15.9 9h.1a1.5 1.5 0 0 1 1.5 1.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ci = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 17h3m2.5 0h1m2.5 0h3m-9-4h6m-9 0h.5m11 0h.5m-8 9h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), li = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 2.5v0c0 1.398 0 2.097-.228 2.648a3 3 0 0 1-1.624 1.624C4.597 7 3.898 7 2.5 7v0M17 2.5v0c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C19.403 7 20.102 7 21.5 7v0M17 17.5v0c0-1.398 0-2.097.228-2.648a3 3 0 0 1 1.624-1.624C19.403 13 20.102 13 21.5 13v0M7 17.5v0c0-1.398 0-2.097-.228-2.648a3 3 0 0 0-1.624-1.624C4.597 13 3.898 13 2.5 13v0M5 22h14m-5-12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 1.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 18 6.16 18 8.4 18h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 14.96 22 13.84 22 11.6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ui = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 10.5V10v0c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22v0h-.5M6 22c0-2.154-1.825-4-4-4m8 4c0-4.308-3.65-8-8-8m.5 8a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), di = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6a6 6 0 0 1 6 6m4 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 8h6m-6 4h8m-8 4h4m-2 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 16v-6m4 6V8m4 8v-4m-6 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 15 4-4 2 2 4-4m-7 13h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 2.458C4.943 3.732 2 7.523 2 12c0 5.523 4.477 10 10 10 4.478 0 8.268-2.943 9.542-7M15.2 12h5.2c.548 0 .822 0 1.052-.132.183-.104.365-.318.44-.516.093-.248.056-.48-.018-.946a10.008 10.008 0 0 0-8.28-8.28c-.465-.074-.698-.111-.946-.018a1.097 1.097 0 0 0-.516.44C12 2.778 12 3.052 12 3.6v5.2c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C13.52 12 14.08 12 15.2 12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 12 2 2 5-5m6 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _i = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.5 12.5 11 15l5.5-5.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.5 12.5 11 15l6-6m-5.4 13h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m4 13 5 5L20 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16.444 3.04A9.958 9.958 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.376-.02-.746-.061-1.111M9 11l3 3L22 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16.444 2H11.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-1.511M9 11l3 3L22 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Si = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M13.806 14.936c-.623.713-.935 1.069-1.305 1.2a1.499 1.499 0 0 1-1.002 0c-.37-.131-.682-.487-1.305-1.2L8.483 12.98c-1.106-1.264-1.66-1.896-1.677-2.432a1.5 1.5 0 0 1 .548-1.208C7.77 9 8.61 9 10.29 9h3.422c1.68 0 2.52 0 2.934.34a1.5 1.5 0 0 1 .549 1.208c-.017.536-.57 1.168-1.677 2.432l-1.71 1.956Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ci = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 9 6 6 6-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wi = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M9.064 10.194c-.712.623-1.069.935-1.2 1.304a1.5 1.5 0 0 0 0 1.003c.131.37.488.681 1.2 1.305l1.956 1.711c1.264 1.106 1.896 1.66 2.432 1.677a1.5 1.5 0 0 0 1.208-.549c.34-.414.34-1.254.34-2.934v-3.422c0-1.68 0-2.52-.34-2.935a1.5 1.5 0 0 0-1.208-.548c-.536.017-1.168.57-2.432 1.677l-1.956 1.71Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ti = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m14 6-6 6 6 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ei = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M14.936 10.194c.713.623 1.069.935 1.2 1.305.115.324.115.678 0 1.002-.131.37-.487.682-1.2 1.305l-1.956 1.711c-1.264 1.106-1.896 1.66-2.432 1.677a1.5 1.5 0 0 1-1.208-.549C9 16.231 9 15.391 9 13.711v-3.422c0-1.68 0-2.52.34-2.935a1.5 1.5 0 0 1 1.208-.548c.536.018 1.168.57 2.432 1.677l1.956 1.71Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Di = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10 6 6 6-6 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oi = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M13.806 9.064c-.623-.712-.935-1.069-1.305-1.2a1.5 1.5 0 0 0-1.002 0c-.37.131-.682.488-1.305 1.2L8.483 11.02c-1.106 1.264-1.66 1.896-1.677 2.432a1.5 1.5 0 0 0 .548 1.208C7.77 15 8.61 15 10.29 15h3.422c1.68 0 2.52 0 2.934-.34a1.5 1.5 0 0 0 .549-1.208c-.017-.536-.57-1.168-1.677-2.432l-1.71-1.956Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), ki = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 15 6-6 6 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ai = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 8-.375.375L12 11 9.375 8.375 9 8m-2.5 2.5L12 16l5.5-5.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ji = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m16 7-4 4-4-4m-4 3 8 8 8-8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 9-3 3 3 3m-2.5 2.5L7 12l5.5-5.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ni = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m13 4-8 8 8 8m3-12-4 4 4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 9 3 3-3 3m2.5 2.5L17 12l-5.5-5.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m11 4 8 8-8 8M8 8l4 4-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ii = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 16-.375-.375L12 13l-2.625 2.625L9 16m-2.5-2.5L12 8l5.5 5.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Li = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m4 14 8-8 8 8M8 17l4-4 4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ri = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3v0a4 4 0 0 1 4 4v7c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V7a4 4 0 0 1 4-4v0m8 0v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0m8 0v0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v0m1.5 10.5L11 15l4-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3v0a4 4 0 0 1 4 4v7c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V7a4 4 0 0 1 4-4v0m8 0v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0m8 0v0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v0m2 12 2-2m0 0 2-2m-2 2-2-2m2 2 2 2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3v0a4 4 0 0 1 4 4v7c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V7a4 4 0 0 1 4-4v0m8 0v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0m8 0v0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v0m1.5 10h5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3v0a4 4 0 0 1 4 4v7c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V7a4 4 0 0 1 4-4v0m8 0v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0m8 0v0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v0m1.5 10H12m0 0h2.5M12 13v-2.5m0 2.5v2.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3a2 2 0 0 1-2 2h-4a2 2 0 1 1 0-4h4a2 2 0 0 1 2 2Zm0 0a4 4 0 0 1 4 4v7c0 .552 0 1.049-.004 1.5M2 2l2.716 2.716M22 22l-2.609-2.609M4.716 4.716A3.982 3.982 0 0 0 4 7v7c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C7.8 22 9.2 22 12 22c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.121-2.064M4.716 4.716 19.39 19.39",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ui = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3v0a4 4 0 0 1 4 4v7c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V7a4 4 0 0 1 4-4v0m8 0v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0m8 0v0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v0m1 8h6m-6 4h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 3v0a4 4 0 0 1 4 4v7c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V7a4 4 0 0 1 4-4v0m8 0v0a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v0m8 0v0a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v0",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 1 1 4m19-3 3 3M9 12l2 2 5-5m6 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ki = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 1 1 4m19-3 3 3M9 15l3-3m0 0 3-3m-3 3L9 9m3 3 3 3m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 1 1 4m19-3 3 3M8 12h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ji = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 1 1 4m19-3 3 3M8 12h4m0 0h4m-4 0V8m0 4v4m10-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M1 3.667 2.692 2l2.974 2.929m2.667-1.89A10.24 10.24 0 0 1 12.846 2C18.454 2 23 6.477 23 12c0 1.597-.38 3.106-1.055 4.444m-1.919 2.627A10.2 10.2 0 0 1 12.846 22C7.238 22 2.692 17.523 2.692 12a9.894 9.894 0 0 1 2.974-7.071m14.36 14.142L23 22m-2.974-2.929L5.666 4.93M20 1l3 3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 1 1 4m19-3 3 3M10 9h4l-4 6h4m8-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8v4l3 2M4 1 1 4m19-3 3 3m-1 8c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qi = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 11-4 4-1.5-1.5m-5.2-2.567C4.3 6.552 7.747 3 12 3c3.621 0 6.658 2.575 7.48 6.045 2.06.82 3.52 2.878 3.52 5.288C23 17.463 20.538 20 17.5 20H5.4C2.97 20 1 17.97 1 15.467c0-2.113 1.403-3.888 3.301-4.391a8.34 8.34 0 0 1-.001-.143Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $i = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10 15 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m-9.7-4.067C4.3 6.552 7.747 3 12 3c3.621 0 6.658 2.575 7.48 6.045 2.06.82 3.52 2.878 3.52 5.288C23 17.463 20.538 20 17.5 20H5.4C2.97 20 1 17.97 1 15.467c0-2.113 1.403-3.888 3.301-4.391a8.34 8.34 0 0 1-.001-.143Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ea = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.2 18A4.427 4.427 0 0 1 1 14.167a4.422 4.422 0 0 1 3.301-4.285l-.001-.14C4.3 5.468 7.747 2 12 2c3.621 0 6.658 2.513 7.48 5.9A5.532 5.532 0 0 1 23 13.061c0 1.81-.864 3.416-2.2 4.425M12 13v9m0 0 3.5-3.5M12 22l-3.5-3.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ta = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.2 18A4.427 4.427 0 0 1 1 14.167a4.422 4.422 0 0 1 3.301-4.285l-.001-.14C4.3 5.468 7.747 2 12 2c3.621 0 6.658 2.513 7.48 5.9A5.532 5.532 0 0 1 23 13.061c0 1.81-.864 3.416-2.2 4.425M8 14v2m0 3v2m8-7v2m0 3v2m-4-6v2m0 3v2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), na = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.2 18A4.427 4.427 0 0 1 1 14.167a4.422 4.422 0 0 1 3.301-4.285l-.001-.14C4.3 5.468 7.747 2 12 2c3.621 0 6.658 2.513 7.48 5.9A5.532 5.532 0 0 1 23 13.061c0 1.81-.864 3.416-2.2 4.425M13 14l-4 4h6l-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ra = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.2 18A4.427 4.427 0 0 1 1 14.167a4.422 4.422 0 0 1 3.301-4.285l-.001-.14C4.3 5.468 7.747 2 12 2c3.621 0 6.658 2.513 7.48 5.9A5.532 5.532 0 0 1 23 13.061c0 1.81-.864 3.416-2.2 4.425M8.5 15a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m9 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-7 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5-3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ia = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.2 18A4.427 4.427 0 0 1 1 14.167a4.422 4.422 0 0 1 3.301-4.285l-.001-.14C4.3 5.468 7.747 2 12 2c3.621 0 6.658 2.513 7.48 5.9A5.532 5.532 0 0 1 23 13.061c0 1.81-.864 3.416-2.2 4.425M12 22v-9m0 0-3.5 3.5M12 13l3.5 3.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), aa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3c-4.253 0-7.7 3.552-7.7 7.933l.001.143C2.403 11.579 1 13.354 1 15.466 1 17.97 2.97 20 5.4 20h12.1c3.038 0 5.5-2.537 5.5-5.667 0-2.41-1.46-4.469-3.52-5.288C18.659 5.575 15.622 3 12 3Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10 8-4 4 4 4m4-8 4 4-4 4m-4 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 6-6 6 6 6m8-12 6 6-6 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ca = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 22h18M19 6v0c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C22 7.602 22 8.068 22 9v1c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C20.398 13 19.932 13 19 13v0m-8 5v0c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C19 14.2 19 12.8 19 10V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 2 15.88 2 14.2 2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.28 3 5.12 3 6.8V10c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C6.8 18 8.2 18 11 18Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), la = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 10.224a6.06 6.06 0 0 0-4 5.715C2 19.287 4.686 22 8 22s6-2.713 6-6.06c0-.679-.11-1.331-.314-1.94M12 20.614A6.116 6.116 0 0 0 15.89 22c3.374 0 6.11-2.713 6.11-6.06 0-2.612-1.665-4.838-4-5.69M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ua = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15.5 12h-7m7 0L14 10.5m1.5 1.5L14 13.5M8.5 12l1.5-1.5M8.5 12l1.5 1.5m8 3.5V7M6 17V7m4 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), da = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 21V3m20 0v18m-4-9H6m12 0-2.5-2.5M18 12l-2.5 2.5M6 12l2.5-2.5M6 12l2.5 2.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 12.5v-5m.5 8.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M22 12c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 14.5 12 12m0 0 2.5-2.5M12 12 9.5 9.5M12 12l2.5 2.5M22 12c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ma = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 12 2 2 4.5-4.5M22 12c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ha = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m6 0c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ga = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 16v-5m.5-3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M22 12c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _a = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 12h6m7 0c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), va = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 12h3m0 0h3m-3 0V9m0 3v3m10-3c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ya = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12.5 16a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M10 10.5V10a2 2 0 1 1 4 0v.121c0 .563-.223 1.102-.621 1.5L12 13m10-1c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ba = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 2 2.929 2.929M22 22l-2.929-2.929m0 0A9.97 9.97 0 0 1 12 22c-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12a9.969 9.969 0 0 1 2.929-7.071M19.07 19.07 4.93 4.93M8 2.832A9.966 9.966 0 0 1 12 2c5.523 0 10 4.477 10 10a9.966 9.966 0 0 1-.832 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 10h8m-8 4h4m10-2c0 5.523-4.477 10-10 10-1.14 0-2.116-.162-3.024-.487-.857-.307-1.286-.46-1.45-.499-1.518-.357-2.148.684-3.456.902a1 1 0 0 1-1.161-1.069c.046-.567.439-1.104.596-1.65.325-1.133-.117-1.992-.584-3A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.499.33 2.921.921 4.197.467 1.008.91 1.867.584 3-.157.546-.55 1.083-.596 1.65a1 1 0 0 0 1.16 1.069c1.309-.218 1.939-1.259 3.457-.902.164.04.593.192 1.45.5.908.324 1.885.486 3.024.486Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ca = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 11V7m.5 7.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7.216 6.53v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 13.5 12 11m0 0 2.5-2.5M12 11 9.5 8.5M12 11l2.5 2.5m4.216 7.53v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ta = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 11 2 2 4.5-4.5m3.216 12.53v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ea = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 11a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m2.716 10.03v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Da = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 11h6m3.716 10.03v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 11h3m0 0h3m-3 0V8m0 3v3m6.716 7.03v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ka = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m22.5 1.5-1.965 1.964M2 22l2.621-2.621M20.535 3.464a4.998 4.998 0 0 0-.922-.727C18.41 2 16.773 2 13.5 2H11c-3.75 0-5.625 0-6.939.955A5 5 0 0 0 2.955 4.06C2 5.375 2 7.251 2 11c0 3.75 0 5.625.955 6.939a5 5 0 0 0 1.106 1.106c.176.128.361.238.56.334M20.535 3.464 4.621 19.38M21.935 7S22 13.025 22 16v3.17c0 1.027 0 1.54-.163 1.86a1.5 1.5 0 0 1-1.442.817c-.359-.025-.799-.29-1.678-.817-.525-.315-.788-.472-1.063-.595a5.001 5.001 0 0 0-1.439-.399C15.916 20 15.61 20 14.998 20c-2.165 0-4.332.026-6.498 0",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Aa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8h8m-8 4h4m7.716 9.03v0c.88.528 1.32.792 1.679.817a1.5 1.5 0 0 0 1.442-.817c.163-.32.163-.833.163-1.86V10c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 20 7.2 20 10 20h4.998c.612 0 .918 0 1.217.036.497.06.982.195 1.44.399.274.123.537.28 1.061.595Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ja = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v9.17c0 1.027 0 1.54-.163 1.86a1.5 1.5 0 0 1-1.442.817c-.359-.025-.799-.29-1.678-.817v0c-.525-.315-.788-.472-1.063-.595a4.998 4.998 0 0 0-1.439-.399C15.916 20 15.61 20 14.998 20H10c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 16.2 2 14.8 2 12v-2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ma = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.977 18.868a6.767 6.767 0 0 1-1.047-.282c-.729-.26-1.093-.39-1.233-.424-1.29-.303-1.826.581-2.938.766a.85.85 0 0 1-.987-.908c.04-.482.374-.939.507-1.402.277-.963-.099-1.694-.496-2.55A8.5 8.5 0 0 1 17.713 6M11 15a6 6 0 0 0 6 6c.684 0 1.27-.097 1.814-.292.515-.184.772-.276.87-.3.911-.213 1.29.41 2.074.541a.6.6 0 0 0 .697-.64c-.028-.341-.264-.663-.358-.99-.195-.68.07-1.196.35-1.8A6 6 0 1 0 11 15Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Na = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 14H7.25c-.247 0-.37 0-.491.01-.483.039-.95.194-1.36.453-.102.065-.201.139-.399.287v0c-.511.384-.767.575-.962.65a1.5 1.5 0 0 1-1.98-.99C2 14.209 2 13.89 2 13.25V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C18 4.28 18 5.12 18 6.8v.7m2.09 13.682v0c.72.685 1.91.175 1.91-.818V13.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 10 19.92 10 18.8 10h-6.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C9 11.52 9 12.08 9 13.2v3.743c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h5.294c.967 0 1.897.372 2.597 1.039Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pa = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M9.755 12.139c.276-.607.414-.91.608-1.17.172-.23.376-.434.606-.606.26-.194.563-.332 1.17-.608L16 8l-1.755 3.861c-.276.607-.414.91-.608 1.17-.172.23-.376.434-.606.606-.26.194-.563.332-1.17.608L8 16l1.755-3.861Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Fa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16.167 8v0c1.707 0 2.56 0 3.242.256a4 4 0 0 1 2.335 2.335c.256.681.256 1.535.256 3.242V15.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22h-1.766c-1.708 0-2.562 0-3.243-.256a4 4 0 0 1-2.334-2.335C8 18.728 8 17.874 8 16.167v0M8.4 16h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C16 12.96 16 11.84 16 9.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C12.96 2 11.84 2 9.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 16 6.16 16 8.4 16Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ia = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 9.6a3.968 3.968 0 0 0-.778-.8A3.801 3.801 0 0 0 11.89 8C9.74 8 8 9.79 8 12s1.741 4 3.889 4c.875 0 1.683-.298 2.333-.8.295-.227.557-.497.778-.8M12 22v0c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), La = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 15.286V9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C5.04 3 6.16 3 8.4 3h7.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 6.04 22 7.16 22 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 21 17.84 21 15.6 21H11m-9-2h6m0 0-2-2m2 2-2 2M2.5 8h19M15 12h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ra = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 13.286V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 3 17.84 3 15.6 3H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 6.04 2 7.16 2 9.4v5.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 21 6.16 21 8.4 21H14M2.5 8h19M6 12h3m8.5 7h5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), za = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 13.286V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 3 17.84 3 15.6 3H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 6.04 2 7.16 2 9.4v5.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 21 6.16 21 8.4 21H14M2.5 8h19M6 12h3m8 7h6m0 0-2-2m2 2-2 2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ba = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 13.286V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 3 17.84 3 15.6 3H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 6.04 2 7.16 2 9.4v5.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 21 6.16 21 8.4 21H14M2.5 8h19M20 16.5V19m0 0v2.5m0-2.5h-2.5m2.5 0h2.5M6 12h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Va = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 7v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 2 18.88 2 17.2 2H17m5 15v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 22 18.88 22 17.2 22H17M2 17v.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22H7M2 7v-.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2H7m-1 9h12m0 2.8v-3.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 7 15.92 7 14.8 7H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 8.52 6 9.08 6 10.2v3.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C7.52 17 8.08 17 9.2 17h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C18 15.48 18 14.92 18 13.8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ha = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.006 8H8m13.006 0H12M2 2l1.716 1.716M22 22l-1.716-1.716m0 0a4.005 4.005 0 0 1-.468.28C18.96 21 17.84 21 15.6 21H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 17.96 2 16.84 2 14.6V9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.28-1.468m16.568 16.568L8 8M3.716 3.716 8 8M7 3.006C7.413 3 7.876 3 8.4 3h7.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 6.04 22 7.16 22 9.4v5.2c0 .997 0 1.771-.038 2.4-.011.178-.025.344-.043.5M6 12h2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ua = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.5 8h19M6 12h4m-1.6 9h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 17.96 22 16.84 22 14.6V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 3 17.84 3 15.6 3H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 6.04 2 7.16 2 9.4v5.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 21 6.16 21 8.4 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 16h-4.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C8 14.48 8 13.92 8 12.8V8m8 8v2m0-2h2M8 8V6m0 2H6m5 0h1.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 9.52 16 10.08 16 11.2V13m-6 9h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ga = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 12a7 7 0 0 0 7 7l-1-1.5m8-5.5a7 7 0 0 0-7-7l1 1.5m1.5 8h-2.9c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C10 13.74 10 13.46 10 12.9V10m4.5 4.5v1m0-1h1M10 10V9m0 1H9m3 0h.9c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.109.214.109.494.109 1.054v.9M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ka = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 16h-4.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C8 14.48 8 13.92 8 12.8V8m8 8v2m0-2h2M8 8V6m0 2H6m-4 4c0 5.523 4.477 10 10 10l-1.5-2.5M22 12c0-5.523-4.477-10-10-10l1.5 2.5m-3 3.5h2.3c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 9.52 16 10.08 16 11.2v2.3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 19H8.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C5 17.48 5 16.92 5 15.8V5m14 14v3m0-3h3M5 5V2m0 3H2m6 0h7.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C19 6.52 19 7.08 19 8.2V16",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ja = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 15 3-3m0 0 3-3m-3 3L9 9m3 3 3 3m7-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ya = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 15 3-3m0 0 3-3m-3 3L9 9m3 3 3 3M3.875 17.875l2.25 2.25c.692.692 1.038 1.038 1.442 1.286a4 4 0 0 0 1.156.479c.46.11.95.11 1.928.11h2.698c.978 0 1.468 0 1.928-.11.408-.099.798-.26 1.156-.48.404-.247.75-.593 1.442-1.285l2.25-2.25c.692-.692 1.038-1.038 1.286-1.442.219-.358.38-.748.479-1.156.11-.46.11-.95.11-1.928v-2.698c0-.978 0-1.468-.11-1.928a4 4 0 0 0-.48-1.156c-.247-.404-.593-.75-1.285-1.442l-2.25-2.25c-.692-.692-1.038-1.038-1.442-1.286a3.998 3.998 0 0 0-1.156-.478C14.817 2 14.327 2 13.349 2h-2.698c-.978 0-1.468 0-1.928.11a4 4 0 0 0-1.156.48c-.404.247-.75.593-1.442 1.285l-2.25 2.25c-.692.692-1.038 1.038-1.286 1.442a4 4 0 0 0-.478 1.156C2 9.183 2 9.673 2 10.651v2.698c0 .978 0 1.468.11 1.928.099.408.26.798.48 1.156.247.404.593.75 1.285 1.442Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 16 4-4m0 0 4-4m-4 4L8 8m4 4 4 4m-4.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Za = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18 18 6M6 6l12 12",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qa = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10h-3m-7 10C6.477 22 2 17.523 2 12m10 10v-3M2 12C2 6.477 6.477 2 12 2M2 12h3m7-10v3m2 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $a = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("g", {
		clipPath: "url(#a)",
		children: /*#__PURE__*/ M("path", {
			d: "M7 14 17.5 1.5m0 12.5-5.25-6.25M10.36 5.5 7 1.5M22 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-12 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
			stroke: e.color,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /*#__PURE__*/ M("defs", { children: /*#__PURE__*/ M("clipPath", {
		id: "a",
		children: /*#__PURE__*/ M("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
}), eo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 21 6-6 3-3m5 1 4.737-4.737c.792-.792 1.188-1.188 1.337-1.645a2 2 0 0 0 0-1.236c-.149-.457-.545-.853-1.337-1.645L20 3l-7 7M3.5 4.5l6 6m0 0-1.916.274c-.58.083-.871.124-1.149.086a2.001 2.001 0 0 1-.7-.233c-.244-.136-.452-.344-.866-.758L2 7m7.5 3.5.274-1.916c.083-.58.124-.871.086-1.149a2 2 0 0 0-.233-.7c-.136-.244-.344-.452-.758-.866L6 3m3.5 7.5L20 21",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), to = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 2v9m0 11V11m0 0L5.425 9.95c-.521-.347-.782-.521-.97-.75a2 2 0 0 1-.369-.69C4 8.228 4 7.915 4 7.288V2m3 9 1.575-1.05c.521-.347.782-.521.97-.75a2 2 0 0 0 .369-.69C10 8.228 10 7.915 10 7.288V2m7 0v12m0 0c-1.657 0-3.5 1.79-3.5 4s1.843 4 3.5 4 3.5-1.79 3.5-4-1.843-4-3.5-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), no = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 22v-8m0 0V2l1.576.394c.867.217 1.3.325 1.623.567.284.213.507.498.645.826.156.371.156.818.156 1.711v4.524c0 .718 0 1.077-.11 1.394a2 2 0 0 1-.461.747c-.235.24-.556.4-1.198.721L15 14ZM7 2v9m0 0v11m0-11L5.425 9.95c-.521-.347-.782-.521-.97-.75a2 2 0 0 1-.369-.69C4 8.228 4 7.915 4 7.288V2m3 9 1.575-1.05c.521-.347.782-.521.97-.75a2 2 0 0 0 .369-.69C10 8.228 10 7.915 10 7.288V2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ro = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 21 7-7 2-2m5 1 4.737-4.737c.792-.792 1.188-1.188 1.337-1.645a2 2 0 0 0 0-1.236c-.149-.457-.545-.853-1.337-1.645L20 3l-7 7m7 11-3.3-3.3-5.5-5.5L9 10m-.474-5.526c1.64 1.64 2.084 3.856.444 5.496-1.64 1.64-3.855 1.196-5.496-.444C1.834 7.886 1.39 5.67 3.03 4.03c1.64-1.64 3.855-1.196 5.496.444Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), io = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12m20 0c0-5.523-4.477-10-10-10m10 10h-2M2 12C2 6.477 6.477 2 12 2M2 12h2m8-10v2M4 18l1.232-1.232A6.035 6.035 0 0 1 9.5 15v0M20 18l-1.232-1.232A6.036 6.036 0 0 0 14.5 15v0M19 5l-1 1M5 5l1 1m6 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0V9",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ao = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12m20 0c0-5.523-4.477-10-10-10m10 10h-2M2 12C2 6.477 6.477 2 12 2M2 12h2m8-10v2m7 1-1 1m1 13-1-1M5 19l1-1M5 5l1 1m6 3s-2 1.482-2 3.556c0 3.259 4 3.259 4 0C14 10.482 12 9 12 9Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 12h.01M19 21H4.556A3.556 3.556 0 0 1 1 17.444v0c0-.245.199-.444.444-.444H15M3 17V9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h9.1A2.5 2.5 0 0 1 21 5.5V6m-1.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1.3 9h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C23 19.48 23 18.92 23 17.8v-5.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C21.48 9 20.92 9 19.8 9h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C15 10.52 15 11.08 15 12.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C16.52 21 17.08 21 18.2 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), so = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM22 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM22 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), co = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("g", {
		clipPath: "url(#a)",
		children: /*#__PURE__*/ M("path", {
			d: "M21.466 6.478c.502-1.791.752-2.687.52-3.302a2 2 0 0 0-1.162-1.162c-.615-.233-1.51.018-3.302.52L7.296 5.397C4.466 6.19 3.05 6.586 2.64 7.258a2 2 0 0 0-.09 1.917c.345.708 1.716 1.236 4.459 2.29l2.663 1.024c.488.188.733.282.938.429a2 2 0 0 1 .471.47c.146.206.24.45.428.94l1.024 2.662c1.055 2.743 1.583 4.114 2.291 4.459a2 2 0 0 0 1.916-.09c.673-.41 1.07-1.825 1.862-4.655l2.863-10.226Z",
			stroke: e.color,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /*#__PURE__*/ M("defs", { children: /*#__PURE__*/ M("clipPath", {
		id: "a",
		children: /*#__PURE__*/ M("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
}), lo = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("g", {
		clipPath: "url(#a)",
		children: /*#__PURE__*/ M("path", {
			d: "M14.862 4.724c-.921-1.842-1.382-2.763-2.005-3.059a2 2 0 0 0-1.714 0c-.623.296-1.084 1.217-2.005 3.06L4.019 14.96c-1.498 2.997-2.247 4.496-1.996 5.274A2 2 0 0 0 3.48 21.57c.797.182 2.224-.696 5.078-2.452l1.764-1.086c.609-.375.913-.562 1.24-.635a2 2 0 0 1 .875 0c.326.073.63.26 1.24.635l1.763 1.086c2.854 1.756 4.28 2.634 5.078 2.452a2 2 0 0 0 1.458-1.335c.251-.778-.498-2.277-1.996-5.274L14.862 4.724Z",
			stroke: e.color,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /*#__PURE__*/ M("defs", { children: /*#__PURE__*/ M("clipPath", {
		id: "a",
		children: /*#__PURE__*/ M("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
}), uo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 8h8m0 13.5v-5.3c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 13 13.92 13 12.8 13h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 14.52 8 15.08 8 16.2v5.3M14.349 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6V9.651c0-.978 0-1.468-.11-1.928a4 4 0 0 0-.48-1.156c-.247-.404-.593-.75-1.285-1.442l-1.25-1.25c-.692-.692-1.038-1.038-1.442-1.286a3.998 3.998 0 0 0-1.156-.478C15.817 2 15.327 2 14.349 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), fo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 3v18M22 3v18m-10.2-1h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C17 17.72 17 16.88 17 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C14.72 4 13.88 4 12.2 4h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C7 6.28 7 7.12 7 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C9.28 20 10.12 20 11.8 20Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), po = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 22h18M3 2h18M8.8 17h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 14.72 20 13.88 20 12.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 7 16.88 7 15.2 7H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 9.28 4 10.12 4 11.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 17 7.12 17 8.8 17Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 14a2 2 0 0 0 2 2h2.257a1.743 1.743 0 0 0 .55-3.397l-3.615-1.206A1.743 1.743 0 0 1 10.743 8H13a2 2 0 0 1 2 2m-3-3.5v11M22 12v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10v0c5.523 0 10-4.477 10-10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ho = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 16a4 4 0 0 0 4 4h4.513a3.487 3.487 0 0 0 1.103-6.795l-7.232-2.41A3.487 3.487 0 0 1 9.487 4H14a4 4 0 0 1 4 4m-6-6v20",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), go = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.744 2.554a49.721 49.721 0 0 1 7.801 18.35m5.43-8.013a16.979 16.979 0 0 0-17.045 6.18m0 0c3.905 3.905 10.236 3.905 14.141 0 3.905-3.905 3.905-10.237 0-14.142M4.93 19.07C1.024 15.166 1.023 8.834 4.929 4.93c3.905-3.905 10.237-3.905 14.142 0m-17.01 6c6.067.643 12.36-1.351 17.01-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _o = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 2 4.762 4.762M22 22l-3.356-3.356M6.762 6.762C5.25 8.695 4 11.119 4 13.852c0 8.918 10.782 10.516 14.644 4.792M6.762 6.762l11.882 11.882M9.386 4c.358-.317.7-.6 1.011-.847.454-.359.68-.538 1.073-.646a2.412 2.412 0 0 1 1.059 0c.393.108.619.287 1.072.645C15.935 5 20 8.924 20 13.852c0 .397-.021.78-.063 1.148",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 13.852c0 10.864-16 10.864-16 0C4 8.924 8.064 5 10.399 3.152c.453-.358.679-.537 1.072-.645a2.412 2.412 0 0 1 1.058 0c.393.108.619.287 1.072.645C15.935 5 20 8.924 20 13.852Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.5 20.5 5 19M19 5l1.5-1.5M15 9l-6 6m2 6v0c.545-.545.818-.818.964-1.112a2 2 0 0 0 0-1.776c-.146-.294-.419-.567-.964-1.112l-4-4c-.545-.545-.818-.818-1.112-.964a2 2 0 0 0-1.776 0c-.294.146-.567.419-1.112.964v0c-.545.545-.818.818-.964 1.112a2 2 0 0 0 0 1.776c.146.294.419.567.964 1.112l4 4c.545.545.818.818 1.112.964a2 2 0 0 0 1.776 0c.294-.146.567-.419 1.112-.964Zm10-10v0c.545-.545.818-.818.964-1.112a2 2 0 0 0 0-1.776C21.818 7.818 21.545 7.545 21 7l-4-4c-.545-.545-.818-.818-1.112-.964a2 2 0 0 0-1.776 0c-.294.146-.567.419-1.112.964v0c-.545.545-.818.818-.964 1.112a2 2 0 0 0 0 1.776c.146.294.419.567.964 1.112l4 4c.545.545.818.818 1.112.964a2 2 0 0 0 1.776 0c.294-.146.567-.419 1.112-.964Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 21H4M16 4a2.652 2.652 0 0 0 3 3M7 16l.57-2.28c.16-.64.24-.96.369-1.259.114-.265.256-.517.425-.75.19-.265.423-.498.89-.965L16.5 3.5c.08-.08.12-.12.155-.151a2 2 0 0 1 2.69 0c.035.032.075.071.155.151v0c.08.08.12.12.151.155a2 2 0 0 1 0 2.69c-.032.035-.072.075-.151.155l-7.247 7.246c-.466.467-.7.7-.963.89a3.996 3.996 0 0 1-.751.425c-.299.129-.619.209-1.259.369L7 16Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 5a4 4 0 0 0 4 4M4 20l.62-3.1c.141-.706.212-1.06.341-1.389.115-.292.263-.57.443-.827.202-.29.457-.545.966-1.054L16 4c.545-.545.818-.818 1.112-.964a2 2 0 0 1 1.776 0c.294.146.567.419 1.112.964v0c.545.545.818.818.964 1.112a2 2 0 0 1 0 1.776c-.146.294-.419.567-.964 1.112l-9.63 9.63c-.51.51-.764.764-1.054.966-.257.18-.535.328-.827.443-.33.13-.683.2-1.39.341L4 20Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), So = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m4 3 6.5 6.5M21 20l-6.5-6.5m0 0-4.13 4.13c-.51.51-.764.764-1.054.966-.257.18-.535.328-.827.443-.33.13-.683.2-1.39.341L4 20l.62-3.1c.141-.706.212-1.06.341-1.389.115-.292.263-.57.443-.827.202-.29.457-.545.966-1.054L10.5 9.5m4 4-4-4M13 7l3-3c.545-.545.818-.818 1.112-.964a2 2 0 0 1 1.776 0c.294.146.567.419 1.112.964v0c.545.545.818.818.964 1.112a2 2 0 0 1 0 1.776c-.146.294-.419.567-.964 1.112l-3 3m-2-6a4 4 0 0 0 4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Co = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2h-2c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-2m-5-8a2.652 2.652 0 0 0 3 3m-9 6 .57-2.28c.16-.64.24-.96.369-1.259.114-.265.257-.517.425-.75.19-.265.423-.498.89-.964L17.5 3.5c.08-.08.12-.12.155-.152a2 2 0 0 1 2.69 0c.036.033.075.072.155.152v0c.08.08.12.12.151.155a2 2 0 0 1 0 2.69 4.899 4.899 0 0 1-.151.155l-4.247 4.246c-.466.467-.7.7-.963.89a4 4 0 0 1-.751.425c-.299.129-.619.209-1.259.369L11 13Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM22 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM22 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM10 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), To = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM22 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM22 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM22 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Eo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 3.52 10 4.08 10 5.2v13.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 22 7.92 22 6.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8V5.2ZM14 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 2 16.08 2 17.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 10 19.92 10 18.8 10h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 8.48 14 7.92 14 6.8V5.2ZM14 17.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 14 16.08 14 17.2 14h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 15.52 22 16.08 22 17.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 22 19.92 22 18.8 22h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 20.48 14 19.92 14 18.8v-1.6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Do = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 3.52 10 4.08 10 5.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 12 7.92 12 6.8 12H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 10.48 2 9.92 2 8.8V5.2ZM2 19c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C3.602 16 4.068 16 5 16h2c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C10 17.602 10 18.068 10 19v0c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C8.398 22 7.932 22 7 22H5c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C2 20.398 2 19.932 2 19v0ZM14 5c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C15.602 2 16.068 2 17 2h2c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C22 3.602 22 4.068 22 5v0c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C20.398 8 19.932 8 19 8h-2c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C14 6.398 14 5.932 14 5v0ZM14 15.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 12 16.08 12 17.2 12h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 13.52 22 14.08 22 15.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 22 19.92 22 18.8 22h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 20.48 14 19.92 14 18.8v-3.6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 6h4m0 0h4m-4 0v4m0-4V2m-.8 20h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.48 22 19.92 22 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 14 19.92 14 18.8 14h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C14 15.52 14 16.08 14 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 22 16.08 22 17.2 22Zm-12 0h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 20.48 10 19.92 10 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 14 7.92 14 6.8 14H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 15.52 2 16.08 2 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Zm0-12h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 8.48 10 7.92 10 6.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 2 7.92 2 6.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 10 4.08 10 5.2 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ko = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 3.52 10 4.08 10 5.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 10 7.92 10 6.8 10H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 8.48 2 7.92 2 6.8V5.2ZM14 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 2 16.08 2 17.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 10 19.92 10 18.8 10h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 8.48 14 7.92 14 6.8V5.2ZM2 17.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 14 4.08 14 5.2 14h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 15.52 10 16.08 10 17.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 22 7.92 22 6.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8v-1.6ZM14 17.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 14 16.08 14 17.2 14h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 15.52 22 16.08 22 17.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 22 19.92 22 18.8 22h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 20.48 14 19.92 14 18.8v-1.6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ao = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m18 8-1 .667-.562.375c-1.604 1.069-2.406 1.603-3.273 1.811a5.001 5.001 0 0 1-2.33 0c-.867-.208-1.669-.742-3.273-1.811L7 8.667 6 8m4 13h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 17.2 22 15.8 22 13v-2c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 3 16.8 3 14 3h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 5.73C2 6.8 2 8.2 2 11v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 21 7.2 21 10 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), jo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M1 7v4.4c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C5.56 21 7.24 21 10.6 21H16a3 3 0 0 0 3-3v0M18 6l-.833.667-.169.135c-1.427 1.141-2.14 1.712-2.932 1.93a4 4 0 0 1-2.133 0c-.79-.218-1.504-.789-2.931-1.93l-.169-.135L8 6m2.4 12h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 14.96 22 13.84 22 11.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2h-5.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 5.04 4 6.16 4 8.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 18 8.16 18 10.4 18Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Mo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm5-9s-1.25 4-5 4-5-4-5-4h10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), No = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 10a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m.5 5H9m3 7v0c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Po = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 10a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1.5 6a4.992 4.992 0 0 0-4-2 4.993 4.993 0 0 0-4 2m4 6v0c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 10a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1.5 5a4.992 4.992 0 0 1-4 2 4.993 4.993 0 0 1-4-2m4 7v0c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Io = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 9a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m7 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M12 18a2 2 0 0 1-2-2v-2a2 2 0 1 1 4 0v2a2 2 0 0 1-2 2Zm0 4v0c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8v8m5-5v5m5-7v7m-7 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ro = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 9.354a4 4 0 1 0 0 5.292M7 11h5m-5 2h4m11-1v0c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v0c0 5.523 4.477 10 10 10v0c5.523 0 10-4.477 10-10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 6.047A9.183 9.183 0 0 0 13.143 3C8.093 3 4 7.03 4 12s4.093 9 9.143 9A9.183 9.183 0 0 0 20 17.953M2 10h10M2 14h8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 10h-.5v0c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 13.407 2 14.104 2 15.5v.5c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C5.204 22 6.136 22 8 22h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C22 18.796 22 17.864 22 16v-.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C18.593 10 17.896 10 16.5 10v0H16m-4 5V2m0 0L8 6m4-4 4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m1 9 9-9m0 0h-5m5 0v5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ho = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 16V2m0 0L8 6m4-4 4 4M8 22h8a6 6 0 0 0 6-6v0a6 6 0 0 0-6-6H8a6 6 0 0 0-6 6v0a6 6 0 0 0 6 6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 14v1.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6V14m-10 0V2m0 0 4 4m-4-4L8 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13 4h-3c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 6.73C2 7.8 2 9.2 2 12v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h2c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 18.2 20 16.8 20 14v-3m-8 1L22 2m0 0h-5m5 0v5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Go = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 16 8-8m0 0h-6m6 0v6m-6 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ko = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 3h-.5v0c-1.395 0-2.092 0-2.667.138a5 5 0 0 0-3.695 3.695C3 7.408 3 8.105 3 9.5V13c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C6.8 21 8.2 21 11 21h3.5c1.395 0 2.092 0 2.667-.138a5 5 0 0 0 3.695-3.695C21 16.592 21 15.894 21 14.5v0-.5m-9-2 9-9m0 0h-6m6 0v6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 3 2.826 2.826M21 21l-2.826-2.826m0 0C16.63 19.248 14.588 20 12 20c-7 0-10-5.5-10-8 0-1.576 1.192-4.343 3.826-6.174m12.348 12.348-4.053-4.053M5.826 5.826l4.053 4.053m0 0a3 3 0 1 0 4.243 4.243M9.878 9.878l4.242 4.242M20.42 16c.123-.166.239-.333.347-.5C21.605 14.21 22 12.907 22 12c0-2.5-3-8-10-8-1.097 0-2.096.135-3 .372-.17.045-.337.093-.5.145",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Jo = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M22 12c0 2.5-3 8-10 8S2 14.5 2 12s3-8 10-8 10 5.5 10 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
}), Yo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 10v-.8c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C7.52 6 8.08 6 9.2 6h.8m4 0h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2v.8m0 4.1v.7c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C16.48 18 15.92 18 14.8 18h-.7M10 18h-.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8v-.7m6-4.6V12a.6.6 0 0 1-.6.6M9.5 9.5v1m5-1v1m0 4c-.5.5-1.5 1-2.5 1s-2-.5-2.5-1M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 8v-.5 0A5.5 5.5 0 0 0 16.5 2v0H16m6 14v.5a5.5 5.5 0 0 1-5.5 5.5v0H16M2 16v.5A5.5 5.5 0 0 0 7.5 22v0H8M2 8v-.5 0A5.5 5.5 0 0 1 7.5 2v0H8m4 6v4a1 1 0 0 1-1 1M8 8v1.5M16 8v1.5m0 5.5a4.992 4.992 0 0 1-4 2 4.993 4.993 0 0 1-4-2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13 22h1c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h3Zm0 0V11.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C14.52 8 15.08 8 16.2 8h.8m-7 6h7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qo = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 8.143 6.93 6.17C5.324 5.137 4.522 4.62 3.858 4.668a2 2 0 0 0-1.459.797C2 5.998 2 6.952 2 8.86v6.278c0 1.909 0 2.863.399 3.396a2 2 0 0 0 1.459.797c.664.047 1.466-.47 3.072-1.502L10 15.857m9.813-1.165L14.93 17.83c-1.605 1.033-2.409 1.549-3.072 1.502a2 2 0 0 1-1.459-.797C10 18.002 10 17.048 10 15.14V8.86c0-1.909 0-2.863.399-3.396a2 2 0 0 1 1.459-.797c.663-.047 1.466.47 3.072 1.502l4.883 3.138c1.393.896 2.09 1.344 2.33 1.914a2 2 0 0 1 0 1.556c-.24.57-.937 1.018-2.33 1.914Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $o = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m14 8.143 3.07-1.973c1.605-1.033 2.409-1.549 3.072-1.502a2 2 0 0 1 1.459.797C22 5.998 22 6.952 22 8.86v6.278c0 1.909 0 2.863-.399 3.396a2 2 0 0 1-1.459.797c-.663.047-1.466-.47-3.072-1.502L14 15.857m-9.813-1.165L9.07 17.83c1.605 1.033 2.409 1.549 3.072 1.502a2 2 0 0 0 1.459-.797C14 18.002 14 17.048 14 15.14V8.86c0-1.909 0-2.863-.399-3.396a2 2 0 0 0-1.459-.797c-.663-.047-1.466.47-3.072 1.502L4.187 9.308c-1.393.896-2.09 1.344-2.33 1.914a2 2 0 0 0 0 1.556c.24.57.937 1.018 2.33 1.914Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), es = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 10 19.92 10 18.8 10H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 8.48 2 7.92 2 6.8V5.2ZM2 17.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 14 4.08 14 5.2 14h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C14 15.52 14 16.08 14 17.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.48 22 11.92 22 10.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8v-1.6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ts = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 9h3M9 9a3 3 0 1 0 0 6m0-6a3 3 0 0 1 0-6h3m0 6v6m0-6h3m-3 0V3M9 15h3m-3 0a3 3 0 1 0 3 3v-3m0-12h3a3 3 0 1 1 0 6m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ns = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M9 17h1l1.5-3 1.5 3h2m5-6.686V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3m-10 6.5L11 16l4-4m5-1.686V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), is = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M11 11l-2 2 2 2m2-2 2 2-2 2m7-6.686V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), as = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10 16 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m0-13.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3m.5 2.314V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), os = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M12 11v6m0 0 2.5-2.5M12 17l-2.5-2.5M20 10.314V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ss = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 11V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41V11m0 4v1.5c0 .464 0 .697-.015.892a5 5 0 0 1-4.593 4.593c-.195.015-.428.015-.892.015v0H14M4 15v1.5c0 .464 0 .697.015.892a5 5 0 0 0 4.593 4.593c.196.015.428.015.892.015v0h.5m4-19.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3m-7.716 8.81-2.587-2.263a1.662 1.662 0 0 1 2.092-2.58v0c.421.316 1 .316 1.422 0v0a1.662 1.662 0 0 1 2.092 2.58l-2.587 2.264a.329.329 0 0 1-.432 0ZM20 10.315V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ls = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H10m2-6v-1m0 7v1m8-7.686V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), us = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 14h5M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3m.5 2.314V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ds = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M9 14h6m0 0-2.5 2.5M15 14l-2.5-2.5m7.5-1.186V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 14H12m0 0h2.5M12 14v-2.5m0 2.5v2.5m2-14v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3m.5 2.314V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ps = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 12V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41V12m0 4v.5c0 .464 0 .697-.015.892a5 5 0 0 1-4.593 4.593c-.195.015-.428.015-.892.015h-5c-.464 0-.696 0-.892-.015a5 5 0 0 1-4.593-4.593C4 17.197 4 16.964 4 16.5v0-.5M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M2 12h20",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ms = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 12V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41V12M2 12h20M6 19v-3m4 6v-6m4 6v-6m4 3v-3M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6.887 2.469C7.89 2 9.187 2 11.778 2c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.222.222c1.02 1.02 1.53 1.53 1.87 2.14a5 5 0 0 1 .438 1.06C20 8.372 20 9.093 20 10.536V16M2 2l2.609 2.609M22 22l-2.609-2.609m0 0a5 5 0 0 1-2.121 2.064C16.2 22 14.8 22 12 22c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891.044-.095.09-.187.14-.278M19.39 19.39 4.61 4.61M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M9 12h6m-6 4h4m7-5.686V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _s = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3M12 17v-6m0 0 2.5 2.5M12 11l-2.5 2.5M20 10.314V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.5v2.3c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 8 16.08 8 17.2 8h2.3m.5 2.314V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14V9.778c0-2.591 0-3.887.469-4.891a5 5 0 0 1 2.418-2.418C7.89 2 9.187 2 11.778 2v0c1.133 0 1.699 0 2.233.119a5 5 0 0 1 1.604.664c.462.294.862.695 1.663 1.495l.379.379c.865.865 1.297 1.297 1.606 1.802.274.447.476.935.599 1.445.138.575.138 1.187.138 2.41Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ys = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.5 7h19m-5.2-4.5L19 7m-8.5-5 3 5m-8-4.5L8 7m-.5 10a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m3.5 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0 0h10M6.5 12a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m13 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-5-6a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 12a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m2.5-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 21.5v-19m8 0v19M2.5 12h19m-19-5H8m8 0h5.5M16 17h5.5m-19 0H8m2 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ss = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19.365 2H4.635C3.732 2 3 2.732 3 3.635a6.54 6.54 0 0 0 2.738 5.321l1.929 1.377h0c.642.459.963.688 1.222.959a4 4 0 0 1 1.041 2.024c.07.368.07.762.07 1.551V20a2 2 0 1 0 4 0v-5.133c0-.789 0-1.183.07-1.551a3.999 3.999 0 0 1 1.041-2.024c.26-.27.58-.5 1.222-.959l1.929-1.377A6.54 6.54 0 0 0 21 3.635C21 2.732 20.268 2 19.365 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8h10m-8 4h6m-4 4h2m-1.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ws = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 6h18M6 12h12m-8 6h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Ts = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 12.07C19 8.167 15.866 5 12 5c-.995 0-1.943.21-2.8.588m-2.8 2.24A7.086 7.086 0 0 0 5 12.071c0 3.42 2.405 6.274 5.6 6.929m7.464-3.394A7.014 7.014 0 0 1 13.4 19M12 8a4 4 0 0 0-3.333 6.212m6-5.193a4 4 0 0 1-4 6.754M12 11v2m-2 9h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Es = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0-5.523-4.477-10-10-10a9.966 9.966 0 0 0-4 .832M4 6a9.956 9.956 0 0 0-2 6c0 4.838 3.436 8.873 8 9.8M20.662 17A10.013 10.013 0 0 1 14 21.8M12 6a6 6 0 0 0-5 9.318m9-7.79a6 6 0 0 1-6 10.13M12 10v4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ds = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 10.714C18 7.558 15.314 5 12 5c-.796 0-1.555.147-2.25.415M13.875 19C16.27 18.25 18 16.103 18 13.57M10.125 19C7.73 18.25 6 16.103 6 13.57v-2.856c0-1.351.493-2.593 1.316-3.571M12 11v2m-3 .333v-2.666C9 9.194 10.343 8 12 8m2.599 1.333c.255.393.401.848.401 1.334v2.666C15 14.806 13.657 16 12 16c-.546 0-1.059-.13-1.5-.357M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Os = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 10A8 8 0 0 0 9 2.582m5.5 19.02A8.004 8.004 0 0 0 20 14M9.5 21.602A8.003 8.003 0 0 1 4 14v-4c0-1.892.657-3.63 1.755-5M12 10v4m-4 0v-4a4 4 0 0 1 4-4m3.465 2c.34.588.535 1.271.535 2v4a4 4 0 0 1-6 3.465",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ks = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 14c0 4.546 3.5 8 8 8s8-3.454 8-8c0-8.182-8-12-8-12 0 4 1 10-2 10-2 0-2.5-2-2.5-5.5C7.5 6.5 4 9.455 4 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), As = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-4-8h4m-4-4h4M6 14h12M7.6 10h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 6 8.96 6 8.4 6h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 6.76 6 7.04 6 7.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C6.76 10 7.04 10 7.6 10ZM10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), js = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21h18M13 3h8m-8 6h8M3 15h18M5.4 9h1.2c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .656-.656C9 7.861 9 7.441 9 6.601V5.4c0-.841 0-1.261-.163-1.582a1.5 1.5 0 0 0-.656-.655C7.861 3 7.441 3 6.601 3H5.4c-.84 0-1.26 0-1.582.164a1.5 1.5 0 0 0-.655.655C3 4.14 3 4.56 3 5.4v1.2c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.656C4.14 9 4.56 9 5.4 9Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ms = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-4-8h4m-4-4h4M6 14h12m-8-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 14h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ns = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21h18M13 3h8m-8 6h8M3 15h18M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ps = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-4-8h4m-4-4h4M6 14h12M8 10V6m0 0H6m2 0h2m0 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 9V3m0 0h3M6 3H3m0 18h18M13 3h8m-8 6h8M3 15h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Is = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 4v11M5 4V2m0 2 1.32-.33a6.67 6.67 0 0 1 5.05.752v0a6.67 6.67 0 0 0 5.54.608L20 4v11l-3.09 1.03a6.67 6.67 0 0 1-5.54-.609v0a6.67 6.67 0 0 0-5.05-.75L5 15m0 7v-7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ls = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 4v12M5 4V2m0 2c8 0 7 4 15 4-2 8-12 3-15 8m0 6v-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 4h15l-1.569 3.138c-.525 1.05-.787 1.574-.89 2.124a4.003 4.003 0 0 0 0 1.476c.103.55.365 1.075.89 2.124L20 16H5M5 4v12M5 4V2m0 20v-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 14 3 3m9-8 2-2c.545-.545.818-.818.964-1.112a2 2 0 0 0 0-1.776C21.818 3.818 21.545 3.545 21 3v0c-.545-.545-.818-.818-1.112-.964a2 2 0 0 0-1.776 0c-.294.146-.567.419-1.112.964l-2 2m-.475 14.474 2.95-2.948c1.584-1.585 2.376-2.377 2.672-3.29a4 4 0 0 0 0-2.472c-.296-.913-1.088-1.705-2.672-3.29l-.95-.949c-1.584-1.584-2.376-2.376-3.289-2.672a4 4 0 0 0-2.472 0c-.913.296-1.705 1.088-3.29 2.672l-2.949 2.95c-1.584 1.584-2.376 2.376-2.672 3.289a4 4 0 0 0 0 2.472c.296.913 1.088 1.705 2.672 3.29l.95.948c1.584 1.585 2.376 2.377 3.289 2.673a4 4 0 0 0 2.472 0c.913-.296 1.705-1.088 3.29-2.672Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Bs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 14 2 2 4.5-4.5M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vs = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M7 14a3 3 0 0 0 3 3h4a2 2 0 1 0 0-4v0c-.556 0-1.222-.263-1.54-.718A3 3 0 0 0 7 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Hs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 6.5V7a2 2 0 1 1-4 0V6m2 7v1m0 3v1M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Us = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 16.5 12 14m0 0 2.5-2.5M12 14l-2.5-2.5M12 14l2.5 2.5M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ws = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 11v6m0 0 2.5-2.5M12 17l-2.5-2.5M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gs = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M8.5 14.5 11 17a1.414 1.414 0 0 0 2 0l2.5-2.5a2.121 2.121 0 0 0-3-3v0a.707.707 0 0 1-1 0v0a2.121 2.121 0 0 0-3 3Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ks = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 14h6M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 14h6m0 0-2.5 2.5M15 14l-2.5-2.5M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Js = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13 15.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 0V10l2 2M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ys = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 22H6.8c-1.68 0-2.52 0-3.162-.328a3 3 0 0 1-1.311-1.31C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.31-1.312C4.28 2 5.12 2 6.8 2h.964c.369 0 .553 0 .723.019a3 3 0 0 1 2.172 1.342c.093.144.176.309.34.639v0c.166.33.248.494.342.638a3 3 0 0 0 2.171 1.342c.17.02.355.02.724.02h1.763c.93 0 1.396 0 1.777.102a3 3 0 0 1 2.122 2.12C20 8.605 20 9.07 20 10v0M6 22l1.331-7.99c.238-1.424.357-2.136.712-2.671a3 3 0 0 1 1.27-1.076C9.9 10 10.621 10 12.066 10h7.156c1.3 0 1.95 0 2.412.265a2 2 0 0 1 .88 1.039c.185.5.078 1.14-.135 2.422l-.71 4.263c-.238 1.425-.357 2.137-.713 2.672a3.001 3.001 0 0 1-1.27 1.076c-.585.263-1.308.263-2.753.263H6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 10.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M15 14a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 14h3m0 0h3m-3 0v-3m0 3v3M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qs = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.172 20.828C2 19.657 2 17.771 2 14V7.562c0-2.405 0-3.608.65-4.427a3 3 0 0 1 .485-.485C3.955 2 5.157 2 7.562 2h.755c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.336c1.168 0 2.083 0 2.824.05m3.43 1.81c.621.98.621 2.325.621 5.015V14c0 3.771 0 5.657-1.172 6.828C19.657 22 17.771 22 14 22H7M22 2l-4.05 4.05M1 23 17.95 6.05",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $s = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 17v-6m0 0 2.5 2.5M12 11l-2.5 2.5M6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ec = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h1.517c.801 0 1.202 0 1.564.091a3 3 0 0 1 1.538.95c.243.284.422.642.781 1.359v0c.239.478.359.717.52.906a2 2 0 0 0 1.026.633c.241.061.508.061 1.043.061h.811c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 9.04 22 10.16 22 12.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V6.8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18.71 10A7 7 0 1 1 17 7.101L16 4M9.5 9.5v5m3.5 0v0a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 13 9.5v0a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5ZM10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12A9.98 9.98 0 0 1 12 2c6.667 0 10 5.556 10 5.556v-5M9 9v6m4.5 0v0a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 13.5 9v0a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18.71 10A7 7 0 1 1 17 7.101L16 4m-4.5 10.5h3V12h-3V9.5h3m-5 0v5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ic = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12A9.98 9.98 0 0 1 12 2c6.667 0 10 5.556 10 5.556v-5M9 9v6m3 0h3v-3h-3V9h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ac = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18.71 10A7 7 0 1 1 17 7.101L16 4m-5.5 10.5h3V12h-3V9.5h3M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12A9.98 9.98 0 0 1 12 2c6.667 0 10 5.556 10 5.556v-5M10 15h4v-3h-4V9h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m14 11-3-3m3 3-3 3m3-3H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 12.52 6 13.08 6 14.2V16m9-8 3 3-3 3m-5 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m17 5 5 5-5 5m1-5-5-5m5 5-5 5m5-5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 11.52 2 12.08 2 13.2V17",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m18 11-3-3m3 3-3 3m3-3h-7.333A4.667 4.667 0 0 0 6 15.667V16m4 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m22 11-5-5m5 5-5 5m5-5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 14.04 2 15.16 2 17.4v.6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 8h12M8 6v12m8-12v12M6 16h12m-8 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 5h20M5 2v20M19 2v20M2 19h20",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pc = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M6 9.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C7.52 6 8.08 6 9.2 6h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C16.48 18 15.92 18 14.8 18H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8V9.2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), mc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 9h6V3H6l6 6Zm0 0H6v6m6-6 6 6H6m0 0 6 6v-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 7H8l5.152 5L8 17h8m-6 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 3H5l9.015 9L5 21h14",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _c = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 11.4c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656C3.139 9 3.559 9 4.4 9h1.606c.367 0 .55 0 .723.041.153.037.3.098.433.18.152.093.282.223.54.482L10 12l-2.297 2.297c-.26.26-.39.39-.54.482-.135.082-.281.143-.434.18-.173.041-.356.041-.723.041H4.4c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.656-.655C2 13.861 2 13.441 2 12.6v-1.2ZM22 11.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C20.861 9 20.441 9 19.6 9h-1.606c-.367 0-.55 0-.723.041a1.5 1.5 0 0 0-.433.18c-.152.093-.282.223-.54.482L14 12l2.297 2.297c.26.26.39.39.54.482.135.082.281.143.434.18.173.041.356.041.723.041H19.6c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.74.164-1.581v-1.2ZM11.4 2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656C9 3.139 9 3.559 9 4.4v1.606c0 .367 0 .55.041.723.037.153.098.3.18.433.093.152.223.282.482.54L12 10l2.297-2.297c.26-.26.39-.39.482-.54.082-.135.143-.281.18-.434.041-.173.041-.356.041-.723V4.4c0-.84 0-1.26-.164-1.581a1.5 1.5 0 0 0-.655-.656C13.861 2 13.441 2 12.6 2h-1.2ZM11.4 22c-.84 0-1.26 0-1.581-.163a1.5 1.5 0 0 1-.656-.656C9 20.861 9 20.441 9 19.6v-1.606c0-.367 0-.55.041-.723a1.5 1.5 0 0 1 .18-.433c.093-.152.223-.282.482-.54L12 14l2.297 2.297c.26.26.39.39.482.54.082.135.143.281.18.434.041.173.041.356.041.723V19.6c0 .84 0 1.26-.164 1.581a1.5 1.5 0 0 1-.655.655c-.32.164-.74.164-1.581.164h-1.2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vc = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M4.107 13.313c.1.606.008 1.24-.349 1.74l-1.38 1.933a2 2 0 0 0 .213 2.576l1.847 1.847a2 2 0 0 0 2.577.213l1.932-1.38c.5-.357 1.135-.45 1.741-.35a8.048 8.048 0 0 0 2.624 0c.607-.1 1.241-.007 1.741.35l1.932 1.38a2 2 0 0 0 2.577-.213l1.847-1.847a2 2 0 0 0 .213-2.577l-1.38-1.931c-.357-.5-.45-1.135-.35-1.742a8.065 8.065 0 0 0 0-2.624c-.1-.607-.007-1.241.35-1.741l1.38-1.932a2 2 0 0 0-.213-2.577l-1.847-1.846a2 2 0 0 0-2.577-.213l-1.931 1.379c-.5.357-1.135.45-1.741.35a8.056 8.056 0 0 0-2.626 0c-.606.1-1.24.007-1.74-.35l-1.932-1.38a2 2 0 0 0-2.577.214L2.591 4.438a2 2 0 0 0-.213 2.577l1.38 1.932c.357.5.45 1.134.35 1.74a8.057 8.057 0 0 0 0 2.626Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), yc = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M12 4c-.697 0-1.387-.262-1.814-.813l-.452-.583a2 2 0 0 0-2.58-.507l-1.307.754a2 2 0 0 0-.851 2.489l.279.683c.264.645.147 1.37-.203 1.974v0C4.723 8.6 4.15 9.07 3.46 9.165l-.73.1A2 2 0 0 0 1 11.244v1.51a2 2 0 0 0 1.73 1.98l.73.1c.69.095 1.263.565 1.612 1.168v0c.35.604.467 1.329.203 1.974l-.28.683a2 2 0 0 0 .852 2.49l1.306.754a2 2 0 0 0 2.581-.508l.452-.583C10.613 20.262 11.303 20 12 20v0c.697 0 1.387.262 1.814.813l.452.583a2 2 0 0 0 2.58.507l1.307-.754a2 2 0 0 0 .852-2.489l-.28-.683c-.264-.645-.147-1.37.203-1.974v0c.349-.603.922-1.073 1.612-1.168l.73-.1a2 2 0 0 0 1.73-1.98v-1.51a2 2 0 0 0-1.73-1.98l-.73-.1c-.69-.095-1.263-.565-1.612-1.168v0c-.35-.604-.467-1.329-.203-1.974l.28-.683a2 2 0 0 0-.852-2.49l-1.306-.753a2 2 0 0 0-2.581.507l-.452.583C13.387 3.738 12.697 4 12 4v0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), bc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 11v6.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V11m8-4v15m0-15h3.5a2.5 2.5 0 0 0 0-5h-.08a2.58 2.58 0 0 0-2.472 1.839L12 7Zm0 0H8.5a2.5 2.5 0 0 1 0-5h.08a2.58 2.58 0 0 1 2.472 1.839L12 7Zm-8 4h16a2 2 0 0 0 2-2v0a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12.076C2 6.377 6.274 2 11.839 2 17.443 2 22 6.377 22 12.076c0 4.584-2.742 8.507-6.774 9.87-.524.124-.726-.207-.726-.496 0-.254.035-1.45.035-2.45 0-1-.68-1.918-.68-1.918 2.258-.248 4.637-1.578 4.637-5.543 0-1.156-.403-1.693-1.049-2.436.081-.29.444-1.363-.12-2.808-.847-.29-2.783 1.115-2.783 1.115-.806-.248-1.653-.33-2.54-.33-.847 0-1.694.082-2.5.33 0 0-1.976-1.363-2.782-1.115-.565 1.445-.242 2.519-.121 2.808-.645.743-.968 1.28-.968 2.436 0 3.965 2.298 5.295 4.556 5.543 0 0-.685.78-.685 1.85v2.56c0 .247-.161.578-.685.495C4.782 20.583 2 16.66 2 12.077Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m12 16 8.193-11.47c.584-.818.876-1.226.863-1.567a1 1 0 0 0-.388-.755C20.398 2 19.895 2 18.89 2H5.109c-1.005 0-1.507 0-1.777.208a1 1 0 0 0-.388.755c-.013.34.28.75.863 1.567L12 16Zm0 0v6m0 0H8m4 0h4M7 9h10",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 15v7m0 0H8m4 0h4m-4-7v0a9 9 0 0 0 9-9V3.444C21 2.647 20.353 2 19.556 2H4.444C3.647 2 3 2.647 3 3.444V6a9 9 0 0 0 9 9Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 14V6.713c0-.627 0-.94-.087-1.224a1.999 1.999 0 0 0-.368-.689c-.189-.229-.45-.403-.97-.75L19 3M2 14V6.713c0-.627 0-.94.086-1.224a2 2 0 0 1 .369-.689c.188-.229.449-.403.97-.75L5 3m5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 21h8c.929 0 1.393 0 1.782-.062a5 5 0 0 0 4.156-4.156C22 16.393 22 15.93 22 15v0c0-.929 0-1.393-.062-1.782a5 5 0 0 0-4.156-4.156C17.393 9 16.93 9 16 9H8c-.929 0-1.394 0-1.782.062a5 5 0 0 0-4.156 4.156C2 13.607 2 14.07 2 15v0c0 .929 0 1.393.062 1.782a5 5 0 0 0 4.156 4.156C6.606 21 7.07 21 8 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 16a4 4 0 1 0 8 0 4 4 0 0 0-8 0Zm0 0V7.713c0-.627 0-.94.086-1.224a2 2 0 0 1 .369-.689c.188-.229.449-.403.97-.75L5 4m5 12.5s.5-1 2-1 2 1 2 1m8-.5V7.713c0-.627 0-.94-.087-1.224a2 2 0 0 0-.368-.689c-.189-.229-.45-.403-.97-.75L19 4m3 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ec = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 19c5.523 0 10-4.477 10-10a9.967 9.967 0 0 0-2.859-7M12 19a9.967 9.967 0 0 1-7-2.859M12 19v3m0 0h-2m2 0h2m5-13A7 7 0 1 1 5 9a7 7 0 0 1 14 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10m10-10c0-5.523-4.477-10-10-10m10 10c0-2.21-4.477-4-10-4S2 9.79 2 12m20 0c0 2.21-4.477 4-10 4S2 14.21 2 12m10 10C6.477 22 2 17.523 2 12m10 10c2.21 0 4-4.477 4-10S14.21 2 12 2m0 20c-2.21 0-4-4.477-4-10S9.79 2 12 2M2 12C2 6.477 6.477 2 12 2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 8 5 21M5 3l10 13m3.217-1.23-9.414 5.45c-1.576.912-2.364 1.368-3.01 1.3a2 2 0 0 1-1.41-.813C4 20.181 4 19.271 4 17.45V6.55c0-1.82 0-2.731.382-3.257a2 2 0 0 1 1.41-.813c.647-.068 1.435.388 3.011 1.3l9.414 5.45c1.57.91 2.355 1.364 2.619 1.957a2 2 0 0 1 0 1.626c-.264.593-1.05 1.047-2.62 1.956Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
}), kc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 21a9 9 0 0 1-9-9m9 9a8.972 8.972 0 0 0 6.364-2.636M12 21v2M3 12a8.972 8.972 0 0 1 2.636-6.364M3 12H1m11-9a9 9 0 0 1 9 9m-9-9a8.963 8.963 0 0 0-4 .936M12 3V1m9 11a8.963 8.963 0 0 1-.936 4M21 12h2m-4.636 6.364L22 22m-3.636-3.636-4.235-4.25-4.25-4.235M2 2l3.636 3.636m0 0 4.243 4.243m0 0A2.986 2.986 0 0 0 9 12a3 3 0 0 0 5 2.236",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ac = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9h2m-11 9a9 9 0 0 1-9-9m9 9v2M3 12a9 9 0 0 1 9-9m-9 9H1m11-9V1m3 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v20M2 12h20M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v20m-2 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12h20M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 2v20m1 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 2v20m-5 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ic = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 9v13M2 9h20M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 9h7m0 0h13M9 9v6m0 0v7m0-7h13m-12 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 9v13M2 9h20M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 9h7m0 0h6M9 9v13m6-13h7m-7 0v13m-5 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 9v13M2 9h20M2 15h20m-12 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 12h13M9 2v20m6-20v20m-5 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 2v20M2 12h20M15 2v20m-5 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 2v20m6-20v20m-5 0h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 9h20M2 15h20m-12 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v20M2 9h10m0 6h10m-12 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 2v20m6-20v20M2 15h20M2 9h20M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 17v-1.453c0-.205 0-.307.007-.41a3 3 0 0 1 .03-.27c.017-.1.04-.2.086-.4l1.732-7.506c.409-1.771.613-2.657 1.095-3.318a4 4 0 0 1 1.663-1.322C7.365 2 8.273 2 10.09 2h3.818c1.817 0 2.726 0 3.478.32a4 4 0 0 1 1.663 1.323c.482.661.686 1.547 1.095 3.318l1.732 7.506c.046.2.07.3.085.4.015.09.025.18.031.27.007.103.007.205.007.41V17m-11 1h6M7 18h.01m.49 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM6 22h12c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C22 19.395 22 18.93 22 18v0c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C19.395 14 18.93 14 18 14H6c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C2 16.605 2 17.07 2 18v0c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C4.605 22 5.07 22 6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m11 8-1 8m4-8-1 8m-4.5-5.5H16m-8 3h7.5M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10.5 7-1 10m5-10-1 10m-5.875-7H17M7 14h9.375M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 3 8 21m8-18-2 18M3 9h18M2 15h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 13V9a7 7 0 0 0-7-7v0a7 7 0 0 0-7 7v4m17 6v-3c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C20.398 13 19.932 13 19 13v0c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C16 14.602 16 15.068 16 16v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C17.602 22 18.068 22 19 22v0c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C22 20.398 22 19.932 22 19ZM5 22v0c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C8 20.398 8 19.932 8 19v-3c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C6.398 13 5.932 13 5 13v0c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C2 14.602 2 15.068 2 16v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C3.602 22 4.068 22 5 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qc = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 17v-5c0-5.523-4.477-10-10-10v0C6.477 2 2 6.477 2 12v5m20 2v-3c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C20.398 13 19.932 13 19 13v0c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C16 14.602 16 15.068 16 16v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C17.602 22 18.068 22 19 22v0c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C22 20.398 22 19.932 22 19ZM5 22v0c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C8 20.398 8 19.932 8 19v-3c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C6.398 13 5.932 13 5 13v0c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C2 14.602 2 15.068 2 16v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C3.602 22 4.068 22 5 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $c = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 2 2.312 2.312M21 21l-3.494-3.494m0 0C15.093 19.703 12.51 21 12 21 11 21 2 16 2 9c0-1.968.948-3.62 2.312-4.688m13.194 13.194L4.312 4.312M19.798 15c.068-.092.136-.186.202-.28 1.177-1.668 2-3.603 2-5.72 0-3.5-3-5.957-6-6-1.5-.022-3 .5-4 2-1-1.5-2.526-2-4-2-.167 0-.334.008-.5.023",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), el = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 21c1 0 10-5 10-12 0-3.5-3-5.956-6-6-1.5-.021-3 .5-4 2-1-1.5-2.526-2-4-2-3 0-6 2.5-6 6 0 7 9 12 10 12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11.5 10v.264c0 1.37.774 2.623 2 3.236v0M6 12a6 6 0 1 0 6-6C9.78 6 8 7 6.5 8.5l1-3.5m4.1 17h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 4.97 4 10 10 10s10-4 10-10S18 2 12 2 2 7 2 7m0 0V3m0 4h3.5M12 8v4l3 2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 16h6M7.002 3.998l-2 1.6C3.9 6.48 3.35 6.921 2.952 7.468a5 5 0 0 0-.772 1.607C2 9.727 2 10.433 2 11.845V14c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-2.155c0-1.412 0-2.118-.18-2.77a5.001 5.001 0 0 0-.772-1.606c-.397-.548-.948-.989-2.05-1.871l-2-1.6c-1.784-1.427-2.676-2.14-3.665-2.414a5 5 0 0 0-2.666 0c-.99.274-1.881.987-3.665 2.414Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), il = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 22v-7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C13.398 12 12.932 12 12 12v0c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C9 13.602 9 14.068 9 15v7M7.002 3.998l-2 1.6C3.9 6.48 3.35 6.921 2.952 7.468a5 5 0 0 0-.772 1.607C2 9.727 2 10.433 2 11.845V14c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-2.155c0-1.412 0-2.118-.18-2.77a5.001 5.001 0 0 0-.772-1.606c-.397-.548-.948-.989-2.05-1.871l-2-1.6c-1.784-1.427-2.676-2.14-3.665-2.414a5 5 0 0 0-2.666 0c-.99.274-1.881.987-3.665 2.414Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), al = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2.5 9.5 1.471 7.355c.367 1.833.55 2.75 1.028 3.435a4 4 0 0 0 1.678 1.375c.766.335 1.7.335 3.57.335h3.506c1.87 0 2.804 0 3.57-.335A4 4 0 0 0 19 20.29c.478-.686.661-1.602 1.028-3.435L21.5 9.5M1 11l6.475-6.475C9.059 2.941 9.85 2.15 10.764 1.853a4 4 0 0 1 2.472 0c.913.296 1.705 1.088 3.29 2.672L23 11m-8 1a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ol = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 17v-5.155c0-1.412 0-2.118-.18-2.77a5.001 5.001 0 0 0-.772-1.606c-.397-.548-.948-.989-2.05-1.871l-2-1.6c-1.784-1.427-2.676-2.14-3.665-2.414a5 5 0 0 0-2.666 0c-.99.274-1.881.987-3.665 2.414l-2 1.6C3.9 6.48 3.35 6.921 2.952 7.468a5 5 0 0 0-.772 1.607C2 9.727 2 10.433 2 11.845V17a5 5 0 0 0 5 5 2 2 0 0 0 2-2v-4a3 3 0 0 1 6 0v4a2 2 0 0 0 2 2 5 5 0 0 0 5-5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12h3.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 15.04 12 16.16 12 18.4V22m-3.6 0h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 16 1.25-2.5M14 16l-1.25-2.5M16.5 16v-4m.5-3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-8.75 4.5h5.5m-5.5 0L10 8l2.75 5.5M2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ll = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 22H5.861c-1.909 0-2.863 0-3.396-.399a2 2 0 0 1-.797-1.459c-.047-.663.47-1.466 1.502-3.072l3.138-4.883c.896-1.393 1.344-2.09 1.914-2.33a2 2 0 0 1 1.556 0c.57.24 1.018.937 1.914 2.33l2.808 4.369M18 22h.139c1.909 0 2.863 0 3.396-.399a2 2 0 0 0 .797-1.459c.047-.663-.47-1.466-1.502-3.072l-.638-.994c-.896-1.394-1.344-2.09-1.914-2.33a2 2 0 0 0-1.556 0c-.57.24-1.018.936-1.914 2.33l-.308.48M18 22l-3.5-5.444M20 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ul = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 18 3.77-3.77c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6.4 14h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2.5 18.5 4.27-4.27c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M15 6l2 2 4-4m-9-2h-.5v0c-3.266 0-4.899 0-6.154.619A6 6 0 0 0 2.62 5.346C2 6.601 2 8.234 2 11.5v.9c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.9c3.266 0 4.899 0 6.154-.619a6 6 0 0 0 2.727-2.727C22 17.399 22 15.766 22 12.5v0-.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2.5 18.5 4.27-4.27c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M20 8l-2-2m0 0-2-2m2 2-2 2m2-2 2-2m-8-2h-.5v0c-3.266 0-4.899 0-6.154.619A6 6 0 0 0 2.62 5.346C2 6.601 2 8.234 2 11.5v.9c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.9c3.266 0 4.899 0 6.154-.619a6 6 0 0 0 2.727-2.727C22 17.399 22 15.766 22 12.5v0-.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 18 3.77-3.77c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M17 3v6m0 0-2.5-2.5M17 9l2.5-2.5M12 2h-.5v0c-3.266 0-4.899 0-6.154.619A6 6 0 0 0 2.62 5.346C2 6.601 2 8.234 2 11.5v.9c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.9c3.266 0 4.899 0 6.154-.619a6 6 0 0 0 2.727-2.727C22 17.399 22 15.766 22 12.5v0-.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ml = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2h-.5v0c-3.266 0-4.899 0-6.154.619A6 6 0 0 0 2.62 5.346C2 6.601 2 8.234 2 11.5v.9c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.9c3.266 0 4.899 0 6.154-.619a6 6 0 0 0 2.727-2.727C22 17.399 22 15.766 22 12.5v0-.5m-.5 5.688-1.425-1.425c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.645 1.337l-1.064 1.063M2.5 18.5l4.27-4.27c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m0 0L18.5 21.34M14 10l.12-.6c.141-.706.212-1.06.341-1.389.115-.292.263-.57.443-.827.202-.29.457-.545.966-1.054L18 4a1.414 1.414 0 0 1 2 0v0a1.414 1.414 0 0 1 0 2l-2.13 2.13c-.51.51-.764.764-1.054.966-.257.18-.535.328-.827.443-.33.13-.683.2-1.39.341L14 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2.5 18.5 4.27-4.27c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M18 9V6m0 0V3m0 3h-3m3 0h3m-9-4h-.5v0c-3.266 0-4.899 0-6.154.619A6 6 0 0 0 2.62 5.346C2 6.601 2 8.234 2 11.5v.9c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.9c3.266 0 4.899 0 6.154-.619a6 6 0 0 0 2.727-2.727C22 17.399 22 15.766 22 12.5v0-.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 2 1.757 1.757M22 22l-1.757-1.757m0 0c-.37.369-.787.69-1.243.953C17.608 22 15.739 22 12 22c-3.738 0-5.608 0-7-.804A6 6 0 0 1 2.804 19C2 17.608 2 15.739 2 12c0-3.738 0-5.608.804-7a6 6 0 0 1 .953-1.243m16.486 16.486L3.757 3.757M7 2.172C8.197 2 9.764 2 12 2c3.739 0 5.608 0 7 .804A6 6 0 0 1 21.196 5C22 6.392 22 8.262 22 12c0 2.236 0 3.803-.172 5M3 18l2.737-2.737c.792-.792 1.188-1.188 1.645-1.337a2 2 0 0 1 1.236 0c.457.149.853.545 1.645 1.337L16.5 21.5M18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _l = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2.5 18.5 4.27-4.27c.782-.782 1.173-1.173 1.624-1.322A2 2 0 0 1 9.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M18 9V3m0 0-2.5 2.5M18 3l2.5 2.5M12 2h-.5v0c-3.266 0-4.899 0-6.154.619A6 6 0 0 0 2.62 5.346C2 6.601 2 8.234 2 11.5v.9c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22h.9c3.266 0 4.899 0 6.154-.619a6 6 0 0 0 2.727-2.727C22 17.399 22 15.766 22 12.5v0-.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m14 17-2.237-2.237c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 0 0-1.236 0c-.457.149-.853.545-1.645 1.337L5 17l-.5.5M14 17l.737-.737c.792-.792 1.188-1.188 1.645-1.337a2 2 0 0 1 1.236 0c.457.149.853.545 1.645 1.337L20 17m-6 0 3 3M16 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 8h.5v0c1.396 0 2.093 0 2.661.172a4 4 0 0 1 2.667 2.667C22 11.407 22 12.104 22 13.5v2.1c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6v-2.1c0-1.396 0-2.093.172-2.661A4 4 0 0 1 4.84 8.172C5.407 8 6.104 8 7.5 8v0H8m4-6v15m0 0 4-4m-4 4-4-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2.2c-.646-.131-1.315-.2-2-.2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.685-.069-1.354-.2-2M10 14 20 4M10 14V9m0 5h5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2v15m0 0 4-4m-4 4-4-4m1 9h6a7 7 0 0 0 7-7v0a7 7 0 0 0-7-7H9a7 7 0 0 0-7 7v0a7 7 0 0 0 7 7Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 14v1.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 18.96 2 17.84 2 15.6V14M12 2v12m0 0 4-4m-4 4-4-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.5 14h2.787c.626 0 .94 0 1.224.086a2 2 0 0 1 .688.369c.23.188.403.449.75.97l.1.15c.348.521.522.782.751.97a2 2 0 0 0 .689.369c.284.086.597.086 1.223.086h2.575c.626 0 .94 0 1.224-.086a2 2 0 0 0 .688-.369c.23-.189.403-.449.75-.97l.1-.15c.348-.521.522-.782.751-.97.203-.167.437-.292.689-.369.284-.086.597-.086 1.223-.086H21.5M9 7h6m-5 4h4M3.485 8.06l-.616 2.464c-.14.562-.21.843-.267 1.123a12 12 0 0 0 0 4.706c.056.28.126.561.267 1.123v0c.175.7.262 1.05.38 1.35a5 5 0 0 0 4.012 3.133c.32.041.68.041 1.402.041h6.674c.721 0 1.082 0 1.402-.041a5 5 0 0 0 4.011-3.133c.118-.3.206-.65.38-1.35v0c.141-.562.212-.843.268-1.123.31-1.553.31-3.153 0-4.706-.056-.28-.127-.561-.267-1.123l-.616-2.464c-.542-2.167-.813-3.25-1.417-4.057a5 5 0 0 0-2.065-1.613C16.103 2 14.987 2 12.753 2h-1.507c-2.233 0-3.35 0-4.279.39a5 5 0 0 0-2.065 1.613c-.604.807-.875 1.89-1.417 4.057Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), wl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15.5 3h.5v0a3.928 3.928 0 0 1 3.79 2.894l1.243 4.562c.14.515.211.772.269 1.029.375 1.659.393 3.378.054 5.045-.053.257-.118.516-.247 1.034v0c-.154.616-.231.924-.331 1.19a5 5 0 0 1-4.115 3.214c-.283.032-.6.032-1.236.032H8.573c-.636 0-.954 0-1.236-.032a5 5 0 0 1-4.115-3.213c-.1-.267-.177-.575-.331-1.191v0a25.13 25.13 0 0 1-.247-1.034 12 12 0 0 1 .054-5.046c.058-.256.128-.513.268-1.028l1.245-4.562A3.928 3.928 0 0 1 8 3v0h.5m-6 11h2.787c.627 0 .94 0 1.224.086a2 2 0 0 1 .689.369c.229.188.403.449.75.97l.1.15c.347.521.521.782.75.97a2 2 0 0 0 .69.369c.283.086.596.086 1.223.086h2.574c.627 0 .94 0 1.224-.086a2 2 0 0 0 .689-.369c.229-.189.403-.449.75-.97l.1-.15c.347-.521.521-.782.75-.97a2 2 0 0 1 .69-.369c.283-.086.596-.086 1.223-.086H21.5M12 11l3-3m-3 3L9 8m3 3V2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15.5 8h.916c.705 0 1.058 0 1.378.07a3 3 0 0 1 1.682 1.04c.206.255.364.57.68 1.201l.254.509c.263.526.394.789.503 1.053a8 8 0 0 1 .488 4.44c-.05.28-.12.566-.264 1.137v0c-.18.725-.271 1.087-.395 1.398a5 5 0 0 1-3.98 3.108c-.332.044-.705.044-1.453.044H8.69c-.747 0-1.12 0-1.452-.044a5 5 0 0 1-3.98-3.108c-.124-.31-.214-.673-.396-1.398v0c-.142-.57-.214-.856-.263-1.137a8 8 0 0 1 .487-4.44c.11-.264.241-.527.504-1.053l.254-.509c.316-.63.474-.946.68-1.201a3 3 0 0 1 1.682-1.04C6.526 8 6.879 8 7.584 8H8.5M3 14h2.287c.626 0 .94 0 1.224.086a2 2 0 0 1 .688.369c.23.188.404.449.75.97l.1.15c.348.521.522.782.751.97a2 2 0 0 0 .689.369c.284.086.597.086 1.223.086h2.575c.626 0 .94 0 1.224-.086a2 2 0 0 0 .688-.369c.23-.189.403-.449.75-.97l.1-.15c.348-.521.522-.782.751-.97.203-.167.438-.292.689-.369.284-.086.597-.086 1.223-.086H21M12 2l3 3m-3-3L9 5m3-3v9",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), El = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.5 14h2.787c.626 0 .94 0 1.224.086a2 2 0 0 1 .688.369c.23.188.404.449.75.97l.1.15c.348.521.522.782.751.97a2 2 0 0 0 .689.369c.284.086.597.086 1.223.086h2.575c.626 0 .94 0 1.224-.086a2 2 0 0 0 .688-.369c.23-.189.403-.449.75-.97l.1-.15c.348-.521.522-.782.751-.97.203-.167.438-.292.689-.369.284-.086.597-.086 1.223-.086H21.5M3.485 8.06l-.616 2.464c-.14.562-.21.843-.267 1.123a12 12 0 0 0 0 4.706c.056.28.126.561.267 1.123v0c.175.7.262 1.05.38 1.35a5 5 0 0 0 4.012 3.133c.32.041.68.041 1.402.041h6.674c.721 0 1.082 0 1.402-.041a5 5 0 0 0 4.012-3.133c.117-.3.205-.65.38-1.35v0c.14-.562.21-.843.267-1.123a12 12 0 0 0 0-4.706c-.056-.28-.127-.561-.267-1.123l-.616-2.464c-.542-2.167-.813-3.25-1.416-4.057a5 5 0 0 0-2.066-1.613C16.103 2 14.987 2 12.753 2h-1.507c-2.233 0-3.35 0-4.279.39a5 5 0 0 0-2.065 1.613c-.604.807-.875 1.89-1.417 4.057Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Dl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-6-4h6m-6-4h6M6 6h12M8 10l-2 2 2 2m2 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ol = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 9-3 3 3 3m-3 6h18M11 9h10m-10 6h10M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-7-8h7m-7-4h7M6 14h12M6 6l2 2-2 2m4 12h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Al = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21h18M12 3h9m-9 6h9M4 3l3 3-3 3m-1 6h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-7-4h7m-7-4h7M6 6h12M6 10l2 2-2 2m4 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ml = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21h18M11 9h10m-10 6h10M3 3h18M3 9l3 3-3 3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 9.17A3 3 0 1 1 12 12a3 3 0 1 0-2 2.83M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 16a5 5 0 1 1 2-4 5 5 0 1 0 2-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 16v-5m.5-3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Il = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 6a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-1 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-6 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ll = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 12V2l-2.713 1.206c-.611.271-.917.407-1.226.441a2 2 0 0 1-.997-.146c-.287-.12-.541-.338-1.05-.774v0c-.674-.578-1.011-.867-1.384-.991a2 2 0 0 0-1.26 0c-.373.124-.71.413-1.385.991v0c-.508.436-.762.653-1.049.774a2 2 0 0 1-.997.146c-.31-.034-.615-.17-1.226-.441L2 2v13.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22H20m-2-10h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 13.52 22 14.08 22 15.2V20a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v-8Zm-6-2h-2m0 0h-.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H10m0-6V9m0 7H8m2 0v1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 3.52 10 4.08 10 5.2v13.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 22 7.92 22 6.8 22H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.48 2 19.92 2 18.8V5.2ZM14 5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 2 16.08 2 17.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 14 19.92 14 18.8 14h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 12.48 14 11.92 14 10.8V5.2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m20 2-8.5 8.5M14 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm8-10-3.5 3.5-5-1L19 3l3 3Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 11h4M6 7h.05M10 7h.05M14 7h.05M18 7h.05M18 11h.05M6 11h.05M9 20l.737.737c.792.792 1.188 1.188 1.645 1.337a2 2 0 0 0 1.236 0c.457-.149.853-.545 1.645-1.337L15 20M6.25 7a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-12 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm2.15 5h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 12.96 22 11.84 22 9.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 16 6.16 16 8.4 16Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 11h4M6 7h.05M10 7h.05M14 7h.05M18 7h.05M18 11h.05M6 11h.05M9 22l.737-.737c.792-.792 1.188-1.188 1.645-1.337a2 2 0 0 1 1.236 0c.457.149.853.545 1.645 1.337L15 22M6.25 7a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-12 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm2.15 5h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 12.96 22 11.84 22 9.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 16 6.16 16 8.4 16Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 14h4m-8-4h.05M10 10h.05M14 10h.05M18 10h.05M18 14h.05M6 14h.05m.2-4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm4 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-12 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm2.15 5h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 15.96 22 14.84 22 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 5 17.84 5 15.6 5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 8.04 2 9.16 2 11.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 19 6.16 19 8.4 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ul = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 13H7l4-4v4Zm0 0v2m2.5-6v4m0 0v2m0-2 .875-1m0 0L17 9m-2.625 3L17 15m-7 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 12V9h4m-4 3v3h4m-4-3h4m-4 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 9v3m0 0v3m0-3h4m0 0V9m0 3v3m2.5-6v6h1a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3h-1ZM10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 9v3m0 0v3m0-3h4m0 0V9m0 3v3m5 0 1 1m-3.5-5v2a2 2 0 1 0 4 0v-2a2 2 0 1 0-4 0ZM10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ql = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 17V9.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C17.96 3 16.84 3 14.6 3H9.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 6.04 3 7.16 3 9.4V17m1.556 4h14.888A3.556 3.556 0 0 0 23 17.444v0a.444.444 0 0 0-.444-.444H1.444a.444.444 0 0 0-.444.444v0A3.556 3.556 0 0 0 4.556 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m22 13-5.707 2.853c-1.574.787-2.361 1.181-3.187 1.336a6 6 0 0 1-2.212 0c-.826-.155-1.613-.549-3.187-1.336L2 13m20 5-5.707 2.853c-1.574.787-2.361 1.181-3.187 1.336a6 6 0 0 1-2.212 0c-.826-.155-1.613-.549-3.187-1.336L2 18m3.724-8.138 3.414 1.707c1.05.525 1.574.787 2.124.89.488.092.988.092 1.476 0 .55-.103 1.075-.365 2.124-.89l3.414-1.707c1.842-.921 2.763-1.382 3.059-2.005a2 2 0 0 0 0-1.714c-.296-.623-1.217-1.084-3.06-2.005L14.863 2.43c-1.05-.525-1.574-.787-2.124-.89a4 4 0 0 0-1.476 0c-.55.103-1.075.365-2.124.89L5.724 4.138c-1.842.921-2.763 1.382-3.059 2.005a2 2 0 0 0 0 1.714c.296.623 1.217 1.084 3.06 2.005Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6v6m0-6H9m3 0h3m4 10H5m14 0-2-2m2 2-2 2M5 16l2-2m-2 2 2 2m3 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3v10m0-10H7m5 0h5m5 16H2m20 0-2.5-2.5M22 19l-2.5 2.5M2 19l2.5-2.5M2 19l2.5 2.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zl = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 17V7m12 10V7m-9 8 1.2-2.4m0 0L12 9l1.8 3.6m-3.6 0s.6.6 1.8.6c1.2 0 1.8-.6 1.8-.6m0 0L15 15m-5 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ql = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 21V3m20 18V3M7 17l2-4m0 0 3-6 3 6m-6 0s1 1 3 1 3-1 3-1m0 0 2 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $l = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m19.071 4.929.53-.53-.53.53Zm-4.601 3.54a.75.75 0 0 0 1.06 1.061l-1.06-1.06ZM9.53 15.53a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-1.06-6a.75.75 0 0 0 1.06-1.06L8.47 9.53Zm7.06 4.94a.75.75 0 1 0-1.06 1.06l1.06-1.06ZM12 21.25a9.219 9.219 0 0 1-6.54-2.71l-1.061 1.061A10.719 10.719 0 0 0 12 22.75v-1.5Zm-6.54-2.71A9.219 9.219 0 0 1 2.75 12h-1.5c0 2.968 1.204 5.657 3.149 7.601l1.06-1.06ZM21.25 12a9.218 9.218 0 0 1-2.71 6.54l1.061 1.061A10.719 10.719 0 0 0 22.75 12h-1.5Zm-2.71 6.54A9.218 9.218 0 0 1 12 21.25v1.5c2.968 0 5.657-1.204 7.601-3.149l-1.06-1.06ZM12 2.75a9.219 9.219 0 0 1 6.54 2.71l1.061-1.061A10.719 10.719 0 0 0 12 1.25v1.5Zm6.54 2.71A9.219 9.219 0 0 1 21.25 12h1.5c0-2.968-1.204-5.657-3.149-7.601l-1.06 1.06ZM2.75 12a9.219 9.219 0 0 1 2.71-6.54L4.398 4.398A10.719 10.719 0 0 0 1.25 12h1.5Zm2.71-6.54A9.219 9.219 0 0 1 12 2.75v-1.5a10.719 10.719 0 0 0-7.601 3.149l1.06 1.06Zm13.08-1.061-4.07 4.07 1.06 1.061 4.071-4.07-1.06-1.061ZM8.47 14.469l-4.071 4.072 1.06 1.06 4.071-4.07-1.06-1.061ZM4.399 5.46l4.07 4.071L9.53 8.47 5.46 4.399l-1.061 1.06Zm10.07 10.071 4.072 4.071 1.06-1.06-4.07-4.071-1.061 1.06ZM15.25 12A3.25 3.25 0 0 1 12 15.25v1.5A4.75 4.75 0 0 0 16.75 12h-1.5ZM12 15.25A3.25 3.25 0 0 1 8.75 12h-1.5A4.75 4.75 0 0 0 12 16.75v-1.5ZM8.75 12A3.25 3.25 0 0 1 12 8.75v-1.5A4.75 4.75 0 0 0 7.25 12h1.5ZM12 8.75A3.25 3.25 0 0 1 15.25 12h1.5A4.75 4.75 0 0 0 12 7.25v1.5Z",
		fill: e.color
	})
}), eu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 3 4.333 4.333M21 21l-4.333-4.333m0 0-2.393 2.99c-1.31 1.639-1.966 2.458-2.54 2.549a1.5 1.5 0 0 1-1.342-.47C10 21.305 10 20.255 10 18.157V16.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.655C8.861 14 8.441 14 7.6 14h-.606c-1.599 0-2.398 0-2.809-.328a1.5 1.5 0 0 1-.564-1.174c0-.525.5-1.149 1.498-2.397l2.214-2.768m9.334 9.334L7.333 7.333M9.2 5l.4-.5.126-.157c1.31-1.639 1.966-2.458 2.54-2.549a1.5 1.5 0 0 1 1.342.47c.392.43.392 1.48.392 3.578V7.6c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.656c.32.163.74.163 1.581.163h.798c1.433 0 2.15 0 2.534.266.436.301.68.81.643 1.339-.032.467-.48 1.026-1.375 2.145v0l-.2.25",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m5.12 10.1 4.606-5.757c1.31-1.639 1.966-2.458 2.54-2.549a1.5 1.5 0 0 1 1.342.47c.392.43.392 1.48.392 3.578V7.6c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.656c.32.163.74.163 1.581.163h.607c1.598 0 2.397 0 2.808.328a1.5 1.5 0 0 1 .564 1.174c0 .525-.5 1.149-1.498 2.397l-4.607 5.758c-1.31 1.639-1.966 2.458-2.54 2.549a1.5 1.5 0 0 1-1.342-.47C10 21.305 10 20.255 10 18.157V16.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.655C8.861 14 8.441 14 7.6 14h-.606c-1.599 0-2.398 0-2.809-.328a1.5 1.5 0 0 1-.564-1.174c0-.525.5-1.149 1.498-2.397Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13 17h5m-5-5h5m-5-5h5M8 6v12M8 6 6 8m2-2 2 2M8 18l-2-2m2 2 2-2m0 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ru = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 20h10m-10-8h10M12 4h10M5 3v18M5 3 2 6m3-3 3 3M5 21l-3-3m3 3 3-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), iu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 18h10m0-12H7m2 9 1.2-2.4m0 0L12 9l1.8 3.6m-3.6 0s.6.6 1.8.6c1.2 0 1.8-.6 1.8-.6m0 0L15 15m-5 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), au = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 3h18M3 21h18M7 17l2-4m0 0 3-6 3 6m-6 0s1 1 3 1 3-1 3-1m0 0 2 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ou = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13.75 8h.35v0a3.9 3.9 0 0 1 3.9 3.9v.2a3.9 3.9 0 0 1-3.9 3.9v0h-.35m-3.5 0H9.9v0A3.9 3.9 0 0 1 6 12.1v-.2A3.9 3.9 0 0 1 9.9 8v0h.35M10 12h4m-4 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), su = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14.5 5h.5v0a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7v0h-.5m-5-14H9v0a7 7 0 0 0-7 7v0a7 7 0 0 0 7 7v0h.5M8 12h8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m12.193 16.499-.474.489a3.278 3.278 0 0 1-4.738 0c-1.308-1.35-1.308-3.538 0-4.888l1.13-1.166a3.026 3.026 0 0 1 4.373 0l.183.188m-.86-3.62.474-.49a3.278 3.278 0 0 1 4.738 0c1.308 1.35 1.308 3.538 0 4.888l-1.13 1.166a3.026 3.026 0 0 1-4.373 0l-.182-.188M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m12.29 18.748-.711.734a4.917 4.917 0 0 1-7.107 0c-1.963-2.025-1.963-5.307 0-7.332l1.695-1.748a4.539 4.539 0 0 1 6.56 0l.273.282m-1.29-5.432.711-.734a4.917 4.917 0 0 1 7.107 0c1.963 2.025 1.963 5.307 0 7.332l-1.695 1.748a4.539 4.539 0 0 1-6.56 0L11 13.316",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11.5 18v-4a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v4m-10 0v-7M8 7.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H7M2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), du = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 10V6l-1 .8M7 10H6m1 0h1m-2 3h2v2H6v2h2m3 0h7m-7-5h7m-7-5h7m-8 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 20h13M9 12h13M9 4h13M3.5 8V3L2 4m1.5 4H2m1.5 0H5m-3 7h3v2.5H2V20h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 17h8m-8-5h8m-8-5h8M7 7v.5H6V7m1 0v-.5H6V7m1 0H6m1 5v.5H6V12m1 0v-.5H6v.5m1 0H6m1 5v.5H6V17m1 0v-.5H6v.5m1 0H6m4 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 20h11m-11-8h11M11 4h11M3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.11-.214.11-.494.11-1.054v-.8c0-.56 0-.84-.11-1.054a1 1 0 0 0-.437-.437C5.24 18 4.96 18 4.4 18h-.8c-.56 0-.84 0-1.054.11a1 1 0 0 0-.437.436C2 18.76 2 19.04 2 19.6v.8c0 .56 0 .84.11 1.054a1 1 0 0 0 .436.437c.214.11.494.11 1.054.11Zm0-8h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.11-.214.11-.494.11-1.054v-.8c0-.56 0-.84-.11-1.054a1 1 0 0 0-.437-.437C5.24 10 4.96 10 4.4 10h-.8c-.56 0-.84 0-1.054.11a1 1 0 0 0-.437.436C2 10.76 2 11.04 2 11.6v.8c0 .56 0 .84.11 1.054a1 1 0 0 0 .436.437c.214.11.494.11 1.054.11Zm0-8h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.11-.214.11-.494.11-1.054v-.8c0-.56 0-.84-.11-1.054a1 1 0 0 0-.437-.437C5.24 2 4.96 2 4.4 2h-.8c-.56 0-.84 0-1.054.11a1 1 0 0 0-.437.436C2 2.76 2 3.04 2 3.6v.8c0 .56 0 .84.11 1.054a1 1 0 0 0 .436.437c.214.11.494.11 1.054.11Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 20h11m-11-8h11M11 4h11M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 17h6m-6-5h6m-6-5h6M6 7l1 1 2-2m-3 6 1 1 2-2m-3 6 1 1 2-2m1 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _u = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 20h11m-11-8h11M11 4h11M2 4l1 1 3-3M2 12l1 1 3-3M2 20l1 1 3-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 17h7m-7-5h7m-7-5h7M6 6l1 1m0 0 1-1M7 7l1 1M7 7 6 8m0 3 1 1m0 0 1-1m-1 1 1 1m-1-1-1 1m0 3 1 1m0 0 1-1m-1 1 1 1m-1-1-1 1m4 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.5 5.5 5 4m0 0 1.5-1.5M5 4 3.5 2.5M5 4l1.5 1.5m-3 8L5 12m0 0 1.5-1.5M5 12l-1.5-1.5M5 12l1.5 1.5m-3 8L5 20m0 0 1.5-1.5M5 20l-1.5-1.5M5 20l1.5 1.5M11 20h11m-11-8h11M11 4h11",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 17h8m-8-5h8m-8-5h8M7 7a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H6m1 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H6m1 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0H6m4 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 20h13M9 12h13M9 4h13M3.5 4a.5.5 0 1 1-1 0m1 0a.5.5 0 1 0-1 0m1 0h-1m1 8a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 8a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Su = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6a6 6 0 1 1-5.376 3.333M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.597.374-3.106 1.04-4.444",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14.716 9.284 16 8m-8 8 1.284-1.284m0-5.432L8 8m8 8-1.284-1.284M15.994 12H18M6 12h2.006M12 8.006V6m0 12v-2.006M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m17 7 2.364-2.364M4.636 19.364 7 17M7 7 4.636 4.636m14.728 14.728L17 17m1.657-5H22M2 12h3.343M12 5.343V2m0 20v-3.343",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Eu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 15H10.163c-1.476 0-2.214 0-2.808-.271a3 3 0 0 1-1.278-1.109c-.353-.55-.457-1.28-.666-2.741L4.354 3.475A2.883 2.883 0 0 0 1.5 1v0H1m10 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6.2-5h.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 12.72 20 11.88 20 10.2v-.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 5 16.88 5 15.2 5h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C10 7.28 10 8.12 10 9.8v.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C12.28 15 13.12 15 14.8 15Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Du = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C9.28 2 10.12 2 11.8 2H15a2 2 0 0 1 2 2v.5M12 14v2m-2.6 6h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C21 18.96 21 17.84 21 15.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C17.96 8 16.84 8 14.6 8H9.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 11.04 3 12.16 3 14.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C6.04 22 7.16 22 9.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Ou = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8h2c2.809 0 4.213 0 5.222.674.437.292.812.667 1.104 1.104C21 10.787 21 12.19 21 15c0 .764 0 1.424-.014 2M4 4l4.013 4.013M22 22l-1.716-1.716M8.014 8.014c-1.552.035-2.5.168-3.236.66a4 4 0 0 0-1.104 1.104C3 10.787 3 12.19 3 15c0 2.809 0 4.213.674 5.222.292.437.667.812 1.104 1.104C5.787 22 7.19 22 10 22h4c2.809 0 4.213 0 5.222-.674a4 4 0 0 0 1.062-1.042M8.014 8.014l12.27 12.27M17 8V7c0-1.87 0-2.804-.402-3.5A3 3 0 0 0 15.5 2.402C14.804 2 13.87 2 12 2s-2.804 0-3.5.402A3 3 0 0 0 7.402 3.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), ku = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C9.28 2 10.12 2 11.8 2h.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 4.28 17 5.12 17 6.8V8m-5 6v2m-2.6 6h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C21 18.96 21 17.84 21 15.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C17.96 8 16.84 8 14.6 8H9.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 11.04 3 12.16 3 14.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C6.04 22 7.16 22 9.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Au = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 13v2M8 7V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2 10.08 2 11.2 2h3.3A1.5 1.5 0 0 1 16 3.5V4m-4 18v0a8 8 0 0 0 8-8v0a8 8 0 0 0-8-8v0a8 8 0 0 0-8 8v0a8 8 0 0 0 8 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), ju = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 3 4.432 4.432M22 22l-3.432-3.432M7.432 7.432a8 8 0 1 0 11.137 11.137M7.431 7.431l11.136 11.136M19.86 15.5A7.98 7.98 0 0 0 20 14a8 8 0 0 0-9.5-7.86M16 7V6c0-1.886 0-2.828-.586-3.414C14.83 2 13.886 2 12 2c-1.886 0-2.828 0-3.414.586-.327.326-.471.764-.535 1.414",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 7V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2 10.08 2 11.2 2h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 3.52 16 4.08 16 5.2V7m-4 6v2m0 7v0a8 8 0 0 0 8-8v0a8 8 0 0 0-8-8v0a8 8 0 0 0-8 8v0a8 8 0 0 0 8 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Nu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 8v-.5 0c0-1.396 0-2.093.172-2.661a4 4 0 0 1 2.667-2.667C11.407 2 12.104 2 13.5 2h2.1c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 5.04 22 6.16 22 8.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22h-2.1c-1.396 0-2.093 0-2.661-.172a4 4 0 0 1-2.667-2.667C8 18.593 8 17.896 8 16.5v0-.5m-6-4h15m0 0-4-4m4 4-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12h15m0 0-4-4m4 4-4 4m2 6v0a7 7 0 0 0 7-7V9a7 7 0 0 0-7-7v0a7 7 0 0 0-7 7v6a7 7 0 0 0 7 7Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 2h1.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 5.04 22 6.16 22 8.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C18.96 22 17.84 22 15.6 22H14M2 12h12m0 0-4-4m4 4-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Iu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 16v.5c0 1.396 0 2.094-.172 2.662a4 4 0 0 1-2.667 2.666C10.594 22 9.895 22 8.5 22H8c-1.864 0-2.796 0-3.53-.304a4 4 0 0 1-2.166-2.165C2 18.796 2 17.864 2 16.001V8c0-1.864 0-2.796.304-3.531A4 4 0 0 1 4.47 2.305C5.204 2 6.136 2 8 2h.5c1.396 0 2.093 0 2.66.173a4 4 0 0 1 2.668 2.667C14 5.407 14 6.105 14 7.5V8m-5 4h13m0 0-4-4m4 4-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h14m0 0-4-4m4 4-4 4M8 22v0a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6v0a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ru = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22H10m0-10h12m0 0-4-4m4 4-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 3v16m8-14v16m-5.184-1.12 2.367.968c1.035.423 1.553.635 2.084.7.472.058.95.031 1.411-.078.521-.124 1.012-.392 1.993-.927l2.078-1.133c.455-.249.683-.373.849-.55a1.5 1.5 0 0 0 .325-.55c.077-.23.077-.49.077-1.007V4.965c0-.977 0-1.465-.205-1.752a1.1 1.1 0 0 0-.762-.452c-.35-.043-.779.191-1.636.659l-.726.396c-.981.535-1.472.803-1.993.926a4 4 0 0 1-1.41.079c-.532-.066-1.05-.277-2.085-.7l-2.367-.969c-1.034-.423-1.552-.635-2.083-.7a4 4 0 0 0-1.411.078c-.521.124-1.012.392-1.993.927L3.25 4.59c-.455.249-.683.373-.849.55a1.5 1.5 0 0 0-.325.55C2 5.92 2 6.18 2 6.696v12.338c0 .977 0 1.465.205 1.752.18.25.456.415.761.452.35.043.78-.191 1.637-.659l.726-.396c.981-.535 1.472-.803 1.993-.926a4 4 0 0 1 1.41-.079c.532.066 1.05.277 2.085.7Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 6v4m0-4h4M6 6l12 12m0 0v-4m0 4h-4m-4 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 21 3 3m18 18v-6m0 6h-6M3 3v6m0-6h6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 6v4m0-4h-4m4 0L6 18m0 0v-4m0 4h4m0 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21 21 3M3 21v-6m0 6h6M21 3v6m0-6h-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 14.4v.4c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C7.52 18 8.08 18 9.2 18h.4M6 9.6v-.4c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C7.52 6 8.08 6 9.2 6h.4m4.8 0h.4c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2v.4m0 4.8v.4c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C16.48 18 15.92 18 14.8 18h-.4M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 8v-.5 0c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C18.593 2 17.896 2 16.5 2v0H16m6 14v.5c0 1.396 0 2.093-.172 2.661a4 4 0 0 1-2.667 2.667C18.593 22 17.896 22 16.5 22v0H16M2 16v.5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C5.407 22 6.104 22 7.5 22v0H8M2 8v-.5 0c0-1.396 0-2.093.172-2.661A4 4 0 0 1 4.84 2.172C5.407 2 6.104 2 7.5 2v0H8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ku = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 6v4m0-4h4M6 6l4 4m8 8v-4m0 4h-4m4 0-4-4m-4 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 3v6m0-6h6M3 3l6 6m12 12v-6m0 6h-6m6 0-6-6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ju = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 6v4m0-4h-4m4 0-2.333 2.333L14 10m-8 8v-4m0 4h4m-4 0 2.333-2.333L10 14m0 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 21v-6m0 6h6m-6 0 3.5-3.5L8 16M21 3v6m0-6h-6m6 0-3.5 3.5L16 8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 7H6a4 4 0 0 0-4 4v0a4 4 0 0 0 4 4h4m0-8v8m0-8 4.965-3.475c1.63-1.141 2.444-1.712 3.122-1.682a2 2 0 0 1 1.5.78C20 3.164 20 4.158 20 6.147V8m-10 7 4.965 3.476c1.63 1.14 2.444 1.71 3.122 1.68a2 2 0 0 0 1.5-.78c.413-.539.413-1.533.413-3.522V14M6 15v4.5A1.5 1.5 0 0 0 7.5 21v0A1.5 1.5 0 0 0 9 19.5V15m11-7v0a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3v0m0-6v6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 9v2m6-4v4m-3-4v4M5.854 5.775l.9-1.08c.731-.878 1.097-1.317 1.53-1.652a5 5 0 0 1 1.975-.924C10.794 2 11.365 2 12.51 2v0c2.321 0 3.482 0 4.398.378a5 5 0 0 1 2.715 2.715C20 6.009 20 7.17 20 9.49V14c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 22 14.8 22 12 22v0c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 18.2 4 16.8 4 14v-3.104c0-1.072 0-1.609.108-2.12a5 5 0 0 1 .471-1.303c.245-.462.588-.874 1.275-1.698Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qu = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8h10M7 12h6m-6 4h8m-3.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $u = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 6h18M3 12h8m-8 6h13",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), ed = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 8h10M7 12h10M7 16h10m-5.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), td = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 6h18M3 12h18M3 18h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), nd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7.255 12.964 3.884-2.913 1.644 2.448 3.962-2.971M2 11.126c0 2.992 1.578 5.626 3.999 7.287C5.998 19.367 6 20.652 6 22l3.923-1.948c.671.129 1.365.2 2.077.2 5.502 0 10-4.064 10-9.126C22 6.063 17.502 2 12 2S2 6.063 2 11.126Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 19c-3.429 0-8-3-8-8m8 8v3m0-3c1.634 0 3.528-.682 5.063-1.937M20 11c0 1.53-.428 2.873-1.12 4M7 7v4a5 5 0 0 0 8 4M3 3l12 12m6 6-3.937-3.937M15 15l2.063 2.063M8 4a5 5 0 0 1 9 3v4c0 .342-.034.677-.1 1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), id = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 19c3.429 0 8-3 8-8m-8 8c-3.429 0-8-3-8-8m8 8v3m0-6a5 5 0 0 1-5-5V7a5 5 0 0 1 10 0v4a5 5 0 0 1-5 5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ad = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 6v1.6c0 .84 0 1.26-.163 1.581a1.5 1.5 0 0 1-.656.656C8.861 10 8.441 10 7.6 10H6m4 8v-1.6c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.655C8.861 14 8.441 14 7.6 14H6m8-8v1.6c0 .84 0 1.26.164 1.581a1.5 1.5 0 0 0 .655.656c.32.163.74.163 1.581.163H18m-4 8v-1.6c0-.84 0-1.26.164-1.581a1.5 1.5 0 0 1 .655-.655c.32-.164.74-.164 1.581-.164H18m-8 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), od = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 2v2.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C6.48 8 5.92 8 4.8 8H2m6 14v-2.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C6.48 16 5.92 16 4.8 16H2M16 2v2.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C17.52 8 18.08 8 19.2 8H22m-6 14v-2.8c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 16 18.08 16 19.2 16H22",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sd = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M2 10c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M10 15c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C11.602 12 12.068 12 13 12h2c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C18 13.602 18 14.068 18 15v0c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C16.398 18 15.932 18 15 18h-2c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C10 16.398 10 15.932 10 15v0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), cd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ld = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h8M3.875 17.875l2.25 2.25c.692.692 1.038 1.038 1.442 1.286a4 4 0 0 0 1.156.479c.46.11.95.11 1.928.11h2.698c.978 0 1.468 0 1.928-.11.408-.099.798-.26 1.156-.48.404-.247.75-.593 1.442-1.285l2.25-2.25c.692-.692 1.038-1.038 1.286-1.442.219-.358.38-.748.479-1.156.11-.46.11-.95.11-1.928v-2.698c0-.978 0-1.468-.11-1.928a4 4 0 0 0-.48-1.156c-.247-.404-.593-.75-1.285-1.442l-2.25-2.25c-.692-.692-1.038-1.038-1.442-1.286a3.998 3.998 0 0 0-1.156-.478C14.817 2 14.327 2 13.349 2h-2.698c-.978 0-1.468 0-1.928.11a4 4 0 0 0-1.156.48c-.404.247-.75.593-1.442 1.285l-2.25 2.25c-.692.692-1.038 1.038-1.286 1.442a4 4 0 0 0-.478 1.156C2 9.183 2 9.673 2 10.651v2.698c0 .978 0 1.468.11 1.928.099.408.26.798.48 1.156.247.404.593.75 1.285 1.442Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ud = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h8m-4.4 10h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 12h14",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 5h4m-7 7v4m14-8v4m-7 7h4m3 3v0a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3ZM5 22v0a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3ZM19 8v0a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3ZM5 8v0a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 18c0 4 2 4 2 4m0 0h1m-1 0H8m-1 0h1m-6-9v.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 18 5.12 18 6.8 18H10m-8-5V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.28 22 5.12 22 6.8V13M2 13h20m0 0v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 18 18.88 18 17.2 18H10m-2 4s2-.5 2-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), md = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 11.449C3 16.724 7.169 21 12.312 21c3.959 0 7.34-2.534 8.688-6.107a8.074 8.074 0 0 1-3.515.8c-4.571 0-8.277-3.8-8.277-8.489 0-1.961.648-3.767 1.737-5.204C6.45 2.678 3 6.65 3 11.449Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7.25 11.5c.412 0 .75.338.75.75s-.338.75-.75.75m0-1.5a.752.752 0 0 0-.75.75c0 .412.338.75.75.75m0-1.5V13m4.5-1.5c.412 0 .75.338.75.75s-.338.75-.75.75m0-1.5a.752.752 0 0 0-.75.75c0 .412.338.75.75.75m0-1.5V13m5-1.5c.413 0 .75.338.75.75s-.337.75-.75.75m0-1.5a.752.752 0 0 0-.75.75c0 .412.337.75.75.75m0-1.5V13m-5.15 9h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.5 9.5A2.507 2.507 0 0 0 2 12c0 1.375 1.125 2.5 2.5 2.5S7 13.375 7 12 5.875 9.5 4.5 9.5ZM19.5 9.5A2.507 2.507 0 0 0 17 12c0 1.375 1.125 2.5 2.5 2.5S22 13.375 22 12s-1.125-2.5-2.5-2.5ZM12 9.5A2.507 2.507 0 0 0 9.5 12c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), _d = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12.75 7.5c0 .412-.338.75-.75.75a.752.752 0 0 1-.75-.75m1.5 0a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75m1.5 0h-1.5m1.5 4.5c0 .412-.338.75-.75.75a.752.752 0 0 1-.75-.75m1.5 0a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75m1.5 0h-1.5m1.5 5c0 .413-.338.75-.75.75a.752.752 0 0 1-.75-.75m1.5 0a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75m1.5 0h-1.5m.35 5h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11.5 7C12.875 7 14 5.875 14 4.5S12.875 2 11.5 2A2.507 2.507 0 0 0 9 4.5C9 5.875 10.125 7 11.5 7ZM11.5 9.5A2.507 2.507 0 0 0 9 12c0 1.375 1.125 2.5 2.5 2.5S14 13.375 14 12s-1.125-2.5-2.5-2.5ZM11.5 17A2.507 2.507 0 0 0 9 19.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), yd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8v2m0 12v0a8 8 0 0 0 8-8v-4a8 8 0 0 0-8-8v0a8 8 0 0 0-8 8v4a8 8 0 0 0 8 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 6v0a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3v0M19 6v0a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3v0m-6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 0V7l3 2m-4.6 13h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C19 18.96 19 17.84 19 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C15.96 2 14.84 2 12.6 2h-1.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C5 5.04 5 6.16 5 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.04 22 9.16 22 11.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 19V9m0 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12-3V6m0 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9 9V7.358C9 6.453 9 6 9.16 5.625a2 2 0 0 1 .657-.83c.328-.241.769-.345 1.65-.552l5.64-1.327c1.306-.307 1.96-.461 2.475-.304a2 2 0 0 1 1.148.909C21 3.987 21 4.658 21 6v0M9 9l12-3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 19v-8m0 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm0-8V6.724c0-.679 0-1.018.12-1.3a1.5 1.5 0 0 1 .493-.622c.246-.18.576-.258 1.237-.414l7.2-1.694c1.007-.237 1.511-.355 1.907-.229a1.5 1.5 0 0 1 .83.657C21 3.478 21 3.996 21 5.03v1.096c0 .67 0 1.005-.117 1.284a1.5 1.5 0 0 1-.484.62c-.242.18-.567.262-1.217.424L9 11Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 19V7.358C9 6.453 9 6 9.16 5.625a2 2 0 0 1 .657-.83c.328-.241.769-.345 1.65-.552l5.6-1.318c1.343-.316 2.014-.474 2.542-.305a2 2 0 0 1 1.106.876C21 3.971 21 4.661 21 6.04V16M9 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13.5 4H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 7.04 2 8.16 2 10.4v5.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 18.96 20 17.84 20 15.6v-5.1M12 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 0V8l3 2m5-9v3m0 0v3m0-3h-3m3 0h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Td = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 6v12m3-10v8m-12-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 0V7l3 2M8.4 22h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C16 18.96 16 17.84 16 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C12.96 2 11.84 2 9.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ed = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 13V8m.5 8a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M7.612 4H6.366c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656c-.163.32-.163.74-.163 1.581v1.22c0 .326 0 .489-.033.644a1.5 1.5 0 0 1-.145.395c-.075.14-.18.264-.391.512l-1.082 1.277c-.467.552-.7.827-.79 1.136a1.5 1.5 0 0 0 0 .832c.09.309.323.584.79 1.136l1.082 1.277c.21.248.316.372.39.512a1.5 1.5 0 0 1 .146.395c.033.155.033.318.033.644v1.22c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.58.164h1.247c.329 0 .493 0 .65.034.138.03.272.08.397.147.14.076.266.183.515.397l1.264 1.083c.554.475.832.713 1.143.803.274.08.565.08.838 0 .311-.09.588-.328 1.143-.803l1.264-1.083c.25-.214.374-.321.515-.397.125-.068.259-.117.397-.147.157-.034.321-.034.65-.034H17.6c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .655-.656c.164-.32.164-.74.164-1.581v-1.212c0-.329 0-.493.034-.65.03-.138.08-.272.147-.397.076-.14.183-.266.397-.515l1.083-1.264c.475-.554.713-.832.803-1.143a1.5 1.5 0 0 0 0-.838c-.09-.311-.328-.588-.803-1.143l-1.083-1.264c-.214-.25-.321-.374-.397-.515a1.497 1.497 0 0 1-.147-.397C20 8.105 20 7.94 20 7.612V6.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C18.861 4 18.441 4 17.6 4h-1.212c-.329 0-.493 0-.65-.034a1.498 1.498 0 0 1-.397-.147c-.14-.076-.266-.183-.515-.397L13.562 2.34c-.554-.475-.832-.713-1.143-.804a1.5 1.5 0 0 0-.838 0c-.311.091-.588.329-1.143.804L9.174 3.422c-.25.214-.374.321-.515.397a1.5 1.5 0 0 1-.397.147C8.105 4 7.94 4 7.612 4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 12V2l-2.713 1.206c-.611.271-.917.407-1.226.441a2 2 0 0 1-.997-.146c-.287-.12-.541-.338-1.05-.774v0c-.674-.578-1.011-.867-1.384-.991a2 2 0 0 0-1.26 0c-.373.124-.71.413-1.385.991v0c-.508.436-.762.653-1.049.774a2 2 0 0 1-.997.146c-.31-.034-.615-.17-1.226-.441L2 2v13.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22H20m-2-10h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 13.52 22 14.08 22 15.2V20a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v-8ZM7 17h6M7 9h4m-4 4h6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Od = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 9h10M7 13h6m-6 4h2M8 1v3m4-3v3m4-3v3m-4.4 18h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 1v3m4-3v3m4-3v3m-4.4 18h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ad = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 21.5v-2.3c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 16 18.08 16 19.2 16h2.3M7 7h8m-8 4h6m-6 4h2m6.172 7H11.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C2 17.44 2 15.76 2 12.4v-.8c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C6.56 2 8.24 2 11.6 2h.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C22 6.56 22 8.24 22 11.6v3.572c0 .337 0 .505-.009.668a6 6 0 0 1-1.525 3.681c-.108.121-.228.24-.466.479v0c-.238.238-.358.358-.479.466a6 6 0 0 1-3.681 1.525c-.163.009-.331.009-.668.009Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 21.5v-2.3c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 16 18.08 16 19.2 16h2.3m-6.328 6H11.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C2 17.44 2 15.76 2 12.4v-.8c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C6.56 2 8.24 2 11.6 2h.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C22 6.56 22 8.24 22 11.6v3.572c0 .337 0 .505-.009.668a6 6 0 0 1-1.525 3.681c-.108.121-.228.24-.466.479v0c-.238.238-.358.358-.479.466a6 6 0 0 1-3.681 1.525c-.163.009-.331.009-.668.009Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Md = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 7v4M6 16H2m4-4H2m4-4H2m10 14v0c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 18.2 20 16.8 20 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 2 14.8 2 12 2v0c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 4.73C4 5.8 4 7.2 4 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C7.8 22 9.2 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3h-2c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 5.73C2 6.8 2 8.2 2 11v3c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h3c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C21 18.2 21 16.8 21 14v-2m1-7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.5 6v15m0-15L3 3.5M5.5 6 20 5.094l.75-.047M9.125 9.375l1.25-.078m0 0 7.125 8.547V8.812m-7.125.485v9.031M17.5 8.813l1-.063m-1 .063-1 .062m-6.125 9.453-.875.055m.875-.055 1.125-.07M2 16.402V5.542c0-1.04 0-1.561.197-1.971a2 2 0 0 1 .796-.864c.393-.229.912-.27 1.95-.354l9.555-.772c.372-.03.558-.045.74-.027.162.017.321.053.474.108.172.062.334.156.656.344l1.957 1.142c1.157.675 1.735 1.012 2.156 1.482.372.416.653.905.825 1.437.194.6.194 1.27.194 2.609v9.318c0 1.058 0 1.587-.201 2.002a2 2 0 0 1-.814.866c-.4.227-.929.26-1.985.326l-9.625.601c-1.235.077-1.852.116-2.424-.018a4 4 0 0 1-1.41-.635c-.478-.34-.858-.829-1.617-1.805l-.75-.964c-.25-.322-.375-.482-.464-.66a2 2 0 0 1-.17-.5C2 17.014 2 16.81 2 16.403Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fd = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M5.107 18.864c-1.133-.68-1.7-1.02-2.111-1.487a4 4 0 0 1-.807-1.425C2 15.358 2 14.698 2 13.376v-2.752c0-1.322 0-1.982.19-2.576a4 4 0 0 1 .807-1.425c.411-.468.978-.808 2.11-1.487l3.6-2.16c1.198-.719 1.797-1.078 2.436-1.218a4 4 0 0 1 1.716 0c.639.14 1.237.5 2.434 1.218l3.6 2.16c1.134.68 1.7 1.02 2.111 1.487.365.415.64.9.807 1.425.19.594.19 1.254.19 2.576v2.752c0 1.322 0 1.982-.19 2.576a4 4 0 0 1-.806 1.425c-.412.468-.979.808-2.112 1.487l-3.6 2.16c-1.197.719-1.795 1.078-2.434 1.218a3.998 3.998 0 0 1-1.716 0c-.64-.14-1.238-.5-2.435-1.218l-3.6-2.16Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Id = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 12h12M6 12v-2m0 2v2m12-2v2m0-2v-2m-6-4v12m0-12h-2m2 0h2m-2 12h2m-2 0h-2m-1.6 4h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 2 17.84 2 15.6 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ld = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 2v1.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 7 18.92 7 17.8 7H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 5.48 3 4.92 3 3.8V2m18 20v-1.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 17 18.92 17 17.8 17H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 18.52 3 19.08 3 20.2V22m1.5-10h-1m5 0h-1m5 0h-1m5 0h-1m5 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 11c5.175-3.293 10.5 8.5 15 4l1.5-1.5m-.5 6.055c0-1.14.604-2.1 1.148-2.735.177-.205.265-.308.514-.398a1.34 1.34 0 0 1 .676 0c.249.09.337.192.514.398.544.635 1.148 1.596 1.148 2.735 0 3.26-4 3.26-4 0Zm-3.475-2.08 2.95-2.95c1.584-1.584 2.376-2.376 2.672-3.289a4 4 0 0 0 0-2.472c-.296-.913-1.088-1.705-2.672-3.29l-.95-.949c-1.584-1.584-2.376-2.376-3.289-2.672a4 4 0 0 0-2.472 0c-.913.296-1.705 1.088-3.29 2.672l-2.949 2.95C2.941 9.059 2.15 9.85 1.853 10.764a4 4 0 0 0 0 2.472c.296.913 1.088 1.705 2.672 3.29l.95.948c1.584 1.585 2.376 2.377 3.289 2.673a4 4 0 0 0 2.472 0c.913-.296 1.705-1.088 3.29-2.672Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 5h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 6.52 21 7.08 21 8.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 12 18.92 12 17.8 12h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C11 13.52 11 14.08 11 15.2v.8m0 6v0a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2ZM8 8h6c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C17 6.398 17 5.932 17 5v0c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C15.398 2 14.932 2 14 2H8c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C5 3.602 5 4.068 5 5v0c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C6.602 8 7.068 8 8 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 8v5.5a4.5 4.5 0 0 1-4.5 4.5v0A4.5 4.5 0 0 1 8 13.5V9a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v4.5a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5V9m-1 13h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 8v5.5m-.857 2.643L18 18m-1.857-1.857A4.5 4.5 0 0 1 8 13.5V9a3 3 0 0 1 .129-.871m8.014 8.014-2.207-2.207m0 0A1.5 1.5 0 0 1 11 13.5V11m2.936 2.936L11 11m0 0L8.129 8.129M6 6l2.129 2.129M10 6.17A3 3 0 0 1 14 9v1.499M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 5v9.5c0 .34-.023.673-.066 1M2 2l3.297 3.297M22 22l-3.291-3.291M5.297 5.297A4.991 4.991 0 0 0 5 7v7.5a7.5 7.5 0 0 0 13.709 4.209M5.297 5.297 10 10m8.709 8.709-3.75-3.75M15 11V7a5 5 0 0 0-8-4m7.958 11.958A2.5 2.5 0 0 1 10 14.5V10m4.958 4.958L10 10",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ud = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 5v9.5a7.5 7.5 0 0 1-7.5 7.5v0A7.5 7.5 0 0 1 5 14.5V7a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v7.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m19 12-4.5 4.5a4.95 4.95 0 0 1-7 0v0a4.95 4.95 0 0 1 0-7l3.208-3.208a3.241 3.241 0 0 1 4.584 0v0a3.24 3.24 0 0 1 .083 4.497l-3.15 3.392c-.669.72-1.803.741-2.498.046v0a1.735 1.735 0 0 1 0-2.454L13 8.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m16 15-1.5 1.5a4.95 4.95 0 1 1-7-7L9 8m7 7-2.352-2.352M16 15l2 2M9 8 7 6m2 2 2.25 2.25m2.398 2.398-1.423 1.532a1.735 1.735 0 1 1-2.498-2.407l1.523-1.523m2.398 2.398L11.25 10.25M19 12l-1 1m-2.435-2.435a3.241 3.241 0 0 0-4.547-4.547M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m22 12-3 3m-6-8-1 1M3 3l7 7m11 11-4-4m-7-7-1.75 1.75a2.475 2.475 0 0 0 0 3.5v0a2.475 2.475 0 0 0 3.5 0l1.75-1.75M10 10l3.5 3.5M6.25 6.75l-1.5 1.5c-2.9 2.9-2.9 7.6 0 10.5v0c2.9 2.9 7.6 2.9 10.5 0L17 17m-3.5-3.5L17 17m-1.5-5.5 1-1a4.95 4.95 0 0 0 0-7v0a4.95 4.95 0 0 0-7 0l-1 1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m22 12-6.75 6.75c-2.9 2.9-7.6 2.9-10.5 0v0c-2.9-2.9-2.9-7.6 0-10.5L9.5 3.5a4.95 4.95 0 0 1 7 0v0a4.95 4.95 0 0 1 0 7l-4.75 4.75a2.475 2.475 0 0 1-3.5 0v0a2.475 2.475 0 0 1 0-3.5L13 7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 9.5v5m4-5v5m8-2.5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 3 5.08 3 6.2 3h.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C10 4.52 10 5.08 10 6.2v11.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C8.48 21 7.92 21 6.8 21h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.48 3 18.92 3 17.8V6.2ZM14 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 3 16.08 3 17.2 3h.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C21 4.52 21 5.08 21 6.2v11.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C19.48 21 18.92 21 17.8 21h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 19.48 14 18.92 14 17.8V6.2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3.5 3.5 4 4M13.999 19l5-5v-3.63c0-1.91 0-2.864-.346-3.64a4 4 0 0 0-1.417-1.69c-.705-.475-1.645-.641-3.525-.973l-7.21-1.273c-1.515-.267-2.272-.4-2.817-.169a2 2 0 0 0-1.06 1.06c-.231.545-.098 1.302.17 2.817l1.272 7.21c.332 1.88.498 2.82.973 3.525a4 4 0 0 0 1.69 1.417c.776.346 1.73.346 3.64.346h3.63ZM13 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-.001 9 6.5-6.5a1.414 1.414 0 0 1 2 0v0a1.414 1.414 0 0 1 0 2l-6.5 6.5a1.414 1.414 0 0 1-2 0v0a1.414 1.414 0 0 1 0-2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 19-2.026-2.026c-1.408-1.408-2.112-2.112-2.415-2.936a4 4 0 0 1-.148-2.269c.195-.857.802-1.645 2.015-3.223l4.038-5.249c.863-1.122 1.294-1.683 1.82-1.884a2 2 0 0 1 1.432 0c.526.201.957.762 1.82 1.884l4.038 5.249c1.213 1.578 1.82 2.366 2.015 3.223a4 4 0 0 1-.148 2.27c-.303.823-1.007 1.527-2.415 2.935L16 19M12 2v5m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM7.5 22h9a1.5 1.5 0 0 0 1.5-1.5v0a1.5 1.5 0 0 0-1.5-1.5h-9A1.5 1.5 0 0 0 6 20.5v0A1.5 1.5 0 0 0 7.5 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qd = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 6H7m5 2.5v7m0-7L10.5 10M12 8.5l1.5 1.5M12 15.5 10.5 14m1.5 1.5 1.5-1.5m3.5 4H7m3 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $d = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 3H3m9 4v10m0-10L9.5 9.5M12 7l2.5 2.5M12 17l-2.5-2.5M12 17l2.5-2.5M21 21H3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ef = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.793 13c-1.351-2.29-2.245-4.953-2.609-7.919-.106-.869-.16-1.303-.004-1.745.16-.455.565-.913.998-1.128C3.598 2 4.095 2 5.088 2v0c.81 0 1.215 0 1.556.129a2 2 0 0 1 .939.732c.207.3.305.693.502 1.478l.122.49c.29 1.161.436 1.742.414 2.312a4 4 0 0 1-.338 1.464c-.231.522-.617.98-1.388 1.896L4.793 13Zm0 0a17.45 17.45 0 0 0 5.865 6m0 0c2.364 1.467 5.146 2.434 8.26 2.816.87.106 1.304.16 1.746.004.455-.16.913-.565 1.127-.997.209-.42.209-.928.209-1.942v0c0-.79 0-1.184-.129-1.526a2 2 0 0 0-.732-.938c-.3-.207-.693-.306-1.479-.502l-.708-.177c-1.084-.271-1.627-.407-2.162-.395a4 4 0 0 0-1.385.279c-.499.197-.946.532-1.84 1.202L10.657 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 16v-3m0 0V8h2.5a2.5 2.5 0 0 1 0 5H7Zm10.555-1.583A1.57 1.57 0 0 0 16.483 11h-.79c-.69 0-1.248.524-1.248 1.17 0 .537.39 1.005.945 1.135l1.665.39c.555.13.945.598.945 1.135 0 .646-.559 1.17-1.248 1.17h-1.314c-.609 0-1.166-.323-1.438-.833M2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 14c3.293.69 5 2.124 5 3.78C22 20.112 17.523 22 12 22S2 20.111 2 17.78c0-1.656 1.707-3.09 5-3.78m5-2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 0v6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19.778 17c1.39.527 2.222 1.199 2.222 1.93C22 20.625 17.523 22 12 22S2 20.625 2 18.93c0-.731.832-1.403 2.222-1.93M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 10c1.556 0 7-2.918 7-9.2 0-4-3.111-6.8-7-6.8S5 4.8 5 8.8c0 6.282 5.444 9.2 7 9.2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), af = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 12 2 2 5-5m-4 13c2 0 9-3.648 9-11.5 0-5-4-8.5-9-8.5s-9 3.5-9 8.5C3 18.352 10 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), of = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.5 9.5 12 12m0 0 2.5 2.5M12 12l-2.5 2.5M12 12l2.5-2.5M12 22c2 0 9-3.648 9-11.5 0-5-4-8.5-9-8.5s-9 3.5-9 8.5C3 18.352 10 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 12h6m-3 10c2 0 9-3.648 9-11.5 0-5-4-8.5-9-8.5s-9 3.5-9 8.5C3 18.352 10 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 9v3m0 0v3m0-3H9m3 0h3m-3 10c2 0 9-3.648 9-11.5 0-5-4-8.5-9-8.5s-9 3.5-9 8.5C3 18.352 10 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 2 3.009 3.009M22 22l-3.804-3.804m0 0C16.012 20.768 13.162 22 12 22c-2 0-9-3.648-9-11.5 0-2.166.75-4.051 2.009-5.491m13.187 13.187L5.01 5.01M7.625 3C8.917 2.355 10.408 2 12 2c5 0 9 3.5 9 8.5 0 1.694-.326 3.192-.857 4.5M12 8a3 3 0 0 1 3 3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uf = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M3 10.5C3 5.5 7 2 12 2s9 3.5 9 8.5c0 7.852-7 11.5-9 11.5s-9-3.648-9-11.5Z",
		stroke: e.color,
		strokeWidth: 1.5
	}), /*#__PURE__*/ M("path", {
		d: "M15 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5
	})]
}), df = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11.726 11.188a.75.75 0 0 0-1.452-.376l1.452.376Zm7.345-6.26-.53.531.53-.53Zm0 14.143-.53-.53.53.53Zm-14.142 0 .53-.53-.53.53Zm0-14.142.53.53-.53-.53Zm1.141 8.41a.75.75 0 0 0 1.413-.503l-1.413.503Zm2.258 7.965-.274.698.274-.698ZM18.541 5.46a9.25 9.25 0 0 1 0 13.082l1.06 1.06c4.198-4.198 4.198-11.004 0-15.202l-1.06 1.06ZM5.459 18.541a9.25 9.25 0 0 1 0-13.082L4.4 4.4C.2 8.597.2 15.403 4.399 19.6l1.06-1.06Zm0-13.082a9.25 9.25 0 0 1 13.082 0L19.6 4.4C15.403.2 8.597.2 4.4 4.399l1.06 1.06ZM12 7.194c2.71 0 4.751 2.012 4.751 4.306h1.5c0-3.228-2.823-5.806-6.25-5.806v1.5Zm-4.516 5.642c-.543-1.526-.18-2.909.686-3.93.88-1.039 2.293-1.712 3.83-1.712v-1.5c-1.962 0-3.799.855-4.974 2.242-1.19 1.403-1.688 3.342-.955 5.403l1.413-.503ZM16.75 11.5c0 3.346-3.822 5.275-6.528 3.48l-.829 1.25c3.658 2.426 8.857-.134 8.857-4.73h-1.5Zm-6.216 4.294 1.192-4.606-1.452-.376-1.192 4.606 1.452.376Zm8.007 2.747a9.252 9.252 0 0 1-9.938 2.066l-.55 1.395c3.86 1.521 8.425.722 11.548-2.4l-1.06-1.061Zm-9.938 2.066A9.218 9.218 0 0 1 5.46 18.54L4.4 19.6a10.716 10.716 0 0 0 3.655 2.401l.55-1.395Zm.451.886 1.48-5.699-1.452-.377-1.48 5.699 1.452.377Z",
		fill: e.color
	})
}), ff = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20.81 10.153C22.295 8.462 22.94 6.947 22.392 6c-.546-.947-2.181-1.147-4.39-.706m2.808 4.859C19.294 11.88 16.9 13.79 14 15.464 8.26 18.778 2.712 19.914 1.608 18c-.547-.947.097-2.462 1.582-4.153m17.62-3.694a9 9 0 0 1-17.62 3.694m17.62-3.694a8.99 8.99 0 0 0-2.807-4.859m0 0A9 9 0 0 0 3.19 13.847",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 5v14m-7.187-4.308L8.93 17.83c-1.606 1.033-2.408 1.549-3.072 1.502a2 2 0 0 1-1.459-.797C4 18.002 4 17.048 4 15.14V8.86c0-1.909 0-2.863.399-3.396a2 2 0 0 1 1.459-.797c.664-.047 1.466.47 3.072 1.502l4.883 3.138c1.393.896 2.09 1.344 2.33 1.914a2 2 0 0 1 0 1.556c-.24.57-.937 1.018-2.33 1.914Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 5v14m7.187-4.308 4.883 3.138c1.605 1.033 2.409 1.549 3.072 1.502a2 2 0 0 0 1.459-.797C21 18.002 21 17.048 21 15.14V8.86c0-1.909 0-2.863-.399-3.396a2 2 0 0 0-1.459-.797c-.663-.047-1.466.47-3.072 1.502l-4.883 3.138c-1.393.896-2.09 1.344-2.33 1.914a2 2 0 0 0 0 1.556c.24.57.937 1.018 2.33 1.914Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2.832 8A9.99 9.99 0 0 1 4 6M2.832 16A9.992 9.992 0 0 0 4 18M8 21.168A9.99 9.99 0 0 1 5.999 20M8 2.832A9.99 9.99 0 0 0 6 4M2.05 11a10.118 10.118 0 0 0 0 2M11 21.95c.329.033.662.05 1 .05 5.523 0 10-4.477 10-10S17.523 2 12 2c-.338 0-.671.017-1 .05m4.002 10.616-3.758 2.505c-.404.27-.606.404-.774.394a.5.5 0 0 1-.369-.198C10 15.234 10 14.991 10 14.505v-5.01c0-.486 0-.729.101-.862a.5.5 0 0 1 .37-.198c.167-.01.369.125.773.394l3.758 2.505c.333.223.5.334.558.475a.5.5 0 0 1 0 .383c-.058.14-.225.251-.559.474Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _f = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 17.294V6.706c0-1.865 0-2.798.39-3.328a2 2 0 0 1 1.436-.804c.655-.058 1.451.429 3.043 1.401l8.663 5.295c1.477.902 2.216 1.354 2.468 1.935a2 2 0 0 1 0 1.59c-.252.581-.99 1.033-2.468 1.935l-8.663 5.295c-1.592.972-2.388 1.459-3.043 1.401a2 2 0 0 1-1.435-.804C6 20.091 6 19.159 6 17.294Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4h18M2 9h14M2 14h9m-9 5h7m12.002-1.334-3.758 2.505c-.404.27-.606.404-.774.394a.5.5 0 0 1-.369-.198C16 20.234 16 19.991 16 19.505v-5.01c0-.486 0-.729.101-.862a.5.5 0 0 1 .37-.198c.167-.01.369.125.773.394l3.758 2.505c.333.223.5.334.559.474a.5.5 0 0 1 0 .384c-.059.14-.226.251-.56.474Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4h18M2 9h14M2 14h10M2 19h7m10-5v3m0 0v3m0-3h-3m3 0h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 0v-8l3 2M2 4h18M2 9h14M2 14h10M2 19h7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 2v2m8 3V2m6 20-2.284-2.291-.003.004M3 3l4.007 4.007.019.019M11 7h4c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C21 10.204 21 11.136 21 13c0 1.828 0 3.059-.128 4M7.026 7.026c-.668.032-1.144.107-1.557.278A4 4 0 0 0 3.304 9.47C3 10.204 3 11.136 3 13c0 2.796 0 4.194.457 5.296a6 6 0 0 0 3.247 3.247C7.807 22 9.204 22 12 22c2.796 0 4.194 0 5.296-.457a6 6 0 0 0 2.417-1.83M7.026 7.026l12.687 12.687",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 7V2m8 5V2m-4 8.5-2 4h4l-2 4m0 3.5v0c-2.796 0-4.193 0-5.296-.457a6 6 0 0 1-3.247-3.247C3 17.194 3 15.796 3 13v0c0-1.864 0-2.796.304-3.53A4 4 0 0 1 5.47 7.303C6.204 7 7.136 7 9 7h6c1.864 0 2.796 0 3.53.304a4 4 0 0 1 2.165 2.165C21 10.204 21 11.136 21 13v0c0 2.796 0 4.194-.457 5.296a6 6 0 0 1-3.247 3.247C16.194 22 14.796 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h4m0 0h4m-4 0V8m0 4v4m10-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 12h4m0 0h4m-4 0V8m0 4v4m-.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 12h7m7 0h-7m0 0V5m0 7v7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ef = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6.5 14a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5-4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5-4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m8.5-8h-4m0-3h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 8.52 22 9.08 22 10.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 17 19.92 17 18.8 17H18M6.6 10h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C15 9.24 15 8.96 15 8.4V6.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 5 13.96 5 13.4 5H6.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C5 5.76 5 6.04 5 6.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C5.76 10 6.04 10 6.6 10Zm.2 12h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C18 19.72 18 18.88 18 17.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C15.72 2 14.88 2 13.2 2H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.28 2 5.12 2 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Df = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 6.803a6 6 0 1 0 6 0M12 5v7m-.4 10h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Of = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12.75 2a.75.75 0 0 0-1.5 0h1.5Zm-1.5 10a.75.75 0 0 0 1.5 0h-1.5Zm5.084-7.736a.75.75 0 1 0-.668 1.343l.668-1.343Zm-8 1.343a.75.75 0 0 0-.668-1.343l.668 1.343ZM11.25 2v10h1.5V2h-1.5Zm9 11A8.25 8.25 0 0 1 12 21.25v1.5c5.385 0 9.75-4.365 9.75-9.75h-1.5ZM12 21.25A8.25 8.25 0 0 1 3.75 13h-1.5c0 5.385 4.365 9.75 9.75 9.75v-1.5Zm3.666-15.643A8.25 8.25 0 0 1 20.25 13h1.5a9.75 9.75 0 0 0-5.416-8.736l-.668 1.343ZM3.75 13a8.25 8.25 0 0 1 4.584-7.393l-.668-1.343A9.75 9.75 0 0 0 2.25 13h1.5Z",
		fill: e.color
	})
}), kf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 2h18M3 2v7.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C6.04 16 7.16 16 9.4 16h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C21 12.96 21 11.84 21 9.6V2M3 2H1.5M21 2h1.5M8 9v2m4-4v4m4-3v3m-4 5v3m0 0-5 3m5-3 5 3m-5-3v3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Af = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 2h18M3 2v7.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C6.04 16 7.16 16 9.4 16h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C21 12.96 21 11.84 21 9.6V2M3 2H1.5M21 2h1.5M12 16v3m0 0-5 3m5-3 5 3m-5-3v3M8 10l3-2 2 2 3-2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 8H7c-1.87 0-2.804 0-3.5.402A3 3 0 0 0 2.402 9.5C2 10.196 2 11.13 2 13v1c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C4.605 18 5.07 18 6 18M8 8 2 2m6 6 10 10m0 0 4 4m-4-4v.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C16.48 22 15.92 22 14.8 22H9c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C6 20.398 6 19.932 6 19c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C7.602 16 8.068 16 9 16h7m5.236 1c.308-.345.538-.762.662-1.223C22 15.395 22 14.93 22 14v-1c0-1.87 0-2.804-.402-3.5A3 3 0 0 0 20.5 8.402C19.804 8 18.87 8 17 8h-5m6 0V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 2 15.92 2 14.8 2H8m-3 9h1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 18v0c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.121C22 15.395 22 14.93 22 14v-1.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 8 18.88 8 17.2 8H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 10.28 2 11.12 2 12.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C4.605 18 5.07 18 6 18v0M18 8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C16.48 2 15.92 2 14.8 2H9.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C6 3.52 6 4.08 6 5.2V8m-1 3h1m3 11h6c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C18 20.398 18 19.932 18 19v0c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C16.398 16 15.932 16 15 16H9c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C6 17.602 6 18.068 6 19v0c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C7.602 22 8.068 22 9 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 7 9 17m13-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM10 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 3 6 21M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ff = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 4V2m0 20v-2M2 8h2m16 0h2M12 4V2m0 20v-2M2 12h2m16 0h2m-6-8V2m0 20v-2M2 16h2m16 0h2m-10.6-1h1.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.74.164-1.581v-1.2c0-.84 0-1.26-.164-1.581a1.5 1.5 0 0 0-.655-.656C13.861 9 13.441 9 12.6 9h-1.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656C9 10.139 9 10.559 9 11.4v1.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.581.164Zm-1 5h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 16.96 20 15.84 20 13.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 4 15.84 4 13.6 4h-3.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 20 8.16 20 10.4 20Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), If = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 17v-4m0 0V7h3a3 3 0 1 1 0 6h-3Zm12-1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 10.5V10a2 2 0 1 1 4 0v.121c0 .563-.223 1.102-.621 1.5L12 13m.5 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 16v-4.024c0-1.467 0-2.2.166-2.891a6 6 0 0 1 .718-1.735c.371-.605.89-1.124 1.928-2.162L6 4m8 12v-4.024c0-1.467 0-2.2.166-2.891a6 6 0 0 1 .718-1.735c.371-.605.89-1.124 1.928-2.162L18 4m.8 16h-1.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 18.48 14 17.92 14 16.8v-1.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 12 16.08 12 17.2 12h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 13.52 22 14.08 22 15.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 20 19.92 20 18.8 20Zm-12-8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 13.52 2 14.08 2 15.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 20 4.08 20 5.2 20h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 18.48 10 17.92 10 16.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 12 7.92 12 6.8 12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 8v5.25c0 .732 0 1.098-.04 1.444A6 6 0 0 1 8.13 18.35c-.253.24-.545.46-1.131.899v0L6 20M22 8v5.25c0 .732 0 1.098-.04 1.444a6 6 0 0 1-1.829 3.657c-.253.24-.545.46-1.131.899v0L18 20m-.8-8h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 10.48 22 9.92 22 8.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C14 5.52 14 6.08 14 7.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 12 16.08 12 17.2 12Zm-12 0h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 10.48 10 9.92 10 8.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 4 7.92 4 6.8 4H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 5.52 2 6.08 2 7.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 12 4.08 12 5.2 12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 4v0a3 3 0 0 1 3-3h8m-3 8h4m-4 4h4m-8-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 11h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-2c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 4 16.8 4 14 4h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 6.73C2 7.8 2 9.2 2 12v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 12V2l-2.713 1.206c-.611.271-.917.407-1.226.441a2 2 0 0 1-.997-.146c-.287-.12-.541-.338-1.05-.774v0c-.674-.578-1.011-.867-1.384-.991a2 2 0 0 0-1.26 0c-.373.124-.71.413-1.385.991v0c-.508.436-.762.653-1.049.774a2 2 0 0 1-.997.146c-.31-.034-.615-.17-1.226-.441L2 2v13.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22H20m-2-10h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 13.52 22 14.08 22 15.2V20a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v-8Zm-7.5 5h3m-7-8H11m-.5 4h3m-6 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 4a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("circle", {
		cx: 12,
		cy: 12,
		r: 10,
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 14v-4m0 4h-4m4 0s-3-4-6.5-4C7 10 6 14 6 14m4 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 15V7m0 8h-7.778M22 15s-5-8-11-8c-8 0-9 8-9 8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 8h-7.5A4.5 4.5 0 0 0 6 12.5v0a4.5 4.5 0 0 0 4.5 4.5H13m5-9-2-2m2 2-2 2m-6 12h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 6H9a7 7 0 0 0-7 7v0a7 7 0 0 0 7 7h5m8-14-4-4m4 4-4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 12a6 6 0 0 0 6 6c3.314 0 5.5-3 5.5-3m.5-3c0-3.314-2.667-6-6-6-4 0-5.5 3-5.5 3m0 0V6.5m0 2.5h2m9 6h-2m2 0v2.5M12 11V9m.5 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 5.523 4.477 10 10 10s9-5.5 9-5.5m1-4.5A9.98 9.98 0 0 0 12 2C5.333 2 2 7.5 2 7.5m0 0V4m0 3.5h3.5m15.5 9h-3.5m3.5 0V20m-9-8V8m.5 7a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 12a6 6 0 0 0 6 6c3.314 0 5.5-3 5.5-3m.5-3c0-3.314-2.667-6-6-6-4 0-5.5 3-5.5 3m0 0V6.5m0 2.5H9m8.5 6H15m2.5 0v2.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 5.523 4.477 10 10 10s9-5.5 9-5.5m1-4.5A9.98 9.98 0 0 0 12 2C5.333 2 2 7.5 2 7.5m0 0V4m0 3.5h3.5m15.5 9h-3.5m3.5 0V20",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 12a6 6 0 0 1-6 6c-3.314 0-5.5-3-5.5-3M6 12c0-3.314 2.667-6 6-6 4 0 5.5 3 5.5 3m0 0V6.5m0 2.5h-2m-9 6h2m-2 0v2.5M12 11V9m.5 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qf = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10s-9-5.5-9-5.5M2 12A9.98 9.98 0 0 1 12 2c6.667 0 10 5.5 10 5.5m0 0V4m0 3.5h-3.5M3 16.5h3.5m-3.5 0V20m9-8V8m.5 7a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $f = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 12a6 6 0 0 1-6 6c-3.314 0-5.5-3-5.5-3M6 12c0-3.314 2.667-6 6-6 4 0 5.5 3 5.5 3m0 0V6.5m0 2.5H15m-8.5 6H9m-2.5 0v2.5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ep = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10s-9-5.5-9-5.5M2 12A9.98 9.98 0 0 1 12 2c6.667 0 10 5.5 10 5.5m0 0V4m0 3.5h-3.5M3 16.5h3.5m-3.5 0V20",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12.5 15V9L10 11.5M3 20h13.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 17.72 21 16.88 21 15.2V14M3 20l3-3m-3 3 3 3M21 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8V10m18-6-3-3m3 3-3 3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), np = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 20h13.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 17.72 21 16.88 21 15.2V14M3 20l3-3m-3 3 3 3M21 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8V10m18-6-3-3m3 3-3 3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.29 10A7 7 0 1 0 7 7.101L8 4m1.5 5.5v5m3.5 0v0a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 13 9.5v0a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5ZM10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ip = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10A9.98 9.98 0 0 0 12 2C5.333 2 2 7.556 2 7.556v-5M9 9v6m4.5 0v0a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 13.5 9v0a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ap = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.29 10A7 7 0 1 0 7 7.101L8 4m3.5 10.5h3V12h-3V9.5h3m-5 0v5M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), op = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10A9.98 9.98 0 0 0 12 2C5.333 2 2 7.556 2 7.556v-5M9 9v6m3 0h3v-3h-3V9h3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.29 10A7 7 0 1 0 7 7.101L8 4m2.5 10.5h3V12h-3V9.5h3M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10A9.98 9.98 0 0 0 12 2C5.333 2 2 7.556 2 7.556v-5M10 15h4v-3h-4V9h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 6.295A6.805 6.805 0 0 1 12 6a6 6 0 1 1-4.99 2.667M10 6.295 12 4m-2 2.295L12.333 8M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), up = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 4.443A10.208 10.208 0 0 1 12 4a9 9 0 1 1-7.484 4M9 4.443 12 1M9 4.443 12.5 7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m10 11 3-3m-3 3 3 3m-3-3h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 12.52 18 13.08 18 14.2V16M9 8l-3 3 3 3m1 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 10 5-5m-5 5 5 5m-5-5h11.2c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.28 22 13.12 22 14.8V17M7 5l-5 5 5 5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 11 3-3m-3 3 3 3m-3-3h7.5a4.5 4.5 0 0 1 4.5 4.5v.5m-8 6h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 11 5-5m-5 5 5 5m-5-5h13.6c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C22 14.04 22 15.16 22 17.4v.6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 11-2.08 1.56c-.704.527-1.056.791-1.31 1.126a3 3 0 0 0-.495.99C2 15.079 2 15.52 2 16.399V20l4-1m12-8 2.08 1.56c.704.529 1.056.793 1.31 1.127a3 3 0 0 1 .495.99c.115.403.115.844.115 1.723V20l-4-1m-6 3v-3M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8.74 4.02l-.687.636c-.756.7-1.134 1.05-1.405 1.466a4 4 0 0 0-.525 1.203C6 7.806 6 8.322 6 9.352V16c0 1.864 0 2.796.305 3.53a4 4 0 0 0 2.164 2.165C9.204 22 10.136 22 12 22v0c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.166-2.164C18 18.796 18 17.864 18 16V9.352c0-1.03 0-1.546-.121-2.027a4.002 4.002 0 0 0-.526-1.203c-.27-.416-.649-.766-1.405-1.466l-.687-.636c-1.15-1.065-1.724-1.597-2.378-1.799a3 3 0 0 0-1.766 0c-.653.202-1.228.734-2.378 1.799Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.5 10.5 2 8l1.078-1.078c.886-.886 1.329-1.328 1.853-1.608a4 4 0 0 1 1.495-.453c.591-.058 1.205.065 2.433.31L10.5 5.5m8 8 .328 1.64c.246 1.229.37 1.843.311 2.434a4.002 4.002 0 0 1-.452 1.496c-.28.524-.723.967-1.609 1.852L16.001 22l-2.5-3.5M7 17l2-2m8.002-6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm.197-7h-.549c-.978 0-1.467 0-1.928.11a4 4 0 0 0-1.156.48c-.404.247-.75.593-1.441 1.285L7 9c-1.09 1.09-1.636 1.636-1.927 2.224a4 4 0 0 0 0 3.552c.291.588.836 1.133 1.927 2.224v0c1.09 1.09 1.636 1.636 2.224 1.927a4 4 0 0 0 3.552 0C13.364 18.636 13.91 18.09 15 17l5.125-5.126c.692-.691 1.037-1.037 1.285-1.44.22-.359.38-.749.479-1.157.11-.46.11-.95.11-1.928V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.31-1.311C19.718 2 18.878 2 17.198 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _p = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 12a6 6 0 0 0 12 0c0-3.314-2.667-6-6-6-4 0-5.6 3-5.6 3m0 0V6.5m0 2.5h2.1M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10A9.98 9.98 0 0 0 12 2C5.333 2 2 7.5 2 7.5m0 0V4m0 3.5h3.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 12a6 6 0 0 1-12 0c0-3.314 2.667-6 6-6 4 0 5.6 3 5.6 3m0 0V6.5m0 2.5h-2.1M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12A9.98 9.98 0 0 1 12 2c6.667 0 10 5.5 10 5.5m0 0V4m0 3.5h-3.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 19h8.5a3.5 3.5 0 0 0 3.5-3.5v0a3.5 3.5 0 0 0-3.5-3.5h-10A3.5 3.5 0 0 1 3 8.5v0A3.5 3.5 0 0 1 6.5 5H12M8 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm4-14L9.5 2.5M12 5 9.5 7.5M21 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m11 20-2-2m5-1-3.5-3.5M20 11l-3.5-3.5M17 14l-2-2m-3.106 7.606 7.712-7.712c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 0 0 0-1.854c-.222-.685-.816-1.28-2.004-2.467l-.712-.712c-1.188-1.188-1.782-1.782-2.467-2.005a3 3 0 0 0-1.854 0c-.685.223-1.28.817-2.467 2.005l-7.712 7.712c-1.188 1.188-1.782 1.782-2.005 2.467a3 3 0 0 0 0 1.854c.223.685.817 1.28 2.005 2.467l.712.712c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 0 0 1.854 0c.685-.222 1.28-.816 2.467-2.004Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 2h-1c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-1m-12 1L22 2M10 14V9m0 5h5m7-12h-5m5 0v5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 9v-.3 0c0-.651 0-.977.075-1.243a2 2 0 0 1 1.382-1.382C7.723 6 8.05 6 8.7 6H10m4 0h1.3c.651 0 .977 0 1.243.075a2 2 0 0 1 1.382 1.382C18 7.723 18 8.05 18 8.7V9m0 6v.3c0 .651 0 .977-.075 1.243a2 2 0 0 1-1.382 1.382C16.277 18 15.95 18 15.3 18H14m-4.2 0H8.7c-.651 0-.977 0-1.243-.075a2 2 0 0 1-1.382-1.382C6 16.277 6 15.95 6 15.3v0-.3m0-3h12m-8 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 8v-.5 0A5.5 5.5 0 0 0 16.5 2v0H16m6 14v.5a5.5 5.5 0 0 1-5.5 5.5v0H16M2 16v.5A5.5 5.5 0 0 0 7.5 22v0H8M2 8v-.5 0A5.5 5.5 0 0 1 7.5 2v0H8M2 12h20",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ep = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.5 9.5 6 12l2.5 2.5m7-5L18 12l-2.5 2.5M13 7l-2 10m-1 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 8-4 4 4 4m12-8 4 4-4 4M14 3l-4 18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Op = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m21 21-3.636-3.636m0 0A9 9 0 1 0 4.636 4.636a9 9 0 0 0 12.728 12.728Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), kp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11 6h2m2.5 0h.5v0a2 2 0 0 1 2 2v.5m-12 0V8v0a2 2 0 0 1 2-2v0h.5M6 11v2m0 2.6v.4a2 2 0 0 0 2 2v0h.5m2.5 0h2m2.5 0h.5v0a2 2 0 0 0 2-2v0-.5m0-2.5v-2m-8-9h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C22 5.8 22 7.2 22 10v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-4c0-2.8 0-4.2.545-5.27A5 5 0 0 1 4.73 2.545C5.8 2 7.2 2 10 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ap = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 2h4m4 0h.389v0A3.611 3.611 0 0 1 22 5.611V6M2 6v-.389 0A3.611 3.611 0 0 1 5.611 2v0H6m-4 8v4m0 4v.389A3.611 3.611 0 0 0 5.611 22v0H6m4 0h4m4 0h.389v0A3.611 3.611 0 0 0 22 18.389v0V18m0-4v-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jp = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("g", {
		clipPath: "url(#a)",
		children: /*#__PURE__*/ M("path", {
			d: "m11 13 1.534 3.99c1.055 2.743 1.583 4.114 2.291 4.459a2 2 0 0 0 1.916-.09c.673-.41 1.07-1.825 1.862-4.655l2.863-10.226c.502-1.791.752-2.687.52-3.302a2 2 0 0 0-1.162-1.162c-.615-.233-1.51.018-3.302.52L7.296 5.397C4.466 6.19 3.05 6.586 2.64 7.258a2 2 0 0 0-.09 1.917c.345.708 1.716 1.236 4.459 2.29L11 13Zm0 0 2.5-2.5",
			stroke: e.color,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /*#__PURE__*/ M("defs", { children: /*#__PURE__*/ M("clipPath", {
		id: "a",
		children: /*#__PURE__*/ M("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
}), Mp = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("g", {
		clipPath: "url(#a)",
		children: /*#__PURE__*/ M("path", {
			d: "m7 12-2.118 3.441c-1.756 2.854-2.634 4.28-2.452 5.078a2 2 0 0 0 1.335 1.458c.778.251 2.277-.498 5.274-1.996l10.237-5.119c1.842-.921 2.763-1.382 3.059-2.005a2 2 0 0 0 0-1.714c-.296-.623-1.217-1.084-3.06-2.005L9.04 4.019C6.042 2.521 4.543 1.772 3.765 2.023A2 2 0 0 0 2.43 3.48c-.182.797.696 2.224 2.452 5.078L7 12Zm0 0h4",
			stroke: e.color,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /*#__PURE__*/ M("defs", { children: /*#__PURE__*/ M("clipPath", {
		id: "a",
		children: /*#__PURE__*/ M("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
}), Np = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 12c0 1.657-4.03 3-9 3s-9-1.343-9-3m18-7c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v14c0 1.657-4.03 3-9 3s-9-1.343-9-3V5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17.5 6a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m1 11a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M7 21h10c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 18.395 21 17.93 21 17v0c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C18.395 13 17.93 13 17 13H7c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.121C3 15.605 3 16.07 3 17v0c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C5.605 21 6.07 21 7 21Zm0-11h10c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C21 7.395 21 6.93 21 6v0c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C18.395 2 17.93 2 17 2H7c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C3 4.605 3 5.07 3 6v0c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C5.605 10 6.07 10 7 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M16 5a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm0 0H9a4 4 0 0 0-4 4v0m0 6a3 3 0 0 1 0-6m0 6a3 3 0 0 0 0-6m0 6v0a4 4 0 0 0 4 4h7m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ip = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 12 2 2 4.5-4.5M9.4 2.155 5.85 3.733c-1.031.459-1.547.688-1.925 1.05a3 3 0 0 0-.747 1.15C3 6.426 3 6.99 3 8.119v5.456c0 1.252 0 1.878.173 2.447.152.503.403.97.737 1.377.377.459.898.806 1.94 1.5l3.487 2.326c.963.641 1.444.962 1.964 1.087.46.11.938.11 1.398 0 .52-.125 1.001-.446 1.964-1.087L18.15 18.9c1.042-.695 1.563-1.042 1.94-1.5a4 4 0 0 0 .737-1.378c.173-.569.173-1.195.173-2.447V8.119c0-1.129 0-1.693-.178-2.186a3 3 0 0 0-.747-1.15c-.378-.362-.894-.591-1.925-1.05L14.6 2.155c-.958-.425-1.436-.638-1.934-.722a4 4 0 0 0-1.332 0c-.498.084-.976.297-1.933.722Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m2 2 2.371 2.371M21 21l-2.34-2.34m0 0c-.967.944-2.161 1.54-4.046 2.483-1.02.51-1.956.857-2.614.857-.658 0-1.594-.347-2.615-.857-2.57-1.286-3.856-1.929-5.033-3.687a9.648 9.648 0 0 1-.306-.495C3 15.12 3 13.208 3 9.38c0-2.106 0-3.16.617-4.137.049-.077.126-.19.18-.262.179-.239.366-.437.574-.61M18.66 18.658 4.371 4.371M20.696 15C21 13.61 21 11.915 21 9.38c0-2.105 0-3.158-.617-4.136a4.68 4.68 0 0 0-.18-.262c-.693-.926-1.512-1.24-3.152-1.867C15.48 2.513 13.654 2 12 2c-1.296 0-2.698.315-4 .741",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 8.12c0-1.13 0-1.694.178-2.187a3 3 0 0 1 .747-1.15c.378-.362.894-.591 1.926-1.05L9.4 2.155c.957-.425 1.435-.638 1.933-.722a4 4 0 0 1 1.332 0c.498.084.976.297 1.933.722l3.55 1.578c1.032.459 1.548.688 1.926 1.05a3 3 0 0 1 .747 1.15C21 6.426 21 6.99 21 8.119v5.456c0 1.252 0 1.878-.173 2.447a4 4 0 0 1-.737 1.377c-.377.459-.898.806-1.94 1.5l-3.487 2.326c-.963.641-1.444.962-1.964 1.087-.46.11-.938.11-1.398 0-.52-.125-1.001-.446-1.964-1.087L5.85 18.9c-1.042-.695-1.563-1.042-1.94-1.5a4.001 4.001 0 0 1-.737-1.378C3 15.453 3 14.827 3 13.575V8.119Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 8V6a4 4 0 1 1 8 0v2m-7.5 3.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m9 0a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M10.582 22h2.836c1.98 0 2.971 0 3.766-.223a6 6 0 0 0 4.256-4.566c.166-.808.097-1.796-.042-3.772v0c-.122-1.742-.184-2.612-.421-3.328a6 6 0 0 0-4.21-3.924C16.037 6 15.163 6 13.417 6h-2.835c-1.745 0-2.618 0-3.35.187a6 6 0 0 0-4.209 3.924c-.237.716-.299 1.586-.421 3.328v0c-.139 1.976-.208 2.964-.042 3.772a6 6 0 0 0 4.256 4.566C7.611 22 8.601 22 10.582 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 7v2a3 3 0 0 0 3 3v0a3 3 0 0 0 3-3V7m-3 15v0c3.068 0 4.602 0 5.766-.517a6 6 0 0 0 3.272-3.639c.392-1.212.23-2.737-.095-5.788l-.236-2.225c-.246-2.319-.37-3.478-.806-4.4a6 6 0 0 0-3.441-3.095C15.498 2 14.332 2 12 2v0c-2.332 0-3.498 0-4.46.336A6 6 0 0 0 4.1 5.432c-.436.92-.56 2.08-.806 4.399l-.236 2.225c-.325 3.051-.487 4.576-.095 5.788a6 6 0 0 0 3.272 3.639C7.398 22 8.932 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 7 3-5m6 0 3 5M9.247 22h5.506c1.87 0 2.804 0 3.57-.335A4 4 0 0 0 20 20.29c.478-.686.661-1.602 1.028-3.435l.44-2.2c.525-2.624.787-3.936.432-4.963a4 4 0 0 0-1.756-2.142C19.207 7 17.869 7 15.193 7H8.807c-2.676 0-4.014 0-4.952.55A4 4 0 0 0 2.1 9.692c-.355 1.027-.093 2.34.432 4.963l.44 2.2c.367 1.833.55 2.75 1.028 3.435a4 4 0 0 0 1.678 1.375c.766.335 1.7.335 3.57.335Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M1 1h.5v0c.108 0 .161 0 .21.002a3 3 0 0 1 2.804 2.23l.048.204.13.564m0 0 1.45 6.28c.306 1.328.46 1.992.82 2.488a3 3 0 0 0 1.247.991C8.773 14 9.455 14 10.82 14h5.61c1.281 0 1.922 0 2.462-.218a3 3 0 0 0 1.219-.907c.364-.455.548-1.068.916-2.296l.738-2.46c.419-1.396.628-2.094.477-2.647a2 2 0 0 0-.869-1.168C20.886 4 20.157 4 18.7 4H4.692ZM14 14H6a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h15m-10 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Up = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M1 1h.5v0c.226 0 .339 0 .44.007a3 3 0 0 1 2.62 1.976c.034.095.065.204.127.42l.17.597m0 0 1.817 6.358c.475 1.664.713 2.496 1.198 3.114a4 4 0 0 0 1.633 1.231c.727.297 1.592.297 3.322.297h2.285c1.75 0 2.626 0 3.359-.302a4 4 0 0 0 1.64-1.253c.484-.627.715-1.472 1.175-3.161l.06-.221c.563-2.061.844-3.092.605-3.906a3 3 0 0 0-1.308-1.713C19.92 4 18.853 4 16.716 4H4.857ZM12 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 20h2.252c1.34 0 2.01 0 2.568-.234a3 3 0 0 0 1.24-.968c.361-.484.524-1.134.849-2.434l2.182-8.728c.325-1.3.488-1.95.85-2.434a3 3 0 0 1 1.24-.968C13.737 4 14.407 4 15.747 4H22m0 0-3-3m3 3-3 3M2 4h6m14 16-3 3m3-3-3-3m3 3H12",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 21 3.208 10.952c-.609-.696-.913-1.044-1.04-1.439a2 2 0 0 1-.04-1.075c.096-.403.373-.773.928-1.513L5.04 4.28c.352-.47.528-.704.751-.873a2 2 0 0 1 .66-.33C6.72 3 7.013 3 7.6 3H12m0 18 8.792-10.048c.609-.696.913-1.044 1.04-1.439a2 2 0 0 0 .04-1.075c-.096-.403-.373-.773-.928-1.513L18.96 4.28c-.352-.47-.528-.704-.751-.873a1.999 1.999 0 0 0-.66-.33C17.28 3 16.987 3 16.4 3H12m0 18L8 9m4 12 4-12m-4-6L8 9m4-6 4 6M8 9h8M8 9H2.5M16 9h5.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 19 5 5m17 7c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 6v12m4-9v6M6.8 21h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C14 18.72 14 17.88 14 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C11.72 3 10.88 3 9.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4v16M22 4v16m-11.2 1h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C18 18.72 18 17.88 18 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C15.72 3 14.88 3 13.2 3h-2.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C6 5.28 6 6.12 6 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C8.28 21 9.12 21 10.8 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 18h12m-9 4h6m-7.2-8h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 11.72 21 10.88 21 9.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 2 17.88 2 16.2 2H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.28 3 5.12 3 6.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 14 6.12 14 7.8 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 2h18M3 22h18M7.8 18h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2v-2.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 6 17.88 6 16.2 6H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 8.28 3 9.12 3 10.8v2.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 18 6.12 18 7.8 18Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 18h3M19 6h3m-6 12h6M2 6h6m.2 16h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C13 20.48 13 19.92 13 18.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C11.48 14 10.92 14 9.8 14H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 15.52 5 16.08 5 17.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C6.52 22 7.08 22 8.2 22Zm6-12h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 8.48 19 7.92 19 6.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 2 16.92 2 15.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C11 3.52 11 4.08 11 5.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C12.52 10 13.08 10 14.2 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), Qp = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 19h3m-3 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM2 12h3m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm14-7h3m-3 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM2 19h8m4-7h8M2 5h8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), $p = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 5V2m0 20v-6m12 6v-3m0-11V2m-.8 17h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.48 22 16.92 22 15.8v-1.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 11 19.92 11 18.8 11h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C14 12.52 14 13.08 14 14.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C15.52 19 16.08 19 17.2 19Zm-12-6h1.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C10 11.48 10 10.92 10 9.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C8.48 5 7.92 5 6.8 5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 6.52 2 7.08 2 8.2v1.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 13 4.08 13 5.2 13Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), em = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 5V2m0 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm-7 17v-3m0 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM5 5V2m0 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm14 17v-8m-7-4V2M5 22v-8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), tm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 7v10m0-10H6m4 0h4m2 6v4m0-4h-2m2 0h2m-8 9h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 3v18M9 3H2m7 0h7m2 10v8m0-8h-4m4 0h4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 6v12m0-12H6.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C5 6.76 5 7.04 5 7.6V8m5-2h3.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 6.76 15 7.04 15 7.6V8m-5 10h1.5M10 18H8.5m8-5v5m0-5H14v1m2.5-1H19v1m-2.5 4h1m-1 0h-1M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), im = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 13v8m0-8h-3.2c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C14 13.38 14 13.52 14 13.8v.7m4-1.5h3.2c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v.7M18 21h1.5M18 21h-1.5M9 3v18M9 3H4.5c-.465 0-.697 0-.89.038A2 2 0 0 0 2.038 4.61C2 4.803 2 5.035 2 5.5V6m7-3h4.5c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89V6M9 21h2m-2 0H7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), am = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6h.01M10 19h4M12.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1.1 16h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C19 18.96 19 17.84 19 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C15.96 2 14.84 2 12.6 2h-1.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C5 5.04 5 6.16 5 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C8.04 22 9.16 22 11.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), om = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 15 3 3V5m5.667 5V5L13 6.563M14.667 10H16m-1.333 0h-1.334M16 14.5v.8c0 .651 0 .977-.075 1.243a2 2 0 0 1-1.382 1.382C14.277 18 13.95 18 13.3 18H13m3-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 15 3 3V5m5.667 13v-5L13 14.563M14.667 18H16m-1.333 0h-1.334M16 6.5v.8c0 .651 0 .977-.075 1.243a2 2 0 0 1-1.382 1.382C14.277 10 13.95 10 13.3 10H13m3-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 4v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 10 17.88 10 16.2 10H16M7 22l-4-4m4 4 4-4m-4 4v-8M7 3v7m12 12v-8l-2.5 2.5M19 22h2m-2 0h-2m4-18v0a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 16v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 22 17.88 22 16.2 22H16m-9 0-4-4m4 4 4-4m-4 4v-8M7 3v7m12 0V2l-2.5 2.5M19 10h2m-2 0h-2m4 6v0a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), um = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 15 3 3V5m4 8h3l-3 5h3m-3-8V8.125m0 0V6.5a1.5 1.5 0 0 1 3 0v1.625m-3 0h3m0 0V10m-4.4 12h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m6 15 3 3V5m4 0h3l-3 5h3m-3 8v-1.875m0 0V14.5a1.5 1.5 0 0 1 3 0v1.625m-3 0h3m0 0V18m-4.4 4h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 22-4-4m4 4 4-4m-4 4v-8M7 3v7m9-8h5l-5 8h5m-5 12v-3m0 0v-2.5a2.5 2.5 0 0 1 5 0V19m-5 0h5m0 0v3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 22-4-4m4 4 4-4m-4 4v-8M7 3v7m9 4h5l-5 8h5m-5-12V7m0 0V4.5a2.5 2.5 0 0 1 5 0V7m-5 0h5m0 0v3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17.881 10.921A6.507 6.507 0 0 0 11.395 5c-.832 0-1.644.164-2.36.44L9 18h10.31c2.038 0 3.69-1.65 3.69-3.682 0-2.604-2.765-4.38-5.119-3.397Zm0 0c.04.36.019 1.279-.381 2.079m-12-5.5V18M2 11.5V18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 9v6m-3-4v2m6-6v10m3-8v6m3-4v2m-8 9h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 7v10m-5-6v2M12 3v18m5-14v10m5-6v2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _m = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 17h.01m.49 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-3 13v0c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 18.2 20 16.8 20 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 2 14.8 2 12 2v0c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 4.73C4 5.8 4 7.2 4 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C7.8 22 9.2 22 12 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 17h3.249C7.319 16.032 6 14.077 6 11.823 6 8.607 8.686 6 12 6s6 2.607 6 5.823c0 2.254-1.319 4.209-3.248 5.177H18m-8 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ym = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 21h5.414A10.065 10.065 0 0 1 2 12.059C2 6.503 6.477 2 12 2s10 4.503 10 10.059c0 3.893-2.198 7.269-5.414 8.941H22",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 15h3m-3-3a6 6 0 1 1 6 6H8.974M12 11v2m-.4 9h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xm = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("g", {
		clipPath: "url(#a)",
		children: /*#__PURE__*/ M("path", {
			d: "M2 16h5m-3 3h6m-7-6a9 9 0 1 1 9 9H7m7-21h-4m2 9v4",
			stroke: e.color,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /*#__PURE__*/ M("defs", { children: /*#__PURE__*/ M("clipPath", {
		id: "a",
		children: /*#__PURE__*/ M("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		})
	}) })]
}), Sm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 9.533s6-2.033 11 1.11M7.5 12.5s5-1.858 9.5 1m-9 1.896s4-1.396 7.5.826M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 9v0c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C7.602 6 8.068 6 9 6h5.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2V15c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C16.398 18 15.932 18 15 18v0M10 5v0c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C11.602 2 12.068 2 13 2h5.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2V11c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C20.398 14 19.932 14 19 14v0M5.2 22h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C14 20.48 14 19.92 14 18.8v-5.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.48 10 11.92 10 10.8 10H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 11.52 2 12.08 2 13.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m3 3 4.084 4.084M22 22 19.7 19.7m0 0c.08.45.074.791-.036 1.06a2 2 0 0 1-1.335 1.176c-.732.196-1.859-.367-4.111-1.493l-.645-.323c-.663-.331-.995-.497-1.347-.537-.15-.017-.3-.017-.45 0-.352.04-.684.206-1.347.537l-.645.323c-2.252 1.126-3.378 1.69-4.111 1.493a2 2 0 0 1-1.335-1.176c-.287-.702.13-1.89.964-4.267.256-.73.384-1.094.378-1.452a2 2 0 0 0-.215-.868c-.161-.32-.445-.583-1.011-1.109l-.14-.13c-1.796-1.667-2.693-2.5-2.748-3.29a2 2 0 0 1 .475-1.436c.513-.602 1.73-.737 4.165-1.007.38-.043.657-.074.88-.116M19.698 19.7 7.084 7.084M9 5c1.075-2.147 1.646-3.23 2.47-3.456a2 2 0 0 1 1.06 0c.86.236 1.445 1.406 2.615 3.745l.047.095c.313.627.47.94.706 1.173a2 2 0 0 0 .553.385c.3.142.648.18 1.344.258 2.435.27 3.652.405 4.165 1.007a2 2 0 0 1 .475 1.436c-.055.79-.952 1.623-2.747 3.29-.39.362-.786.718-1.188 1.067",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9.138 4.724c.921-1.842 1.382-2.763 2.005-3.059a2 2 0 0 1 1.714 0c.623.296 1.084 1.217 2.005 3.06l.36.718c.284.569.426.853.634 1.071.184.193.405.347.65.453.276.12.592.155 1.224.225l.326.036c2.209.246 3.313.369 3.812.878a2 2 0 0 1 .553 1.674c-.098.706-.912 1.462-2.54 2.974l-.345.32c-.556.516-.834.774-.994 1.086a2.001 2.001 0 0 0-.22.893c-.005.352.123.714.377 1.44v0c.83 2.366 1.246 3.549.974 4.24a2 2 0 0 1-1.37 1.209c-.721.182-1.826-.37-4.036-1.475l-.836-.418c-.525-.262-.787-.394-1.062-.445a2.001 2.001 0 0 0-.738 0c-.275.051-.537.183-1.062.445l-.836.418c-2.21 1.105-3.315 1.657-4.035 1.475a2 2 0 0 1-1.371-1.208c-.272-.692.144-1.875.974-4.242v0c.254-.725.382-1.087.378-1.439a2 2 0 0 0-.22-.893c-.161-.312-.44-.57-.995-1.086l-.344-.32C2.49 11.242 1.677 10.486 1.58 9.78a2 2 0 0 1 .552-1.674c.5-.51 1.603-.632 3.812-.878l.326-.036c.632-.07.948-.105 1.224-.225a2 2 0 0 0 .65-.453c.208-.218.35-.502.635-1.071l.359-.719Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Em = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M11.637 2A7.78 7.78 0 0 0 22 12.363M11.637 2C6.282 2.193 2 6.595 2 11.997 2 17.52 6.479 22 12.003 22c5.402 0 9.805-4.282 9.997-9.637M11.637 2 22 12.363",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dm = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M9 11.4c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656C10.139 9 10.559 9 11.4 9h1.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .655.656c.164.32.164.74.164 1.581v1.2c0 .84 0 1.26-.164 1.581a1.5 1.5 0 0 1-.655.655c-.32.164-.74.164-1.581.164h-1.2c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.656-.655C9 13.861 9 13.441 9 12.6v-1.2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Om = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("rect", {
		x: 2,
		y: 2,
		width: 20,
		height: 20,
		rx: 6,
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), km = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 4.936A8.963 8.963 0 0 1 12 4a8.972 8.972 0 0 1 6.364 2.636M20.064 17A8.963 8.963 0 0 0 21 13a8.972 8.972 0 0 0-2.636-6.364m0 12.728A9 9 0 1 1 5.636 6.636m12.728 12.728L21 22m-2.636-2.636L5.636 6.636M3 4l2.636 2.636M20.5 4.5l-2.136 2.136M14 1h-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Am = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m20.5 4.5-2.136 2.136m0 0A9 9 0 1 0 5.636 19.364 9 9 0 0 0 18.364 6.636ZM12 10v4m2-13h-4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 20v2m0-20v2m8 8h2M2 12h2m14 6 1.5 1.5m-15-15L6 6m12 0 1.5-1.5m-15 15L6 18m11-6a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 18a5 5 0 0 1 10 0M6 22h12M12 2l3 3m-3-3L9 5m3-3v7m10 9H2m1.929-8.071L6.05 12.05m11.9 0 2.121-2.122",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 18a5 5 0 0 1 10 0M6 22h12M12 9l3-3m-3 3L9 6m3 3V2m10 16H2m1.929-8.071L6.05 12.05m11.9 0 2.121-2.122",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 22h9.5c1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C22 19.597 22 18.898 22 17.5V17c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C19.395 13 18.93 13 18 13v0m-6-6 1.119-1.12c.706-.706 1.06-1.059 1.431-1.264a3 3 0 0 1 2.899 0c.372.205.725.558 1.431 1.265v0c.649.648.973.972 1.171 1.318a3 3 0 0 1 .13 2.734c-.165.363-.457.716-1.04 1.423L12 20m-4.5-3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m5.5 5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C9.72 2 8.88 2 7.2 2h-.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.28 2 5.12 2 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22H12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6h.01M10 19h4M12.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-2.1 16h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 18.96 20 17.84 20 15.6V8.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 2 15.84 2 13.6 2h-3.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C4 5.04 4 6.16 4 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 22 8.16 22 10.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Im = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M3 10.349c0 .978 0 1.468.11 1.928.099.408.26.798.48 1.156.247.404.593.75 1.285 1.441l3.6 3.6c1.584 1.585 2.376 2.377 3.289 2.673a4 4 0 0 0 2.472 0c.913-.296 1.705-1.088 3.29-2.672l.948-.95c1.585-1.584 2.377-2.376 2.673-3.289a4 4 0 0 0 0-2.472c-.296-.913-1.088-1.705-2.672-3.29l-3.6-3.6c-.692-.691-1.038-1.037-1.442-1.285a3.998 3.998 0 0 0-1.156-.478C11.817 3 11.327 3 10.349 3H9.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 6.04 3 7.16 3 9.4v.949Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Lm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 22 .5-.5 1.58-1.58c2.773-2.773 4.159-4.159 4.678-5.757a7 7 0 0 0 0-4.326c-.52-1.598-1.905-2.984-4.678-5.757L16 3l-.5-.5M11 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm5.474-2.525-2.6-2.6c-.691-.692-1.037-1.038-1.44-1.286a3.998 3.998 0 0 0-1.157-.478C10.817 3 10.327 3 9.349 3H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 6.04 2 7.16 2 9.4v.949c0 .978 0 1.468.11 1.928.099.408.26.798.48 1.156.247.404.593.75 1.285 1.441l2.6 2.6c1.584 1.585 2.376 2.377 3.289 2.673a4 4 0 0 0 2.472 0c.913-.296 1.705-1.088 3.29-2.672l.948-.95c1.585-1.584 2.377-2.376 2.673-3.289a4 4 0 0 0 0-2.472c-.296-.913-1.088-1.705-2.672-3.29Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 2h1.8c3.92 0 5.88 0 7.378.763a7 7 0 0 1 3.059 3.06C23 7.318 23 9.28 23 13.2V16m-11-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.6-7H9.944c-1.083 0-1.624 0-2.127.133a4 4 0 0 0-1.247.574c-.428.295-.78.706-1.485 1.528l-.514.6C3.303 9.313 2.67 10.052 2.428 10.88a4 4 0 0 0 0 2.238c.242.829.875 1.568 2.143 3.046l.514.6c.704.822 1.057 1.233 1.485 1.528a4 4 0 0 0 1.247.574C8.32 19 8.861 19 9.944 19H13.6c2.24 0 3.36 0 4.217-.436a4 4 0 0 0 1.747-1.748C20 15.96 20 14.84 20 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.961 5 15.841 5 13.601 5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bm = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Vm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 10 3 3-3 3m6 0h4m-5.4 6h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 7v10m0-10H8m4 0h4m-6 15h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Um = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3v18m0-18H4m8 0h8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8v8m0-8H8m4 0h4m-6 14h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 12h6a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3H8.5c-.466 0-.699 0-.883.076a1 1 0 0 0-.54.541C7 6.801 7 7.034 7 7.5V12Zm0 0h8a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 17.24 7 16.96 7 16.4V12Zm3 10h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Km = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 12h11.5a4.5 4.5 0 0 1 4.5 4.5v0a4.5 4.5 0 0 1-4.5 4.5H5.778A1.778 1.778 0 0 1 4 19.222V12Zm0 0h8.5A4.5 4.5 0 0 0 17 7.5v0A4.5 4.5 0 0 0 12.5 3H5.444C4.647 3 4 3.647 4 4.444V12Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 9v6m0-6H9m3 0h3M4 6a2 2 0 0 0 2-2M4 6a2 2 0 1 1 2-2M4 6v12M6 4h12m0 0a2 2 0 0 0 2 2m-2-2a2 2 0 1 1 2 2m0 12a2 2 0 0 0-2 2m2-2a2 2 0 1 1-2 2m2-2V6m-2 14H6m0 0a2 2 0 1 1-2-2m2 2a2 2 0 0 0-2-2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 6h7M7 18h7m0-12-4 12m0 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ym = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 3h10M5 21h10M14 3l-4 18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6v12m0-12H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 6.76 7 7.04 7 7.6V8m5-2h3.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C17 6.76 17 7.04 17 7.6V8m-5 10h3m-3 0H9m1 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 7h4m-4 0h-2m2 0v2m0 3v5M7 7l10 10m-7 5h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qm = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3h7m-7 0H8.5M12 3v4m0 5v9M4 4l16 16",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $m = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 6h4c.736 0 1.334.597 1.334 1.333V8M12 6h-2m2 0v2.5m0 9.5h2.667M12 18H9.334M12 18v-6M6 6l12 12m-8 4h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), eh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3h5.5c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89V6m-8-3H8.5M12 3v4m0 14h4m-4 0H8m4 0v-9M4 4l16 16",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), th = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12.74 12H6m6.74 0c1.637 0 2.963 1.343 2.963 3s-1.326 3-2.962 3h-1.482c-1.636 0-2.963-1.343-2.963-3m4.445-3H18m-2.296-3c0-1.657-1.327-3-2.963-3h-1.482C9.623 6 8.296 7.343 8.296 9c0 .259.033.51.093.75M10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10.889 12h2.222c2.454 0 4.444 2.015 4.444 4.5s-1.99 4.5-4.444 4.5h-2.222c-2.455 0-4.445-2.015-4.445-4.5m11.111-9c0-2.485-1.99-4.5-4.444-4.5h-2.222C8.434 3 6.444 5.015 6.444 7.5c0 .388.049.765.14 1.125M3 12h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 18h8m0-12v5a4 4 0 0 1-8 0V6m2 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ih = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 21h12m0-18v8a6 6 0 0 1-12 0V3",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ah = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 3v18m0-18H6.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656C4 4.139 4 4.559 4 5.4V6m8-3h5.6c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .655.656c.164.32.164.74.164 1.581V6m-8 15h5m-5 0H7",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 5h1.5M9 8h1.5M9 11h1.5m4.5 2V5a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v8a5 5 0 1 0 6 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 4v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v0m0-9v9m0-9s-1-2-3-2H7.118c-1.461 0-2.192 0-2.782.268A3 3 0 0 0 3.06 3.36c-.354.543-.465 1.265-.687 2.71l-.525 3.414c-.291 1.892-.437 2.837-.16 3.574a3 3 0 0 0 1.335 1.555C3.709 15 4.666 15 6.58 15h.907a1 1 0 0 1 .917 1.39l-.004.01-1.294 3.019A1.852 1.852 0 0 0 8.808 22v0c.123 0 .24-.049.328-.135L18 13",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ch = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 3v12M14.2 2H7.118c-1.461 0-2.192 0-2.782.267A3 3 0 0 0 3.06 3.361c-.354.542-.465 1.265-.687 2.71l-.523 3.4c-.293 1.904-.44 2.857-.157 3.598a3 3 0 0 0 1.32 1.539c.69.392 1.653.392 3.58.392h1.867c.234 0 .35 0 .436.01a1.5 1.5 0 0 1 1.265 1.92c-.024.082-.07.189-.162.403l-.917 2.14A1.813 1.813 0 0 0 10.75 22v0c.16 0 .314-.064.427-.177l5.011-5.011c1.038-1.038 1.557-1.557 1.928-2.162a6 6 0 0 0 .718-1.735c.166-.69.166-1.424.166-2.891V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 2 15.88 2 14.2 2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 19s1 2 3 2h7.883c1.46 0 2.191 0 2.781-.267a3 3 0 0 0 1.275-1.094c.354-.542.465-1.265.687-2.71l.525-3.414c.291-1.891.437-2.837.16-3.574a3 3 0 0 0-1.334-1.554C20.29 8 19.334 8 17.42 8v0c-.804 0-1.207 0-1.459-.168a1 1 0 0 1-.428-.65c-.055-.297.103-.667.42-1.406l1.007-2.35A1.74 1.74 0 0 0 15.36 1v0a.87.87 0 0 0-.615.255L6 10m-4 9v-9a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 8v12m7.8 1h7.082c1.461 0 2.192 0 2.782-.267a3 3 0 0 0 1.275-1.094c.354-.542.465-1.265.687-2.71l.523-3.4c.293-1.904.44-2.857.157-3.598a3 3 0 0 0-1.32-1.539C20.296 8 19.333 8 17.406 8h-1.142c-.878 0-1.316 0-1.614-.136a1.5 1.5 0 0 1-.875-1.327c-.008-.327.165-.73.51-1.537l.675-1.574A1.74 1.74 0 0 0 13.36 1v0a.87.87 0 0 0-.615.255L7.812 6.188C6.774 7.226 6.255 7.745 5.884 8.35a6 6 0 0 0-.718 1.735C5 10.775 5 11.509 5 12.976V16.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C7.28 21 8.12 21 9.8 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M9 11v2m0-7v2m0 8v2m-7-2.823V17.4c0 .557 0 .836.037 1.07a3 3 0 0 0 2.494 2.493C4.764 21 5.043 21 5.6 21h12.8c.557 0 .836 0 1.07-.037a3 3 0 0 0 2.493-2.494C22 18.236 22 17.957 22 17.4v-2.223a.176.176 0 0 0-.177-.177v0A2.823 2.823 0 0 1 19 12.177v-.354A2.823 2.823 0 0 1 21.823 9v0A.176.176 0 0 0 22 8.824V6.6c0-.557 0-.836-.037-1.07a3 3 0 0 0-2.494-2.493C19.236 3 18.957 3 18.4 3H5.6c-.557 0-.836 0-1.07.037A3 3 0 0 0 2.038 5.53C2 5.764 2 6.043 2 6.6v2.224c0 .097.079.176.176.176v0A2.824 2.824 0 0 1 5 11.823v.354A2.824 2.824 0 0 1 2.176 15v0a.176.176 0 0 0-.176.177Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 8v4l3 2m-3 8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ph = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10.5 10.5 12 12M7.757 7.757A6 6 0 1 0 12 6v1.5M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8.667 8.667 12 12M4.929 4.929A9.969 9.969 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2v3.333",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m15 14.5.6.5v0c1.66 1.384 2.49 2.076 2.768 2.601a3 3 0 0 1-1.51 4.173c-.55.226-1.63.226-3.792.226H12c-3.038 0-4.558 0-5.278-.44a3 3 0 0 1-1.276-3.526c.271-.799 1.438-1.771 3.773-3.716l5.562-4.636c2.335-1.945 3.502-2.918 3.773-3.716a3 3 0 0 0-1.276-3.526C16.558 2 15.038 2 12 2h-1.066c-2.161 0-3.242 0-3.791.226A3 3 0 0 0 5.633 6.4C5.908 6.924 6.738 7.616 8.4 9v0l.6.5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gh = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M1 12a9 9 0 0 1 9-9h4a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9h-4a9 9 0 0 1-9-9v0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M14 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), _h = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M1 12a9 9 0 0 1 9-9h4a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9h-4a9 9 0 0 1-9-9v0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M18 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), vh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 5a3 3 0 0 1-3 3m3-3a3 3 0 1 0-3 3m3-3h8M5 8v8M16 5a3 3 0 0 0 3 3m-3-3a3 3 0 1 1 3 3M5 16a3 3 0 1 0 3 3m-3-3a3 3 0 0 1 3 3m0 0h8m0 0a3 3 0 1 0 3-3m-3 3a3 3 0 0 1 3-3m0 0V8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m4 5 .646 10.976c.124 2.12.187 3.18.64 3.985a4 4 0 0 0 1.733 1.635C7.849 22 8.91 22 11.035 22h1.93c2.124 0 3.186 0 4.016-.404a4 4 0 0 0 1.734-1.635c.452-.805.515-1.865.64-3.985L20 5M4 5H2m2 0h16m0 0h2m-6 0-.453-1.359c-.197-.59-.295-.885-.478-1.103a1.5 1.5 0 0 0-.601-.434C14.203 2 13.892 2 13.27 2h-2.54c-.622 0-.933 0-1.198.104a1.5 1.5 0 0 0-.602.434c-.182.218-.28.513-.477 1.103L8 5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m4 5 .646 10.976c.124 2.12.187 3.18.64 3.985a4 4 0 0 0 1.733 1.635C7.849 22 8.91 22 11.035 22h1.93c2.124 0 3.186 0 4.016-.404a4 4 0 0 0 1.734-1.635c.452-.805.515-1.865.64-3.985L20 5M4 5H2m2 0h16m0 0h2m-6 0-.453-1.359c-.197-.59-.295-.885-.478-1.103a1.5 1.5 0 0 0-.601-.434C14.203 2 13.892 2 13.27 2h-2.54c-.622 0-.933 0-1.198.104a1.5 1.5 0 0 0-.602.434c-.182.218-.28.513-.477 1.103L8 5m2 5v7m4-7v4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 16v-4m0 4h-4m4 0-3.58-4.296a2.025 2.025 0 0 0-2.988-.136v0c-.79.79-2.073.79-2.864 0L6 9m4 13h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 18v-6m0 6h-6m6 0-7-7c-.545-.545-.818-.818-1.112-.964a2 2 0 0 0-1.776 0c-.294.146-.567.419-1.112.964v0c-.545.545-.818.818-1.112.964a2 2 0 0 1-1.776 0C7.818 11.818 7.545 11.545 7 11L2 6",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ch = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M18 8v4m0-4h-4m4 0-3.58 4.296a2.025 2.025 0 0 1-2.988.136v0a2.025 2.025 0 0 0-2.864 0L6 15m4 7h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M22 6v6m0-6h-6m6 0-7 7c-.545.545-.818.818-1.112.964a2 2 0 0 1-1.776 0c-.294-.146-.567-.419-1.112-.964v0c-.545-.545-.818-.818-1.112-.964a2 2 0 0 0-1.776 0c-.294.146-.567.419-1.112.964l-5 5",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Th = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 5H3c-.465 0-.697 0-.888.051a1.5 1.5 0 0 0-1.06 1.06C1 6.304 1 6.536 1 7v0c0 .93 0 1.395.102 1.776a3 3 0 0 0 2.122 2.122C3.605 11 4.07 11 5 11v0m14-6h2c.465 0 .698 0 .888.051a1.5 1.5 0 0 1 1.06 1.06C23 6.304 23 6.536 23 7v0c0 .93 0 1.395-.102 1.776a3 3 0 0 1-2.122 2.122C20.395 11 19.93 11 19 11v0m-7 3v4m-2.91 4h5.82A1.09 1.09 0 0 0 16 20.91v0A2.909 2.909 0 0 0 13.09 18h-2.18A2.91 2.91 0 0 0 8 20.91v0c0 .602.488 1.09 1.09 1.09ZM12 14v0c1.861 0 2.792 0 3.545-.245a5 5 0 0 0 3.21-3.21C19 9.792 19 8.861 19 7v-.5c0-1.398 0-2.097-.228-2.648a3 3 0 0 0-1.624-1.624C16.597 2 15.898 2 14.5 2h-5c-1.398 0-2.097 0-2.648.228a3 3 0 0 0-1.624 1.624C5 4.403 5 5.102 5 6.5V7c0 1.861 0 2.792.245 3.545a5 5 0 0 0 3.21 3.21C9.208 14 10.139 14 12 14Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Eh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M10 19h4m-4 0a3 3 0 1 1-6 0m6 0a3 3 0 1 0-6 0m10 0a3 3 0 1 0 6 0m-6 0a3 3 0 1 1 6 0m0 0v0a3 3 0 0 0 3-3V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C20.72 2 19.88 2 18.2 2h-2.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C11 4.28 11 5.12 11 6.8v1c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C9.48 11 8.92 11 7.8 11H1.5M4 19v0c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C1 17.398 1 16.932 1 16v-3.227c0-.66 0-.99.052-1.31.047-.285.124-.564.23-.832.12-.302.29-.585.63-1.151l.224-.373c.68-1.133 1.02-1.7 1.487-2.11a4 4 0 0 1 1.425-.807C5.642 6 6.302 6 7.624 6H11",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m8 1 .16.12c1.377 1.033 2.066 1.55 2.822 1.748a4 4 0 0 0 2.036 0c.756-.199 1.445-.715 2.822-1.748L16 1M8 20l-1 2m9-2 1 2m-4.5-6a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m-3.1 4h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 16.96 22 15.84 22 13.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 4 17.84 4 15.6 4H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 7.04 2 8.16 2 10.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 20 6.16 20 8.4 20Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M23 3.304c0 2.872-1.642 3.931-1.642 3.931v.84C21.358 14.104 16.67 21 8.127 21 5.47 21 3.037 20.263 1 18.961c2.443.3 4.912-.38 6.861-1.865-2.036-.043-3.762-1.344-4.338-3.166.72.1 1.37.088 2.08-.087-2.17-.443-3.718-2.349-3.718-4.51.62.347 1.373.52 2.125.563C2.004 8.61 1.31 5.85 2.55 3.824c2.301 2.733 5.754 4.554 9.605 4.771a4.198 4.198 0 0 1-.133-1.04C12.022 5.038 14.102 3 16.67 3c1.328 0 2.523.52 3.408 1.431A9.936 9.936 0 0 0 23 3.304Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 2C7.025 2 4.495 5.666 3.226 8.946c-.466 1.207-.7 1.81-.51 2.688.141.652.726 1.505 1.284 1.872C4.75 14 5.572 14 7.217 14h9.566c1.645 0 2.467 0 3.217-.494.558-.367 1.143-1.22 1.284-1.872.19-.878-.044-1.482-.51-2.688C19.505 5.666 16.974 2 12 2Zm0 0C9.5 2 8 8.5 8 14h8c0-6-1.5-12-4-12Zm0 12v6a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ah = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 14v-4m0 4h4m-4 0s3-4 6.5-4c4.5 0 5.5 4 5.5 4m-8 8h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 15V7m0 8h7.778M2 15s5-8 11-8c8 0 9 8 9 8",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 8h7.5a4.5 4.5 0 0 1 4.5 4.5v0a4.5 4.5 0 0 1-4.5 4.5H11M6 8l2-2M6 8l2 2m2 12h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 6h13a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7h-5M2 6l4-4M2 6l4 4",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ph = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 5v5m.5 3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m17 12 5-5m-5 5V8m0 4h4m-8-6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ih = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 7v6m0 0 3-3m-3 3-3-3m-4-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 10h6m0 0-3-3m3 3-3 3m-7-7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 7v6m0-6-3 3m3-3 3 3M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m17 12 5-5m0 0h-4m4 0v4m-9-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m17 10 2 2 4-4M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vh = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Hh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m18 12 2.5-2.5m0 0L23 7m-2.5 2.5L18 7m2.5 2.5L23 12M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 10h6M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20 7v3m0 0v3m0-3h-3m3 0h3M13 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H6.8A4.8 4.8 0 0 0 2 18.8v0A3.2 3.2 0 0 0 5.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gh = (e) => /*#__PURE__*/ N("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /*#__PURE__*/ M("path", {
		d: "M2 11.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C6.56 2 8.24 2 11.6 2h.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C22 6.56 22 8.24 22 11.6v.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C17.44 22 15.76 22 12.4 22h-.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C2 17.44 2 15.76 2 12.4v-.8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Kh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 18.8A4.8 4.8 0 0 1 8.8 14h6.4a4.8 4.8 0 0 1 4.8 4.8v0a3.2 3.2 0 0 1-3.2 3.2H7.2A3.2 3.2 0 0 1 4 18.8v0ZM16 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 10a4 4 0 0 0 0-8m2 20h2.8a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H17m-5-8a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM4.2 22h7.6a3.2 3.2 0 0 0 3.2-3.2v0a4.8 4.8 0 0 0-4.8-4.8H5.8A4.8 4.8 0 0 0 1 18.8v0A3.2 3.2 0 0 0 4.2 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 15c0-5 4-9 9-9m7-.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-13 13a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m9 12 2 2 5-5M7.612 4H6.366c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656c-.163.32-.163.74-.163 1.581v1.22c0 .326 0 .489-.033.644a1.5 1.5 0 0 1-.145.395c-.075.14-.18.264-.391.512l-1.082 1.277c-.467.552-.7.827-.79 1.136a1.5 1.5 0 0 0 0 .832c.09.309.323.584.79 1.136l1.082 1.277c.21.248.316.372.39.512a1.5 1.5 0 0 1 .146.395c.033.155.033.318.033.644v1.22c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.58.164h1.247c.329 0 .493 0 .65.034.138.03.272.08.397.147.14.076.266.183.515.397l1.264 1.083c.554.475.832.713 1.143.803.274.08.565.08.838 0 .311-.09.588-.328 1.143-.803l1.264-1.083c.25-.214.374-.321.515-.397.125-.068.259-.117.397-.147.157-.034.321-.034.65-.034H17.6c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .655-.656c.164-.32.164-.74.164-1.581v-1.212c0-.329 0-.493.034-.65.03-.138.08-.272.147-.397.076-.14.183-.266.397-.515l1.083-1.264c.475-.554.713-.832.803-1.143a1.5 1.5 0 0 0 0-.838c-.09-.311-.328-.588-.803-1.143l-1.083-1.264c-.214-.25-.321-.374-.397-.515a1.497 1.497 0 0 1-.147-.397C20 8.105 20 7.94 20 7.612V6.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C18.861 4 18.441 4 17.6 4h-1.212c-.329 0-.493 0-.65-.034a1.498 1.498 0 0 1-.397-.147c-.14-.076-.266-.183-.515-.397L13.562 2.34c-.554-.475-.832-.713-1.143-.804a1.5 1.5 0 0 0-.838 0c-.311.091-.588.329-1.143.804L9.174 3.422c-.25.214-.374.321-.515.397a1.5 1.5 0 0 1-.397.147C8.105 4 7.94 4 7.612 4Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m1 1 2.621 2.621M21.5 21.501l-3.121-3.122M3.621 3.621a3.623 3.623 0 0 0-.56.334 5 5 0 0 0-1.106 1.106C1 6.375 1 8.251 1 12.001c0 3.749 0 5.624.955 6.938a5 5 0 0 0 1.106 1.106C4.375 21 6.251 21 10 21c3.75 0 5.625 0 6.939-.955a5 5 0 0 0 1.106-1.106c.128-.176.238-.361.334-.56M3.621 3.621 18.379 18.38M7 3.03C7.844 3 8.831 3 10 3c3.75 0 5.625 0 6.939.955a5 5 0 0 1 1.106 1.106c.657.905.862 2.075.926 3.94m0 0c.029.843.029 1.83.029 3v1.171c0 .203 0 .305.013.403a1.5 1.5 0 0 0 .297.717c.06.078.132.15.276.294v0c.71.71 1.064 1.064 1.34 1.179a1.5 1.5 0 0 0 1.96-.812c.114-.276.114-.778.114-1.781v-2.393c0-1.539 0-2.308-.318-2.715a1.5 1.5 0 0 0-1.147-.576c-.517-.012-1.134.447-2.368 1.366L18.97 9Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M14 8.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m6 6.5.16.12c1.236.927 1.854 1.39 2.371 1.38a1.5 1.5 0 0 0 1.15-.575C23 15.517 23 14.745 23 13.2v-2.4c0-1.545 0-2.317-.319-2.725a1.5 1.5 0 0 0-1.15-.575c-.517-.01-1.135.453-2.371 1.38L19 9v6ZM9 21h2c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C19 17.2 19 15.8 19 13v-2c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C15.2 3 13.8 3 11 3H9c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 1.545 5.73C1 6.8 1 8.2 1 11v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C4.8 21 6.2 21 9 21Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qh = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 19v0a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v0M5 5v0a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v0m-4.997 8.331-1.515 1.01c-.808.54-1.213.809-1.548.789a1 1 0 0 1-.737-.395C10 14.467 10 13.982 10 13.01v-2.02c0-.972 0-1.457.203-1.725a1 1 0 0 1 .737-.395c.335-.02.74.25 1.548.788l1.515 1.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948ZM8.4 19h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 15.96 22 14.84 22 12.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 5 17.84 5 15.6 5H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 8.04 2 9.16 2 11.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 19 6.16 19 8.4 19Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $h = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M13.5 4H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 7.04 2 8.16 2 10.4v5.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h5.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 18.96 20 17.84 20 15.6v-5.1M20 1v3m0 0v3m0-3h-3m3 0h3m-9.997 10.331-1.515 1.01c-.808.54-1.213.809-1.548.789a1 1 0 0 1-.738-.395C9 15.467 9 14.982 9 14.01v-2.02c0-.972 0-1.457.202-1.725a1 1 0 0 1 .738-.395c.335-.02.74.25 1.548.788l1.515 1.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), eg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 5h12M8 2h8m-1.997 14.331-1.515 1.01c-.808.54-1.213.809-1.548.789a1 1 0 0 1-.737-.395C10 17.467 10 16.982 10 16.01v-2.02c0-.972 0-1.457.203-1.725a1 1 0 0 1 .737-.395c.335-.02.74.25 1.548.788l1.515 1.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948ZM8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6v-1.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 8 17.84 8 15.6 8H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 11.04 2 12.16 2 14.4v1.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 0h12m0 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ng = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m17 15 2.5-2.5m0 0L22 10m-2.5 2.5L17 10m2.5 2.5L22 15M8.837 6.745v0c1.197-1.796 1.796-2.694 2.274-2.931a2 2 0 0 1 2.622.794C14 5.07 14 6.15 14 8.308v7.384c0 2.158 0 3.237-.267 3.7a2 2 0 0 1-2.622.794c-.479-.237-1.077-1.135-2.274-2.931v0c-.237-.355-.355-.532-.498-.674a2 2 0 0 0-1.01-.54C7.131 16 6.92 16 6.492 16H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.48 2 13.92 2 12.8v-1.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 8 4.08 8 5.2 8h1.292c.426 0 .64 0 .837-.04a2 2 0 0 0 1.01-.54c.143-.143.261-.32.498-.675Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 10c.598.4 1 1.145 1 2s-.402 1.6-1 2m1-8c1.793 1.198 3 3.436 3 6s-1.207 4.802-3 6M8.837 6.745v0c1.197-1.796 1.796-2.694 2.274-2.931a2 2 0 0 1 2.622.794C14 5.07 14 6.15 14 8.308v7.384c0 2.158 0 3.237-.267 3.7a2 2 0 0 1-2.622.794c-.479-.237-1.077-1.135-2.274-2.931v0c-.237-.355-.355-.532-.498-.674a2 2 0 0 0-1.01-.54C7.131 16 6.92 16 6.492 16H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.48 2 13.92 2 12.8v-1.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 8 4.08 8 5.2 8h1.292c.426 0 .64 0 .837-.04a2 2 0 0 0 1.01-.54c.143-.143.261-.32.498-.675Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ig = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M19 10c.598.4 1 1.145 1 2s-.402 1.6-1 2M9.837 6.745v0c1.197-1.796 1.796-2.694 2.274-2.931a2 2 0 0 1 2.622.794C15 5.07 15 6.15 15 8.308v7.384c0 2.158 0 3.237-.267 3.7a2 2 0 0 1-2.622.794c-.479-.237-1.077-1.135-2.274-2.931v0c-.237-.355-.355-.532-.498-.674a2 2 0 0 0-1.01-.54C8.131 16 7.92 16 7.492 16H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 14.48 3 13.92 3 12.8v-1.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 8 5.08 8 6.2 8h1.292c.426 0 .64 0 .837-.04a2 2 0 0 0 1.01-.54c.143-.143.261-.32.498-.675Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ag = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 12.8v-1.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.52 8 7.08 8 8.2 8h1.292c.426 0 .64 0 .837-.04a2 2 0 0 0 1.01-.54c.143-.143.261-.32.498-.675 1.197-1.796 1.796-2.694 2.274-2.931a2 2 0 0 1 2.622.794C17 5.07 17 6.15 17 8.308v7.384c0 2.158 0 3.237-.267 3.7a2 2 0 0 1-2.622.794c-.479-.237-1.077-1.135-2.274-2.931-.237-.355-.355-.532-.498-.674a2 2 0 0 0-1.01-.54C10.131 16 9.92 16 9.492 16H8.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C5 14.48 5 13.92 5 12.8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), og = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 10c.598.399 1 1.145 1 2 0 .358-.07.697-.197 1M18 6c1.793 1.197 3 3.436 3 6a7.794 7.794 0 0 1-.59 3c-.147.35-.318.685-.511 1m-5.9-2v1.691c0 2.158 0 3.238-.266 3.701a2 2 0 0 1-2.622.794c-.479-.238-1.077-1.136-2.275-2.931-.236-.355-.354-.533-.498-.675a2 2 0 0 0-1.01-.54c-.197-.04-.41-.04-.837-.04H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.48 2 13.92 2 12.8v-1.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 8 4.079 8 5.199 8H6.49c.427 0 .64 0 .838-.04A2 2 0 0 0 7.8 7.8M14 14 7.8 7.8M14 14l7 7M3 3l4.8 4.8m1.872-2.3c.671-.981 1.087-1.512 1.44-1.687a2 2 0 0 1 2.621.794C14 5.07 14 6.15 14 8.307V10",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4v11.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 6 17.84 6 15.6 6H12m10 5h-.5a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h.5M7.5 14h5M17 6l-1.08-1.44c-.704-.939-1.056-1.408-1.502-1.746a4 4 0 0 0-1.32-.66C12.56 2 11.973 2 10.8 2H4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h13Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4v11.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 6 17.84 6 15.6 6H12m10 5h-.5a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h.5M7 14h6m0 0-2.5-2.5M13 14l-2.5 2.5M17 6l-1.08-1.44c-.704-.939-1.056-1.408-1.502-1.746a4 4 0 0 0-1.32-.66C12.56 2 11.973 2 10.8 2H4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h13Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4v11.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 22 6.16 22 8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C22 18.96 22 17.84 22 15.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C18.96 6 17.84 6 15.6 6H12m10 5h-.5a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h.5m-12-5.5V14m0 0v2.5m0-2.5H7.5m2.5 0h2.5M17 6l-1.08-1.44c-.704-.939-1.056-1.408-1.502-1.746a4 4 0 0 0-1.32-.66C12.56 2 11.973 2 10.8 2H4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h13Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ug = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 4v13.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.72 22 18.88 22 17.2v-6.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 6 18.88 6 17.2 6H12m10 5h-.5a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h.5M17 6l-1.08-1.44c-.704-.939-1.056-1.408-1.502-1.746a4 4 0 0 0-1.32-.66C12.56 2 11.973 2 10.8 2H4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h13Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 9v3l2 1.5M16 4l-.166-.625c-.227-.85-.34-1.275-.583-1.591a2 2 0 0 0-.821-.631C14.062 1 13.622 1 12.742 1h-1.484c-.88 0-1.32 0-1.687.153a2 2 0 0 0-.822.63c-.242.317-.356.742-.582 1.592L8 4m8 16-.166.625c-.227.85-.34 1.275-.583 1.591a2 2 0 0 1-.821.631c-.368.153-.808.153-1.688.153h-1.484c-.88 0-1.32 0-1.687-.152a2 2 0 0 1-.822-.632c-.242-.316-.356-.741-.582-1.591L8 20m4 0v0c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12v0c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C16.2 4 14.8 4 12 4v0c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 4.545 6.73C4 7.8 4 9.2 4 12v0c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C7.8 20 9.2 20 12 20Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 10v2l1.5 1M16 5l-.394-1.576c-.217-.867-.325-1.3-.567-1.623a2 2 0 0 0-.826-.645C13.842 1 13.395 1 12.502 1h-1.004c-.893 0-1.34 0-1.711.156a2 2 0 0 0-.826.645c-.242.323-.35.756-.567 1.623L8 5m8 14-.394 1.576c-.217.867-.325 1.3-.567 1.623a2.001 2.001 0 0 1-.826.645c-.371.156-.818.156-1.711.156h-1.004c-.893 0-1.34 0-1.711-.156a2.001 2.001 0 0 1-.826-.645c-.242-.323-.35-.756-.567-1.623L8 19m4 1v0a8 8 0 0 0 8-8v0a8 8 0 0 0-8-8v0a8 8 0 0 0-8 8v0a8 8 0 0 0 8 8Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M7 16.246A7.966 7.966 0 0 0 12 18c1.698 0 3.273-.529 4.568-1.431M7 16.245A7.985 7.985 0 0 1 4 10c0-1.698.53-3.273 1.432-4.568M7 16.246c0 1.777-3.332 3.252-1.514 5.141.59.613 1.832.613 4.315.613h4.398c2.483 0 3.724 0 4.315-.613.962-1 .375-2.166-.288-3.161m0 0L22 22m-3.774-3.774-1.658-1.657m0 0L5.432 5.431M18.93 14A8 8 0 0 0 8 3.07M5.432 5.432 2 2m10 6a2 2 0 0 1 2 2",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "m7 16.5-.304.418c-1.192 1.64-1.789 2.46-1.767 3.144A2 2 0 0 0 5.7 21.58c.542.42 1.555.42 3.583.42h5.432c2.028 0 3.041 0 3.583-.42a2 2 0 0 0 .773-1.518c.02-.684-.575-1.504-1.768-3.144L17 16.5m3-6.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M8 4.5v-.3c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 1 10.08 1 11.2 1h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v.3M12 18a4 4 0 0 1-4-4m4 8v0a9 9 0 0 0 9-9v0a9 9 0 0 0-9-9v0a9 9 0 0 0-9 9v0a9 9 0 0 0 9 9Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M17 6v0c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143C22 9.606 22 10.07 22 11v3c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C18.2 22 16.8 22 14 22h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C2 18.2 2 16.8 2 14v-3c0-.93 0-1.394.077-1.78A4 4 0 0 1 5.22 6.077C5.606 6 6.07 6 7 6v0m5 4 1-4m-3 11h4m-3.502-7h3.004c.893 0 1.34 0 1.711-.156a2 2 0 0 0 .826-.645c.242-.323.35-.756.567-1.623l.4-1.6c.339-1.355.508-2.033.343-2.567a2 2 0 0 0-.874-1.12C15.997 2 15.298 2 13.9 2h-3.803c-1.397 0-2.095 0-2.573.29a2 2 0 0 0-.874 1.12c-.165.533.004 1.21.343 2.566l.4 1.6c.217.867.325 1.3.567 1.623a2 2 0 0 0 .826.645c.371.156.818.156 1.711.156Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), _g = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 13h2.588c.514 0 .77 0 1-.076a1.5 1.5 0 0 0 .546-.32c.177-.164.302-.39.552-.838l.515-.928c.254-.456.38-.685.4-1.028a1.863 1.863 0 0 0-.214-.86c-.178-.295-.334-.397-.646-.6C15.748 7.705 14.168 7 12 7c-2.167 0-3.748.705-4.74 1.35-.313.203-.47.305-.647.6-.125.206-.228.62-.214.86.02.343.146.572.4 1.028l.515.928c.25.449.375.674.552.837a1.5 1.5 0 0 0 .546.321c.23.076.486.076 1 .076H12Zm0 0-2-3m0 7h4m-2.4 5h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
}), vg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12.5 5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1M18 17h-.667c-.097 0-.145 0-.186-.003a1.229 1.229 0 0 1-1.144-1.144c-.003-.04-.003-.09-.003-.186v-.7c0-.689 0-1.033-.134-1.296a1.23 1.23 0 0 0-.537-.537C15.066 13 14.722 13 14.034 13h-.068c-.688 0-1.032 0-1.295-.134a1.23 1.23 0 0 1-.537-.537C12 12.066 12 11.722 12 11.034V8a2 2 0 0 0 2 2h1m-6-.87a4.002 4.002 0 0 0 1 7.874c1.014 0 1.94-.378 2.646-1M11.6 22h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M21 22h-1v0a2 2 0 0 1-2-2v-1c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C16.398 16 15.932 16 15 16v0c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C12 14.398 12 13.932 12 13V9a3 3 0 0 0 3 3h1m-7-2a6 6 0 1 0 4.472 10M14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 10a9.586 9.586 0 0 1 7-3 9.586 9.586 0 0 1 7 3m-2 2a7.237 7.237 0 0 0-5-2c-1.935 0-3.694.76-5 2m7.5 2c-.808-.624-1.355-1-2.5-1s-1.692.376-2.5 1m3 2.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m.1 5.5h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5 10a9.513 9.513 0 0 1 2.903-2.097M19 10a9.586 9.586 0 0 0-7-3c-.338 0-.671.017-1 .05M9.5 14c.808-.624 1.355-1 2.5-1 .48 0 .856.066 1.19.19M17 12a7.256 7.256 0 0 0-3.5-1.844M7 12a7.264 7.264 0 0 1 3.22-1.78M6 6l1.903 1.903M17 17l-3.81-3.81m0 0-2.97-2.97m0 0L7.903 7.903M12.5 16.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1m.1 5.5h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C6.56 22 8.24 22 11.6 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M5.146 12.718a9.971 9.971 0 0 1 5.022-2.55M14 10.2a9.975 9.975 0 0 1 4.853 2.518M8.108 15.433A5.976 5.976 0 0 1 12 14c.925 0 1.8.21 2.583.583m7.737-4.043A13.963 13.963 0 0 0 12 6c-.68 0-1.347.048-2 .142M1.68 10.54a14.024 14.024 0 0 1 5.262-3.598M3 3l18 18m-8.5-3a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M1.68 10.54A13.963 13.963 0 0 1 12 6c4.085 0 7.76 1.75 10.32 4.54m-3.467 2.178A9.966 9.966 0 0 0 12 10a9.966 9.966 0 0 0-6.854 2.718m10.745 2.715A5.977 5.977 0 0 0 12 14c-1.485 0-2.844.54-3.892 1.433M12.5 18a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M2 12v2.866c0 1.467 0 2.2.269 2.792a3 3 0 0 0 1.098 1.275c.545.354 1.27.463 2.721.68l4.412.662M2 12V9.134c0-1.467 0-2.2.269-2.792a3 3 0 0 1 1.098-1.275c.545-.354 1.27-.463 2.721-.68l4.412-.662M2 12h20m0 0V7.574c0-1.921 0-2.882-.39-3.57a3 3 0 0 0-1.534-1.32c-.738-.285-1.688-.142-3.588.143l-5.988.898M22 12v4.426c0 1.921 0 2.882-.39 3.57a3 3 0 0 1-1.534 1.32c-.738.285-1.688.142-3.588-.143l-5.988-.898m0-16.55v16.55",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M6 17h2.5M6 11.5h10.25A2.75 2.75 0 0 1 19 14.25v0A2.75 2.75 0 0 1 16.25 17H12m0 0 2-2m-2 2 2 2M6 6h12m-8 16h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C22 18.2 22 16.8 22 14v-4c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C18.2 2 16.8 2 14 2h-4c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 2.545 4.73C2 5.8 2 7.2 2 10v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C5.8 22 7.2 22 10 22Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Eg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3 19h4m-4-8h15a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4h-6m0 0 3-3m-3 3 3 3M3 3h18",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M15 16a7 7 0 0 0 6.71-9l-2.447 2.447h0c-.792.792-1.188 1.188-1.645 1.337a2 2 0 0 1-1.236 0c-.457-.149-.853-.545-1.645-1.337l-.184-.184c-.792-.792-1.188-1.188-1.337-1.645a2 2 0 0 1 0-1.236c.149-.457.545-.853 1.337-1.645L17 2.29A7 7 0 0 0 8 9c0 1.074.068 2.59.5 3.5l-6 6h0c-.08.08-.12.12-.152.155a2 2 0 0 0 0 2.69c.033.036.072.075.152.155h0c.08.08.12.12.155.151a2 2 0 0 0 2.69 0c.036-.032.075-.071.155-.151l6-6c.91.432 2.426.5 3.5.5Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Og = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2m0 20C6.477 22 2 17.523 2 12S6.477 2 12 2m0 20c3.314 0 6-2.238 6-5 0-2.761-2.686-5-6-5S6 9.762 6 7c0-2.761 2.686-5 6-5m-.5 5a.5.5 0 1 1-1 0m1 0a.5.5 0 1 0-1 0m1 0h-1m3 10a.5.5 0 1 1-1 0m1 0a.5.5 0 1 0-1 0m1 0h-1",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		clipRule: "evenodd",
		d: "m10 15 5-3-5-3v6Z",
		stroke: e.color,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ag = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20.47 21.53a.75.75 0 1 0 1.06-1.06l-1.06 1.06ZM8 10.25a.75.75 0 0 0 0 1.5v-1.5Zm6 1.5a.75.75 0 0 0 0-1.5v1.5ZM11.75 8a.75.75 0 0 0-1.5 0h1.5Zm-1.5 6a.75.75 0 0 0 1.5 0h-1.5Zm.75 5.25A8.25 8.25 0 0 1 2.75 11h-1.5c0 5.385 4.365 9.75 9.75 9.75v-1.5ZM2.75 11A8.25 8.25 0 0 1 11 2.75v-1.5c-5.385 0-9.75 4.365-9.75 9.75h1.5ZM11 2.75A8.25 8.25 0 0 1 19.25 11h1.5c0-5.385-4.365-9.75-9.75-9.75v1.5ZM19.25 11c0 2.278-.923 4.34-2.416 5.834l1.06 1.06A9.722 9.722 0 0 0 20.75 11h-1.5Zm-2.416 5.834A8.222 8.222 0 0 1 11 19.25v1.5a9.722 9.722 0 0 0 6.894-2.856l-1.06-1.06Zm0 1.06 3.636 3.636 1.06-1.06-3.636-3.636-1.06 1.06ZM8 11.75h3v-1.5H8v1.5Zm3 0h3v-1.5h-3v1.5Zm.75-.75V8h-1.5v3h1.5Zm-1.5 0v3h1.5v-3h-1.5Z",
		fill: e.color
	})
}), jg = (e) => /*#__PURE__*/ M("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M20.47 21.53a.75.75 0 1 0 1.06-1.06l-1.06 1.06ZM8 10.25a.75.75 0 0 0 0 1.5v-1.5Zm6 1.5a.75.75 0 0 0 0-1.5v1.5Zm-3 7.5A8.25 8.25 0 0 1 2.75 11h-1.5c0 5.385 4.365 9.75 9.75 9.75v-1.5ZM2.75 11A8.25 8.25 0 0 1 11 2.75v-1.5c-5.385 0-9.75 4.365-9.75 9.75h1.5ZM11 2.75A8.25 8.25 0 0 1 19.25 11h1.5c0-5.385-4.365-9.75-9.75-9.75v1.5ZM19.25 11c0 2.278-.923 4.34-2.416 5.834l1.06 1.06A9.722 9.722 0 0 0 20.75 11h-1.5Zm-2.416 5.834A8.222 8.222 0 0 1 11 19.25v1.5a9.722 9.722 0 0 0 6.894-2.856l-1.06-1.06Zm0 1.06 3.636 3.636 1.06-1.06-3.636-3.636-1.06 1.06ZM8 11.75h3v-1.5H8v1.5Zm3 0h3v-1.5h-3v1.5Z",
		fill: e.color
	})
}), Mg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.59574 7.74468L7.74468 4.59574C8.08511 4.25532 8.08511 3.74468 7.74468 3.40426L4.59574 0.255319C4.25532 -0.0851065 3.74468 -0.0851066 3.40426 0.255319C3.06383 0.595744 3.06383 1.10638 3.40426 1.44681L5.10638 3.14894L0.851065 3.14894C0.340426 3.14894 8.01149e-07 3.48936 7.78829e-07 4C7.56508e-07 4.51064 0.340426 4.85106 0.851064 4.85106L5.10638 4.85106L3.40426 6.55319C3.23404 6.7234 3.14894 6.97872 3.14894 7.14894C3.14894 7.31915 3.23404 7.57447 3.40426 7.74468C3.74468 8.08511 4.25532 8.08511 4.59574 7.74468Z",
		fill: e.color
	})
}), Ng = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M3.40426 7.74468L0.255319 4.59574C-0.0851062 4.25532 -0.0851062 3.74468 0.255319 3.40426L3.40426 0.255319C3.74468 -0.0851065 4.25532 -0.0851066 4.59574 0.255319C4.93617 0.595744 4.93617 1.10638 4.59574 1.44681L2.89362 3.14894L7.14894 3.14894C7.65957 3.14894 8 3.48936 8 4C8 4.51064 7.65957 4.85106 7.14894 4.85106L2.89362 4.85106L4.59574 6.55319C4.76596 6.7234 4.85106 6.97872 4.85106 7.14894C4.85106 7.31915 4.76596 7.57447 4.59574 7.74468C4.25532 8.08511 3.74468 8.08511 3.40426 7.74468Z",
		fill: e.color
	})
}), Pg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 0C5.58658 0 6.87212 1.23282 6.87212 2.75358V4.05197C6.87212 4.38977 6.902 4.93619 6.93887 5.2718L6.99823 5.81233C7.01667 5.9802 6.8886 6.11688 6.7121 6.11688H1.28789C1.11221 6.11688 0.983288 5.98053 1.00176 5.81233L1.06113 5.2718C1.09786 4.93737 1.12787 4.39005 1.12787 4.05197V2.75358C1.12787 1.23154 2.41377 0 4 0ZM3.99999 8C3.38312 8 2.88305 7.49922 2.88305 6.88148H5.11693C5.11693 7.49922 4.61686 8 3.99999 8Z",
		fill: e.color
	})
}), Fg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.17364 6.92731C2.9068 6.96674 2.63451 6.89426 2.43965 6.70641L0.889466 5.21201C0.549012 4.88381 0.573861 4.32773 0.944966 3.96998C1.31607 3.61223 1.8929 3.58828 2.23336 3.91648L3.26379 4.90983L6.28755 1.99489C6.65865 1.63714 7.23548 1.61318 7.57594 1.94138C7.91639 2.26958 7.89154 2.82566 7.52044 3.18341L3.93013 6.64451C3.71773 6.84927 3.43793 6.94469 3.17364 6.92731Z",
		fill: e.color
	})
}), Ig = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4ZM6.05781 5.29332C6.11114 5.31554 6.16892 5.32444 6.22225 5.32444C6.40003 5.32444 6.56444 5.21777 6.63556 5.04888C6.72444 4.82222 6.61336 4.56444 6.38669 4.47111L4.28003 3.62666L3.02222 1.94667C2.87555 1.75111 2.5956 1.71111 2.40004 1.85778C2.20449 2.00444 2.16445 2.28445 2.31112 2.48001L3.64445 4.25779C3.69334 4.32445 3.76003 4.37332 3.83559 4.40443L6.05781 5.29332Z",
		fill: e.color
	})
}), Lg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.27833 4L7.73961 6.46128C8.0868 6.80847 8.0868 7.37137 7.73961 7.71856L7.71856 7.73961C7.37137 8.0868 6.80847 8.0868 6.46128 7.73961L4 5.27833L1.53872 7.73961C1.19153 8.0868 0.62863 8.0868 0.281443 7.73961L0.26039 7.71856C-0.0867967 7.37137 -0.0867967 6.80847 0.26039 6.46128L2.72167 4L0.26039 1.53872C-0.0867967 1.19153 -0.0867967 0.62863 0.26039 0.281443L0.281443 0.26039C0.62863 -0.0867967 1.19153 -0.0867967 1.53872 0.26039L4 2.72167L6.46128 0.26039C6.80847 -0.0867967 7.37137 -0.0867967 7.71856 0.26039L7.73961 0.281443C8.0868 0.62863 8.0868 1.19153 7.73961 1.53872L5.27833 4Z",
		fill: e.color
	})
}), Rg = (e) => /*#__PURE__*/ N("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M0 7.99978L2.11843 7.53207L0.467681 5.88135L0 7.99978Z",
		fill: e.color
	}), /*#__PURE__*/ M("path", {
		d: "M7.60012 2.37833C7.8576 2.1214 7.99949 1.77961 7.99968 1.41586C7.99987 1.05211 7.85833 0.710162 7.6011 0.452985L7.54665 0.398502C7.28971 0.141542 6.94798 0 6.58453 0C6.58426 0 6.58407 0 6.58382 0C6.2201 0.000190501 5.87826 0.142087 5.62133 0.399563L0.693359 5.33779L2.66186 7.3063L7.60012 2.37833Z",
		fill: e.color
	})]
}), zg = (e) => /*#__PURE__*/ N("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/*#__PURE__*/ M("path", {
		d: "M6.49922 3.11084V2.22203C6.49922 0.999912 5.37422 0 3.99922 0C2.62422 0 1.49922 0.999912 1.49922 2.22203V3.11084H0.999225C0.815891 3.11084 2.64922 3.11084 6.49922 3.11084ZM2.49922 2.22203C2.49922 1.48876 3.17422 0.888811 3.99922 0.888811C4.82422 0.888811 5.49922 1.48876 5.49922 2.22203V3.11084H2.49922V2.22203Z",
		fill: e.color
	}), /*#__PURE__*/ M("path", {
		d: "M7 3.11154H1C0.725 3.11154 0.5 3.31152 0.5 3.55595V6.22238C0.5 7.20007 1.4 8 2.5 8H5.5C6.6 8 7.5 7.20007 7.5 6.22238V3.55595C7.5 3.31152 7.275 3.11154 7 3.11154ZM3.9725 4.77806H4.0275C4.28845 4.77806 4.5 4.97146 4.5 5.21002V5.67931C4.5 5.91788 4.28845 6.11128 4.0275 6.11128H3.9725C3.71155 6.11128 3.5 5.91788 3.5 5.67931V5.21002C3.5 4.97146 3.71155 4.77806 3.9725 4.77806Z",
		fill: e.color
	})]
}), Bg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4.67583 3H3.32417H0.675833C0.302581 3 0 3.44772 0 4C0 4.55228 0.302581 5 0.675833 5H3.32417H4.67583H7.32417C7.69742 5 8 4.55228 8 4C8 3.44772 7.69742 3 7.32417 3H4.67583Z",
		fill: e.color
	})
}), Vg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		d: "M4 3.94988C2.89543 3.94988 2 3.06567 2 1.97494C2 0.884211 2.89543 0 4 0C5.10457 0 6 0.884211 6 1.97494C6 3.06567 5.10457 3.94988 4 3.94988ZM8 7.10945H0C0 7.10205 0 6.96714 0 6.70472C0 5.61956 1.55832 4.73986 4 4.73986C6.44168 4.73986 8 5.61956 8 6.70472C8 6.98262 8 7.11753 8 7.10945Z",
		fill: e.color
	})
}), Hg = (e) => /*#__PURE__*/ M("svg", {
	width: "8",
	height: "8",
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /*#__PURE__*/ M("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.32417 3.32417V0.675833C3.32417 0.302581 3.62675 0 4 0C4.37325 0 4.67583 0.302581 4.67583 0.675833V3.32417H7.32417C7.69742 3.32417 8 3.62675 8 4C8 4.37325 7.69742 4.67583 7.32417 4.67583H4.67583V7.32417C4.67583 7.69742 4.37325 8 4 8C3.62675 8 3.32417 7.69742 3.32417 7.32417V4.67583H0.675833C0.302581 4.67583 0 4.37325 0 4C0 3.62675 0.302581 3.32417 0.675833 3.32417H3.32417Z",
		fill: e.color
	})
}), Ug = (e, t) => e === "✓" ? /*#__PURE__*/ M(Fg, { color: t }) : e === "→" || e === "->" ? /*#__PURE__*/ M(Mg, { color: t }) : e, Wg = ({ children: e, scrollMargin: t = "45px", block: n = "start" }) => {
	let r = T(null);
	return x(() => {
		r.current?.scrollIntoView({
			behavior: "smooth",
			block: n
		});
	}, [n]), /*#__PURE__*/ M(Gg, {
		scrollMargin: t,
		ref: r,
		children: e
	});
}, Gg = P.div.withConfig({
	displayName: "AutoScrolled__Container",
	componentId: "sc-95107c3a-0"
})(["scroll-margin:", ";"], ({ scrollMargin: e }) => e), z = P.div.withConfig({
	displayName: "Container",
	componentId: "sc-20aa896e-0"
})(/* @__PURE__ */ ". . . . . . . . . . . . . . . . . . . . . . . . . . .".split("."), ({ relative: e }) => e && "position: relative;", ({ background: e }) => e && `background: ${e};`, ({ tabletBackground: e }) => e && c`background: ${e};`, ({ radius: e }) => e && `border-radius: ${e};`, ({ border: e }) => e && `border: ${e};`, ({ tabletBorder: e }) => e && c`border: ${e};`, ({ desktopBorder: e }) => e && u`border: ${e};`, ({ borderBottom: e }) => e && `border-bottom: ${e};`, ({ borderTop: e }) => e && `border-top: ${e};`, ({ shadow: e }) => e && `box-shadow: ${e};`, ({ tabletShadow: e }) => e && c`box-shadow: ${e};`, ({ padding: e }) => e && `padding: ${e};`, ({ tabletPadding: e }) => e && c`padding: ${e};`, ({ desktopPadding: e }) => e && u`padding: ${e};`, ({ desktopLargePadding: e }) => e && o`padding: ${e};`, ({ paddingTop: e }) => e && `padding-top: ${e};`, ({ tabletPaddingTop: e }) => e && c`padding-top: ${e};`, ({ desktopPaddingTop: e }) => e && u`padding-top: ${e};`, ({ paddingRight: e }) => e && `padding-right: ${e};`, ({ tabletPaddingRight: e }) => e && c`padding-right: ${e};`, ({ desktopPaddingRight: e }) => e && u`padding-right: ${e};`, ({ paddingBottom: e }) => e && `padding-bottom: ${e};`, ({ tabletPaddingBottom: e }) => e && c`padding-bottom: ${e};`, ({ desktopPaddingBottom: e }) => e && u`padding-bottom: ${e};`, ({ paddingLeft: e }) => e && `padding-left: ${e};`, ({ tabletPaddingLeft: e }) => e && c`padding-left: ${e};`, ({ desktopPaddingLeft: e }) => e && u`padding-left: ${e};`), B = P.div.withConfig({
	displayName: "Flexer",
	componentId: "sc-23f104f6-0"
})(/* @__PURE__ */ "display:flex;. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .".split("."), ({ gap: e }) => e && `gap: ${e};`, ({ tabletGap: e }) => e && c`gap: ${e};`, ({ desktopGap: e }) => e && u`gap: ${e};`, ({ desktopLargeGap: e }) => e && o`gap: ${e};`, ({ row: e }) => e && "flex-direction: row;", ({ tabletRow: e }) => e && c`flex-direction: row;`, ({ desktopRow: e }) => e && u`flex-direction: row;`, ({ desktopLargeRow: e }) => e && o`flex-direction: row;`, ({ rowReverse: e }) => e && "flex-direction: row-reverse;", ({ tabletRowReverse: e }) => e && c`flex-direction: row-reverse;`, ({ desktopRowReverse: e }) => e && u`flex-direction: row-reverse;`, ({ desktopLargeRowReverse: e }) => e && o`flex-direction: row-reverse;`, ({ column: e }) => e && "flex-direction: column;", ({ tabletColumn: e }) => e && c`flex-direction: column;`, ({ desktopColumn: e }) => e && u`flex-direction: column;`, ({ columnReverse: e }) => e && "flex-direction: column-reverse;", ({ tabletColumnReverse: e }) => e && c`flex-direction: column-reverse;`, ({ desktopColumnReverse: e }) => e && u`flex-direction: column-reverse;`, ({ alignBaseline: e }) => e && "align-items: baseline;", ({ tabletAlignBaseline: e }) => e && c`align-items: baseline;`, ({ desktopAlignBaseline: e }) => e && u`align-items: baseline;`, ({ desktopLargeAlignBaseline: e }) => e && o`align-items: baseline;`, ({ alignCenter: e }) => e && "align-items: center;", ({ tabletAlignCenter: e }) => e && c`align-items: center;`, ({ desktopAlignCenter: e }) => e && u`align-items: center;`, ({ alignStart: e }) => e && "align-items: start;", ({ tabletAlignStart: e }) => e && c`align-items: start;`, ({ desktopAlignStart: e }) => e && u`align-items: start;`, ({ alignEnd: e }) => e && "align-items: end;", ({ tabletAlignEnd: e }) => e && c`align-items: end;`, ({ desktopAlignEnd: e }) => e && u`align-items: end;`, ({ justifyStart: e }) => e && "justify-content: start;", ({ tabletJustifyStart: e }) => e && c`justify-content: start;`, ({ desktopJustifyStart: e }) => e && u`justify-content: start;`, ({ justifyEnd: e }) => e && "justify-content: end;", ({ tabletJustifyEnd: e }) => e && c`justify-content: end;`, ({ desktopJustifyEnd: e }) => e && u`justify-content: end;`, ({ justifyCenter: e }) => e && "justify-content: center;", ({ tabletJustifyCenter: e }) => e && c`justify-content: center;`, ({ desktopJustifyCenter: e }) => e && u`justify-content: center;`, ({ spaceBetween: e }) => e && "justify-content: space-between;", ({ tabletSpaceBetween: e }) => e && c`justify-content: space-between;`, ({ desktopSpaceBetween: e }) => e && u`justify-content: space-between;`, ({ flexWrap: e }) => e && "flex-wrap: wrap;", ({ tabletFlexWrap: e }) => e && c`flex-wrap: wrap;`, ({ desktopFlexWrap: e }) => e && u`flex-wrap: wrap;`, ({ height: e }) => e && `height: ${e};`, ({ tabletHeight: e }) => e && c`height: ${e};`, ({ desktopHeight: e }) => e && u`height: ${e};`, ({ width: e }) => e && `width: ${e};`, ({ tabletWidth: e }) => e && c`width: ${e};`, ({ desktopWidth: e }) => e && u`width: ${e};`, ({ desktopLargeWidth: e }) => e && o`width: ${e};`), Kg = P.div.withConfig({
	displayName: "Grid",
	componentId: "sc-a7187c54-0"
})(/* @__PURE__ */ "display:grid;. . . . . . . . . . . . . . . . . . . . . . . . . . . . .".split("."), ({ gap: e }) => e && `gap: ${e};`, ({ tabletGap: e }) => e && c`gap: ${e};`, ({ desktopGap: e }) => e && u`gap: ${e};`, ({ desktopLargeGap: e }) => e && o`gap: ${e};`, ({ columnGap: e }) => e && `column-gap: ${e};`, ({ tabletColumnGap: e }) => e && c`column-gap: ${e};`, ({ desktopColumnGap: e }) => e && u`column-gap: ${e};`, ({ rowGap: e }) => e && `row-gap: ${e};`, ({ tabletRowGap: e }) => e && c`row-gap: ${e};`, ({ desktopRowGap: e }) => e && u`row-gap: ${e};`, ({ areas: e }) => e && `grid-template-areas: ${e};`, ({ columns: e }) => e && `grid-template-columns: ${Number.isInteger(e) ? "1fr ".repeat(Number(e)) : e};`, ({ tabletColumns: e }) => e && c`grid-template-columns: ${Number.isInteger(e) ? "1fr ".repeat(Number(e)) : e};`, ({ desktopColumns: e }) => e && u`grid-template-columns: ${Number.isInteger(e) ? "1fr ".repeat(Number(e)) : e};`, ({ desktopLargeColumns: e }) => e && o`grid-template-columns: ${Number.isInteger(e) ? "1fr ".repeat(Number(e)) : e};`, ({ rows: e }) => e && `grid-template-rows: ${Number.isInteger(e) ? "1fr ".repeat(Number(e)) : e};`, ({ tabletRows: e }) => e && c`grid-template-rows: ${Number.isInteger(e) ? "1fr ".repeat(Number(e)) : e};`, ({ alignCenter: e }) => e && "align-items: center;", ({ tabletAlignCenter: e }) => e && c`align-items: center;`, ({ desktopAlignCenter: e }) => e && u`align-items: center;`, ({ alignEnd: e }) => e && "align-items: end;", ({ tabletAlignEnd: e }) => e && c`align-items: end;`, ({ desktopAlignEnd: e }) => e && u`align-items: end;`, ({ justifyEnd: e }) => e && "justify-content: end;", ({ justifyItemsCenter: e }) => e && "justify-items: center;", ({ tabletJustifyItemsCenter: e }) => e && c`justify-items: center;`, ({ width: e }) => e && `width: ${e};`, ({ tabletWidth: e }) => e && c`width: ${e};`, ({ desktopWidth: e }) => e && u`width: ${e};`), qg = P.div.withConfig({
	displayName: "GridItem",
	componentId: "sc-443001e8-0"
})([
	"",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	" ",
	""
], ({ area: e }) => e && `grid-area: ${e};`, ({ columnStart: e }) => e && `grid-column-start: ${e};`, ({ column: e }) => e && `grid-column: ${e};`, ({ tabletColumn: e }) => e && c`grid-column: ${e};`, ({ desktopColumn: e }) => e && u`grid-column: ${e};`, ({ row: e }) => e && `grid-row: ${e};`, ({ tabletRow: e }) => e && c`grid-row: ${e};`, ({ desktopRow: e }) => e && u`grid-row: ${e};`, ({ alignStart: e }) => e && "align-self: start;", ({ alignEnd: e }) => e && "align-self: end;", ({ alignCenter: e }) => e && "align-self: center;", ({ alignStretch: e }) => e && "align-self: stretch;", ({ justifyStart: e }) => e && "justify-self: start;", ({ justifyEnd: e }) => e && "justify-self: end;", ({ justifyCenter: e }) => e && "justify-self: center;", ({ justifyStretch: e }) => e && "justify-self: stretch;"), Jg = P.div.withConfig({
	displayName: "Heading",
	componentId: "sc-61e7d511-0"
})([
	"color:",
	";font-family:",
	";font-size:",
	";font-weight:",
	";line-height:1.3;text-align:",
	";",
	" ",
	" ",
	" ",
	"{font-size:",
	";font-weight:",
	";}",
	"{font-size:",
	";font-weight:",
	";}",
	"{font-size:",
	";}"
], ({ color: e }) => e ?? "inherit", ({ family: e }) => e ?? "inherit", ({ size: e }) => e ?? i.title.medium, ({ weight: e }) => e ?? i.weight.medium, ({ textAlign: e }) => e ?? "inherit", ({ tabletTextAlign: e }) => e && c`text-align: ${e};`, ({ desktopTextAlign: e }) => e && u`text-align: ${e};`, ({ alignCenter: e }) => e && "text-align: center;", R.tablet, ({ size: e, tabletSize: t }) => t ?? e ?? i.title.large, ({ weight: e, tabletWeight: t }) => t ?? e ?? i.weight.medium, R.desktop, ({ size: e, tabletSize: t, desktopSize: n }) => n ?? t ?? e ?? i.title.large, ({ weight: e, desktopWeight: t }) => t ?? e ?? i.weight.medium, R.desktopLarge, ({ size: e, tabletSize: t, desktopSize: n, desktopLargeSize: r }) => r ?? n ?? t ?? e ?? i.title.large), Yg = P.a.withConfig({
	displayName: "InlineLink",
	componentId: "sc-fd0ea23e-0"
})([
	"color:",
	";font-weight:",
	";cursor:pointer;text-decoration:underline;",
	"{&:hover{text-decoration:none;color:",
	";}}"
], ({ color: e }) => e || l.text.interactive, i.weight.medium, R.pointer, l.text.base), V = P.div.withConfig({
	displayName: "Line",
	componentId: "sc-d0b6c888-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";line-height:",
	";text-align:",
	";",
	" ",
	" ",
	"{font-size:",
	";}"
], ({ color: e }) => e || "inherit", ({ size: e }) => e || i.body.medium, ({ weight: e }) => e || i.weight.normal, ({ lineHeight: e }) => e || 1.5, ({ textAlign: e }) => e || "inherit", ({ tabletTextAlign: e }) => e && c`text-align: ${e};`, ({ desktopTextAlign: e }) => e && u`text-align: ${e};`, R.tablet, ({ size: e, tabletSize: t }) => t || e || i.body.large), Xg = P.p.withConfig({
	displayName: "Paragraph",
	componentId: "sc-2f5f4ca7-0"
})([
	"color:",
	";font-size:",
	";line-height:1.5;text-align:",
	";",
	" ",
	" margin:0;",
	" ",
	"{font-size:",
	";}&:not(:last-child){margin-bottom:9px;}strong{font-weight:",
	";}"
], ({ color: e }) => e || "inherit", ({ size: e }) => e || i.body.medium, ({ textAlign: e }) => e || "inherit", ({ tabletTextAlign: e }) => e && c`text-align: ${e};`, ({ desktopTextAlign: e }) => e && u`text-align: ${e};`, ({ alignCenter: e }) => e && "text-align: center;", R.tablet, ({ size: e, tabletSize: t }) => t || e || i.body.large, i.weight.bold), H = P.div.withConfig({
	displayName: "Spacer",
	componentId: "sc-4bfd1167-0"
})(/* @__PURE__ */ ". . . . . . . . . . . . . . . . . . . . . . . . .".split("."), ({ alignSelf: e }) => e && `align-self: ${e};`, ({ inline: e }) => e && "display: inline;", ({ flex: e }) => e && `flex: ${e};`, ({ tabletFlex: e }) => e && c`flex: ${e};`, ({ desktopFlex: e }) => e && u`flex: ${e};`, ({ flexFill: e }) => e && "flex: 1 1 auto;", ({ margin: e }) => e && `margin: ${e};`, ({ tabletMargin: e }) => e && c`margin: ${e};`, ({ desktopMargin: e }) => e && u`margin: ${e};`, ({ marginTop: e }) => e && `margin-top: ${e};`, ({ tabletMarginTop: e }) => e && c`margin-top: ${e};`, ({ desktopMarginTop: e }) => e && u`margin-top: ${e};`, ({ marginRight: e }) => e && `margin-right: ${e};`, ({ tabletMarginRight: e }) => e && c`margin-right: ${e};`, ({ desktopMarginRight: e }) => e && u`margin-right: ${e};`, ({ marginBottom: e }) => e && `margin-bottom: ${e};`, ({ tabletMarginBottom: e }) => e && c`margin-bottom: ${e};`, ({ desktopMarginBottom: e }) => e && u`margin-bottom: ${e};`, ({ marginLeft: e }) => e && `margin-left: ${e};`, ({ tabletMarginLeft: e }) => e && c`margin-left: ${e};`, ({ desktopMarginLeft: e }) => e && u`margin-left: ${e};`, ({ width: e }) => e && `width: ${e};`, ({ tabletWidth: e }) => e && c`width: ${e};`, ({ desktopWidth: e }) => e && u`width: ${e};`, ({ desktopLargeWidth: e }) => e && o`width: ${e};`), Zg = P.div.withConfig({
	displayName: "TextEllipsis",
	componentId: "sc-2667fd09-0"
})(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"]), Qg = ({ children: e }) => /*#__PURE__*/ M(ue, {
	shouldForwardProp: pe,
	children: e
}), $g = fe(["to{transform:rotate(360deg);}"]), e_ = P.div.withConfig({
	displayName: "Spinner__Container",
	componentId: "sc-eb2d2366-0"
})([
	"content:'';box-sizing:border-box;width:",
	";height:",
	";border:",
	";border-top-color:",
	";border-radius:",
	";animation:",
	" 0.6s linear infinite;"
], ({ isSmall: e }) => e ? "20px" : "42px", ({ isSmall: e }) => e ? "20px" : "42px", ({ color2: e }) => `2px solid ${e}`, ({ color: e }) => e, I.full, $g), U = ({ color: e = l.line.neutral, color2: t = l.line.inverted, isSmall: n = !1 }) => /*#__PURE__*/ M(e_, {
	role: "progressbar",
	"aria-busy": "true",
	"aria-live": "polite",
	"aria-label": "loading",
	color: e,
	color2: t,
	isSmall: n
}), t_ = ({ children: e, isLoading: t, isSmall: n, overlayColor: r, overlayOpacity: i = .8, shouldHideContentWhenLoading: a, spinnerColor: o, spinnerColor2: s, ...c }) => {
	let l = T(null);
	return /*#__PURE__*/ N(n_, {
		isEmpty: !e,
		isSmall: n,
		isLoading: t,
		...c,
		children: [/*#__PURE__*/ M(he, {
			nodeRef: l,
			timeout: {
				appear: 0,
				enter: 0,
				exit: 150
			},
			in: t,
			children: (e) => /*#__PURE__*/ M(r_, {
				ref: l,
				state: e,
				hasOverlay: !a,
				overlayColor: r,
				overlayOpacity: i,
				children: /*#__PURE__*/ M(a_, { children: /*#__PURE__*/ M(U, {
					isSmall: n,
					color: o,
					color2: s
				}) })
			})
		}), /*#__PURE__*/ M(i_, {
			shouldHideContentWhenLoading: a,
			isLoading: t,
			children: e
		})]
	});
}, n_ = P.div.withConfig({
	displayName: "Loadable__Container",
	componentId: "sc-59ddb9de-0"
})([
	"position:relative;height:100%;",
	" ",
	""
], ({ isEmpty: e, isLoading: t, isSmall: n, isFullViewportHeight: r }) => e && t && !r && `
        min-height: ${n ? "48px" : "96px"};
    `, ({ isFullViewportHeight: e }) => e && "\n        min-height: 100vh;\n    "), r_ = P.div.withConfig({
	displayName: "Loadable__Overlay",
	componentId: "sc-59ddb9de-1"
})([
	"position:absolute;top:0;left:0;z-index:10;height:100%;width:100%;display:block;opacity:0;transition:opacity 150ms linear;",
	" ",
	";",
	";",
	";",
	";"
], ({ hasOverlay: e, overlayColor: t, overlayOpacity: n }) => e && `background: ${k(t ?? l.surface.neutral, n)};`, ({ state: e }) => e === "entering" && "\n        display: block;\n        opacity: 0;\n    ", ({ state: e }) => e === "entered" && "\n        display: block;\n        opacity: 1;\n    ", ({ state: e }) => e === "exiting" && "\n        display: block;\n        opacity: 0;\n    ", ({ state: e }) => e === "exited" && "\n        display: none;\n        opacity: 0;\n    "), i_ = P.div.withConfig({
	displayName: "Loadable__Content",
	componentId: "sc-59ddb9de-2"
})([
	"height:100%;",
	" ",
	""
], ({ isLoading: e }) => e && "\n        pointer-events: none;\n        user-select: none;\n    ", ({ isLoading: e, shouldHideContentWhenLoading: t }) => e && t && "visibility: hidden;\n    "), a_ = P.div.withConfig({
	displayName: "Loadable__SpinnerContainer",
	componentId: "sc-59ddb9de-3"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]), o_ = ({ as: e = "button", type: t = "button", variant: n = "primary", color: r = "primary", size: i = "large", disabled: a, isSmall: o, isLoading: s, children: c, ...l }) => {
	let u = a || s, d = o ? "medium" : i;
	return /*#__PURE__*/ M(m_, {
		...l,
		as: e,
		type: t,
		isSmall: o,
		isLoading: s,
		"aria-disabled": u,
		disabled: u,
		size: d,
		variant: n,
		color: r,
		children: /*#__PURE__*/ M(t_, {
			isSmall: !0,
			isLoading: s,
			spinnerColor: s_({
				...l,
				variant: n,
				color: r,
				disabled: a,
				isLoading: s
			}),
			spinnerColor2: l_({
				...l,
				variant: n,
				color: r
			}),
			overlayOpacity: 1,
			shouldHideContentWhenLoading: !0,
			overlayColor: c_({
				...l,
				variant: n,
				color: r,
				disabled: a,
				isLoading: s
			}),
			children: c
		})
	});
}, s_ = ({ variant: e, color: n, disabled: r, isLoading: i }) => {
	switch (!0) {
		case A(e) && r && !i: return t.text.disabled;
		case A(e) && n === "primary": return t.primary.main;
		case A(e) && n === "error": return t.error.main;
		case A(e) && n === "neutral": return t.neutral.main;
		default: return t.primary.contrast;
	}
}, c_ = ({ variant: e, color: n, disabled: r, isLoading: i }) => {
	switch (!0) {
		case e === "primary" && r && !i: return t.common.disabled1;
		case e === "primary" && n === "primary": return t.primary.primaryAction;
		case e === "primary" && n === "error": return t.error.primaryAction;
		case e === "primary" && n === "neutral": return t.neutral.primaryAction;
		case e === "secondary" && r && !i: return t.common.disabled2;
		case e === "secondary" && n === "primary": return t.primary.secondaryAction;
		case e === "secondary" && n === "error": return t.error.secondaryAction;
		case e === "secondary" && n === "neutral": return t.neutral.secondaryAction;
		case e === "tertiary": return "transparent";
		default: return t.primary.primaryAction;
	}
}, l_ = ({ variant: e, color: n }) => {
	switch (!0) {
		case e === "secondary" && n === "primary": return t.primary.hover;
		case e === "secondary" && n === "error": return t.error.hover;
		case e === "secondary" && n === "neutral": return t.neutral.hover;
		case e === "tertiary" && n === "primary": return t.primary.hover;
		case e === "tertiary" && n === "error": return t.error.hover;
		case e === "tertiary" && n === "neutral": return t.neutral.hover;
		case e === "primary": return t.common.hover;
		default: return t.primary.primaryAction;
	}
}, u_ = ({ variant: e, color: n }) => {
	switch (!0) {
		case e === "secondary" && n === "primary": return t.primary.pressed;
		case e === "secondary" && n === "error": return t.error.pressed;
		case e === "secondary" && n === "neutral": return t.neutral.pressed;
		case e === "tertiary" && n === "primary": return t.primary.pressed;
		case e === "tertiary" && n === "error": return t.error.pressed;
		case e === "tertiary" && n === "neutral": return t.neutral.pressed;
		case e === "primary": return t.common.pressed;
		default: return t.primary.primaryAction;
	}
}, d_ = ({ size: e }) => e === "large" ? i.body.large : i.body.medium, f_ = ({ size: e }) => e === "large" ? "14px 20px" : "8px 16px", p_ = ({ size: e }) => e === "large" ? I.buttonLarge : I.buttonMedium, m_ = P.button.withConfig({
	displayName: "ActionButton__Container",
	componentId: "sc-8db87e89-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";line-height:1.3;text-align:center;text-decoration:none;white-space:nowrap;display:",
	";position:relative;width:",
	";padding:",
	";background:",
	";border-radius:",
	";cursor:pointer;",
	"{display:",
	";width:",
	";}&::after{content:'';color:",
	";position:absolute;inset:0;border-radius:",
	";background-color:rgba(0,0,0,0);transition:background-color 150ms ease-in-out;z-index:0;}> *{position:relative;z-index:1;}",
	"{&:hover::after{background-color:",
	";}}&:active::after{background:",
	";outline:none;}&:focus-visible{outline:",
	";&::after{background:",
	";}}",
	" ",
	" ",
	""
], s_, d_, i.weight.medium, ({ isMobileFullWidth: e, isFullWidth: t }) => e || t ? "block" : "inline-block", ({ isMobileFullWidth: e, isFullWidth: t }) => e || t ? "100%" : "auto", f_, c_, p_, R.tablet, ({ isFullWidth: e }) => e ? "block" : "inline-block", ({ isFullWidth: e }) => e ? "100%" : "auto", s_, p_, R.pointer, l_, u_, s.interactive.medium, u_, ({ disabled: e }) => e && "\n        pointer-events: none;\n        user-select: none;\n    ", ({ isLoading: e }) => e && "\n        pointer-events: none;\n        user-select: none;\n    ", ({ isSelected: e, isSmall: t }) => e && `
        position: relative;
        padding-left: ${t ? "32px" : "36px"};
        
        &:before {
            content: '\\002713';
            color: ${s_};
            font-weight: ${i.weight.medium};
            line-height: 1;
            display: block;
            position: absolute;
            z-index: 1;
            left: ${t ? "12px" : "14px"};
            top: 50%;
            transform: translateY(-50%);
        }
    `), h_ = ({ background: e, IconComponent: t, label: n, onClick: r }) => /*#__PURE__*/ M(g_, {
	"aria-label": n,
	onClick: r,
	children: /*#__PURE__*/ M(z, {
		background: e || l.surface.neutral,
		padding: "12px",
		radius: I.full,
		children: /*#__PURE__*/ N(B, {
			gap: "18px",
			alignCenter: !0,
			children: [/*#__PURE__*/ M(__, { children: /*#__PURE__*/ M(G, { Component: t }) }), /*#__PURE__*/ M(v_, { children: n })]
		})
	})
}), g_ = P.button.withConfig({
	displayName: "ActionPill__Wrapper",
	componentId: "sc-6dca8e35-0"
})([
	"text-align:left;display:block;width:100%;border-radius:",
	";cursor:pointer;&:focus{color:",
	";}",
	"{&:hover{color:",
	";}}"
], I.full, l.text.interactive, R.pointer, l.text.interactive), __ = P.div.withConfig({
	displayName: "ActionPill__IconContainer",
	componentId: "sc-6dca8e35-1"
})([
	"display:flex;align-items:center;justify-content:center;width:45px;height:45px;background:",
	";border-radius:",
	";box-shadow:",
	";",
	"{",
	":hover &{box-shadow:",
	";}}"
], l.surface.base, I.full, L.medium, R.pointer, g_, L.high), v_ = P.div.withConfig({
	displayName: "ActionPill__LabelContainer",
	componentId: "sc-6dca8e35-2"
})(["font-weight:", ";"], i.weight.medium), y_ = ({ width: e = "48px", tabletWidth: n, desktopWidth: r, backgroundColor: i = t.neutral.background, src: a, shadow: o, alt: s }) => {
	let [c, l] = E(!1);
	return /*#__PURE__*/ M(b_, {
		width: e,
		tabletWidth: n,
		backgroundColor: i,
		shadow: o,
		desktopWidth: r,
		children: /*#__PURE__*/ M(x_, {
			src: a,
			alt: s ?? "Avatar",
			onLoad: () => l(!0),
			isLoaded: c
		})
	});
}, b_ = le.div.withConfig({
	displayName: "Avatar__Container",
	componentId: "sc-82a0877e-0"
})([
	"position:relative;width:",
	";height:",
	";border-radius:",
	";overflow:hidden;background-color:",
	";box-shadow:",
	";",
	"{width:",
	";height:",
	";}",
	"{width:",
	";height:",
	";}"
], ({ width: e }) => e, ({ width: e }) => e, I.full, ({ backgroundColor: e }) => e, ({ shadow: e }) => e ?? "none", R.tablet, ({ tabletWidth: e, width: t }) => e ?? t, ({ tabletWidth: e, width: t }) => e ?? t, R.desktop, ({ desktopWidth: e, tabletWidth: t, width: n }) => e ?? t ?? n, ({ desktopWidth: e, tabletWidth: t, width: n }) => e ?? t ?? n), x_ = le.img.withConfig({
	displayName: "Avatar__Image",
	componentId: "sc-82a0877e-1"
})(["width:100%;height:100%;object-fit:cover;opacity:", ";transition:opacity 0.2s;"], ({ isLoaded: e }) => +!!e), S_ = P.div.withConfig({
	displayName: "Badge",
	componentId: "sc-1dc501b5-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";display:inline-flex;align-items:center;justify-content:space-around;position:relative;height:",
	";min-width:",
	";padding:",
	";background:",
	";border-radius:",
	";&:not(:last-child){margin-right:6px;}"
], ({ color: e }) => e ?? t.primary.contrast, ({ isSmall: e }) => e ? i.body.small : i.body.medium, i.weight.medium, ({ isSmall: e }) => e ? "18px" : "24px", ({ isSmall: e }) => e ? "18px" : "24px", ({ isSmall: e }) => e ? "0 4px" : "0 6px", ({ background: e }) => e ?? t.primary.primaryAction, I.full), C_ = ({ variant: e }) => {
	switch (e) {
		case "default": return l.text.inverted;
		case "dim": return l.text.neutral;
		default: return l.text.interactive;
	}
}, w_ = ({ size: e }) => {
	switch (e) {
		case "small": return i.body.small;
		default: return i.body.medium;
	}
}, T_ = ({ variant: e }) => {
	switch (e) {
		case "neutral": return l.surface.neutral;
		case "highlight": return l.surface.highlight;
		case "highlightSoft": return l.surface.highlightSoft;
		case "dim": return l.surface.neutral;
		case "inverted": return l.surface.base;
		default: return l.surface.interactive;
	}
}, E_ = ({ size: e }) => {
	switch (e) {
		case "small": return "18px";
		default: return "24px";
	}
}, D_ = ({ children: e, variant: t = "default", size: n = "medium", onClick: r, disabled: i }) => /*#__PURE__*/ M(O_, {
	size: n,
	variant: t,
	onClick: r,
	disabled: i,
	children: e
}), O_ = P.button.withConfig({
	displayName: "BadgeButton__Container",
	componentId: "sc-de69e676-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";display:flex;align-items:center;justify-content:center;position:relative;height:",
	";width:",
	";min-width:",
	";overflow:hidden;background:",
	";border-radius:",
	";",
	"{&:hover{opacity:0.8;}}&:disabled{opacity:0.5;pointer-events:none;user-select:none;}",
	"{&:active{transform:scale(0.96);}}"
], C_, w_, i.weight.medium, E_, E_, E_, T_, I.full, R.pointer, R.pointer), k_ = ({ variant: e, color: n, disabled: r, isLoading: i }) => {
	switch (!0) {
		case A(e) && r && !i: return t.text.disabled;
		case A(e) && n === "primary": return t.primary.main;
		case A(e) && n === "error": return t.error.main;
		case A(e) && n === "neutral": return t.neutral.main;
		default: return t.primary.contrast;
	}
}, A_ = ({ variant: e, color: n, disabled: r, isLoading: i }) => {
	switch (!0) {
		case e === "primary" && r && !i: return t.common.disabled1;
		case e === "primary" && n === "primary": return t.primary.primaryAction;
		case e === "primary" && n === "error": return t.error.primaryAction;
		case e === "primary" && n === "neutral": return t.neutral.primaryAction;
		case e === "secondary" && r && !i: return t.common.disabled2;
		case e === "secondary" && n === "primary": return t.primary.secondaryAction;
		case e === "secondary" && n === "error": return t.error.secondaryAction;
		case e === "secondary" && n === "neutral": return t.neutral.secondaryAction;
		case e === "tertiary": return "transparent";
		default: return t.primary.primaryAction;
	}
}, j_ = ({ variant: e, color: n }) => {
	switch (!0) {
		case e === "primary": return t.common.hover;
		case e === "secondary" && n === "primary": return t.primary.hover;
		case e === "secondary" && n === "error": return t.error.hover;
		case e === "secondary" && n === "neutral": return t.neutral.hover;
		case e === "tertiary" && n === "primary": return t.primary.hover;
		case e === "tertiary" && n === "error": return t.error.hover;
		case e === "tertiary" && n === "neutral": return t.neutral.hover;
		default: return t.primary.primaryAction;
	}
}, M_ = ({ variant: e, color: n }) => {
	switch (!0) {
		case e === "primary": return t.common.pressed;
		case e === "secondary" && n === "primary": return t.primary.pressed;
		case e === "secondary" && n === "error": return t.error.pressed;
		case e === "secondary" && n === "neutral": return t.neutral.pressed;
		case e === "tertiary" && n === "primary": return t.primary.pressed;
		case e === "tertiary" && n === "error": return t.error.pressed;
		case e === "tertiary" && n === "neutral": return t.neutral.pressed;
		default: return t.primary.primaryAction;
	}
}, N_ = ({ size: e }) => {
	switch (e) {
		case "small": return i.body.small;
		case "large": return i.body.large;
		default: return i.body.medium;
	}
}, P_ = ({ size: e }) => {
	switch (!0) {
		case e === "large": return "14px 20px";
		case e === "small": return "6px 12px";
		default: return "8px 16px";
	}
}, F_ = ({ size: e }) => {
	switch (!0) {
		case e === "large": return I.buttonLarge;
		case e === "small": return I.small;
		default: return I.buttonMedium;
	}
}, W = ({ as: e = "button", type: t = "button", size: n = "medium", variant: r = "primary", color: i = "primary", children: a, isLoading: o, disabled: s, ...c }) => {
	let l = s || o;
	return /*#__PURE__*/ M(I_, {
		...c,
		"aria-disabled": l,
		disabled: l,
		isLoading: o,
		variant: r,
		color: i,
		as: e,
		type: t,
		size: n,
		children: /*#__PURE__*/ M(t_, {
			isSmall: !0,
			isLoading: o,
			spinnerColor: k_({
				...c,
				variant: r,
				color: i,
				disabled: s,
				isLoading: o
			}),
			spinnerColor2: j_({
				...c,
				variant: r,
				color: i
			}),
			overlayOpacity: 1,
			shouldHideContentWhenLoading: !0,
			overlayColor: A_({
				...c,
				variant: r,
				color: i,
				disabled: s,
				isLoading: o
			}),
			children: a
		})
	});
}, I_ = P.button.withConfig({
	displayName: "Button__Container",
	componentId: "sc-40163ea5-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";line-height:1.3;text-decoration:none;text-align:center;white-space:nowrap;display:",
	";position:relative;width:",
	";padding:",
	";background:",
	";border-radius:",
	";cursor:pointer;",
	"{display:",
	";width:",
	";}&::after{content:'';color:",
	";position:absolute;inset:0;border-radius:",
	";background-color:rgba(0,0,0,0);transition:background-color 150ms ease-in-out;z-index:0;}> *{position:relative;z-index:1;}",
	"{&:hover::after{background-color:",
	";}}&:active::after{background:",
	";outline:none;}&:focus-visible{outline:",
	";&::after{background:",
	";}}",
	" ",
	""
], k_, N_, i.weight.medium, ({ isMobileFullWidth: e, isFullWidth: t }) => e || t ? "block" : "inline-block", ({ isMobileFullWidth: e, isFullWidth: t }) => e || t ? "100%" : "auto", P_, A_, F_, R.tablet, ({ isFullWidth: e }) => e ? "block" : "inline-block", ({ isFullWidth: e }) => e ? "100%" : "auto", k_, F_, R.pointer, j_, M_, s.interactive.medium, M_, ({ disabled: e }) => e && "\n        pointer-events: none;\n        user-select: none;\n    ", ({ isLoading: e }) => e && "\n        pointer-events: none;\n        user-select: none;\n    "), L_ = ({ children: e, ...t }) => /*#__PURE__*/ M(R_, {
	...t,
	"aria-disabled": t.disabled,
	children: e
}), R_ = P.button.attrs(({ type: e }) => ({ type: e || "button" })).withConfig({
	displayName: "ButtonLink__Container",
	componentId: "sc-5a03fdb1-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";line-height:1;text-decoration:underline;white-space:nowrap;display:inline-block;padding:0;background:none;border:none;cursor:pointer;-webkit-appearance:none;&:focus{outline:",
	";outline-offset:6px;border-radius:",
	";}&:active{outline:",
	";outline-offset:6px;border-radius:",
	";}",
	"{&:hover{color:",
	";text-decoration:none;}}",
	""
], ({ color: e }) => e || l.text.interactive, ({ isSmall: e, size: t }) => t || (e ? i.body.small : i.body.medium), i.weight.medium, s.interactive.medium, I.small, s.interactive.medium, I.small, R.tablet, l.text.base, ({ disabled: e }) => e && "\n        opacity: 0.5;\n        pointer-events: none;\n        user-select: none;\n    "), z_ = "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxM0w5IDE4TDIwIDYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=')", B_ = "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxM0w5IDE4TDIwIDYiIHN0cm9rZT0iIzJGMzg0QyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==')", V_ = ({ isLabelless: e, isSmall: t }) => {
	switch (!0) {
		case e: return 0;
		case t: return i.body.medium;
		default: return i.body.large;
	}
}, H_ = ({ isLabelless: e, isSmall: t }) => {
	switch (!0) {
		case e: return "22px";
		case t: return "24px";
		default: return "34px";
	}
}, U_ = ({ isLabelless: e, isSmall: t }) => {
	switch (!0) {
		case e: return "-22px";
		case t: return "-24px";
		default: return "-34px";
	}
}, W_ = /*#__PURE__*/ g(({ checked: e, id: t, isLabelless: n, isSmall: r, label: i, name: a, onChange: o, readOnly: s, disabled: c, value: l = "on", ...u }, d) => {
	let f = t || `${a || ""}${l || ""}`;
	return /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ M(G_, {
		ref: d,
		type: "checkbox",
		id: f,
		name: a,
		value: l,
		onChange: (e) => {
			if (!o) return;
			let { target: t } = e;
			o({
				name: t.name,
				checked: t.checked,
				value: t.value
			});
		},
		checked: e,
		readOnly: s,
		disabled: c || s,
		"aria-disabled": c,
		"aria-readonly": s,
		...u
	}), /*#__PURE__*/ M(K_, {
		htmlFor: f,
		isSmall: r,
		isLabelless: n,
		children: i
	})] });
}), G_ = P.input.withConfig({
	displayName: "Checkbox__InputElement",
	componentId: "sc-27621c16-0"
})([
	"white-space:nowrap;clip:rect(1px,1px,1px,1px);overflow:hidden;position:absolute;top:auto;width:1px;height:1px;",
	"{&:hover + label:before{border-color:",
	";}}&:focus + label{border-radius:",
	";outline:",
	";outline-offset:6px;}&:checked + label:before{background-color:",
	";background-image:",
	";border-color:",
	";}&:disabled + label:before{border-color:",
	";pointer-events:none;}&:disabled + label{color:",
	";pointer-events:none;}&:checked:disabled + label:before{background-color:",
	";background-image:",
	";}"
], R.pointer, t.grey.graphics1, I.small, s.interactive.medium, t.primary.light, z_, t.primary.light, t.common.disabled1, ({ readOnly: e }) => e ? t.text.primary : t.text.disabled, t.common.disabled1, ({ readOnly: e }) => e ? B_ : z_), K_ = P.label.withConfig({
	displayName: "Checkbox__Label",
	componentId: "sc-27621c16-1"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";line-height:1.3;text-align:left;display:block;height:",
	";padding-left:",
	";cursor:pointer;&:before{content:'';display:block;float:left;width:",
	";height:",
	";margin-top:",
	";margin-left:",
	";background-color:",
	";background-position:center;background-repeat:no-repeat;background-size:contain;border:",
	" solid ",
	";border-radius:",
	";cursor:pointer;transition:all 0.1s ease-out;}a{color:",
	";font-weight:",
	";&:hover{color:",
	";text-decoration:none;}}"
], t.text.primary, V_, i.weight.normal, ({ isLabelless: e }) => e ? "22px" : "auto", H_, ({ isSmall: e }) => e ? "16px" : "22px", ({ isSmall: e }) => e ? "16px" : "22px", ({ isSmall: e }) => e ? "1px" : "-1px", U_, t.grey.background, ({ isSmall: e }) => e ? "1px" : "2px", l.line.base, I.small, t.primary.contrast, i.weight.medium, t.text.title), q_ = ({ size: e }) => {
	switch (!0) {
		case e === "small": return i.body.small;
		case e === "large": return i.body.large;
		default: return i.body.medium;
	}
}, J_ = ({ size: e }) => {
	switch (!0) {
		case e === "small": return "2px 8px";
		case e === "large": return "5px 17px";
		default: return "5px 11px";
	}
}, Y_ = ({ withBorder: e, background: t }) => {
	switch (!0) {
		case e: return t || l.line.neutralSoft;
		default: return t || l.line.neutralSoft;
	}
}, X_ = ({ withBorder: e, background: t }) => {
	switch (!0) {
		case e: return l.surface.base;
		default: return t || l.surface.neutral;
	}
}, Z_ = ({ disabled: e, color: t }) => e ? l.text.base : t ?? l.text.interactive, Q_ = ({ background: e }) => fe([
	"0%{background-color:",
	";}50%{background-color:",
	";}100%{background-color:",
	";}"
], e, k(e, .5), e), $_ = (e) => {
	let { children: t, size: n = "medium", ...r } = e;
	return /*#__PURE__*/ M(ev, {
		size: n,
		...r,
		children: t
	});
}, ev = P.span.withConfig({
	displayName: "Chip__ChipElement",
	componentId: "sc-a0d34530-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";line-height:1.3;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;display:inline-block;overflow:hidden;position:relative;width:",
	";max-width:100%;padding:",
	";background:",
	";border:1px solid ",
	";border-radius:",
	";",
	" ",
	" ",
	""
], Z_, q_, i.weight.normal, ({ isFullWidth: e }) => e ? "100%" : "auto", J_, X_, Y_, I.full, ({ isInline: e }) => e && de(["text-overflow:unset;white-space:nowrap;overflow:visible;max-width:none;"]), ({ disabled: e }) => e && de(["pointer-events:none;user-select:none;"]), ({ background: e, isPulsating: t }) => t && e && de(["animation-duration:2s;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:ease-in-out;"], Q_({ background: e }))), tv = ({ variant: e, disabled: n }) => {
	switch (!0) {
		case n:
		case e === "dim": return t.text.secondary;
		case e === "affirm":
		case e === "default":
		case e === "contrast": return t.primary.contrast;
		default: return t.text.title;
	}
}, nv = ({ size: e }) => {
	switch (e) {
		case "small": return i.body.small;
		default: return i.body.medium;
	}
}, rv = ({ variant: e, disabled: n, isLoading: r }) => {
	switch (!0) {
		case n && !r: return l.surface.neutral;
		case e === "neutral": return l.surface.neutral;
		case e === "highlight": return l.surface.highlight;
		case e === "highlightSoft": return l.surface.highlightSoft;
		case e === "dim": return l.surface.neutral;
		case e === "affirm": return t.primary.background;
		case e === "contrast": return t.primary.primaryAction;
		default: return l.surface.base;
	}
}, iv = ({ variant: e }) => {
	switch (e) {
		case "neutral": return l.surface.neutral;
		case "highlight": return l.surface.highlight;
		case "highlightSoft": return l.surface.highlightSoft;
		case "dim":
		case "inverted":
		case "contrast": return l.line.neutralSoft;
		default: return l.surface.interactive;
	}
}, av = ({ size: e }) => {
	switch (e) {
		case "small": return "2px 8px";
		case "large": return "11px 23px";
		default: return "5px 11px";
	}
}, ov = ({ as: e = "button", children: t, IconComponent: n, iconPosition: r = "after", variant: i = "default", size: a = "medium", withBorder: o = !1, onClick: s, isFullWidth: c, isLoading: l = !1, disabled: u = !1, ...d }) => {
	let f = u || l;
	return /*#__PURE__*/ M(sv, {
		...d,
		as: e,
		"aria-disabled": f,
		disabled: f,
		isLoading: l,
		isFullWidth: c,
		onClick: s,
		size: a,
		variant: i,
		withBorder: o,
		children: /*#__PURE__*/ M(t_, {
			isSmall: !0,
			isLoading: l,
			spinnerColor: iv({ variant: i }),
			shouldHideContentWhenLoading: !0,
			children: /*#__PURE__*/ N(B, {
				gap: a === "small" ? "6px" : "9px",
				alignCenter: !0,
				justifyCenter: !0,
				children: [
					n && r === "before" && /*#__PURE__*/ M(n, { fill: tv({
						variant: i,
						disabled: u
					}) }),
					/*#__PURE__*/ M(cv, { children: t }),
					n && r === "after" && /*#__PURE__*/ M(n, { fill: tv({
						variant: i,
						disabled: u
					}) })
				]
			})
		})
	});
}, sv = P.button.withConfig({
	displayName: "ChipButton__Container",
	componentId: "sc-68fa91b8-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";line-height:1.3;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;display:inline-block;overflow:hidden;position:relative;width:",
	";max-width:100%;padding:",
	";background:",
	";border-radius:",
	";&:focus{outline:",
	";}",
	"{cursor:pointer;&:hover{opacity:0.75;}}",
	" ",
	""
], tv, nv, i.weight.medium, ({ isFullWidth: e }) => e ? "100%" : "auto", av, rv, I.full, s.interactive.medium, R.pointer, ({ disabled: e }) => !e && `
        &:focus {
            outline: ${s.interactive.medium};
        }

        ${R.pointer} {
            &:active {
                transform: scale(0.98);
            }
        }
    `, ({ disabled: e }) => e && `
        user-select: none;

        ${R.pointer} {
            cursor: not-allowed;

            &:hover {
                opacity: 1;
            }
        }
    `), cv = P.span.withConfig({
	displayName: "ChipButton__ChipContentWrapper",
	componentId: "sc-68fa91b8-1"
})(["display:block;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;"]), lv = ({ size: e, displayAs: t }) => {
	switch (!0) {
		case t === "chip": return I.full;
		case e === "large": return I.buttonLarge;
		case e === "small": return I.small;
		default: return I.buttonMedium;
	}
}, uv = ({ size: e }) => {
	switch (!0) {
		case e === "large": return "14px 36px 14px 20px";
		case e === "small": return "6px 30px 6px 12px";
		case e === "smaller": return "4px 30px 4px 8px";
		default: return "8px 30px 8px 16px";
	}
}, dv = ({ isSecondary: e }) => e ? t.primary.pressed : t.primary.primaryAction, fv = ({ actions: e, alignMobileLeft: n, alignRight: r, children: i, isMobileFullWidth: a, isSecondary: o, isLoading: s, isHorizontal: c, size: u = "medium", displayAs: d = "button", ...f }) => {
	let [p, m] = E(!1), h = (e) => {
		e.preventDefault(), e.stopPropagation(), m(!0);
	}, g = (e) => ({ onClick: t }) => {
		m(!1), t(e);
	}, _ = T(null);
	ie(_, () => {
		m(!1);
	}), ae(() => m(!1));
	let v = !!i;
	return /*#__PURE__*/ N(pv, {
		isMobileFullWidth: a,
		children: [
			!v && /*#__PURE__*/ N(mv, {
				onClick: h,
				disabled: s,
				isSecondary: o,
				isHorizontal: c,
				...f,
				children: [s && /*#__PURE__*/ M(U, {
					isSmall: !0,
					color: o ? l.surface.interactive : l.line.neutral
				}), !s && /*#__PURE__*/ N(j, { children: [
					/*#__PURE__*/ M(hv, {}),
					/*#__PURE__*/ M(hv, {}),
					/*#__PURE__*/ M(hv, {})
				] })]
			}),
			v && /*#__PURE__*/ M(gv, {
				isMobileFullWidth: a,
				isSecondary: o,
				onClick: h,
				size: u,
				displayAs: d,
				...f,
				children: /*#__PURE__*/ M(t_, {
					isSmall: !0,
					isLoading: s,
					spinnerColor: o ? t.primary.contrast : l.line.neutral,
					spinnerColor2: o ? t.primary.hover : l.line.neutral,
					shouldHideContentWhenLoading: !0,
					children: /*#__PURE__*/ M(B, {
						alignCenter: !0,
						spaceBetween: !0,
						children: /*#__PURE__*/ M(_v, {
							size: u,
							children: i
						})
					})
				})
			}),
			p && /*#__PURE__*/ M(vv, {
				ref: _,
				alignRight: r,
				alignMobileLeft: n,
				children: /*#__PURE__*/ M(_e, {
					autoFocus: !1,
					returnFocus: !0,
					children: e.filter(({ shouldHide: e }) => !e).map(({ title: e, onClick: t, color: n, disabled: r, ...i }) => /*#__PURE__*/ M(yv, {
						onClick: (e) => {
							e.preventDefault(), g(e)({ onClick: t });
						},
						color: n,
						disabled: r,
						...i,
						children: /*#__PURE__*/ M(bv, { children: e })
					}, e))
				})
			})
		]
	});
}, pv = P.div.withConfig({
	displayName: "DropdownButton__Container",
	componentId: "sc-16b3bf23-0"
})([
	"display:",
	";position:relative;",
	"{display:inline-block;}"
], ({ isMobileFullWidth: e }) => e ? "block" : "inline-block", R.tablet), mv = P.button.attrs(({ type: e }) => ({ type: e || "button" })).withConfig({
	displayName: "DropdownButton__LabellessContainer",
	componentId: "sc-16b3bf23-1"
})([
	"display:flex;flex-direction:",
	";align-items:center;justify-content:center;width:30px;height:30px;background:",
	";border:2px solid ",
	";border-radius:",
	";cursor:pointer;&:active{border:",
	";outline:none;}&:focus{border:2px solid transparent;outline:",
	";}",
	"{&:hover{opacity:0.75;}}",
	" ",
	""
], ({ isHorizontal: e }) => e ? "row" : "column", ({ isSecondary: e }) => e ? l.surface.base : l.surface.neutral, ({ isSecondary: e }) => e ? l.surface.base : l.line.neutralSoft, I.full, s.interactive.medium, s.interactive.medium, R.pointer, ({ disabled: e }) => e && "\n        pointer-events: none;\n        user-select: none;\n    ", ({ isSecondary: e }) => e && `
        & ${hv} {
            background: ${t.primary.contrast};
        }
    `), hv = P.div.withConfig({
	displayName: "DropdownButton__Dot",
	componentId: "sc-16b3bf23-2"
})([
	"width:3px;height:3px;margin:1px;background:",
	";border-radius:",
	";"
], l.line.neutral, I.full), gv = P.button.attrs(({ type: e }) => ({ type: e || "button" })).withConfig({
	displayName: "DropdownButton__LabelContainer",
	componentId: "sc-16b3bf23-3"
})([
	"color:",
	";font-family:inherit;line-height:1;text-align:left;display:flex;align-items:center;justify-content:space-between;width:",
	";padding:",
	";background:",
	";background-image:url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2210%22%20viewBox%3D%220%200%2016%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%209.0625L7.46875%208.53125L1.46875%202.53125L0.9375%202L2%200.9375L2.53125%201.46875L8%206.96875L13.4688%201.5L14%200.96875L15.0625%202L14.5312%202.53125L8.53125%208.53125L8%209.0625Z%22%20fill%3D%22%230C0B0A%22%20fill-opacity%3D%220.65%22%2F%3E%3C%2Fsvg%3E');background-repeat:no-repeat;background-position:right 12px top 50%;background-size:14px 14px;border:2px solid ",
	";border-radius:",
	";cursor:pointer;&:active::after{background:",
	";outline:none;}&:focus-visible{outline:",
	";&::after{background:",
	";}}",
	"{width:auto;&:hover{opacity:0.75;}}"
], ({ isSecondary: e }) => e ? t.primary.contrast : l.text.base, ({ isMobileFullWidth: e }) => e ? "100%" : "auto", uv, ({ isSecondary: e }) => e ? t.primary.primaryAction : l.surface.neutral, ({ isSecondary: e }) => e ? t.primary.primaryAction : l.line.neutralSoft, lv, dv, s.interactive.medium, dv, R.tablet), _v = P.div.withConfig({
	displayName: "DropdownButton__Label",
	componentId: "sc-16b3bf23-4"
})([
	"font-size:",
	";font-weight:",
	";"
], ({ size: e }) => e === "smaller" ? i.body.small : i.body.medium, i.weight.medium), vv = P.div.withConfig({
	displayName: "DropdownButton__ActionsContainer",
	componentId: "sc-16b3bf23-5"
})([
	"position:absolute;top:100%;right:",
	";left:",
	";z-index:9999;padding:6px 0;background:",
	";border-radius:",
	";box-shadow:",
	";",
	" ",
	" ",
	"{right:",
	";left:",
	";}"
], ({ alignRight: e }) => e ? 0 : "auto", ({ alignRight: e }) => e ? "auto" : 0, l.surface.neutral, I.medium, L.medium, ({ alignRight: e }) => e && "\n        left: auto;\n        right: 0;\n    ", ({ alignMobileLeft: e }) => e && "\n        left: 0;\n        right: auto;\n    ", R.tablet, ({ alignRight: e }) => e ? 0 : "auto", ({ alignRight: e }) => e ? "auto" : 0), yv = P.button.attrs({ type: "button" }).withConfig({
	displayName: "DropdownButton__Action",
	componentId: "sc-16b3bf23-6"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";text-align:left;white-space:nowrap;display:block;width:100%;padding:9px 30px 10px 18px;background:",
	";border:0;cursor:pointer;",
	"{",
	"}"
], ({ disabled: e, color: t }) => e ? l.text.neutral : t || l.text.base, i.body.medium, i.weight.medium, l.surface.neutral, R.pointer, ({ disabled: e }) => !e && `
            &:hover {
                color: ${l.text.interactive};
            }
            &:focus {
                color: ${l.text.interactive};
            }
        `), bv = P.div.withConfig({
	displayName: "DropdownButton__ActionTitle",
	componentId: "sc-16b3bf23-7"
})([""]), xv = ({ size: e, displayAs: t, isSmall: n }) => {
	switch (!0) {
		case t === "chip": return I.full;
		case e === "large": return I.buttonLarge;
		case e === "small" || n: return I.small;
		default: return I.buttonMedium;
	}
}, Sv = ({ size: e, isSmall: t }) => {
	switch (!0) {
		case e === "large": return "14px 36px 14px 20px";
		case e === "small" || t: return "6px 30px 6px 12px";
		case e === "smaller": return "4px 30px 4px 8px";
		default: return "8px 30px 8px 16px";
	}
}, Cv = ({ alignRight: e, name: t, onChange: n, options: r, value: i, width: a, isSmall: o, size: s, displayAs: c, isLoading: u, innerLabel: d, maxHeight: f, borderColor: p }) => {
	let [m, h] = E(!1), g = (e) => {
		e.preventDefault(), h(!0);
	}, _ = ({ name: e, value: t }) => {
		n && n({
			name: e,
			value: t
		});
	}, v = ({ value: e }) => {
		n && (h(!1), n({
			name: t,
			value: e
		}));
	}, y = T(null);
	ie(y, () => {
		h(!1);
	});
	let b = r.findIndex((e) => e.value === i), x = b > -1, S = x ? r[b].title : i;
	return /*#__PURE__*/ N(wv, {
		width: a,
		"aria-expanded": m,
		children: [!ve && /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ M(Tv, {
			isSmall: o,
			color: (() => {
				if (x && r[b].color) return r[b].color;
			})(),
			onClick: g,
			width: a,
			size: s,
			displayAs: c,
			borderColor: p,
			children: /*#__PURE__*/ M(t_, {
				isSmall: !0,
				isLoading: u,
				spinnerColor: l.line.neutral,
				spinnerColor2: l.line.neutralLight,
				shouldHideContentWhenLoading: !0,
				children: /*#__PURE__*/ M(B, {
					alignCenter: !0,
					spaceBetween: !0,
					children: /*#__PURE__*/ N(Ev, {
						size: s,
						children: [!!d && /*#__PURE__*/ N("strong", { children: [d, ": "] }), S]
					})
				})
			})
		}), m && /*#__PURE__*/ M(Dv, {
			ref: y,
			alignRight: e,
			maxHeight: f,
			children: r.map(({ value: e, title: t, disabled: n = !1 }) => /*#__PURE__*/ M(Ov, {
				onClick: (t) => {
					t.preventDefault(), v({ value: e });
				},
				disabled: n,
				children: /*#__PURE__*/ M(kv, { children: t })
			}, e))
		})] }), ve && /*#__PURE__*/ M(Cy, {
			options: r,
			name: t,
			value: i,
			onChange: _,
			width: a
		})]
	});
}, wv = P.div.withConfig({
	displayName: "DropdownSelect__Container",
	componentId: "sc-e99c35bc-0"
})(["position:relative;width:", ";"], ({ width: e }) => e || "auto"), Tv = P.button.withConfig({
	displayName: "DropdownSelect__LabelContainer",
	componentId: "sc-e99c35bc-1"
})([
	"color:",
	";font-family:inherit;line-height:1;text-align:left;display:flex;align-items:center;justify-content:space-between;width:",
	";padding:",
	";background:",
	";background-image:url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2210%22%20viewBox%3D%220%200%2016%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%209.0625L7.46875%208.53125L1.46875%202.53125L0.9375%202L2%200.9375L2.53125%201.46875L8%206.96875L13.4688%201.5L14%200.96875L15.0625%202L14.5312%202.53125L8.53125%208.53125L8%209.0625Z%22%20fill%3D%22%230C0B0A%22%20fill-opacity%3D%220.65%22%2F%3E%3C%2Fsvg%3E');background-repeat:no-repeat;background-position:right 12px top 50%;background-size:14px 14px;border:2px solid ",
	";border-radius:",
	";cursor:pointer;",
	"{&:not(:disabled){&:hover{border-color:",
	";}&:focus{border-color:",
	";outline:",
	";}}}"
], l.text.base, ({ width: e }) => e || "auto", Sv, ({ color: e }) => e ?? l.surface.neutral, ({ color: e, borderColor: t }) => t ?? e ?? l.line.neutralSoft, xv, R.pointer, ({ color: e, borderColor: t }) => t ?? e ?? l.line.neutralLight, ({ color: e, borderColor: t }) => t ?? e ?? l.line.neutralLight, s.interactive.medium), Ev = P.div.withConfig({
	displayName: "DropdownSelect__Label",
	componentId: "sc-e99c35bc-2"
})([
	"font-size:",
	";font-weight:",
	";> strong{font-weight:",
	";}"
], ({ size: e }) => e === "smaller" ? i.body.small : i.body.medium, i.weight.medium, i.weight.bold), Dv = P.div.withConfig({
	displayName: "DropdownSelect__OptionsContainer",
	componentId: "sc-e99c35bc-3"
})([
	"position:absolute;top:100%;right:",
	";left:",
	";z-index:9999;padding:6px 0;max-height:",
	";overflow:auto;background:",
	";border-radius:",
	";box-shadow:",
	";"
], ({ alignRight: e }) => e ? 0 : "auto", ({ alignRight: e }) => e ? "auto" : 0, ({ maxHeight: e }) => e ?? "auto", l.surface.neutral, I.medium, L.medium), Ov = P.button.withConfig({
	displayName: "DropdownSelect__Option",
	componentId: "sc-e99c35bc-4"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";text-align:left;white-space:nowrap;display:block;width:100%;padding:9px 30px 10px 18px;background:",
	";border:0;cursor:",
	";",
	"{&:hover{color:",
	";}&:focus{color:",
	";}}"
], ({ disabled: e }) => e ? l.text.neutral : l.text.base, i.body.medium, i.weight.medium, l.surface.neutral, ({ disabled: e }) => e ? "auto" : "pointer", R.pointer, ({ disabled: e }) => e ? l.text.neutral : l.text.interactive, ({ disabled: e }) => e ? l.text.neutral : l.text.interactive), kv = P.div.withConfig({
	displayName: "DropdownSelect__OptionTitle",
	componentId: "sc-e99c35bc-5"
})([""]), G = ({ color: e = l.text.base, hoverColor: t, onClick: n, Component: r, background: i, width: a, height: o, isLoading: s, ariaLabel: c }) => {
	let [u, d] = E(!1), [f, p] = E(!1), m = !!n, h = () => {
		n && !s && n();
	}, g = () => {
		m && d(!0);
	}, _ = () => {
		m && d(!1);
	}, v = () => {
		m && p(!0);
	}, y = () => {
		m && p(!1);
	}, b = m && (u || f) && !s;
	return /*#__PURE__*/ N(Av, {
		"aria-label": m ? c : void 0,
		as: m ? "button" : "div",
		background: i,
		height: o,
		isInteractive: m,
		onBlur: m ? y : void 0,
		onClick: m ? h : void 0,
		onFocus: m ? v : void 0,
		onKeyDown: m ? O(h) : void 0,
		onMouseEnter: m ? g : void 0,
		onMouseLeave: m ? _ : void 0,
		role: m ? "button" : void 0,
		tabIndex: m ? 0 : void 0,
		type: m ? "button" : void 0,
		width: a,
		children: [s && /*#__PURE__*/ M(U, {
			isSmall: !0,
			color: e
		}), !s && /*#__PURE__*/ M(r, {
			"aria-hidden": m || !m && !c ? !0 : void 0,
			"aria-label": !m && c ? c : void 0,
			color: b && t ? t : e,
			role: !m && c ? "img" : void 0
		})]
	});
}, Av = P.div.withConfig({
	displayName: "Icon__Container",
	componentId: "sc-bca308da-0"
})([
	"display:flex;align-items:center;justify-content:center;width:",
	";height:",
	";cursor:",
	";background:",
	";&[type='button']{border:none;padding:0;font:inherit;color:inherit;text-align:inherit;&:focus-visible{outline:",
	";outline-offset:6px;border-radius:",
	";}}"
], ({ width: e }) => e || "24px", ({ height: e }) => e || "24px", ({ isInteractive: e }) => e ? "pointer" : "inherit", ({ background: e }) => e || "none", s.interactive.medium, I.small), jv = P.div.withConfig({
	displayName: "Indicators",
	componentId: "sc-f743a11f-0"
})(["display:flex;gap:6px;"]), Mv = P.div.withConfig({
	displayName: "Indicators__Indicator",
	componentId: "sc-f743a11f-1"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";display:flex;align-items:center;justify-content:center;width:36px;height:36px;background:",
	";border:1px solid ",
	";border-radius:",
	";"
], ({ color: e }) => e || l.text.base, i.body.small, i.weight.medium, ({ background: e }) => e || "transparent", ({ border: e, background: t }) => e || t || "transparent", I.full), Nv = ({ children: e, id: t }) => /*#__PURE__*/ M(Pv, {
	id: t,
	children: e
}), Pv = P.div.withConfig({
	displayName: "ErrorMessage__Container",
	componentId: "sc-34b92c1b-0"
})([
	"font-size:",
	";color:",
	";padding-top:6px;line-height:1.3;"
], i.body.medium, l.text.alert), Fv = ({ hasError: e, disabled: n }) => {
	switch (!0) {
		case n: return t.common.disabled1;
		case e: return t.error.main;
		default: return t.grey.graphics2;
	}
}, Iv = /*#__PURE__*/ g(({ disabled: e, readOnly: t, floatingLabel: n, formatter: r = (e) => e, isLarge: i, onChange: a, placeholder: o, shouldAlwaysDisplayFloatingLabel: s, suffix: c, value: l, errorMessage: u, hasError: d, width: f, ...p }, m) => {
	let h = l && String(l).length > 0, g = (e) => {
		e.currentTarget.type === "number" && e.currentTarget.blur();
	}, _ = (e) => {
		if (!a) return;
		let { target: t } = e, { name: n, value: i } = t;
		a({
			name: n,
			rawValue: i,
			value: r(i)
		}, e);
	};
	return n ? /*#__PURE__*/ N(Lv, {
		width: f,
		children: [
			/*#__PURE__*/ M(Rv, {
				hasSuffix: !!c,
				isLarge: i,
				onChange: _,
				placeholder: s ? o : n || o,
				ref: m,
				value: l,
				hasError: d,
				disabled: e,
				readOnly: t,
				"aria-disabled": e,
				"aria-readonly": t,
				onWheel: g,
				...p
			}),
			/*#__PURE__*/ M(zv, {
				isVisible: h || s,
				isLarge: i,
				hasError: d,
				children: n
			}),
			c && /*#__PURE__*/ M(Bv, { children: c }),
			d && u && /*#__PURE__*/ M(Nv, { children: u })
		]
	}) : /*#__PURE__*/ N(Lv, { children: [
		/*#__PURE__*/ M(Rv, {
			hasSuffix: !!c,
			hasError: d,
			isLarge: i,
			onChange: _,
			placeholder: o,
			ref: m,
			value: l,
			disabled: e,
			readOnly: t,
			"aria-disabled": e,
			"aria-readonly": t,
			onWheel: g,
			...p
		}),
		c && /*#__PURE__*/ M(Bv, { children: c }),
		d && u && /*#__PURE__*/ M(Nv, { children: u })
	] });
}), Lv = P.div.withConfig({
	displayName: "Input__Container",
	componentId: "sc-ff095029-0"
})(["position:relative;width:", ";"], ({ width: e }) => e || "auto"), Rv = P.input.withConfig({
	displayName: "Input__InputElement",
	componentId: "sc-ff095029-1"
})([
	"appearance:none;border-radius:0;color:",
	";font-family:inherit;font-size:",
	";line-height:1.35;width:100%;padding:",
	";background:",
	";border:1px solid ",
	";border-radius:",
	";&::placeholder{color:",
	";transition:color 0.1s;}&:focus-visible{color:",
	";border:1px solid ",
	";outline:",
	";::placeholder{color:transparent;}}&:read-only{color:",
	";border-color:",
	";}&:disabled{color:",
	";border:1px solid ",
	";}&:focus:read-only{border-color:",
	";outline:0;}",
	"{&:not(:disabled):not(:read-only){&:hover{border-color:",
	";}}}",
	" &::-webkit-search-cancel-button{opacity:0.3;}"
], t.text.primary, i.body.large, ({ isLarge: e }) => e ? "12px 15px 13px" : "7px 9px", t.grey.background, Fv, I.small, t.text.secondary, t.text.primary, Fv, s.interactive.medium, t.text.secondary, t.common.disabled1, t.text.disabled, Fv, t.common.disabled1, R.tablet, t.grey.graphics1, ({ hasSuffix: e }) => e && "\n        /* Chrome, Safari, Edge, Opera */\n        &:not(:focus, :hover)::-webkit-outer-spin-button,\n        &:not(:focus, :hover)::-webkit-inner-spin-button {\n            -webkit-appearance: none;\n            margin: 0;\n        }\n\n        /* Firefox */\n        &[type=number]:not(:focus, :hover) {\n            -moz-appearance: textfield;\n        }\n    "), zv = P.div.withConfig({
	displayName: "Input__FloatingLabel",
	componentId: "sc-ff095029-2"
})([
	"font-size:",
	";position:absolute;top:-8px;left:",
	";display:block;padding:2px 4px;background:",
	";border-radius:",
	";opacity:",
	";visibility:",
	";transform:",
	";transition:all 0.1s;color:",
	";input:focus ~ &{opacity:1;visibility:visible;transform:translateY(0);}input:disabled ~ &{color:",
	";}"
], i.body.small, ({ isLarge: e }) => e ? "12px" : "6px", t.grey.background, I.small, ({ isVisible: e }) => +!!e, ({ isVisible: e }) => e ? "visible" : "hidden", ({ isVisible: e }) => e ? "translateY(0)" : "translateY(6px)", ({ hasError: e }) => e ? t.error.main : "unset", t.text.disabled), Bv = P.div.withConfig({
	displayName: "Input__Suffix",
	componentId: "sc-ff095029-3"
})([
	"color:",
	";line-height:1.35;display:flex;align-items:center;position:absolute;top:0;right:0;width:auto;height:100%;padding:0 9px;pointer-events:none;input[type='number']:not(:disabled):is(:focus,:hover) ~ &{display:none;}input:disabled ~ &{color:",
	";}"
], t.text.primary, t.text.disabled), Vv = ({ background: e, children: t, color: n, label: r, position: i = "start" }) => /*#__PURE__*/ N(B, {
	width: "100%",
	gap: "3px",
	children: [
		i === "start" && /*#__PURE__*/ M(Hv, {
			background: e,
			color: n,
			children: r
		}),
		/*#__PURE__*/ M(Uv, { children: t }),
		i === "end" && /*#__PURE__*/ M(Hv, {
			background: e,
			color: n,
			children: r
		})
	]
}), Hv = P.div.withConfig({
	displayName: "InputAffix__AffixLabel",
	componentId: "sc-cc36aef9-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";line-height:1.35;display:flex;flex:0 1 auto;align-items:center;justify-content:center;min-width:36px;padding:0 12px;background:",
	";border-radius:",
	";",
	"{font-size:",
	";}"
], ({ color: e }) => e || l.text.base, i.body.medium, ({ background: e }) => e || l.surface.neutral, I.small, R.tablet, i.body.large), Uv = P.div.withConfig({
	displayName: "InputAffix__Content",
	componentId: "sc-cc36aef9-1"
})(["flex:1;"]), Wv = P.div.withConfig({
	displayName: "Label",
	componentId: "sc-6cde2bd1-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";display:inline-block;position:relative;padding:",
	";background:",
	";border-radius:",
	";",
	""
], ({ color: e }) => e || "inherit", ({ fontSize: e }) => e || i.body.medium, i.weight.normal, ({ background: e }) => e ? "4px 6px" : 0, ({ background: e }) => e || "inherit", I.small, ({ hasEllipsis: e }) => e && "\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        max-width: 100%;\n    "), Gv = "Taxfix logo", Kv = ({ onClick: e }) => {
	let t = () => {
		e && e();
	}, n = e !== void 0, r = S();
	return /*#__PURE__*/ M(qv, {
		isLink: n,
		onClick: t,
		onKeyDown: n ? O(t) : void 0,
		role: n ? "button" : void 0,
		tabIndex: n ? 0 : void 0,
		"aria-label": n ? Gv : void 0,
		children: /*#__PURE__*/ M(Jv, {
			isDecorative: n,
			titleText: Gv,
			titleId: r
		})
	});
}, qv = P.div.withConfig({
	displayName: "Logo__LogoContainer",
	componentId: "sc-9b92b4b7-0"
})(["width:100%;height:100%;position:relative;cursor:", ";svg{width:100%;height:100%;}"], ({ isLink: e }) => e ? "pointer" : "inherit"), Jv = ({ titleText: e, titleId: t, isDecorative: n, ...r }) => /*#__PURE__*/ N("svg", {
	width: 120,
	height: 30,
	viewBox: "0 0 120 30",
	fill: "none",
	"aria-labelledby": n ? void 0 : t,
	"aria-hidden": n ? "true" : void 0,
	role: n ? void 0 : "img",
	xmlns: "http://www.w3.org/2000/svg",
	...r,
	children: [t && e && /*#__PURE__*/ M("title", {
		id: t,
		children: e
	}), /*#__PURE__*/ M("path", {
		d: "M84.6698 29.109H92.3846C92.5766 29.109 92.7047 28.9809 92.7047 28.7888V9.42201C92.7047 9.22995 92.5766 9.1019 92.3846 9.1019H84.6698C84.4778 9.1019 84.3497 9.22995 84.3497 9.42201V28.7888C84.3497 28.9809 84.4778 29.109 84.6698 29.109ZM69.2724 29.109H76.9871C77.1792 29.109 77.3072 28.9809 77.3072 28.7888V14.7039C77.3072 14.5118 77.4353 14.3838 77.6273 14.3838H82.0609C82.253 14.3838 82.381 14.2557 82.381 14.0637V9.42201C82.381 9.22995 82.253 9.1019 82.0609 9.1019H77.4993C77.3072 9.1019 77.1792 8.97386 77.1792 8.78179V7.98151C77.1792 6.50899 77.9475 5.77273 79.9322 5.77273C80.9245 5.77273 81.4527 5.80474 82.0129 5.93278C82.253 6.01281 82.365 5.90077 82.365 5.6927V1.32316C82.365 1.1631 82.285 1.00305 82.0769 0.971036C80.7645 0.570895 79.1159 0.330811 77.3232 0.330811C71.3211 0.330811 68.9203 2.8597 68.9203 7.61338V28.7888C68.9523 28.9809 69.0643 29.109 69.2724 29.109ZM62.2619 29.6691C64.9509 29.6691 67.1917 27.4284 67.1917 24.7394C67.1917 22.0505 64.9509 19.8097 62.2619 19.8097C59.573 19.8097 57.3802 22.0505 57.3802 24.7394C57.3802 27.4284 59.573 29.6691 62.2619 29.6691ZM42.655 29.109H51.106C51.2661 29.109 51.4261 29.0289 51.5061 28.9169L66.0393 9.50204C66.1993 9.26196 66.0713 9.1019 65.8472 9.1019H57.3962C57.2362 9.1019 57.0761 9.18193 56.9961 9.29397L42.463 28.7088C42.2869 28.9489 42.4149 29.109 42.655 29.109ZM46.2243 18.3852C48.9132 18.3852 51.106 16.1444 51.106 13.4554C51.106 10.7665 48.8972 8.5257 46.2243 8.5257C43.5513 8.5257 41.2946 10.7665 41.2946 13.4554C41.2946 16.1444 43.5353 18.3852 46.2243 18.3852ZM27.7698 23.9871C25.3689 23.9871 24.0085 22.0985 24.0085 19.1054C24.0085 16.0644 25.3689 14.2237 27.7698 14.2237C30.0426 14.2237 31.3711 16.1124 31.3711 19.1054C31.3711 22.0665 30.0586 23.9871 27.7698 23.9871ZM24.6167 29.6211C27.7378 29.6211 29.7385 28.2607 31.099 25.9718C31.227 25.8118 31.4191 25.8438 31.4191 26.0999V28.7888C31.4191 28.9809 31.5471 29.109 31.7392 29.109H39.2138C39.4059 29.109 39.5339 28.9809 39.5339 28.7888V9.42201C39.5339 9.22995 39.4059 9.1019 39.2138 9.1019H31.7232C31.5311 9.1019 31.4031 9.22995 31.4031 9.42201V12.0629C31.4031 12.303 31.163 12.351 31.0509 12.143C29.7385 9.90218 27.7218 8.58972 24.6167 8.58972C19.1267 8.58972 15.4134 13.0713 15.4134 19.1214C15.3974 25.1075 19.1267 29.6211 24.6167 29.6211ZM94.7534 29.109H103.364C103.524 29.109 103.653 29.0289 103.717 28.9169L106.95 24.6274C107.078 24.4353 107.302 24.4353 107.43 24.6274L110.631 28.9169C110.711 29.0449 110.871 29.109 111.031 29.109H119.722C120.01 29.109 120.074 28.9169 119.914 28.7088L112.312 19.3455C112.184 19.2175 112.184 19.0254 112.312 18.8653L119.914 9.50204C120.074 9.30997 119.994 9.1019 119.722 9.1019H111.111C110.951 9.1019 110.871 9.13391 110.759 9.29397L107.526 13.6155C107.398 13.7755 107.174 13.7755 107.046 13.6155L103.845 9.29397C103.717 9.13391 103.605 9.1019 103.444 9.1019H94.7534C94.4653 9.1019 94.4013 9.26196 94.5613 9.50204L102.116 18.8974C102.244 19.0254 102.244 19.2175 102.116 19.3775L94.5613 28.7088C94.4013 28.9009 94.4653 29.109 94.7534 29.109ZM8.40296 29.6691C10.3556 29.6691 11.7962 29.5091 13.6848 28.9009C13.8769 28.8689 13.9729 28.7088 13.9729 28.5488V23.619C13.9729 23.4269 13.8449 23.2989 13.6208 23.3789C13.0286 23.539 12.3884 23.667 11.6681 23.667C9.26727 23.667 8.38696 22.5466 8.38696 20.5779V14.7039C8.38696 14.5118 8.515 14.3838 8.70707 14.3838H13.5888C13.7809 14.3838 13.9089 14.2557 13.9089 14.0637V9.42201C13.9089 9.22995 13.7809 9.1019 13.5888 9.1019H8.67506C8.48299 9.1019 8.35494 8.97386 8.35494 8.78179V3.05177C8.35494 2.8597 8.2269 2.76367 8.03483 2.76367L0.320113 3.01976C0.128045 3.01976 0 3.1478 0 3.33987V22.5146C0 27.4604 3.23314 29.6691 8.40296 29.6691Z",
		fill: "#154618"
	})]
}), Yv = ({ onClick: e }) => {
	let t = () => {
		e && e();
	}, n = e !== void 0;
	return /*#__PURE__*/ M(Xv, {
		isLink: n,
		onClick: t,
		onKeyDown: n ? O(t) : void 0,
		role: n ? "button" : void 0,
		tabIndex: n ? 0 : void 0,
		children: /*#__PURE__*/ M(Zv, {})
	});
}, Xv = P.div.withConfig({
	displayName: "Logomark__Container",
	componentId: "sc-54bb4b3e-0"
})(["display:flex;align-items:center;position:relative;width:100%;height:100%;cursor:", ";svg{width:100%;height:100%;}"], ({ isLink: e }) => e ? "pointer" : "inherit"), Zv = () => /*#__PURE__*/ N("svg", {
	color: "#154618",
	viewBox: "0 0 30 24",
	"data-testid": "TaxfixLogomarkIcon",
	style: { aspectRatio: "1.25 / 1" },
	children: [
		/*#__PURE__*/ M("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.5913 18.4087C29.5913 21.4537 27.045 24 24 24C20.955 24 18.4558 21.4537 18.4558 18.4087C18.4558 15.3637 20.955 12.8174 24 12.8174C27.045 12.8174 29.5913 15.3637 29.5913 18.4087Z",
			fill: "currentColor"
		}),
		/*#__PURE__*/ M("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.227 23.3627H1.6375C1.3632 23.3627 1.22743 23.1799 1.4103 22.9083L17.91 0.864466C18.0014 0.728701 18.1815 0.637266 18.3644 0.637266H27.9538C28.2254 0.637266 28.3639 0.820135 28.181 1.09167L11.6814 23.1355C11.5899 23.2713 11.4098 23.3627 11.227 23.3627Z",
			fill: "currentColor"
		}),
		/*#__PURE__*/ M("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.1355 5.59132C11.1355 8.63634 8.63634 11.1826 5.59132 11.1826C2.54629 11.1826 0 8.63634 0 5.59132C0 2.54629 2.54629 0 5.59132 0C8.63634 0 11.1355 2.54629 11.1355 5.59132Z",
			fill: "currentColor"
		})
	]
}), Qv = () => ({ handleKeyDown: y((e) => {
	if (e && e.key === "Tab") {
		let t = e.target;
		t.value && (e.preventDefault(), t.blur(), setTimeout(() => t.focus()));
	}
}, []) }), $v = ({ emails: e, onChange: t, onChangeInput: n, placeholder: r, autoFocus: i, allowDuplicate: a, hasError: o, floatingLabel: s, style: c }) => {
	let { handleKeyDown: u } = Qv(), d = e.length > 0, f = y((r) => {
		t && t(r), r.length > e.length && n && n("");
	}, [
		e,
		t,
		n
	]);
	return /*#__PURE__*/ N(ey, {
		hasAnyEmailItems: d,
		hasError: o,
		children: [s && /*#__PURE__*/ M(ty, { children: s }), /*#__PURE__*/ M(ye, {
			allowDuplicate: a,
			autoFocus: i,
			placeholder: r,
			emails: e,
			allowDisplayName: !0,
			stripDisplayName: !0,
			onChange: f,
			onChangeInput: n,
			onKeyDown: u,
			style: c,
			getLabel: (e, t, n) => /*#__PURE__*/ M($_, {
				color: l.text.base,
				background: l.surface.highlightSoft,
				children: /*#__PURE__*/ N(B, {
					gap: "6px",
					alignCenter: !0,
					children: [/*#__PURE__*/ M(ny, { children: /*#__PURE__*/ M(V, {
						as: "span",
						lineHeight: 1.3,
						children: e
					}) }), /*#__PURE__*/ M(ry, {
						onClick: () => n(t),
						onKeyDown: O(() => n(t)),
						role: "button",
						tabIndex: 0,
						children: "✕"
					})]
				})
			}, t)
		})]
	});
}, ey = P.div.withConfig({
	displayName: "MultiEmailInput__Styles",
	componentId: "sc-26145bee-0"
})([
	"position:relative;.react-multi-email{display:flex;flex-wrap:wrap;align-content:flex-start;align-items:center;gap:8px;padding:8px;border:1px solid ",
	";border-radius:",
	";outline:none;",
	" span[data-placeholder]{color:",
	";display:none;position:absolute;left:12px;}input{font-size:",
	";line-height:1;display:inline-block;flex:1 1;width:auto;padding:",
	";border:none;outline:none;}&:hover{border:1px solid ",
	";}&.focused{color:",
	";border:1px solid ",
	";outline:",
	";}&.empty{span[data-placeholder]{display:inline;}}&.fill{span[data-placeholder]{display:none;}}}"
], t.grey.graphics2, I.small, ({ hasError: e }) => e && `
            border-color: ${t.error.main};
        `, t.text.secondary, i.body.large, (e) => e.hasAnyEmailItems ? "9px 14px" : "9px 4px", t.grey.graphics1, t.text.primary, t.grey.graphics1, s.interactive.medium), ty = P.div.withConfig({
	displayName: "MultiEmailInput__FloatingLabel",
	componentId: "sc-26145bee-1"
})([
	"color:",
	";font-size:",
	";display:block;position:absolute;top:-8px;left:6px;padding:2px 4px;background:",
	";border-radius:",
	";"
], ({ hasError: e }) => e ? l.text.alert : "unset", i.body.small, t.grey.background, I.small), ny = P.span.withConfig({
	displayName: "MultiEmailInput__TextOverflow",
	componentId: "sc-26145bee-2"
})(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"]), ry = P.span.withConfig({
	displayName: "MultiEmailInput__IconRemove",
	componentId: "sc-26145bee-3"
})([
	"color:",
	";position:relative;padding:3px;cursor:pointer;&:hover{color:",
	";}&::before{content:'';position:absolute;top:-6px;right:-6px;bottom:-6px;left:-6px;border-radius:50%;}"
], t.text.primary, t.error.main), iy = ({ children: e, background: t = l.surface.attention, textAlignLeft: n, isCompact: r, borderRadius: i = "0" }) => /*#__PURE__*/ M(oy, {
	background: t,
	isCompact: r,
	borderRadius: i,
	role: "status",
	children: /*#__PURE__*/ M(sy, {
		textAlignLeft: n,
		children: e
	})
}), ay = P.div.withConfig({
	displayName: "Notice__NoticeAction",
	componentId: "sc-698b01fb-0"
})(["margin:6px 12px;display:inline-block;", "{margin:0 12px;}"], R.tablet), oy = P.div.withConfig({
	displayName: "Notice__Container",
	componentId: "sc-698b01fb-1"
})([
	"padding:",
	";background:",
	";border-radius:",
	";",
	"{padding:",
	";}&:not(:last-child){margin-bottom:2px;}"
], ({ isCompact: e }) => e ? "12px" : "12px 24px", ({ background: e }) => e, ({ borderRadius: e }) => e, R.tablet, ({ isCompact: e }) => e ? "12px" : "18px 48px"), sy = P.div.withConfig({
	displayName: "Notice__Body",
	componentId: "sc-698b01fb-2"
})([
	"font-size:",
	";line-height:1.5;text-align:",
	";p:not(:first-child){margin-top:6px;}a{color:",
	";font-weight:",
	";text-decoration:underline;",
	"{&:hover{color:",
	";text-decoration:none;}}}"
], i.body.medium, ({ textAlignLeft: e }) => e ? "left" : "center", l.text.interactive, i.weight.medium, R.pointer, l.text.base), cy = ({ children: e, description: n, isActive: r, isDisabled: a, onClick: o }) => /*#__PURE__*/ M(ly, {
	isActive: r,
	onClick: a ? void 0 : () => o(),
	isDisabled: a,
	children: /*#__PURE__*/ N(B, {
		column: !0,
		gap: "3px",
		tabletGap: "6px",
		children: [
			/*#__PURE__*/ M(V, {
				color: l.text.interactive,
				size: i.title.medium,
				weight: i.weight.medium,
				lineHeight: 1.3,
				children: e
			}),
			!!n && /*#__PURE__*/ M(V, {
				size: i.body.small,
				tabletSize: i.body.medium,
				children: n
			}),
			r && /*#__PURE__*/ M(uy, { children: /*#__PURE__*/ M(S_, {
				background: t.primary.main,
				children: /*#__PURE__*/ M(Fg, { color: l.text.inverted })
			}) })
		]
	})
}), ly = P.button.withConfig({
	displayName: "OptionButton__Container",
	componentId: "sc-3ed211c7-0"
})([
	"color:",
	";text-align:left;position:relative;width:100%;padding:12px 60px 12px 18px;background-color:",
	";border:2px solid ",
	";border-radius:",
	";opacity:",
	";",
	"{&:hover{box-shadow:",
	";}}",
	"{padding:18px 72px 18px 36px;&:after{right:36px;}}"
], ({ isActive: e }) => e ? l.text.base : l.text.neutral, ({ isActive: e }) => e ? t.common.active : l.surface.base, ({ isActive: e }) => e ? "transparent" : l.line.neutralSoft, I.large, ({ isDisabled: e }) => e ? .6 : 1, R.pointer, ({ isActive: e, isDisabled: t }) => e || t ? "none" : L.medium, R.tablet), uy = P.div.withConfig({
	displayName: "OptionButton__BadgeContainer",
	componentId: "sc-3ed211c7-1"
})(["position:absolute;top:50%;right:18px;transform:translateY(-50%);", "{right:36px;}"], R.tablet), dy = ({ background: e, width: t }) => /*#__PURE__*/ M(fy, { children: /*#__PURE__*/ M(py, {
	width: t,
	background: e
}) }), fy = P.div.withConfig({
	displayName: "ProgressLine__Container",
	componentId: "sc-ef72c9a0-0"
})(["position:relative;width:100%;height:2px;"]), py = P.div.withConfig({
	displayName: "ProgressLine__Line",
	componentId: "sc-ef72c9a0-1"
})([
	"position:absolute;top:0;left:0;width:",
	";height:100%;background-color:",
	";transition:width 0.2s;"
], ({ width: e = 0 }) => `${e}%`, ({ background: e }) => e || l.surface.highlight), my = ({ isSmall: e }) => {
	switch (!0) {
		case e: return i.body.medium;
		default: return i.body.large;
	}
}, hy = ({ isSmall: e }) => {
	switch (!0) {
		case e: return "24px";
		default: return "30px";
	}
}, gy = ({ isSmall: e }) => {
	switch (!0) {
		case e: return "-24px";
		default: return "-30px";
	}
}, _y = /*#__PURE__*/ g(({ checked: e, id: t, isSmall: n, label: r, name: i, onChange: a, readOnly: o, disabled: s, value: c, ...l }, u) => {
	let d = t || `${i}${c}`;
	return /*#__PURE__*/ N(vy, { children: [/*#__PURE__*/ M(yy, {
		ref: u,
		type: "radio",
		id: d,
		name: i,
		value: c,
		onChange: (e) => {
			if (!a) return;
			let { target: t } = e;
			a({
				name: t.name,
				value: t.value
			});
		},
		checked: e,
		readOnly: o,
		disabled: s || o,
		"aria-disabled": s,
		...l
	}), /*#__PURE__*/ M(by, {
		htmlFor: d,
		isSmall: n,
		children: r
	})] });
}), vy = P.div.withConfig({
	displayName: "Radio__Container",
	componentId: "sc-663d0090-0"
})(["position:relative;"]), yy = P.input.withConfig({
	displayName: "Radio__Input",
	componentId: "sc-663d0090-1"
})([
	"position:absolute;top:auto;overflow:hidden;clip:rect(1px,1px,1px,1px);width:1px;height:1px;white-space:nowrap;&:hover + label:before{",
	"{border-color:",
	";}}&:focus + label{outline:",
	";outline-offset:6px;border-radius:",
	";}&:checked + label:before{background-color:",
	";border-color:",
	";box-shadow:inset 0 0 0 4px ",
	";}&:disabled + label:before{border-color:",
	";background-color:",
	";pointer-events:none;}&:disabled + label{color:",
	";pointer-events:none;}&:checked:disabled + label:before{background-color:",
	";box-shadow:inset 0 0 0 4px ",
	";}"
], R.pointer, t.grey.graphics1, s.interactive.medium, I.small, t.primary.light, t.primary.light, t.grey.background, t.common.disabled1, t.grey.background, ({ readOnly: e }) => e ? t.text.secondary : t.text.disabled, t.common.disabled1, t.grey.background), by = P.label.withConfig({
	displayName: "Radio__Label",
	componentId: "sc-663d0090-2"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";line-height:1.5;display:block;padding-left:",
	";cursor:pointer;&:before{content:'';text-align:center;display:block;float:left;width:",
	";height:",
	";margin-left:",
	";margin-top:",
	";background:",
	";border:",
	" solid ",
	";border-radius:100%;cursor:pointer;transition:all 0.1s ease-out;}"
], t.text.primary, my, i.weight.normal, hy, ({ isSmall: e }) => e ? "16px" : "22px", ({ isSmall: e }) => e ? "16px" : "22px", gy, ({ isSmall: e }) => e ? "2px" : "1px", t.grey.background, ({ isSmall: e }) => e ? "1px" : "2px", t.grey.graphics2), xy = /*#__PURE__*/ g(({ name: e, onChange: t, disabled: n, readOnly: r, value: i, options: a, width: o, ...s }, c) => {
	let l = (n) => {
		let { target: r } = n, { value: i } = r;
		t && t({
			name: e,
			value: i
		});
	}, u = a.findIndex((e) => String(e.value) === String(i) || !e.value && !i) > -1;
	return /*#__PURE__*/ N(Sy, {
		ref: c,
		name: e,
		value: i,
		width: o,
		onChange: l,
		readOnly: r,
		disabled: n || r,
		"aria-disabled": n,
		"aria-readonly": r,
		...s,
		children: [!u && /*#__PURE__*/ M("option", { children: " " }), a.map((e) => {
			let { value: t, title: n, disabled: r, key: i } = e;
			return /*#__PURE__*/ M("option", {
				value: t || "",
				disabled: !!r,
				...!!e["data-testid"] && { "data-testid": e["data-testid"] },
				children: n || t
			}, i || `${n}-${t}`);
		})]
	});
}), Sy = P.select.withConfig({
	displayName: "Select__Container",
	componentId: "sc-e0788cee-0"
})([
	"color:",
	";font-size:",
	";line-height:1.35;width:",
	";padding:",
	";background-color:",
	";background-image:url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2210%22%20viewBox%3D%220%200%2016%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%209.0625L7.46875%208.53125L1.46875%202.53125L0.9375%202L2%200.9375L2.53125%201.46875L8%206.96875L13.4688%201.5L14%200.96875L15.0625%202L14.5312%202.53125L8.53125%208.53125L8%209.0625Z%22%20fill%3D%22%230C0B0A%22%20fill-opacity%3D%220.65%22%2F%3E%3C%2Fsvg%3E');background-position:",
	";background-repeat:no-repeat;background-size:14px 14px;border:",
	";border-radius:",
	";appearance:none;&:disabled{color:",
	";background-image:url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2210%22%20viewBox%3D%220%200%2016%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8%209.0625L7.46875%208.53125L1.46875%202.53125L0.9375%202L2%200.9375L2.53125%201.46875L8%206.96875L13.4688%201.5L14%200.96875L15.0625%202L14.5312%202.53125L8.53125%208.53125L8%209.0625Z%22%20fill%3D%22%230C0B0A%22%20fill-opacity%3D%220.5%22%2F%3E%3C%2Fsvg%3E');border-color:",
	";}&::-ms-expand{display:none;}&:focus-visible{color:",
	";border-color:",
	";outline:",
	";}",
	"{&:not(:disabled){&:hover{border-color:",
	";}}}"
], t.text.primary, i.body.large, ({ width: e }) => e || "auto", ({ isLarge: e }) => e ? "12px 36px 12px 15px" : "7px 24px 7px 9px", t.grey.background, ({ isLarge: e }) => e ? "right 12px top 50%" : "right 7px top 50%", ({ isBorderless: e }) => e ? "none" : `1px solid ${t.grey.graphics2}`, I.small, ({ readOnly: e }) => e ? t.text.secondary : t.text.disabled, t.common.disabled1, t.text.primary, t.grey.graphics2, s.interactive.medium, R.pointer, t.grey.graphics1), Cy = /*#__PURE__*/ v(xy), wy = /*#__PURE__*/ g((e, n) => {
	let { id: r, name: i, label: a, width: o = "auto", disabled: s, readOnly: c, isLarge: l } = e, { hasError: u, errorMessage: d, ...f } = e;
	return /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ N(Ty, {
		ref: n,
		width: o,
		disabled: s || c,
		readOnly: c,
		$hasError: u,
		children: [/*#__PURE__*/ M(Ey, {
			isDisabled: s,
			isLarge: l,
			$color: u ? t.error.main : void 0,
			children: /*#__PURE__*/ M("label", {
				htmlFor: r || i,
				children: a
			})
		}), /*#__PURE__*/ M(Cy, {
			...f,
			isBorderless: !0,
			width: "100%"
		})]
	}), u && d && /*#__PURE__*/ M(Nv, { children: d })] });
}), Ty = P.fieldset.withConfig({
	displayName: "SelectWithLabel__Fieldset",
	componentId: "sc-a9d3c31f-0"
})([
	"position:relative;width:",
	";margin:0;padding:0;background-color:",
	";border:1px solid ",
	";border-radius:",
	";&:disabled{color:",
	";border-color:",
	";}",
	"{&:not(:disabled){&:hover{border-color:",
	";}}}"
], ({ width: e }) => e, t.grey.background, ({ isFocused: e, $hasError: n }) => n ? t.error.main : e ? t.grey.graphics1 : t.grey.graphics2, I.small, t.text.disabled, t.common.disabled1, R.pointer, t.grey.graphics1), Ey = P.legend.withConfig({
	displayName: "SelectWithLabel__Legend",
	componentId: "sc-a9d3c31f-1"
})([
	"color:",
	";font-size:",
	";position:absolute;top:-8px;left:",
	";z-index:1;margin:0;padding:2px 4px;background-color:",
	";border-radius:",
	";",
	""
], ({ $color: e }) => e || t.text.primary, i.body.small, ({ isLarge: e }) => e ? "12px" : "6px", t.grey.background, I.small, ({ isDisabled: e }) => e && `color: ${t.text.disabled};`), Dy = ({ children: e, gap: t, padding: n, background: r, radius: i, ...a }) => /*#__PURE__*/ N(jy, {
	gap: t,
	padding: n,
	radius: i,
	background: r,
	...a,
	children: [/*#__PURE__*/ M(Ny, { background: r }), e]
}), Oy = fe(["0%{opacity:1;}50%{opacity:0.3;}100%{opacity:1;}"]), ky = ({ repeat: e = 1, ...t }) => /*#__PURE__*/ M(j, { children: [...Array(Math.abs(e)).keys()].map((e, n) => /*#__PURE__*/ M(Ay, { ...t }, n)) }), Ay = P.div.withConfig({
	displayName: "Skeleton__SkeletonLineItem",
	componentId: "sc-c7ec139b-0"
})([
	"width:",
	";height:",
	";background-color:",
	";border-radius:",
	";opacity:1;animation:",
	" 2s ease-in-out infinite;"
], ({ width: e }) => e ?? "100%", ({ height: e }) => e ?? "18px", ({ backgroundColor: e }) => e ?? l.line.neutralLight, (e) => e.radius ?? I.medium, Oy), jy = P.div.withConfig({
	displayName: "Skeleton__Container",
	componentId: "sc-c7ec139b-1"
})([
	"overflow:hidden;position:relative;top:0;left:0;width:100%;padding:",
	";background:",
	";border-radius:",
	";& > div:not(:last-child){margin-bottom:",
	";}"
], ({ padding: e }) => e ?? "12px", ({ background: e }) => e ?? l.surface.neutral, (e) => e.radius ?? I.medium, ({ gap: e }) => e ?? "12px"), My = fe(["to{background-position:right -80px top 0;}"]), Ny = P.div.withConfig({
	displayName: "Skeleton__ShineLine",
	componentId: "sc-c7ec139b-2"
})([
	"position:absolute;top:0;left:0;z-index:1090;width:100%;height:100%;background-image:linear-gradient( 90deg,",
	" 0%,",
	" 50%,",
	" 100% );background-position:left -80px top 0;background-repeat:no-repeat;background-size:120px 100%;animation:",
	" 2s ease-in-out infinite;"
], ({ background: e }) => k(e || l.surface.neutral, 0), ({ background: e }) => k(e || l.surface.neutral, .5), ({ background: e }) => k(e || l.surface.neutral, 0), My), Py = ({ hasError: e, disabled: n }) => {
	switch (!0) {
		case n: return t.common.disabled1;
		case e: return t.error.main;
		default: return t.grey.graphics2;
	}
}, Fy = /*#__PURE__*/ g(({ floatingLabel: e, disabled: t, readOnly: n, onChange: r, placeholder: i, shouldAlwaysDisplayFloatingLabel: a, value: o, ...s }, c) => {
	let l = o && String(o).length > 0, u = (e) => {
		let { target: t } = e, { name: n, value: i } = t;
		r && r({
			name: n,
			value: i
		});
	};
	return e ? /*#__PURE__*/ N(Iy, { children: [/*#__PURE__*/ M(Ly, {
		onChange: u,
		placeholder: a ? i : e || i,
		ref: c,
		value: o,
		disabled: t,
		readOnly: n,
		"aria-disabled": t,
		"aria-readonly": n,
		...s
	}), /*#__PURE__*/ M(Ry, {
		isVisible: !!l || !!a,
		children: e
	})] }) : /*#__PURE__*/ M(Ly, {
		ref: c,
		onChange: u,
		value: o,
		placeholder: i,
		disabled: t,
		readOnly: n,
		"aria-disabled": t,
		"aria-readonly": n,
		...s
	});
}), Iy = P.div.withConfig({
	displayName: "TextArea__Container",
	componentId: "sc-92781741-0"
})(["position:relative;"]), Ly = P.textarea.withConfig({
	displayName: "TextArea__TextAreaElement",
	componentId: "sc-92781741-1"
})([
	"appearance:none;border-radius:0;resize:",
	";color:",
	";font-family:inherit;font-size:",
	";line-height:1.35;display:block;width:100%;height:",
	";padding:7px 9px;background:",
	";border:1px solid ",
	";border-radius:",
	";&::placeholder{color:",
	";transition:color 0.1s;}&:focus-visible{color:",
	";border:1px solid ",
	";outline:",
	";::placeholder{color:transparent;}}&:read-only{color:",
	";border-color:",
	";}&:disabled{color:",
	";border:1px solid ",
	";}&:focus:read-only{border-color:",
	";outline:0;}",
	"{&:not(:disabled):not(:read-only){&:hover{border-color:",
	";}}}"
], ({ resize: e }) => e || "both", t.text.primary, i.body.large, ({ height: e }) => e || "auto", t.grey.background, Py, I.small, t.text.secondary, t.text.primary, Py, s.interactive.medium, t.text.secondary, t.common.disabled1, t.text.disabled, Py, t.common.disabled1, R.pointer, t.grey.graphics1), Ry = P.div.withConfig({
	displayName: "TextArea__FloatingLabel",
	componentId: "sc-92781741-2"
})([
	"font-size:",
	";position:absolute;top:-8px;left:6px;display:block;padding:2px 4px;background:",
	";border-radius:",
	";opacity:",
	";visibility:",
	";transform:",
	";transition:all 0.1s;input:active + &,input:focus + &{opacity:1;visibility:visible;transform:translateY(0);}"
], i.body.small, t.grey.background, I.small, ({ isVisible: e }) => +!!e, ({ isVisible: e }) => e ? "visible" : "hidden", ({ isVisible: e }) => e ? "translateY(0)" : "translateY(6px)"), zy = ({ background: e, onChange: t, name: n, stateBackground: r, size: i = "medium", optionLabel: a = {
	false: "No",
	true: "Yes"
}, value: o, isLoading: s }) => o === null ? /*#__PURE__*/ N(By, {
	size: i,
	children: [
		/*#__PURE__*/ M(Hy, {
			onClick: () => {
				s || t({
					name: n,
					value: !1
				});
			},
			children: a.false
		}),
		/*#__PURE__*/ M(Wy, {}),
		/*#__PURE__*/ M(Uy, {
			onClick: () => {
				s || t({
					name: n,
					value: !0
				});
			},
			children: a.true
		})
	]
}) : o === !0 ? /*#__PURE__*/ M(Ky, {
	size: i,
	background: e,
	onClick: () => {
		s || t({
			name: n,
			value: !1
		});
	},
	onKeyDown: () => {
		s || O(() => t({
			name: n,
			value: !0
		}));
	},
	children: /*#__PURE__*/ M(Yy, {
		size: i,
		stateBackground: r,
		children: s ? /*#__PURE__*/ M(Qy, {
			background: l.surface.affirmSoft,
			color: l.surface.affirm
		}) : /*#__PURE__*/ M(j, { children: "✓" })
	})
}) : /*#__PURE__*/ M(qy, {
	size: i,
	"aria-label": "Toggle off",
	background: e,
	onClick: () => {
		s || t({
			name: n,
			value: !0
		});
	},
	onKeyDown: () => {
		s || O(() => t({
			name: n,
			value: !0
		}));
	},
	tabIndex: 0,
	children: /*#__PURE__*/ M(Xy, {
		size: i,
		stateBackground: r,
		children: s ? /*#__PURE__*/ M(Qy, {
			background: l.surface.noteStrong,
			color: l.surface.alert
		}) : /*#__PURE__*/ M("span", {
			style: { paddingBottom: "1px" },
			children: "×"
		})
	})
}), By = P.div.withConfig({
	displayName: "Toggle__PickerContainer",
	componentId: "sc-8694cf5d-0"
})([
	"display:flex;align-items:center;justify-content:space-between;width:",
	";height:",
	";background-color:",
	";border-radius:",
	";"
], ({ size: e }) => e === "small" ? "42px" : "72px", ({ size: e }) => e === "small" ? "20px" : "30px", l.surface.neutral, I.full), Vy = P.button.withConfig({
	displayName: "Toggle__PickerOptionBase",
	componentId: "sc-8694cf5d-1"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-align:center;flex:1 1 auto;height:100%;",
	"{&:hover{color:",
	";}}"
], l.text.neutral, i.body.small, i.weight.medium, R.pointer, l.text.interactive), Hy = P(Vy).withConfig({
	displayName: "Toggle__PickerOptionFalse",
	componentId: "sc-8694cf5d-2"
})([
	"padding-left:4px;border-radius:",
	" 0 0 ",
	";",
	"{&:hover{background:linear-gradient(90deg,",
	" 0%,",
	" 100%);}}"
], I.full, I.full, R.pointer, l.surface.highlight, l.surface.neutral), Uy = P(Vy).withConfig({
	displayName: "Toggle__PickerOptionTrue",
	componentId: "sc-8694cf5d-3"
})([
	"padding-right:4px;border-radius:0 ",
	" ",
	" 0;",
	"{&:hover{background:linear-gradient(90deg,",
	" 0%,",
	" 100%);}}"
], I.full, I.full, R.pointer, l.surface.neutral, l.surface.highlight), Wy = P.div.withConfig({
	displayName: "Toggle__PickerDivider",
	componentId: "sc-8694cf5d-4"
})([
	"width:2px;height:2px;background:",
	";border-radius:",
	";"
], l.surface.base, I.full), Gy = P.button.withConfig({
	displayName: "Toggle__StateContainerBase",
	componentId: "sc-8694cf5d-5"
})([
	"display:flex;align-items:center;padding:4px;width:",
	";height:",
	";border-radius:",
	";"
], ({ size: e }) => e === "small" ? "42px" : "72px", ({ size: e }) => e === "small" ? "20px" : "30px", I.full), Ky = P(Gy).withConfig({
	displayName: "Toggle__StateTrueContainer",
	componentId: "sc-8694cf5d-6"
})(["background-color:", ";justify-content:flex-end;"], ({ background: e }) => e ?? t.primary.primaryAction), qy = P(Gy).withConfig({
	displayName: "Toggle__StateFalseContainer",
	componentId: "sc-8694cf5d-7"
})(["background-color:", ";justify-content:flex-start;"], ({ background: e }) => e ?? t.error.primaryAction), Jy = P.div.withConfig({
	displayName: "Toggle__StateBase",
	componentId: "sc-8694cf5d-8"
})([
	"color:",
	";line-height:1;font-size:",
	";font-weight:",
	";display:flex;align-items:center;justify-content:center;width:",
	";height:",
	";border-radius:",
	";"
], l.text.inverted, ({ size: e }) => e === "small" ? i.body.small : i.body.medium, i.weight.medium, ({ size: e }) => e === "small" ? "14px" : "22px", ({ size: e }) => e === "small" ? "14px" : "22px", I.full), Yy = P(Jy).withConfig({
	displayName: "Toggle__StateTrue",
	componentId: "sc-8694cf5d-9"
})([
	"color:",
	";background-color:",
	";"
], ({ stateBackground: e }) => e ?? t.primary.contrast, ({ stateBackground: e }) => e ?? l.surface.affirm), Xy = P(Jy).withConfig({
	displayName: "Toggle__StateFalse",
	componentId: "sc-8694cf5d-10"
})(["background-color:", ";"], ({ stateBackground: e }) => e ?? l.surface.alert), Zy = fe(["to{transform:rotate(360deg);}"]), Qy = P.div.withConfig({
	displayName: "Toggle__StateSpinner",
	componentId: "sc-8694cf5d-11"
})([
	"content:'';box-sizing:border-box;width:12px;height:12px;border:2px solid ",
	";border-top-color:",
	";border-radius:",
	";animation:",
	" 0.6s linear infinite;"
], ({ background: e }) => e, ({ color: e }) => e, I.full, Zy), $y = {
	"en-GB": { textNoResultsFound: "No results found" },
	"es-ES": { textNoResultsFound: "No se han encontrado resultados" }
}, eb = ({ onChange: e, value: t, options: n, name: r, showOptions: i, isRequired: a, autoClear: o, locale: s = D.GB, ...c }) => {
	let l = T(null), u = T(null), d = T(null), f = n.findIndex((e) => e.value === t), p = f > -1 ? n[f].title : t, [m, h] = E(!1), [g, _] = E(null), [v, y] = E(0), b = (e) => {
		let { target: t } = e, { value: n } = t;
		_(String(n)), y(0), h(!0);
	}, x = (t) => {
		_(null), e({
			name: r,
			value: t || ""
		}), h(!1);
	}, S = () => {
		h(!0), o && _("");
	}, C = n.filter((e) => {
		let { title: t } = e;
		return t.toLowerCase().includes(g?.toLowerCase() ?? "");
	}), w = C.length > 0 || i, ee = (g?.length ?? 0) > 2 || i;
	ie(l, () => {
		m && (h(!1), _(null));
	});
	let te = () => {
		d && d.current && d.current.scrollIntoView({
			behavior: "smooth",
			block: "center"
		});
	}, ne = (e) => {
		if (e.key === "ArrowDown") {
			let e = Math.min(C.length - 1, v + 1);
			y(e), te();
		} else if (e.key === "ArrowUp") {
			let e = Math.max(0, v - 1);
			y(e), te();
		} else if (e.key === "Enter") {
			let e = C[v];
			g === "" && !a && e === void 0 ? x("") : e === void 0 && a ? x(t) : (w && e !== void 0 && ee || a && e !== void 0) && x(C[v].value);
		} else (e.key === "Esc" || e.key === "Escape") && _(null);
	}, { textNoResultsFound: k } = $y[s];
	return /*#__PURE__*/ N(nb, {
		ref: l,
		children: [/*#__PURE__*/ M(tb, {
			name: r,
			autoComplete: "off",
			onChange: b,
			onFocus: S,
			onKeyDown: ne,
			ref: u,
			value: g ?? p,
			...c
		}), m && ee && w && /*#__PURE__*/ N(rb, { children: [C.length === 0 && /*#__PURE__*/ M(ib, {
			isEmpty: !0,
			children: k
		}), C.map((e, t) => {
			let n = t === v, { value: r, title: i } = e;
			return /*#__PURE__*/ M(ib, {
				isSelected: n,
				onClick: (e) => {
					e.preventDefault(), x(r);
				},
				onKeyDown: O(() => x(r)),
				role: "button",
				tabIndex: 0,
				ref: n ? d : null,
				children: i || r
			}, r);
		})] })]
	});
}, tb = P.input.withConfig({
	displayName: "TypeSelect__InputElement",
	componentId: "sc-e6fb9125-0"
})([
	"appearance:none;border-radius:0;color:",
	";font-family:inherit;font-size:",
	";line-height:1.35;width:100%;padding:7px 9px;border-radius:",
	";background:",
	";border:1px solid ",
	";&::placeholder{color:",
	";transition:color 0.15s;}&:focus-visible{color:",
	";border:1px solid ",
	";outline:",
	";::placeholder{color:transparent;}}&:read-only{color:",
	";border-color:",
	";}&:disabled{color:",
	";border-color:",
	";}&:focus:read-only{border-color:",
	";outline:0;}",
	"{&:not(:disabled):not(:read-only){&:hover{border-color:",
	";}}}"
], t.text.primary, i.body.large, I.small, t.grey.background, t.grey.graphics2, t.text.secondary, t.text.primary, t.grey.graphics1, s.interactive.medium, t.text.secondary, t.common.disabled1, t.text.disabled, t.common.disabled1, t.common.disabled1, R.pointer, t.grey.graphics1), nb = P.div.withConfig({
	displayName: "TypeSelect__Container",
	componentId: "sc-e6fb9125-1"
})(["position:relative;"]), rb = P.div.withConfig({
	displayName: "TypeSelect__Results",
	componentId: "sc-e6fb9125-2"
})([
	"position:absolute;z-index:1000;overflow:auto;top:100%;max-height:156px;width:100%;padding:6px 0;background:",
	";box-shadow:",
	";"
], t.grey.surface2, L.low), ib = P.div.withConfig({
	displayName: "TypeSelect__ResultsItem",
	componentId: "sc-e6fb9125-3"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-align:left;white-space:nowrap;display:block;width:100%;padding:9px 30px 10px 18px;background:",
	";border:0;cursor:pointer;",
	"{&:hover,&:focus{color:",
	";}}",
	" ",
	""
], t.text.primary, i.body.medium, i.weight.medium, t.grey.surface2, R.pointer, t.primary.main, ({ isSelected: e }) => e && `
        color: ${t.primary.main};
    `, ({ isEmpty: e }) => e && `
        color: ${t.text.disabled};
        cursor: default;

        ${R.pointer} {
            &:hover,
            &:focus {
                color: ${t.text.disabled};
            }
        };
    `), ab = "_container_2pjg6_1", ob = "_heading1Large_2pjg6_5", sb = "_heading2Large_2pjg6_6", cb = "_h1_2pjg6_14", lb = "_accentH1_2pjg6_15", ub = "_h2_2pjg6_23", db = "_accentH2_2pjg6_24", fb = "_h3_2pjg6_32", pb = "_accentH3_2pjg6_33", mb = "_h4_2pjg6_41", hb = "_accentH4_2pjg6_42", gb = "_h5_2pjg6_49", _b = "_accentH5_2pjg6_50", vb = "_h6_2pjg6_57", yb = "_accentH6_2pjg6_58", bb = "_bodyLarge_2pjg6_75", xb = "_body_2pjg6_75", Sb = "_bodyLong_2pjg6_89", Cb = "_bodySmall_2pjg6_96", wb = "_overline_2pjg6_103", Tb = "_left_2pjg6_112", Eb = "_center_2pjg6_116", Db = "_right_2pjg6_120", Ob = {
	heading1Large: ob,
	heading2Large: sb,
	h1: cb,
	h2: ub,
	h3: fb,
	h4: mb,
	h5: gb,
	h6: vb,
	"accent-h1": lb,
	"accent-h2": db,
	"accent-h3": pb,
	"accent-h4": hb,
	"accent-h5": _b,
	"accent-h6": yb,
	bodyLarge: bb,
	body: xb,
	bodyLong: Sb,
	bodySmall: Cb,
	overline: wb
}, kb = {
	left: Tb,
	center: Eb,
	right: Db
}, Ab = (e, t) => {
	if (A(t)) return t;
	switch (e) {
		case "heading1Large":
		case "h1":
		case "accent-h1": return "h1";
		case "heading2Large":
		case "h2":
		case "accent-h2": return "h2";
		case "h3":
		case "accent-h3": return "h3";
		case "h4":
		case "accent-h4": return "h4";
		case "h5":
		case "accent-h5": return "h5";
		case "h6":
		case "accent-h6": return "h6";
		default: return "p";
	}
}, jb = ({ children: e, as: t, variant: n, textAlign: r = "left" }) => {
	let i = Ab(n, t);
	return /*#__PURE__*/ M(i, {
		className: `${ab} ${Ob[n]} ${kb[r]}`,
		children: e
	});
}, Mb = ({ children: e, ...t }) => {
	let n = T(null);
	return /*#__PURE__*/ M(me, {
		...t,
		nodeRef: n,
		classNames: "route",
		timeout: {
			enter: 400,
			exit: 0
		},
		unmountOnExit: !0,
		children: /*#__PURE__*/ M("div", {
			ref: n,
			children: e
		})
	});
}, Nb = ({ locationKey: e, children: t }) => /*#__PURE__*/ M(Pb, { children: /*#__PURE__*/ M(ge, { children: /*#__PURE__*/ M(Mb, { children: t }, e ?? "") }) }), Pb = le.div.withConfig({
	displayName: "RouteTransition__Styles",
	componentId: "sc-e469fbd9-0"
})([".route-enter{opacity:0;transform:translateY(4px);}.route-enter-active{opacity:1;transform:translateY(0);transition:opacity 400ms ease,transform 400ms ease;}.route-exit{display:none;}"]), Fb = ({ children: e, duration: t, ...n }) => {
	let r = T(null);
	return /*#__PURE__*/ M(me, {
		...n,
		nodeRef: r,
		classNames: "content",
		timeout: t,
		unmountOnExit: !0,
		children: /*#__PURE__*/ M("div", {
			ref: r,
			children: e
		})
	});
}, Ib = ({ transitionKey: e, children: t, duration: n = 400 }) => /*#__PURE__*/ M(Lb, {
	$duration: n,
	children: /*#__PURE__*/ M(ge, { children: /*#__PURE__*/ M(Fb, {
		duration: n,
		children: t
	}, e) })
}), Lb = le.div.withConfig({
	displayName: "ContentTransition__Styles",
	componentId: "sc-eba49dbe-0"
})([
	".content-enter{opacity:0;transform:translateY(4px);}.content-enter-active{opacity:1;transform:translateY(0);transition:opacity ",
	"ms ease,transform ",
	"ms ease;}.content-exit{display:none;}"
], ({ $duration: e }) => e, ({ $duration: e }) => e), Rb = P.div.withConfig({
	displayName: "GlobalSpinner__Container",
	componentId: "sc-328e2700-0"
})([
	"display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;z-index:",
	";width:100%;height:100%;background:",
	";"
], a, k(l.surface.base, .5)), zb = (e) => /*#__PURE__*/ M(Rb, { children: /*#__PURE__*/ M(U, { ...e }) }), Bb = ({ children: e }) => {
	let t = document.body;
	return be(e, t);
}, Vb = ({ children: e, isFullScreen: t, isWide: n, onClose: r, width: i, isLoading: a, isError: o, errorMessage: s, ...c }) => {
	let [l, u] = E(null), d = T(null), f = r;
	return oe(d, () => {
		u(window.innerHeight);
	}), ae(r), x(() => (document.body.style.overflow = "hidden", () => {
		document.body.style.overflow = "unset";
	}), []), /*#__PURE__*/ M(Bb, { children: /*#__PURE__*/ M(me, {
		nodeRef: d,
		in: !0,
		appear: !0,
		timeout: 300,
		classNames: "transition",
		children: /*#__PURE__*/ N(Hb, {
			role: "dialog",
			ref: d,
			...c,
			children: [a && /*#__PURE__*/ M(Ub, { children: /*#__PURE__*/ M(U, { isSmall: !0 }) }), !a && /*#__PURE__*/ M(_e, {
				autoFocus: !1,
				returnFocus: !0,
				children: /*#__PURE__*/ N(Wb, {
					isFullScreen: t,
					isWide: n,
					maxHeight: l,
					width: i,
					children: [
						o && /*#__PURE__*/ M(z, {
							padding: "24px 48px 24px 24px",
							tabletPadding: "48px",
							children: /*#__PURE__*/ M(V, { children: s || "Oops! There was an error loading the data…" })
						}),
						!o && e,
						f && /*#__PURE__*/ M(Gb, {
							onClick: f,
							children: "✕"
						})
					]
				})
			})]
		})
	}) });
}, Hb = P.div.withConfig({
	displayName: "Modal__Container",
	componentId: "sc-ea37e492-0"
})([
	"color:",
	";text-align:left;display:flex;flex-direction:column;justify-content:flex-end;overflow:auto;position:fixed;top:0;left:0;z-index:",
	";width:100%;height:100%;background:",
	";transition:background-color 0.15s;&.transition-appear-active,&.transition-enter-active{overflow:hidden;}&.transition-appear-active,&.transition-appear-done,&.transition-enter-active,&.transition-enter-done{background-color:",
	";}",
	"{display:block;padding:0 0 192px;}",
	"{padding:72px 0;}@media (max-height:540px){display:block;}"
], l.text.base, ({ zIndex: e }) => e || 2147483100, k(l.surface.neutral, 0), k(l.surface.neutral, .9), R.tablet, R.desktop), Ub = P.div.withConfig({
	displayName: "Modal__SpinnerContainer",
	componentId: "sc-ea37e492-1"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]), Wb = P.div.withConfig({
	displayName: "Modal__ModalContainer",
	componentId: "sc-ea37e492-2"
})([
	"position:relative;max-width:100%;max-height:",
	";background:",
	";border-top-left-radius:",
	";border-top-right-radius:",
	";box-shadow:",
	";opacity:0;transform:translateY(10%);transition:opacity 0.3s,transform 0.3s;.transition-appear-active &,.transition-appear-done &,.transition-enter-active &,.transition-enter-done &{opacity:1;transform:translateY(0);}",
	"{max-height:unset;min-height:unset;margin:0 auto;border-radius:",
	";",
	" ",
	" ",
	" ",
	"}@media (max-height:540px){max-height:unset;}"
], ({ maxHeight: e }) => e ? `${e}px` : "unset", l.surface.base, I.large, I.large, L.high, R.tablet, I.large, ({ isFullScreen: e }) => e && "\n            width: 90%;\n        ", ({ isWide: e }) => e && "\n            width: 864px;\n        ", ({ width: e }) => e && `
            width: ${e};
        `, ({ isFullScreen: e, isWide: t, width: n }) => !e && !t && !n && "\n            width: 564px;\n        "), Gb = P.button.attrs({ type: "button" }).withConfig({
	displayName: "Modal__Close",
	componentId: "sc-ea37e492-3"
})([
	"content:'✕';color:",
	";font-size:18px;line-height:1;display:flex;align-items:center;justify-content:center;position:absolute;top:9px;right:9px;z-index:4;width:36px;height:36px;background:",
	";border:2px solid ",
	";border-radius:",
	";cursor:pointer;&:focus{outline:none;}&:focus,&:active{border:2px solid ",
	";}",
	"{&:hover{opacity:0.75;}}",
	"{font-size:21px;top:-24px;right:-24px;width:48px;height:48px;}"
], l.text.base, l.surface.neutral, l.line.neutralSoft, I.full, l.line.interactive, R.pointer, R.desktop), Kb = P.div.withConfig({
	displayName: "ModalActions",
	componentId: "sc-d8cd3975-0"
})(["display:flex;flex-wrap:wrap;align-items:center;gap:12px 0;justify-content:flex-end;&:last-child{flex:1 0 auto;}&:not(:last-child){margin-bottom:24px;}> :not(:first-child){margin-left:12px;}", "{&:not(:last-child){margin:0;}}"], R.tablet), qb = ({ children: e, ...t }) => /*#__PURE__*/ N(Jb, {
	...t,
	children: [
		/*#__PURE__*/ M(Yb, {}),
		/*#__PURE__*/ M(Zb, { children: e }),
		/*#__PURE__*/ M(Xb, {})
	]
}), Jb = P.div.withConfig({
	displayName: "ModalBody__Container",
	componentId: "sc-e436fc69-0"
})(["overflow:auto;position:relative;max-height:60vh;", "{overflow:unset;max-height:unset;}@media (max-height:540px){max-height:unset;}"], R.tablet), Yb = P.div.withConfig({
	displayName: "ModalBody__TopFade",
	componentId: "sc-e436fc69-1"
})([
	"position:sticky;top:0;left:0;z-index:3;width:100%;height:12px;background:linear-gradient(to top,",
	",",
	");border-radius:",
	" ",
	" 0 0;pointer-events:none;",
	"{position:static;}"
], k(l.surface.base, 0), l.surface.base, I.large, I.large, R.tablet), Xb = P.div.withConfig({
	displayName: "ModalBody__BottomFade",
	componentId: "sc-e436fc69-2"
})([
	"position:sticky;bottom:0;left:0;z-index:3;width:100%;height:12px;background:linear-gradient(to bottom,",
	",",
	");border-radius:0 0 ",
	" ",
	";pointer-events:none;",
	"{position:static;}"
], k(l.surface.base, 0), l.surface.base, I.large, I.large, R.tablet), Zb = P.div.withConfig({
	displayName: "ModalBody__Content",
	componentId: "sc-e436fc69-3"
})([
	"height:100%;padding:0 24px;",
	"{padding-right:48px;padding-left:48px;}p:not(:last-child){margin-bottom:12px;}h1,h2,h3,h4{font-weight:",
	";margin-bottom:12px;}"
], R.tablet, i.weight.medium), Qb = P.div.withConfig({
	displayName: "ModalFooter",
	componentId: "sc-69756137-0"
})(["padding:18px 24px 36px 24px;", "{padding:24px 48px 36px;}"], R.tablet), $b = P.div.withConfig({
	displayName: "ModalHeader",
	componentId: "sc-e3529b5e-0"
})(["position:relative;padding:18px 60px 9px 24px;", "{padding:36px 48px 18px;}"], R.tablet), ex = P.div.withConfig({
	displayName: "ModalSubtitle",
	componentId: "sc-f1ab3aad-0"
})(["font-size:", ";line-height:1.5;margin-top:12px;"], i.title.small), tx = P.div.withConfig({
	displayName: "ModalTitle",
	componentId: "sc-c158c26e-0"
})([
	"font-size:",
	";font-weight:",
	";line-height:1.3;",
	"{font-size:",
	";}"
], i.title.medium, i.weight.medium, R.tablet, i.title.large), nx = ({ children: e, labelCancel: t = "Cancel", labelConfirm: n = "Confirm", onCancel: r, onClose: i, onConfirm: a, title: o = "Are you sure?", isFullScreen: s, isLoading: c }) => /*#__PURE__*/ N(Vb, {
	isFullScreen: s,
	onClose: i || r,
	"data-testid": "confirmation-dialog",
	children: [
		/*#__PURE__*/ M($b, { children: /*#__PURE__*/ M(tx, { children: o }) }),
		!!e && /*#__PURE__*/ M(qb, { children: /*#__PURE__*/ M(rx, { children: e }) }),
		/*#__PURE__*/ M(Qb, { children: /*#__PURE__*/ N(Kb, { children: [r && /*#__PURE__*/ M(W, {
			disabled: c,
			onClick: r,
			size: "large",
			variant: "tertiary",
			children: t
		}), /*#__PURE__*/ M(W, {
			isLoading: c,
			onClick: a,
			size: "large",
			children: n
		})] }) })
	]
}), rx = P.div.withConfig({
	displayName: "ConfirmationModal__Body",
	componentId: "sc-80bbb87c-0"
})(["line-height:1.5;"]), ix = (e) => {
	let t = e;
	return !(e instanceof Date) && e != null && (t = e.toString().replaceAll("-", "/").replace(/T.+/, "")), t;
}, K = (e) => {
	let t = ix(e), n = e ? new Date(t) : "";
	return n ? n.getDate() : "";
}, ax = (e) => {
	let t = ix(e), n = e ? new Date(t) : "";
	return n ? n.getMonth() + 1 : "";
}, q = (e) => {
	let t = ix(e), n = e ? new Date(t) : "";
	return n ? n.getFullYear() : "";
}, J = (e) => !e || String(e).length > 1 ? e : `0${e}`, ox = (e) => typeof e == "string" ? /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i.test(e) : e instanceof Date, sx = (e) => e % 4 == 0 && e % 100 != 0 || e % 400 == 0, cx = (...e) => (...t) => e.forEach((e) => typeof e == "function" ? e(...t) : void 0);
Array.from({ length: Object.keys(l.surface).length }, (e, t) => t), Object.values(l.surface), Object.keys(l.surface), Array.from({ length: Object.keys(L).length }, (e, t) => t), Object.values(L), Object.keys(L), Array.from({ length: Object.keys(l.text).length }, (e, t) => t), Object.values(l.text), Object.keys(l.text);
//#endregion
//#region src/molecules/DatePicker.tsx
var lx = (/* @__PURE__ */ new Date()).getFullYear(), ux = [...Array(31).keys()].map((e) => e + 1), dx = [...Array(12).keys()].map((e) => e + 1), fx = (e, t) => {
	let n = [];
	for (let r = Number(e); r <= Number(t); r += 1) n.push(r);
	return n;
}, px = {
	[D.GB]: {
		monthsShortNamesArray: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec"
		],
		textDateAfter: "Please select a date that is after",
		textDateBefore: "Please select a date that is before",
		textDay: "Day",
		textIncluded: "(including)",
		textInvalidDateValue: "Invalid date value",
		textInvalidDefaultDate: "Invalid default date",
		textInvalidMaxDate: "Invalid max date",
		textInvalidMinDate: "Invalid min date",
		textMonth: "Month",
		textYear: "Year"
	},
	[D.ES]: {
		monthsShortNamesArray: [
			"ene",
			"feb",
			"mar",
			"abr",
			"may",
			"jun",
			"jul",
			"ago",
			"sep",
			"oct",
			"nov",
			"dic"
		],
		textDateAfter: "Seleccione una fecha posterior",
		textDateBefore: "Seleccione una fecha anterior",
		textDay: "Día",
		textIncluded: "(incluso)",
		textInvalidDateValue: "Valor de fecha no válido",
		textInvalidDefaultDate: "Fecha predeterminada no válida",
		textInvalidMaxDate: "Fecha máxima no válida",
		textInvalidMinDate: "Fecha mínima no válida",
		textMonth: "Mes",
		textYear: "Año"
	}
}, mx = /*#__PURE__*/ g(({ defaultDate: e = "", disabled: t, isBorderless: n, isFullWidth: r, locale: i = "en-GB", maxDate: a = `${lx}-12-31`, minDate: o = "1900-01-01", readOnly: s, name: c, onChange: l, required: u = !1, value: d = "", ...f }, p) => {
	let { monthsShortNamesArray: m, textDateAfter: h, textDateBefore: g, textDay: _, textIncluded: v, textInvalidDateValue: b, textInvalidDefaultDate: x, textInvalidMaxDate: S, textInvalidMinDate: C, textMonth: T, textYear: E } = px[i];
	if (!ox(e) && e !== "") throw Error(x);
	if (!ox(a)) throw Error(S);
	if (!ox(o)) throw Error(C);
	if (!ox(d) && d !== "" && d !== null) throw Error(b);
	let D = y((e) => {
		let t = e;
		if (new Date(e) > new Date(a)) {
			t = a;
			let e = `${g} ${J(K(a))}.${J(ax(a))}.${q(a)} ${v}`;
			alert(e);
		} else if (new Date(e) < new Date(o)) {
			t = o;
			let e = `${h} ${J(K(o))}.${J(ax(o))}.${q(o)} ${v}`;
			alert(e);
		}
		let n = [
			q(t),
			J(ax(t)),
			J(K(t))
		];
		return n.indexOf("") === -1 ? n.join("-") : "";
	}, [
		a,
		o,
		h,
		g,
		v
	]), ee = y(({ name: t, value: n }) => {
		let r = t === "year" ? n : q(d) || q(e) || q(o), i = t === "month" ? n : ax(d) || ax(e) || ax(o), a = t === "day" ? n : K(d) || K(e) || K(o), s = sx(r);
		Number(a) === 31 && [
			4,
			6,
			9,
			11
		].includes(Number(i)) && (a = 30), (Number(a) === 31 && Number(i) === 2 || Number(a) === 30 && Number(i) === 2 || Number(a) === 29 && Number(i) === 2) && (a = s ? 29 : 28);
		let u = [
			r,
			J(i),
			J(a)
		], f = u.indexOf("") === -1 ? u.join("-") : "";
		l({
			name: c,
			value: u.indexOf("") === -1 ? D(f) : f
		});
	}, [
		e,
		o,
		c,
		l,
		D,
		d
	]), te = K(d) || "", ne = ax(d) || "", O = q(d) || "", k = q(a), A = q(o), re = w(() => fx(Number(A), Number(k)), [A, k]), ie = w(() => [{ title: _ }, ...ux.map((e) => ({
		value: e,
		...!!f["data-testid"] && { "data-testid": `${f["data-testid"]}_day_${e}` }
	}))], [f, _]), ae = w(() => [{ title: T }, ...dx.map((e) => ({
		value: e,
		title: `${m[e - 1]}`,
		...!!f["data-testid"] && { "data-testid": `${f["data-testid"]}_month_${e}` }
	}))], [
		m,
		f,
		T
	]), oe = w(() => [{ title: E }, ...re.reverse().map((e) => ({
		value: e,
		...!!f["data-testid"] && { "data-testid": `${f["data-testid"]}_year_${e}` }
	}))], [
		f,
		E,
		re
	]);
	return /*#__PURE__*/ N(B, {
		width: "100%",
		children: [
			/*#__PURE__*/ M(hx, {
				isBorderless: n,
				isFullWidth: r,
				children: /*#__PURE__*/ M(Cy, {
					ref: p,
					disabled: t,
					readOnly: s,
					isBorderless: n,
					name: "day",
					value: te,
					onChange: ee,
					width: "100%",
					options: ie,
					"aria-label": _,
					required: u,
					...!!f["data-testid"] && { "data-testid": `${f["data-testid"]}_day` }
				})
			}),
			/*#__PURE__*/ M(gx, {
				isBorderless: n,
				isFullWidth: r,
				children: /*#__PURE__*/ M(Cy, {
					disabled: t,
					readOnly: s,
					isBorderless: n,
					name: "month",
					value: ne,
					onChange: ee,
					width: "100%",
					options: ae,
					"aria-label": T,
					required: u,
					...!!f["data-testid"] && { "data-testid": `${f["data-testid"]}_month` }
				})
			}),
			/*#__PURE__*/ M(_x, {
				isBorderless: n,
				isFullWidth: r,
				children: /*#__PURE__*/ M(Cy, {
					disabled: t,
					readOnly: s,
					isBorderless: n,
					name: "year",
					value: O,
					onChange: ee,
					width: "100%",
					options: oe,
					"aria-label": E,
					required: u,
					...!!f["data-testid"] && { "data-testid": `${f["data-testid"]}_year` }
				})
			})
		]
	});
}), hx = P.div.withConfig({
	displayName: "DatePicker__DayContainer",
	componentId: "sc-90834985-0"
})([
	"width:",
	";max-width:",
	";min-width:53px;margin:",
	";"
], ({ isBorderless: e }) => e ? "30%" : "calc(30% - 12px)", ({ isFullWidth: e }) => e ? "none" : "84px", ({ isBorderless: e }) => e ? "0" : "0 12px 0 0"), gx = P.div.withConfig({
	displayName: "DatePicker__MonthContainer",
	componentId: "sc-90834985-1"
})([
	"width:",
	";max-width:",
	";min-width:64px;margin:",
	";"
], ({ isBorderless: e }) => e ? "35%" : "calc(35% - 12px)", ({ isFullWidth: e }) => e ? "none" : "120px", ({ isBorderless: e }) => e ? "0" : "0 12px 0 0"), _x = P.div.withConfig({
	displayName: "DatePicker__YearContainer",
	componentId: "sc-90834985-2"
})(["width:35%;max-width:", ";min-width:72px;"], ({ isFullWidth: e }) => e ? "none" : "96px"), vx = P.fieldset.withConfig({
	displayName: "DatePickerWithLabel__Fieldset",
	componentId: "sc-199018c-0"
})([
	"position:relative;width:",
	";margin:0;padding:0;background:",
	";border:1px solid ",
	";border-radius:",
	";&:disabled{border-color:",
	";}",
	"{&:not(:disabled){&:hover{border-color:",
	";}}}"
], ({ width: e }) => e, l.surface.base, ({ hasError: e }) => e ? t.error.main : l.line.base, I.small, ({ readOnly: e }) => e ? l.line.neutralLight : l.line.neutral, R.pointer, t.grey.graphics2), yx = P.legend.withConfig({
	displayName: "DatePickerWithLabel__Legend",
	componentId: "sc-199018c-1"
})([
	"color:",
	";font-size:",
	";position:absolute;top:-8px;left:6px;z-index:1;margin:0;padding:2px 4px;background:",
	";border-radius:2px;",
	""
], ({ hasError: e }) => e ? l.text.alert : l.text.base, i.body.small, l.surface.base, ({ isDisabled: e }) => e && `
        color: ${l.text.neutral};
    `), bx = ({ disabled: e, hasError: t, errorMessage: n, id: r, label: a, name: o, readOnly: s, width: c = "auto", ...u }) => /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ N(vx, {
	width: c,
	disabled: e || s,
	readOnly: s,
	hasError: t,
	children: [/*#__PURE__*/ M(yx, {
		isDisabled: e,
		hasError: t,
		children: /*#__PURE__*/ M("label", {
			htmlFor: r || o,
			children: a
		})
	}), /*#__PURE__*/ M(mx, {
		name: o,
		isBorderless: !0,
		isFullWidth: !0,
		readOnly: s,
		...u
	})]
}), t && n && /*#__PURE__*/ M(H, {
	marginTop: "6px",
	children: /*#__PURE__*/ M(V, {
		color: l.text.alert,
		size: i.body.medium,
		lineHeight: "1.3",
		children: n
	})
})] }), xx = (e, t) => {
	let n = new Set(t);
	return e.length !== t.length || e.some((e) => !n.has(e));
}, Sx = (e, t) => {
	let n = new Set(t);
	return e.filter((e) => n.has(e.value)).map((e) => e.value);
}, Cx = (e, t) => e && !xx(e.baseValue, t) ? e.selectedValues : null, wx = (e, t) => e.filter((e) => t.has(e.value)).map((e) => e.valueTitle ?? e.title).join(", "), Tx = ({ options: e, value: t, onChange: n }) => {
	let [r, i] = E(!1), [a, o] = E(null), s = T(null), c = T(null), l = T(void 0);
	x(() => () => clearTimeout(l.current), []);
	let u = Cx(a, t), d = new Set(r && u ? u : t), f = () => {
		i(!1), u && xx(u, t) && n(Sx(e, u));
	}, p = T(f);
	p.current = () => {
		r && f();
	}, ie(s, r ? f : null);
	let m = (e) => {
		e.preventDefault(), r ? f() : (o(null), i(!0));
	}, h = (e) => {
		e.key === "Escape" && r && (e.stopPropagation(), i(!1), c.current?.focus());
	}, g = () => {
		let { activeElement: e } = document;
		return e && s.current?.contains(e) ? !1 : !document.hasFocus() || e !== null && e !== document.body;
	};
	return {
		handleBlur: (e) => {
			if (!r) return;
			let t = e.relatedTarget;
			t instanceof Node ? s.current?.contains(t) || f() : (clearTimeout(l.current), l.current = setTimeout(() => {
				g() && p.current();
			}));
		},
		handleKeyDown: h,
		handleToggle: ({ value: e, checked: n }) => {
			o((r) => {
				let i = Cx(r, t) ?? t;
				return {
					baseValue: t,
					selectedValues: n ? [...i, e] : i.filter((t) => t !== e)
				};
			});
		},
		handleTriggerClick: m,
		isOpen: r,
		selectedTitle: wx(e, d),
		selectedValueSet: d,
		triggerRef: c,
		wrapperRef: s
	};
}, Ex = {
	scouts: {
		fieldset: "_fieldset_c4kf8_1",
		hasError: "_hasError_c4kf8_17",
		legend: "_legend_c4kf8_31",
		legendLarge: "_legendLarge_c4kf8_44",
		legendError: "_legendError_c4kf8_48",
		legendDisabled: "_legendDisabled_c4kf8_52",
		trigger: "_trigger_c4kf8_56",
		triggerLarge: "_triggerLarge_c4kf8_85",
		triggerText: "_triggerText_c4kf8_90",
		placeholder: "_placeholder_c4kf8_98",
		chevron: "_chevron_c4kf8_106",
		menu: "_menu_c4kf8_110",
		menuAlignRight: "_menuAlignRight_c4kf8_127",
		option: "_option_c4kf8_132"
	},
	tfds: {
		fieldset: "_fieldset_anor0_1",
		fieldsetOpen: "_fieldsetOpen_anor0_12",
		hasError: "_hasError_anor0_21",
		trigger: "_trigger_anor0_26",
		legend: "_legend_anor0_40",
		legendFloated: "_legendFloated_anor0_56",
		legendError: "_legendError_anor0_63",
		legendDisabled: "_legendDisabled_anor0_67",
		triggerText: "_triggerText_anor0_96",
		placeholder: "_placeholder_anor0_104",
		chevron: "_chevron_anor0_112",
		chevronOpen: "_chevronOpen_anor0_123",
		menu: "_menu_anor0_131",
		menuAlignRight: "_menuAlignRight_anor0_149",
		option: "_option_anor0_154"
	}
}, Dx = (...e) => e.filter(Boolean).join(" "), Ox = ({ alignRight: e, describedBy: t, dropdown: n, hideLabel: r, inputId: i, isLarge: a, label: o, labelId: s, maxHeight: c, menuId: l, name: u, options: d, placeholder: f, styles: p, triggerTextId: m }) => {
	let { handleBlur: h, handleKeyDown: g, handleToggle: _, handleTriggerClick: v, isOpen: y, selectedTitle: b, selectedValueSet: x } = n, S = b ? `${r ? i : s} ${m}` : void 0;
	return /*#__PURE__*/ N("div", {
		ref: n.wrapperRef,
		role: "presentation",
		onKeyDown: g,
		onBlur: h,
		children: [/*#__PURE__*/ N("button", {
			ref: n.triggerRef,
			id: i,
			type: "button",
			"aria-label": r ? o : void 0,
			"aria-labelledby": S,
			"aria-describedby": t,
			className: Dx(p.trigger, a && p.triggerLarge),
			"aria-expanded": y,
			"aria-controls": y ? l : void 0,
			onClick: v,
			children: [/*#__PURE__*/ M("span", {
				id: m,
				className: Dx(p.triggerText, !b && p.placeholder),
				children: b || f
			}), /*#__PURE__*/ M("svg", {
				className: Dx(p.chevron, y && p.chevronOpen),
				viewBox: "0 0 512 512",
				"aria-hidden": "true",
				focusable: "false",
				children: /*#__PURE__*/ M("path", { d: "M256.4 425.9l17-17 200-200 17-17-33.9-33.9-17 17-183 183-183-183-17-17-33.9 33.9 17 17 200 200 17 17z" })
			})]
		}), y && /*#__PURE__*/ M("div", {
			id: l,
			className: Dx(p.menu, e && p.menuAlignRight),
			style: { maxHeight: c },
			children: d.map((e) => /*#__PURE__*/ M("div", {
				className: p.option,
				children: /*#__PURE__*/ M(W_, {
					name: u,
					value: e.value,
					label: e.title,
					checked: x.has(e.value),
					disabled: e.disabled,
					onChange: _
				})
			}, e.value))
		})]
	});
}, kx = ({ alignRight: e, disabled: t, errorMessage: n, hasError: r, hideLabel: i, id: a, isLarge: o, label: s, maxHeight: c, name: l, onChange: u, options: d, placeholder: f, readOnly: p, ref: m, value: h, variant: g = "scouts", width: _ = "auto" }) => {
	let v = Tx({
		options: d,
		value: h,
		onChange: (e) => u({
			name: l,
			value: e
		})
	}), y = Ex[g], b = a || l, x = `${b}-label`, S = `${b}-error`, C = !!r && !!n, w = C ? S : void 0, T = v.isOpen || !!v.selectedTitle || !!f, E = {
		styles: y,
		inputId: b,
		label: s,
		hideLabel: i,
		isLarge: o,
		describedBy: w
	};
	return /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ N("fieldset", {
		ref: m,
		className: Dx(y.fieldset, v.isOpen && y.fieldsetOpen, r && y.hasError),
		style: { width: _ },
		"aria-label": i ? s : void 0,
		"aria-invalid": r || void 0,
		disabled: t || p,
		children: [!i && /*#__PURE__*/ M("legend", {
			className: Dx(y.legend, o && y.legendLarge, T && y.legendFloated, r && y.legendError, t && y.legendDisabled),
			children: /*#__PURE__*/ M("label", {
				id: x,
				htmlFor: b,
				children: s
			})
		}), /*#__PURE__*/ M(Ox, {
			...E,
			alignRight: e,
			dropdown: v,
			labelId: x,
			maxHeight: c,
			menuId: `${b}-menu`,
			name: l,
			options: d,
			placeholder: f,
			triggerTextId: `${b}-value`
		})]
	}), C && /*#__PURE__*/ M(Nv, {
		id: S,
		children: n
	})] });
}, Ax = ({ color: e = l.text.base, colorHover: t, onClick: n, IconComponent: r, background: a = l.surface.neutral, backgroundHover: o, isFullWidth: s = !1, isLoading: c, children: u, isActive: d, ...f }) => {
	let [p, m] = E(!1), [h, g] = E(!1), _ = () => {
		n && !c && n();
	}, v = () => {
		m(!0);
	}, y = () => {
		m(!1);
	}, b = () => {
		g(!0);
	}, x = () => {
		g(!1);
	}, S = (p || h || !!d) && !c;
	return /*#__PURE__*/ N(jx, {
		onClick: _,
		onMouseEnter: v,
		onMouseLeave: y,
		onFocus: b,
		onBlur: x,
		isFullWidth: s,
		...f,
		children: [/*#__PURE__*/ N(Mx, {
			background: S && o || a,
			children: [c && /*#__PURE__*/ M(U, {
				isSmall: !0,
				color: e
			}), !c && /*#__PURE__*/ M(r, {
				"aria-hidden": "true",
				color: S && t || e
			})]
		}), /*#__PURE__*/ M(V, {
			size: i.body.medium,
			weight: i.weight.medium,
			color: S && t || e,
			children: u
		})]
	});
}, jx = P.button.withConfig({
	displayName: "IconButton__Wrapper",
	componentId: "sc-cb6b1b87-0"
})([
	"display:flex;gap:12px;align-items:center;cursor:pointer;",
	";border:none;padding:0;background:transparent;font:inherit;color:inherit;text-align:inherit;&:focus-visible{outline:",
	";outline-offset:6px;border-radius:",
	";}"
], ({ isFullWidth: e }) => e ? "width: 100%" : "", s.interactive.medium, I.small), Mx = P.div.withConfig({
	displayName: "IconButton__IconContainer",
	componentId: "sc-cb6b1b87-1"
})([
	"display:flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:",
	";background-color:",
	";"
], I.full, ({ background: e }) => e), Nx = ({ name: e, cancelButtonLabel: t = "✕", onSave: n, saveButtonLabel: r = "Save", value: i, onChange: a, ...o }) => {
	let s = T(i), c = T(null), [l, u] = E(!1), [d, f] = E(i);
	x(() => {
		f(i), s.current = i;
	}, [f, i]);
	let p = (e) => {
		if (d !== i) return;
		let { onBlur: t } = o;
		b(), t && t(e);
	}, m = ({ value: e }) => {
		f(e);
	}, h = (e) => {
		v();
		let { onFocus: t } = o;
		t && t(e);
	}, g = (e) => {
		let { onKeyDown: t } = o;
		switch (e.key) {
			case "Enter":
				e.preventDefault(), _(), t && t(e);
				break;
			case "Esc":
			case "Escape": e.preventDefault(), b(), t && t(e);
		}
	}, _ = () => {
		n({
			name: e,
			value: d
		}), y();
	}, v = () => {
		u(!0);
	}, y = () => {
		c && c.current && c.current.blur(), u(!1);
	}, b = () => {
		y(), f(s.current);
	}, S = {
		...o,
		name: e,
		value: d,
		onChange: a || m,
		onBlur: p,
		onFocus: h,
		onKeyDown: g
	};
	return /*#__PURE__*/ N(B, {
		gap: "6px",
		width: "100%",
		children: [/*#__PURE__*/ M(H, {
			flex: "1 1 auto",
			children: /*#__PURE__*/ M(Iv, {
				...S,
				ref: c
			})
		}), l && /*#__PURE__*/ N(B, {
			gap: "6px",
			alignCenter: !0,
			children: [/*#__PURE__*/ M(W, {
				onClick: _,
				disabled: S.disabled,
				children: r
			}), /*#__PURE__*/ M(W, {
				onClick: b,
				variant: "secondary",
				children: t
			})]
		})]
	});
}, Px = {
	[D.GB]: { textDelete: "Delete" },
	[D.ES]: { textDelete: "Eliminar" }
}, Fx = ({ children: e, background: t, onClick: n, onDelete: r, variant: i = "highlight", locale: a = D.GB, disabled: o = !1 }) => {
	let { textDelete: s } = Px[a];
	return /*#__PURE__*/ N(B, {
		gap: "9px",
		alignCenter: !0,
		children: [n ? /*#__PURE__*/ M(ov, {
			variant: i,
			onClick: n,
			disabled: o,
			children: e
		}) : /*#__PURE__*/ M($_, {
			background: t,
			color: l.text.base,
			disabled: o,
			children: e
		}), r && /*#__PURE__*/ M(L_, {
			isSmall: !0,
			color: l.text.alert,
			onClick: r,
			children: s
		})]
	});
}, Ix = ({ onChange: e, buttonLabel: t = "Choose a file", label: n = "Drag & drop or choose a file" }) => {
	let r = He({ onDropHandler: e }), a = () => {
		re({
			onChange: e,
			multiple: !0
		});
	};
	return /*#__PURE__*/ N(Lx, {
		...r,
		children: [/*#__PURE__*/ M(V, {
			size: i.body.small,
			color: l.text.neutral,
			children: n
		}), /*#__PURE__*/ M(W, {
			onClick: a,
			children: t
		})]
	});
}, Lx = P.div.withConfig({
	displayName: "FileDropZone__Container",
	componentId: "sc-160af401-0"
})([
	"display:grid;gap:12px;place-content:center;padding:24px 36px;background-color:",
	";border:2px solid ",
	";border-style:dashed;border-radius:",
	";"
], ({ isDragging: e }) => e ? l.surface.neutral : "inherit", l.line.neutralSoft, I.large), Rx = ({ isDisabled: e = !1, onChange: t, options: n, value: r }) => /*#__PURE__*/ M(B, {
	column: !0,
	gap: "9px",
	tabletGap: "12px",
	children: n.map((n) => /*#__PURE__*/ M(cy, {
		description: n.description,
		isActive: n.value === r,
		isDisabled: e,
		onClick: () => t(n.value),
		children: n.title
	}, n.value))
}), zx = ({ label: e, onUpload: t, acceptedFileExtensions: n = "", acceptMultiple: r = !0, ...i }) => /*#__PURE__*/ M(W, {
	onClick: () => {
		re({
			multiple: r,
			accept: n,
			onChange: (e) => t(e)
		});
	},
	...i,
	children: e
}), Bx = h(null), Vx = () => {
	let e = b(Bx);
	if (e === null) throw Error("`useAccountantPortalChrome` must be used within a `AccountantPortalChromeContext.Provider`");
	return e;
}, Hx = ({ children: e }) => /*#__PURE__*/ M(Ux, { children: e }), Ux = P.div.withConfig({
	displayName: "Container__Wrapper",
	componentId: "sc-126c8bb6-0"
})(["background:", ";"], l.surface.neutral), Wx = P.div.withConfig({
	displayName: "Content",
	componentId: "sc-6f97550b-0"
})([
	"flex:1 1 auto;min-width:1px;min-height:100%;background:",
	";border-radius:12px 0 0 0;box-shadow:",
	";"
], l.surface.base, L.high), Gx = P.div.withConfig({
	displayName: "Container",
	componentId: "sc-13fe0751-0"
})(["", "{display:flex;}"], R.tablet), Kx = P.div.withConfig({
	displayName: "Content",
	componentId: "sc-4b73f28b-0"
})(["", "{flex:1 1 auto;overflow-y:auto;min-height:0;}"], R.tablet), qx = P.div.withConfig({
	displayName: "ContentContainer",
	componentId: "sc-bc421835-0"
})([
	"",
	"{display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden;position:relative;height:calc(100vh - 60px);border-radius:",
	" 0 0 0;}"
], R.tablet, I.large), Jx = 135, Yx = 180, Xx = ({ children: e }) => {
	let t = Ke(), { setVisibleCustomerMenuItemsCount: n } = Vx(), r = T(null);
	return oe(r, () => {
		let e = r.current?.clientWidth ? r.current?.clientWidth : 0, i = t ? e : e - Yx, a = Math.floor(i / Jx);
		n(a);
	}), /*#__PURE__*/ M(Zx, {
		ref: r,
		children: e
	});
}, Zx = P.div.withConfig({
	displayName: "Container__Wrapper",
	componentId: "sc-b1dc2a2b-0"
})([
	"padding:12px;background:",
	";",
	"{display:flex;align-items:center;justify-content:flex-end;width:100%;min-height:60px;padding:9px 36px;border-radius:",
	" 0 0 0;}",
	"{justify-content:center;padding:9px 48px;}"
], l.surface.base, R.tablet, I.large, R.desktopLarge), Qx = P.div.withConfig({
	displayName: "Item",
	componentId: "sc-7ba0b42d-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:block;padding:12px;border-radius:",
	";",
	" &.is-active{background:",
	";}"
], l.text.base, i.body.medium, i.weight.medium, I.medium, c`
        display: flex;
        align-items: center;
        height: 100%;
        padding: 12px 21px;

        &:hover {
            color: ${l.text.interactive};
        }
    `, l.surface.neutral), $x = ({ children: e }) => /*#__PURE__*/ M(eS, { children: e }), eS = P.div.withConfig({
	displayName: "Items__Container",
	componentId: "sc-97ec6d53-0"
})([
	"position:relative;z-index:2;display:flex;justify-content:flex-end;align-items:center;background-color:",
	";",
	"{background-color:transparent;}&:before{content:'';position:absolute;left:-120px;display:block;width:120px;height:60px;background:linear-gradient(to right,",
	",",
	");pointer-events:none;",
	"{display:none;}}"
], l.surface.base, R.desktopLarge, k(l.surface.base, 0), l.surface.base, R.desktopLarge), tS = ({ items: e }) => {
	let { push: t } = we(), n = w(() => e?.filter(({ shouldHide: e }) => !e).map(({ title: e, path: n }) => ({
		title: e,
		onClick: () => t(n || "")
	})), [e, t]);
	return !e || !n || n?.length === 0 ? null : /*#__PURE__*/ M(H, {
		marginLeft: "12px",
		children: /*#__PURE__*/ M(fv, {
			alignRight: !0,
			actions: n
		})
	});
}, nS = ({ children: e, onClick: t }) => {
	let n = Ge(), r = qe();
	return !n || r ? null : /*#__PURE__*/ M(rS, { children: /*#__PURE__*/ M(L_, {
		onClick: t,
		children: e
	}) });
}, rS = P.div.withConfig({
	displayName: "Title__Container",
	componentId: "sc-c9d24ec-0"
})(["position:absolute;left:36px;"]), iS = {
	Container: Xx,
	Items: $x,
	Item: Qx,
	Title: nS,
	Secondary: tS
}, aS = ({ children: e, backgroundColor: t, isFullWidth: n, padding: r, tabletPadding: i, desktopPadding: a, desktopLargePadding: o, radius: s }) => /*#__PURE__*/ M(oS, {
	backgroundColor: t,
	padding: r,
	tabletPadding: i,
	desktopPadding: a,
	desktopLargePadding: o,
	radius: s,
	children: /*#__PURE__*/ M(sS, {
		isFullWidth: n,
		children: e
	})
}), oS = P.div.withConfig({
	displayName: "Container__Wrapper",
	componentId: "sc-ddf667da-0"
})([
	"padding:",
	";background:",
	";border-radius:",
	";",
	"{padding:",
	";}",
	"{padding:",
	";}",
	"{padding:",
	";}"
], ({ padding: e }) => e || "24px 24px 318px", ({ backgroundColor: e }) => e || "white", ({ radius: e }) => e || 0, R.tablet, ({ tabletPadding: e }) => e || "0 36px 40vh", R.desktop, ({ desktopPadding: e, tabletPadding: t }) => e || t || "0 36px 40vh", R.desktopLarge, ({ desktopLargePadding: e, desktopPadding: t, tabletPadding: n }) => e || t || n || "0 48px 40vh"), sS = P.div.withConfig({
	displayName: "Container__Content",
	componentId: "sc-ddf667da-1"
})([
	"",
	"{max-width:",
	";margin:0 auto;}"
], R.tablet, ({ isFullWidth: e }) => e ? "100%" : "1280px"), cS = P.div.withConfig({
	displayName: "Header",
	componentId: "sc-55c56fb0-0"
})([
	"margin-bottom:30px;display:flex;gap:18px;flex-direction:column;",
	"{flex-direction:row;align-items:center;justify-content:space-between;width:100%;min-height:60px;margin-bottom:24px;",
	"}"
], R.tablet, ({ isSticky: e }) => e && `
            position: sticky;
            top: 0;
            z-index: 100;
            margin-bottom: 0;
            backdrop-filter: blur(9px);
            background: ${k(l.surface.base, .85)};
        `), lS = P.div.withConfig({
	displayName: "HeaderGroup",
	componentId: "sc-2619eead-0"
})(["display:flex;justify-content:flex-start;align-items:center;gap:12px;", "{flex:1 1 auto;gap:24px;&:last-child{justify-content:flex-end;}}"], R.tablet), uS = P.div.withConfig({
	displayName: "SubTitle",
	componentId: "sc-a0d891ec-0"
})([
	"font-size:",
	";font-weight:",
	";",
	"{font-size:",
	";flex:0 0 auto;}"
], i.title.medium, i.weight.medium, R.tablet, i.title.large), dS = {
	Container: Gx,
	Content: Kx,
	ContentContainer: qx,
	Nav: iS,
	Page: {
		Container: aS,
		Header: cS,
		HeaderGroup: lS,
		Title: P.div.withConfig({
			displayName: "Title",
			componentId: "sc-27e72165-0"
		})([
			"font-size:",
			";font-weight:",
			";",
			""
		], i.title.large, i.weight.medium, c`
        font-size: ${i.title.xlarge};
        flex: 0 0 auto;
    `),
		SubTitle: uS
	},
	Sidebar: {
		Container: P.div.withConfig({
			displayName: "Container",
			componentId: "sc-fad64188-0"
		})([
			"",
			"{border-radius:",
			" 0 0 0;display:flex;display:",
			";flex-direction:column;position:absolute;top:60px;width:360px;max-height:calc(100vh - 60px);min-width:360px;background-color:",
			";height:",
			";z-index:",
			";box-shadow:",
			";}",
			"{display:flex;position:sticky;box-shadow:none;}"
		], R.tablet, I.large, ({ tabletIsVisible: e }) => e ? "flex" : "none", l.surface.base, ({ tabletIsVisible: e }) => e ? "100%" : "auto", ({ tabletIsVisible: e }) => e ? 102 : "inherit", L.medium, R.desktopLarge),
		Content: P.div.withConfig({
			displayName: "Content",
			componentId: "sc-a7da36f-0"
		})(["", "{overflow-y:auto;flex:1 1 auto;}"], R.tablet),
		Nav: P.div.withConfig({
			displayName: "Nav",
			componentId: "sc-26180bb4-0"
		})(["display:flex;justify-content:center;"]),
		NavItem: P.div.withConfig({
			displayName: "NavItem",
			componentId: "sc-b756495b-0"
		})([
			"display:flex;align-items:center;justify-content:center;position:relative;width:60px;height:60px;border-bottom:1px solid ",
			";&.is-active{border-bottom:1px solid ",
			";}"
		], l.line.neutralSoft, l.line.base),
		NavItemBadge: P.div.withConfig({
			displayName: "NavItemBadge",
			componentId: "sc-e1a09661-0"
		})(["position:absolute;top:11px;right:8px;"]),
		Profile: {
			Container: P.div.withConfig({
				displayName: "Container",
				componentId: "sc-c1cde23e-0"
			})(["padding:0 0 24px;"]),
			Field: P.div.withConfig({
				displayName: "Field",
				componentId: "sc-9ec3e67e-0"
			})(["&:not(:last-child){margin-bottom:15px;}"]),
			FieldLabel: P.div.withConfig({
				displayName: "FieldLabel",
				componentId: "sc-3d091fcb-0"
			})([
				"color:",
				";font-size:",
				";line-height:1.3;margin-bottom:6px;a{color:",
				";text-decoration:none;&:hover{color:",
				";text-decoration:underline;}}"
			], l.text.neutral, i.body.small, l.text.neutral, l.text.neutral),
			Fieldset: P.div.withConfig({
				displayName: "Fieldset",
				componentId: "sc-b1d2af3d-0"
			})([
				"padding:18px 0;margin:0 24px;background-color:",
				";border-top:1px solid ",
				";"
			], l.surface.base, l.line.neutralSoft),
			FieldValue: P.div.withConfig({
				displayName: "FieldValue",
				componentId: "sc-e1dd85ac-0"
			})(["font-size:", ";line-height:1.3;white-space:pre-line;position:relative;&:not(:last-child){margin-bottom:6px;}"], i.body.medium),
			Head: P.div.withConfig({
				displayName: "Head",
				componentId: "sc-1e4e2b25-0"
			})([
				"padding:18px 24px;background-color:",
				";",
				"{position:sticky;top:0;z-index:1;background:",
				";backdrop-filter:blur(9px);}"
			], l.surface.base, R.tablet, k(l.surface.base, .85))
		}
	}
}, fS = P.div.withConfig({
	displayName: "Header",
	componentId: "sc-5ac9cab9-0"
})(["display:flex;align-items:center;justify-content:flex-end;width:calc(100% - 60px);height:60px;z-index:1000;padding:0;", "{padding:0 24px;justify-content:space-between;}"], R.tablet), pS = P.div.withConfig({
	displayName: "HeaderGroup",
	componentId: "sc-c10e4a17-0"
})([
	"display:flex;align-items:center;gap:12px;",
	" ",
	"{gap:24px;height:100%;",
	" ",
	"}"
], ({ isDesktopOnly: e }) => e && "\n            display: none;\n        ", R.tablet, ({ isMobileOnly: e }) => e && "\n            display: none;\n        ", ({ isDesktopOnly: e }) => e && "\n            display: flex;\n        "), mS = ({ onClick: e }) => /*#__PURE__*/ M(hS, { children: /*#__PURE__*/ M(Yv, { onClick: e }) }), hS = P.div.withConfig({
	displayName: "Logo__Container",
	componentId: "sc-476c98a1-0"
})(["height:60px;width:60px;padding:18px;"]), gS = P.div.withConfig({
	displayName: "Main",
	componentId: "sc-d45ca69b-0"
})(["display:flex;min-height:calc(100vh - 60px);background-color:", ";"], l.surface.neutral), _S = ({ items: e, itemsAs: t }) => /*#__PURE__*/ M(vS, { children: e.map(({ path: e, title: n, url: r, className: i }) => r ? /*#__PURE__*/ M(bS, {
	href: r,
	target: "_blank",
	rel: "noreferrer noopener",
	children: n
}, r) : /*#__PURE__*/ M(yS, {
	as: t,
	to: e || "",
	className: i,
	children: n
}, e)) }), vS = P.div.withConfig({
	displayName: "MainMenu__Container",
	componentId: "sc-afcb4eb8-0"
})(["display:flex;gap:36px;height:100%;"]), yS = P.div.withConfig({
	displayName: "MainMenu__Item",
	componentId: "sc-afcb4eb8-1"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:flex;align-items:center;border-bottom:1px solid transparent;&.active{border-bottom:1px solid ",
	";}",
	"{&:hover{color:",
	";}}"
], l.text.base, i.body.medium, i.weight.medium, l.line.base, R.tablet, l.text.interactive), bS = P.a.withConfig({
	displayName: "MainMenu__ItemExternal",
	componentId: "sc-afcb4eb8-2"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:flex;align-items:center;border-bottom:1px solid transparent;&:hover{opacity:0.75;}"
], l.text.interactive, i.body.medium, i.weight.medium), xS = ({ items: e }) => {
	let { push: t } = we(), n = w(() => e?.map(({ title: e, path: n, url: r, color: i }) => r ? {
		title: e,
		onClick: () => window.open(r, "_blank"),
		color: i
	} : {
		title: e,
		onClick: () => t(n || ""),
		color: i
	}), [e, t]);
	return !e || !n || n?.length === 0 ? null : /*#__PURE__*/ M(fv, {
		alignRight: !0,
		actions: n
	});
}, SS = P.div.withConfig({
	displayName: "Sidebar",
	componentId: "sc-7a53757e-0"
})(["display:none;flex:0 0 60px;width:60px;", "{display:block;}"], R.tablet), CS = P.div.withConfig({
	displayName: "SidebarContent",
	componentId: "sc-b3311319-0"
})(["display:flex;flex-direction:column;justify-content:space-between;height:calc(100% - 60px);position:fixed;bottom:0;"]), wS = P.div.withConfig({
	displayName: "SidebarGroup",
	componentId: "sc-51ef3977-0"
})(["&:only-child{margin-top:auto;}"]), TS = ({ IconComponent: e, path: t, title: n, as: r }) => {
	let i = Te(t);
	return /*#__PURE__*/ M(ES, {
		as: r,
		to: t,
		title: n,
		children: /*#__PURE__*/ M(G, {
			Component: e,
			color: i ? l.text.base : l.text.neutral,
			hoverColor: l.text.interactive,
			width: "100%",
			height: "100%"
		})
	});
}, ES = P.div.withConfig({
	displayName: "SidebarMenuItem__Item",
	componentId: "sc-2cb4592e-0"
})(["display:flex;align-items:center;justify-content:center;position:relative;width:60px;height:60px;"]), DS = ({ items: e, itemsAs: t }) => /*#__PURE__*/ M(j, { children: e.filter(({ shouldHide: e }) => !e).map(({ path: e, title: n, IconComponent: r }) => /*#__PURE__*/ M(TS, {
	as: t,
	path: e,
	title: n,
	IconComponent: r
}, e)) }), OS = ({ IconComponent: e, onClick: t, title: n, isActive: r }) => /*#__PURE__*/ M(kS, {
	onClick: t,
	title: n,
	children: /*#__PURE__*/ M(G, {
		Component: e,
		color: r ? l.text.base : l.text.neutral,
		hoverColor: l.text.interactive,
		width: "100%",
		height: "100%"
	})
}), kS = P.button.withConfig({
	displayName: "SidebarMenuAction__Item",
	componentId: "sc-874916ff-0"
})(["display:flex;align-items:center;justify-content:center;position:relative;width:60px;height:60px;"]), AS = 120, jS = 608, MS = ({ children: e }) => {
	let { setVisibleMainMenuItemsCount: t } = Vx(), n = T(null);
	return oe(n, () => {
		let e = (n.current?.clientWidth ? n.current?.clientWidth : 0) - jS, r = Math.floor(e / AS);
		t(r);
	}), /*#__PURE__*/ M(NS, {
		ref: n,
		children: e
	});
}, NS = P.div.withConfig({
	displayName: "Top__Wrapper",
	componentId: "sc-7f6ba32c-0"
})(["display:flex;width:100%;height:60px;"]), PS = ({ items: e, imageUrl: t, buttonLabel: n = "Menu" }) => {
	let { push: r } = we(), i = w(() => e.filter(({ shouldHide: e }) => !e).map(({ title: e, path: t }) => ({
		title: e,
		onClick: () => r(t)
	})), [e, r]);
	return /*#__PURE__*/ M(fv, {
		alignRight: !0,
		actions: i,
		children: /*#__PURE__*/ N(B, {
			gap: "9px",
			alignCenter: !0,
			children: [t && /*#__PURE__*/ M(FS, {
				alt: n,
				src: t
			}), n]
		})
	});
}, FS = P.img.withConfig({
	displayName: "UserMenu__Image",
	componentId: "sc-b62fd171-0"
})([
	"border-radius:",
	";height:36px;width:36px;display:block;overflow:hidden;box-shadow:",
	";"
], I.full, L.medium), Y = ({ children: e }) => {
	let [t, n] = E(!1), [r, i] = E(100), [a, o] = E(100), s = {
		visibleCustomerMenuItemsCount: r,
		setVisibleCustomerMenuItemsCount: i,
		visibleMainMenuItemsCount: a,
		setVisibleMainMenuItemsCount: o,
		isCustomerSidebarVisible: t,
		setIsCustomerSidebarVisible: n
	};
	return /*#__PURE__*/ M(Bx.Provider, {
		value: s,
		children: e
	});
};
Y.Container = Hx, Y.Content = Wx, Y.Customer = dS, Y.Header = fS, Y.HeaderGroup = pS, Y.HeaderGroup = pS, Y.Logo = mS, Y.Main = gS, Y.MainMenu = _S, Y.MainMenuSecondary = xS, Y.Sidebar = SS, Y.SidebarContent = CS, Y.SidebarGroup = wS, Y.SidebarMenu = DS, Y.Top = MS, Y.UserMenu = PS, Y.SidebarMenuAction = OS;
//#endregion
//#region src/organisms/AccountantPortalSearchFilter/AccountantPortalSearchFilterDropdown.tsx
var IS = ({ children: e }) => /*#__PURE__*/ M(LS, { children: e }), LS = P.div.withConfig({
	displayName: "AccountantPortalSearchFilterDropdown__Container",
	componentId: "sc-64c2bf42-0"
})([
	"position:absolute;top:6px;left:0;z-index:1000;min-width:240px;padding:18px;border-radius:",
	";background:",
	";box-shadow:",
	";"
], I.medium, l.surface.neutral, L.medium), RS = P.div.withConfig({
	displayName: "Actions",
	componentId: "sc-d3c7e90e-0"
})([
	"display:flex;align-items:center;justify-content:",
	";padding:",
	";border-radius:",
	";",
	"{padding:",
	";}",
	";&:not(:first-child){margin-top:",
	";}",
	"{&:not(:first-child){margin-top:",
	";}}&:last-child{flex:1 0 auto;}&:not(:last-child){margin-bottom:24px;}",
	"{&:not(:last-child){margin:0;}}> :not(:first-child){margin-left:12px;}"
], ({ alignRight: e }) => e ? "flex-end" : "flex-start", ({ background: e }) => e ? "18px" : "0", I.medium, R.tablet, ({ background: e }) => e ? "24px 36px" : "0", ({ background: e }) => e && `background: ${e};`, ({ background: e }) => e ? "24px" : "12px", R.tablet, ({ background: e }) => e ? "36px" : "12px", R.tablet);
RS.displayName = "Form.Actions";
//#endregion
//#region src/organisms/Form/Column/Content.tsx
var zS = P.div.withConfig({
	displayName: "Content",
	componentId: "sc-eee27275-0"
})([""]);
zS.displayName = "Form.Column.Content";
//#endregion
//#region src/organisms/Form/Column/Title.tsx
var BS = ({ children: e, ...t }) => /*#__PURE__*/ M(VS, {
	...t,
	children: e
}), VS = P.div.withConfig({
	displayName: "Title__Container",
	componentId: "sc-967e77b7-0"
})(["line-height:1.3;display:block;width:100%;margin-bottom:12px;", "{display:flex;align-items:center;justify-content:space-between;}"], R.tablet), HS = P.span.withConfig({
	displayName: "Title__Required",
	componentId: "sc-967e77b7-1"
})([
	"&:after{content:'",
	"';color:",
	";margin-right:auto;margin-left:4px;}"
], ({ label: e = "(required)" }) => e, l.text.neutral);
BS.displayName = "Form.Column.Title", BS.Required = HS, BS.Required.displayName = "Form.Column.Title.Required";
//#endregion
//#region src/organisms/Form/Column/Column.tsx
var US = ({ children: e, alignSelfCenter: t, width: n }) => /*#__PURE__*/ M(WS, {
	alignSelfCenter: t,
	width: n,
	children: e
});
US.displayName = "Form.Column", US.Content = zS, US.Title = BS;
var WS = P.div.withConfig({
	displayName: "Column__Container",
	componentId: "sc-153750e5-0"
})([
	"width:100%;margin-bottom:12px;",
	" ",
	"{width:",
	";margin-right:0;margin-bottom:0;}&:last-child{margin-bottom:0;}"
], ({ alignSelfCenter: e }) => e && "align-self: center;", R.tablet, ({ width: e }) => e || "100%"), GS = P.div.withConfig({
	displayName: "Columns",
	componentId: "sc-9fc1514-0"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;"]);
GS.displayName = "Form.Columns";
//#endregion
//#region src/organisms/Form/Control.tsx
var KS = P.div.withConfig({
	displayName: "Control",
	componentId: "sc-9e398e94-0"
})(["&:not(:last-child){margin-bottom:18px;}"]);
KS.displayName = "Form.Control";
//#endregion
//#region src/organisms/Form/InlineControl.tsx
var qS = P.div.withConfig({
	displayName: "InlineControl",
	componentId: "sc-fca225b4-0"
})(["margin-bottom:9px;", "{display:inline-block;margin-right:18px;margin-bottom:0;}"], R.tablet);
qS.displayName = "Form.InlineControl";
//#endregion
//#region src/organisms/Form/Row/Action.tsx
var JS = P.div.withConfig({
	displayName: "Action",
	componentId: "sc-f0b5e701-0"
})(["margin-top:9px;", "{margin-top:0;}"], R.tablet);
JS.displayName = "Form.Row.Action";
//#endregion
//#region src/organisms/Form/Row/Content.tsx
var YS = P.div.withConfig({
	displayName: "Content",
	componentId: "sc-cc40474f-0"
})([""]);
YS.displayName = "Form.Row.Content";
//#endregion
//#region src/organisms/Form/Row/Description.tsx
var XS = P.div.withConfig({
	displayName: "Description",
	componentId: "sc-d8c9b3e7-0"
})(["font-size:", ";line-height:1.5;margin-top:12px;&:not(:last-child){margin-bottom:12px;}"], i.body.medium);
XS.displayName = "Form.Row.Description";
//#endregion
//#region src/organisms/Form/Row/Title.tsx
var ZS = ({ children: e, ...t }) => /*#__PURE__*/ M(QS, {
	...t,
	children: e
}), QS = P.div.withConfig({
	displayName: "Title__Container",
	componentId: "sc-1e7c6e95-0"
})(["line-height:1.3;display:block;width:100%;margin-bottom:12px;", "{display:flex;align-items:center;justify-content:space-between;}"], R.tablet), $S = P.span.withConfig({
	displayName: "Title__Required",
	componentId: "sc-1e7c6e95-1"
})([
	"&:after{content:'",
	"';color:",
	";margin-right:auto;margin-left:4px;}"
], ({ label: e = "(required)" }) => e, l.text.neutral);
ZS.displayName = "Form.Row.Title", ZS.Required = $S, ZS.Required.displayName = "Form.Row.Title.Required";
//#endregion
//#region src/organisms/Form/Row/Row.tsx
var eC = ({ children: e, ...t }) => /*#__PURE__*/ M(tC, {
	...t,
	children: e
});
eC.displayName = "Form.Row", eC.Action = JS, eC.Content = YS, eC.Description = XS, eC.Title = ZS;
var tC = P.div.withConfig({
	displayName: "Row__Container",
	componentId: "sc-9314e48-0"
})([
	"padding:",
	";",
	"{padding:",
	";}&:after,&:before{width:24px;}&:not(:first-child){padding-top:",
	";}",
	"{&:not(:first-child){padding-top:",
	";}}&:not(:last-child){padding-bottom:",
	";}",
	"{&:not(:last-child){padding-bottom:",
	";}}",
	";"
], ({ background: e }) => e ? "12px 0" : "0", R.tablet, ({ background: e }) => e ? "18px 0" : "0", ({ isCompact: e }) => e ? "9px" : "12px", R.tablet, ({ isCompact: e }) => e ? "9px" : "18px", ({ isCompact: e }) => e ? "9px" : "12px", R.tablet, ({ isCompact: e }) => e ? "9px" : "18px", ({ background: e }) => e && `
        position: relative;
        /* stacking context for pseudo elements */
        z-index: 0;
        background: ${e};

        &:not(:last-child) {
            margin: 1px 0;
        }

        &:after,
        &:before {
            content: '';
            position: absolute;
            top: 0;
            /* stack pseudo elements below parent */
            z-index: -1;
            height: 100%;
            background: ${e};
        }

        &:after {
            left: 100%;
            border-radius: 0 4px 4px 0;
        }

        &:before {
            right: 100%;
            border-radius: 4px 0 0 4px;
        }
    `), nC = ({ children: e }) => /*#__PURE__*/ N(B, {
	gap: "9px",
	alignCenter: !0,
	children: [/*#__PURE__*/ M(G, {
		color: t.error.main,
		Component: Qe
	}), /*#__PURE__*/ M(V, {
		size: i.body.medium,
		color: t.error.main,
		children: e
	})]
});
nC.displayName = "Form.ValidationError";
//#endregion
//#region src/organisms/Form/Form.tsx
var X = ({ children: e, onSubmit: t, ...n }) => {
	let r = (e) => {
		e.preventDefault(), t && t();
	};
	return /*#__PURE__*/ M("form", {
		...n,
		onSubmit: r,
		children: e
	});
};
X.displayName = "Form", X.Actions = RS, X.Column = US, X.Columns = GS, X.Control = KS, X.InlineControl = qS, X.Row = eC, X.ValidationError = nC;
//#endregion
//#region src/organisms/AccountantPortalSearchFilter/FilterCheckboxes/FilterCheckboxes.tsx
var rC = ({ name: e, values: t, applyFilter: n, removeFilter: r, closeDropdown: i, applyButtonLabel: a = "Apply", removeButtonLabel: o = "Remove" }) => {
	let [s, c] = E({});
	x(() => {
		let e = {};
		t.filter((e) => e.checked).forEach(({ value: t, checked: n }) => {
			e[t] = n;
		}), c(e);
	}, [t]);
	let l = () => {
		let t = Object.keys(s).filter((e) => s[e]);
		n({ [e]: t }), i && i();
	}, u = ({ value: e, checked: t }) => {
		c({
			...s,
			[e]: t
		});
	};
	return /*#__PURE__*/ M(X, {
		onSubmit: l,
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "18px",
			children: [/*#__PURE__*/ M(B, {
				column: !0,
				gap: "6px",
				children: t.map(({ label: t, value: n }) => /*#__PURE__*/ M(H, { children: /*#__PURE__*/ M(W_, {
					isSmall: !0,
					name: e,
					value: n,
					label: t,
					checked: s[n] || !1,
					onChange: u
				}) }, t + n))
			}), /*#__PURE__*/ N(B, {
				gap: "6px",
				children: [/*#__PURE__*/ M(W, {
					type: "submit",
					size: "small",
					children: a
				}), /*#__PURE__*/ M(W, {
					color: "error",
					size: "small",
					onClick: r,
					children: o
				})]
			})]
		})
	});
}, iC = ({ dateFromName: e, dateToName: t, dateFrom: n, dateTo: r, applyFilter: i, removeFilter: a, closeDropdown: o, locale: s = D.GB, applyButtonLabel: c = "Apply", removeButtonLabel: l = "Remove" }) => {
	let [u, d] = E(""), [f, p] = E("");
	x(() => {
		d(n), p(r);
	}, [n, r]);
	let m = () => {
		i({
			[e]: String(u),
			[t]: String(f)
		}), o && o();
	}, h = (e, t) => {
		if (e) {
			let n = ee(e, "YYYY-MM-DD");
			t === "from" && d(n), t === "to" && p(n);
		}
	};
	return /*#__PURE__*/ M(X, {
		onSubmit: m,
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "18px",
			children: [/*#__PURE__*/ N(B, {
				column: !0,
				gap: "6px",
				children: [/*#__PURE__*/ M(mx, {
					locale: s,
					name: "dateFrom",
					value: u,
					onChange: ({ value: e }) => h(e, "from")
				}), /*#__PURE__*/ M(mx, {
					locale: s,
					name: "dateTo",
					value: f,
					onChange: ({ value: e }) => h(e, "to")
				})]
			}), /*#__PURE__*/ N(B, {
				gap: "6px",
				children: [/*#__PURE__*/ M(W, {
					type: "submit",
					size: "small",
					children: c
				}), /*#__PURE__*/ M(W, {
					color: "error",
					size: "small",
					onClick: a,
					children: l
				})]
			})]
		})
	});
}, aC = ({ name: e, value: t, applyFilter: n, removeFilter: r, closeDropdown: i, applyButtonLabel: a = "Apply", removeButtonLabel: o = "Remove" }) => {
	let [s, c] = E(t);
	return x(() => {
		c(t);
	}, [t]), /*#__PURE__*/ M(X, {
		onSubmit: () => {
			n({ [e]: s }), i && i();
		},
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "18px",
			children: [/*#__PURE__*/ M(Iv, {
				autoFocus: !0,
				name: e,
				value: s,
				onChange: ({ value: e }) => {
					c(e);
				}
			}), /*#__PURE__*/ N(B, {
				gap: "6px",
				children: [/*#__PURE__*/ M(W, {
					type: "submit",
					size: "small",
					children: a
				}), /*#__PURE__*/ M(W, {
					color: "error",
					size: "small",
					onClick: r,
					children: o
				})]
			})]
		})
	});
}, oC = ({ values: e, applyFilter: t, removeFilter: n, closeDropdown: r, applyButtonLabel: i = "Apply", removeButtonLabel: a = "Remove" }) => {
	let [o, s] = E([]);
	x(() => {
		s(e);
	}, [e]);
	let c = () => {
		let e = {};
		o.forEach(({ name: t, value: n }) => {
			e[t] = n;
		}), t(e), r && r();
	}, l = ({ name: e, value: t }) => {
		let n = [...o], r = n.findIndex((t) => t.name === e), i = t;
		r > -1 && (n[r].value = i, s(n));
	};
	return /*#__PURE__*/ M(X, {
		onSubmit: c,
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "18px",
			children: [/*#__PURE__*/ M(B, {
				column: !0,
				gap: "6px",
				children: e.map(({ name: e, label: t }, n) => /*#__PURE__*/ M(H, { children: /*#__PURE__*/ M(Iv, {
					name: e,
					autoFocus: n === 0,
					value: o.find((t) => t.name === e)?.value || "",
					onChange: l,
					placeholder: t
				}) }, e))
			}), /*#__PURE__*/ N(B, {
				gap: "6px",
				children: [/*#__PURE__*/ M(W, {
					type: "submit",
					size: "small",
					children: i
				}), /*#__PURE__*/ M(W, {
					color: "error",
					size: "small",
					onClick: n,
					children: a
				})]
			})]
		})
	});
}, sC = ({ name: e, values: t, applyFilter: n, removeFilter: r, closeDropdown: i, applyButtonLabel: a = "Apply", removeButtonLabel: o = "Remove" }) => {
	let [s, c] = E(null);
	x(() => {
		let e = t.find((e) => e.checked)?.value ?? null;
		c(String(e));
	}, [t]);
	let l = () => {
		n({ [e]: te(s) }), i && i();
	}, u = ({ value: e }) => {
		c(e);
	};
	return /*#__PURE__*/ M(X, {
		onSubmit: l,
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "18px",
			children: [/*#__PURE__*/ M(cC, { children: /*#__PURE__*/ M(B, {
				column: !0,
				gap: "6px",
				children: t.map(({ label: t, value: n }) => /*#__PURE__*/ M(H, { children: /*#__PURE__*/ M(_y, {
					isSmall: !0,
					name: e,
					value: String(n),
					label: t,
					checked: String(n) === s,
					onChange: u
				}) }, t + n))
			}) }), /*#__PURE__*/ N(B, {
				gap: "6px",
				children: [/*#__PURE__*/ M(W, {
					type: "submit",
					size: "small",
					children: a
				}), /*#__PURE__*/ M(W, {
					color: "error",
					size: "small",
					onClick: r,
					children: o
				})]
			})]
		})
	});
}, cC = P.div.withConfig({
	displayName: "FilterRadios__OverflowContainer",
	componentId: "sc-b7b61ff6-0"
})(["max-height:320px;overflow-y:auto;"]), lC = ({ children: e, label: n, activeValues: r, removeFilter: a, isNeutral: o, isOpenByDefault: s }) => {
	let [c, u, d] = ce(s), f = (e) => {
		e instanceof MouseEvent && !ne(e.pageX) && d();
	}, h = T(null);
	return ie(h, f), /*#__PURE__*/ N(fC, { children: [
		/*#__PURE__*/ N(dC, {
			onClick: u,
			onKeyDown: O(u),
			role: "button",
			tabIndex: 0,
			children: [/*#__PURE__*/ M(H, {
				marginBottom: "9px",
				children: /*#__PURE__*/ M(V, {
					size: i.body.medium,
					lineHeight: 1,
					weight: i.weight.medium,
					children: n
				})
			}), /*#__PURE__*/ M(pC, { children: r.map((e) => e ? /*#__PURE__*/ M($_, {
				size: "small",
				background: o ? l.surface.neutral : t.primary.primaryAction,
				color: o ? l.text.base : t.primary.contrast,
				children: e
			}, e) : null) })]
		}),
		/*#__PURE__*/ M(mC, {
			ref: h,
			children: c && /*#__PURE__*/ M(IS, { children: p.map(e, (e) => /*#__PURE__*/ m(e, { closeDropdown: d })) })
		}),
		a && /*#__PURE__*/ M(uC, {
			onClick: a,
			onKeyDown: O(a),
			role: "button",
			tabIndex: 0,
			children: "✕"
		})
	] });
};
lC.Checkboxes = rC, lC.Radios = sC, lC.DateRange = iC, lC.Input = aC, lC.Inputs = oC, lC.Dropdown = IS;
var uC = P.div.withConfig({
	displayName: "AccountantPortalSearchFilter__Remove",
	componentId: "sc-c8a03f6a-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";display:none;align-items:center;justify-content:center;position:absolute;top:0;right:0;z-index:2000;width:24px;height:24px;cursor:pointer;",
	"{&:hover{color:",
	";}}"
], l.text.base, i.body.small, i.weight.medium, R.pointer, l.text.alert), dC = P.div.withConfig({
	displayName: "AccountantPortalSearchFilter__Container",
	componentId: "sc-c8a03f6a-1"
})([
	"padding:12px 24px 12px 12px;border-radius:",
	";border:1px solid ",
	";cursor:pointer;"
], I.medium, l.line.neutralSoft), fC = P.div.withConfig({
	displayName: "AccountantPortalSearchFilter__Wrapper",
	componentId: "sc-c8a03f6a-2"
})([
	"margin-right:6px;position:relative;",
	"{&:hover{",
	"{display:flex;}",
	"{border-color:",
	";}}}"
], R.pointer, uC, dC, l.line.neutral), pC = P.div.withConfig({
	displayName: "AccountantPortalSearchFilter__Values",
	componentId: "sc-c8a03f6a-3"
})(["display:flex;gap:3px;flex-wrap:wrap;max-width:240px;"]), mC = P.div.withConfig({
	displayName: "AccountantPortalSearchFilter__DropdownContainer",
	componentId: "sc-c8a03f6a-4"
})(["position:relative;top:-12px;left:12px;"]), hC = P.div.withConfig({
	displayName: "Content",
	componentId: "sc-4eea57e2-0"
})(["background:", ";"], l.surface.base), gC = P.div.withConfig({
	displayName: "Header",
	componentId: "sc-c3259759-0"
})(["display:flex;align-items:center;justify-content:space-between;position:sticky;top:var(--alert-banner-height,0);z-index:1000;width:100%;height:60px;padding:0 24px;background:", ";"], l.surface.base), _C = P.div.withConfig({
	displayName: "HeaderGroup",
	componentId: "sc-c10e4a17-0"
})([
	"display:flex;align-items:center;gap:12px;",
	" ",
	"{gap:24px;height:100%;",
	" ",
	"}"
], ({ isDesktopOnly: e }) => e && "\n            display: none;\n        ", R.tablet, ({ isMobileOnly: e }) => e && "\n            display: none;\n        ", ({ isDesktopOnly: e }) => e && "\n            display: flex;\n        "), vC = ({ href: e }) => /*#__PURE__*/ M(yC, {
	"data-pw": "header-logo",
	children: e ? /*#__PURE__*/ M(Se, {
		"aria-label": "Taxfix logo",
		to: e,
		children: /*#__PURE__*/ M(Kv, {})
	}) : /*#__PURE__*/ M(Kv, {})
}), yC = P.div.withConfig({
	displayName: "Logo__Container",
	componentId: "sc-ff5c192d-0"
})(["display:flex;align-items:center;width:84px;height:60px;", "{width:108px;}"], R.tablet), bC = P.div.withConfig({
	displayName: "Main",
	componentId: "sc-fa03ddec-0"
})([""]), xC = ({ items: e }) => /*#__PURE__*/ M(SC, { children: e.filter(({ shouldHide: e }) => !e).map(({ badge: e, path: t, title: n, url: r }) => r ? /*#__PURE__*/ M(wC, {
	href: r,
	target: "_blank",
	rel: "noreferrer noopener",
	children: n
}, r) : /*#__PURE__*/ N(CC, {
	to: t || "",
	children: [n, !!e && /*#__PURE__*/ M(TC, { children: /*#__PURE__*/ M(EC, { children: e }) })]
}, t)) }), SC = P.div.withConfig({
	displayName: "MainMenu__Container",
	componentId: "sc-2b278c11-0"
})(["display:flex;gap:24px;justify-content:center;height:42px;", "{gap:36px;position:fixed;top:var(--alert-banner-height,0);left:50%;z-index:1001;height:60px;transform:translateX(-50%);}"], R.tablet), CC = P(Ce).withConfig({
	displayName: "MainMenu__Item",
	componentId: "sc-2b278c11-1"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:flex;align-items:center;position:relative;border-bottom:1px solid transparent;&.active{border-bottom:1px solid ",
	";}",
	"{&:hover{color:",
	";}}"
], l.text.base, i.body.medium, i.weight.medium, l.line.base, R.pointer, l.text.interactive), wC = P.a.withConfig({
	displayName: "MainMenu__ItemExternal",
	componentId: "sc-2b278c11-2"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:flex;align-items:center;border-bottom:1px solid transparent;",
	"{opacity:0.75;}"
], l.text.interactive, i.body.medium, i.weight.medium, R.pointer), TC = P.div.withConfig({
	displayName: "MainMenu__ItemBadgeContainer",
	componentId: "sc-2b278c11-3"
})(["white-space:nowrap;position:absolute;top:3px;right:-12px;z-index:1;", "{top:11px;right:-12px;}"], R.tablet), EC = P.div.withConfig({
	displayName: "MainMenu__ItemBadge",
	componentId: "sc-2b278c11-4"
})([
	"color:",
	";font-size:10px;font-weight:",
	";display:inline-flex;align-items:center;justify-content:space-around;height:15px;min-width:15px;padding:0 3px;background:",
	";border-radius:",
	";"
], t.primary.contrast, i.weight.normal, t.primary.primaryAction, I.full), DC = fe([
	"0%{background-color:",
	";}50%{background-color:",
	";}100%{background-color:",
	";}"
], l.surface.noteStrong, k(l.surface.noteStrong, .3), l.surface.noteStrong), OC = P(Se).withConfig({
	displayName: "MessagesLink",
	componentId: "sc-4c14ab0e-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;align-self:center;padding:4px 6px;background:",
	";border-radius:",
	";animation-duration:3s;animation-iteration-count:infinite;animation-name:",
	";"
], l.text.base, i.body.medium, i.weight.medium, l.surface.noteStrong, I.medium, DC), kC = fe(["50%{opacity:0.3;}"]), AC = P(Se).withConfig({
	displayName: "ReferralLink__CustomLink",
	componentId: "sc-6640af54-0"
})([
	"position:relative;color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;padding:4px 6px;border-radius:",
	";"
], l.text.base, i.body.medium, i.weight.medium, I.medium), jC = P.div.withConfig({
	displayName: "ReferralLink__BackgroundPulse",
	componentId: "sc-6640af54-1"
})([
	"position:absolute;z-index:1;top:0;left:0;right:0;bottom:0;border-radius:",
	";background:",
	";opacity:1;animation-duration:3s;animation-iteration-count:infinite;animation-name:",
	";"
], I.medium, l.surface.accent, kC), MC = P.span.withConfig({
	displayName: "ReferralLink__TextContainer",
	componentId: "sc-6640af54-2"
})(["position:relative;z-index:2;"]), NC = (e) => /*#__PURE__*/ N(AC, {
	to: e.to,
	onClick: e.onClick,
	children: [/*#__PURE__*/ M(jC, {}), /*#__PURE__*/ M(MC, { children: e.children })]
}), PC = ({ title: e, items: t }) => {
	let { push: n } = we(), r = qe(), i = w(() => t.filter(({ shouldHide: e }) => !e).map(({ title: e, path: t, onClick: r }) => ({
		title: e,
		onClick: () => {
			n(t), r && r();
		}
	})), [t, n]);
	return /*#__PURE__*/ M(fv, {
		alignRight: !0,
		actions: i,
		"data-pw": "header-usermenu",
		children: r ? /*#__PURE__*/ M(FC, { children: e }) : null
	});
}, FC = le.div.withConfig({
	displayName: "UserMenu__OverflowWrapper",
	componentId: "sc-2e6d1bdb-0"
})(["", "{max-width:120px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"], R.tablet), Z = ({ children: e }) => /*#__PURE__*/ M(z, { children: e });
Z.Content = hC, Z.Header = gC, Z.HeaderGroup = _C, Z.Logo = vC, Z.Main = bC, Z.MainMenu = xC, Z.UserMenu = PC, Z.MessagesLink = OC, Z.ReferralLink = NC;
//#endregion
//#region src/organisms/ContactWidget/InlineAction/InlineAction.tsx
var IC = P.button.withConfig({
	displayName: "InlineAction",
	componentId: "sc-615dfab0-0"
})([
	"display:block;color:",
	";text-decoration:underline;font-weight:",
	";word-break:break-all;font-size:",
	";line-height:",
	";",
	"{&:hover{color:",
	";text-decoration:none;}}"
], l.text.interactive, i.weight.medium, `${e.typography.bodySmall.fontSize.xs}px`, `${e.typography.bodySmall.lineHeight.xs}px`, R.pointer, l.text.base), LC = P.div.withConfig({
	displayName: "Line",
	componentId: "sc-3c18d96a-0"
})([
	"color:",
	";font-weight:",
	";font-size:",
	";line-height:",
	";display:block;&:not(:last-child){margin-right:3px;",
	"{margin:0 0 6px 0;}}"
], t.text.primary, e.typography.bodySmall.fontWeight, `${e.typography.bodySmall.fontSize.xs}px`, `${e.typography.bodySmall.lineHeight.xs}px`, R.tablet), RC = ({ action: e, actionLabel: t, actionSlot: n, children: r, hasBackground: i = !1, imageSrc: a }) => {
	let o = {
		isMobileFullWidth: !n,
		onClick: e
	};
	return /*#__PURE__*/ M(z, {
		background: i ? l.surface.highlight : void 0,
		border: i ? void 0 : `1px solid ${l.line.neutralSoft}`,
		radius: I.large,
		padding: "18px",
		tabletPadding: "24px 36px",
		children: /*#__PURE__*/ N(B, {
			column: !0,
			tabletRow: !0,
			gap: "12px",
			tabletGap: "30px",
			tabletAlignCenter: !0,
			spaceBetween: !0,
			children: [/*#__PURE__*/ N(B, {
				gap: "12px",
				tabletGap: "30px",
				tabletAlignCenter: !0,
				justifyStart: !0,
				children: [/*#__PURE__*/ M(H, {
					width: "36px",
					tabletWidth: "72px",
					children: /*#__PURE__*/ M(y_, {
						src: a,
						width: "36px",
						tabletWidth: "72px"
					})
				}), /*#__PURE__*/ M(H, { children: r })]
			}), (!!e || !!n) && /*#__PURE__*/ N(B, {
				gap: "12px",
				tabletGap: "30px",
				alignCenter: !0,
				justifyCenter: !0,
				tabletAlignCenter: !0,
				children: [!!e && /*#__PURE__*/ M(W, {
					variant: "secondary",
					...o,
					children: t
				}), n]
			})]
		})
	});
};
RC.Line = LC, RC.InlineAction = IC;
//#endregion
//#region src/organisms/CrossOver/Body/Image/Image.tsx
var zC = ({ src: e, background: t }) => /*#__PURE__*/ M(z, {
	relative: !0,
	paddingBottom: "72px",
	children: /*#__PURE__*/ M(BC, { children: /*#__PURE__*/ M(y_, {
		src: e,
		backgroundColor: t,
		width: "96px"
	}) })
});
zC.displayName = "CrossOver.Body.Image";
var BC = P.div.withConfig({
	displayName: "Image__ImageWrapper",
	componentId: "sc-4027c89e-0"
})(["top:-48px;position:absolute;"]), VC = ({ children: e }) => /*#__PURE__*/ M(qg, { children: /*#__PURE__*/ M(z, {
	padding: "0 24px",
	tabletPadding: "0",
	children: e
}) });
VC.displayName = "CrossOver.Body", VC.Image = zC;
//#endregion
//#region src/organisms/CrossOver/Overlay/Overlay.tsx
var HC = ({ children: e }) => /*#__PURE__*/ M(qg, { children: /*#__PURE__*/ M(UC, { children: e }) });
HC.displayName = "CrossOver.Overlay";
var UC = P.div.withConfig({
	displayName: "Overlay__Wrapper",
	componentId: "sc-ad7f49f-0"
})([
	"position:relative;padding:24px;box-shadow:",
	";border-radius:",
	";background:",
	";",
	"{height:calc(100% + 96px);margin:-48px 0;}"
], L.high, I.large, l.surface.base, R.tablet), WC = ({ children: e, background: t }) => /*#__PURE__*/ M(z, {
	padding: "24px 18px 18px",
	tabletPadding: "24px 48px",
	background: t || l.surface.highlight,
	radius: I.large,
	children: /*#__PURE__*/ M(Kg, {
		columns: 1,
		tabletColumns: "1fr 360px",
		gap: "24px",
		children: e
	})
});
WC.Body = VC, WC.Overlay = HC;
//#endregion
//#region src/organisms/Dialogs/Dialog/dialog-context/DialogContextProvider.ts
var GC = h(null), KC = GC.Provider, qC = ({ isOpen: e, onIsOpenChange: t } = {}) => {
	let [n, r] = E(), [i, a] = E(), o = t, s = Pe({
		open: e,
		onOpenChange: o
	}), c = s.context, l = Ne(c, { outsidePressEvent: "mousedown" }), u = Re(c), d = Ie([l, u]);
	return w(() => ({
		isOpen: e,
		setIsOpen: o,
		...d,
		...s,
		labelId: n,
		descriptionId: i,
		setLabelId: r,
		setDescriptionId: a
	}), [
		e,
		o,
		d,
		s,
		n,
		i
	]);
}, JC = ({ children: e, ...t }) => {
	let n = qC(t);
	return /*#__PURE__*/ M(KC, {
		value: n,
		children: e
	});
}, YC = () => {
	let e = b(GC);
	if (e == null) throw Error("Dialog components must be wrapped in <Dialog />");
	return e;
}, XC = /*#__PURE__*/ g(function({ children: e, asChild: t = !1 }, n) {
	let { getReferenceProps: r, setIsOpen: i } = YC(), a = () => {
		i && i(!1);
	};
	return t && /*#__PURE__*/ _(e) ? /*#__PURE__*/ m(e, r({
		ref: n,
		...e.props,
		onClick: a
	})) : /*#__PURE__*/ M("button", {
		type: "button",
		ref: n,
		onClick: a,
		children: e
	});
}), ZC = /*#__PURE__*/ g(function(e, t) {
	let { isOpen: n, context: r, ...i } = YC(), [a, o] = E(n), s = Le([i.refs.setFloating, t]);
	return x(() => {
		o(n);
	}, [n]), !n && !a ? null : /*#__PURE__*/ M(Oe, { children: /*#__PURE__*/ M(De, {
		lockScroll: !0,
		style: { zIndex: d },
		children: /*#__PURE__*/ N(QC, { children: [/*#__PURE__*/ M($C, { isVisible: a }), /*#__PURE__*/ M(Ee, {
			context: r,
			children: /*#__PURE__*/ M("div", {
				ref: s,
				"aria-labelledby": i.labelId,
				"aria-describedby": i.descriptionId,
				...i.getFloatingProps(e),
				children: /*#__PURE__*/ M(ew, {
					isVisible: a,
					children: e.children
				})
			})
		})] })
	}) });
}), QC = P.div.withConfig({
	displayName: "DialogContent__DialogWrapper",
	componentId: "sc-9ae1f4f6-0"
})(["display:grid;place-items:center;height:100%;"]), $C = P.div.withConfig({
	displayName: "DialogContent__DialogOverlayBackground",
	componentId: "sc-9ae1f4f6-1"
})([
	"position:fixed;left:0;top:0;right:0;bottom:0;background:",
	";opacity:",
	";transition:opacity 0.15s;"
], l.surface.neutral, ({ isVisible: e }) => e ? .9 : 0), ew = P.div.withConfig({
	displayName: "DialogContent__DialogContainer",
	componentId: "sc-9ae1f4f6-2"
})([
	"background:",
	";border-radius:",
	";box-shadow:",
	";margin:0 9px;padding:18px;opacity:",
	";transform:",
	";transition:opacity 0.15s,transform 0.15s;",
	"{width:384px;margin:0;padding:30px 36px;}"
], l.surface.base, I.large, L.high, ({ isVisible: e }) => +!!e, ({ isVisible: e }) => e ? "scale(1)" : "scale(0.9)", R.tablet), tw = /*#__PURE__*/ g(function({ children: e, asChild: t = !1 }, n) {
	let { setDescriptionId: r, getReferenceProps: i } = YC(), a = Fe();
	return C(() => (r(a), () => r(void 0)), [a, r]), t && /*#__PURE__*/ _(e) ? /*#__PURE__*/ m(e, i({
		ref: n,
		...e.props
	})) : /*#__PURE__*/ M("p", {
		ref: n,
		id: a,
		children: e
	});
}), nw = /*#__PURE__*/ g(function({ children: e, asChild: t = !1 }, n) {
	let { setLabelId: r, getReferenceProps: i } = YC(), a = Fe();
	return C(() => (r(a), () => r(void 0)), [a, r]), t && /*#__PURE__*/ _(e) ? /*#__PURE__*/ m(e, i({
		ref: n,
		...e.props
	})) : /*#__PURE__*/ M("h2", {
		ref: n,
		id: a,
		children: e
	});
}), rw = ({ children: e, isOpen: t, onIsOpenChange: n, labelClose: r = "Close" }) => /*#__PURE__*/ M(JC, {
	isOpen: t,
	onIsOpenChange: n,
	children: /*#__PURE__*/ M(ZC, { children: /*#__PURE__*/ M("div", {
		style: { textAlign: "center" },
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "24px",
			tabletGap: "36px",
			children: [/*#__PURE__*/ M(B, {
				column: !0,
				gap: "12px",
				tabletGap: "18px",
				children: e
			}), /*#__PURE__*/ M(XC, {
				asChild: !0,
				children: /*#__PURE__*/ M(W, {
					size: "large",
					variant: "tertiary",
					children: r
				})
			})]
		})
	}) })
});
rw.Heading = ({ children: e }) => /*#__PURE__*/ M(nw, {
	asChild: !0,
	children: /*#__PURE__*/ M(Jg, {
		as: "h2",
		color: l.text.affirm,
		children: e
	})
}), rw.Description = ({ children: e }) => /*#__PURE__*/ M(tw, {
	asChild: !0,
	children: /*#__PURE__*/ M(V, {
		as: "p",
		children: e
	})
}), rw.Body = P.div.withConfig({
	displayName: "DialogAffirm__Body",
	componentId: "sc-7f8d7ad1-0"
})([""]);
//#endregion
//#region src/organisms/Dialogs/DialogConfirm.tsx
var iw = ({ children: e, isLoading: t, isOpen: n, labelCancel: r = "Cancel", labelConfirm: i = "Confirm", onConfirm: a, onIsOpenChange: o, variant: s = "default" }) => /*#__PURE__*/ M(JC, {
	isOpen: n,
	onIsOpenChange: o,
	children: /*#__PURE__*/ M(ZC, { children: /*#__PURE__*/ M("div", {
		style: { textAlign: "center" },
		children: /*#__PURE__*/ N(B, {
			column: !0,
			gap: "24px",
			tabletGap: "36px",
			children: [/*#__PURE__*/ M(B, {
				column: !0,
				gap: "12px",
				tabletGap: "18px",
				children: e
			}), /*#__PURE__*/ N(B, {
				gap: "12px",
				children: [/*#__PURE__*/ M(XC, {
					asChild: !0,
					children: /*#__PURE__*/ M(W, {
						size: "large",
						variant: "secondary",
						isFullWidth: !0,
						disabled: t,
						children: r
					})
				}), /*#__PURE__*/ M(W, {
					onClick: a,
					size: "large",
					variant: "secondary",
					color: s === "danger" ? "error" : "primary",
					isFullWidth: !0,
					isLoading: t,
					children: i
				})]
			})]
		})
	}) })
});
iw.Heading = ({ children: e }) => /*#__PURE__*/ M(nw, {
	asChild: !0,
	children: /*#__PURE__*/ M(Jg, {
		as: "h2",
		children: e
	})
}), iw.Description = ({ children: e }) => /*#__PURE__*/ M(tw, {
	asChild: !0,
	children: /*#__PURE__*/ M(V, {
		as: "p",
		children: e
	})
}), iw.Body = P.div.withConfig({
	displayName: "DialogConfirm__Body",
	componentId: "sc-ee386755-0"
})([""]);
//#endregion
//#region src/organisms/Dialogs/DialogInfo.tsx
var aw = ({ children: e, isOpen: t, onIsOpenChange: n, labelClose: r = "Close" }) => /*#__PURE__*/ M(JC, {
	isOpen: t,
	onIsOpenChange: n,
	children: /*#__PURE__*/ M(ZC, { children: /*#__PURE__*/ N(B, {
		column: !0,
		gap: "24px",
		tabletGap: "36px",
		children: [/*#__PURE__*/ M(B, {
			column: !0,
			gap: "12px",
			tabletGap: "18px",
			children: e
		}), /*#__PURE__*/ M(XC, {
			asChild: !0,
			children: /*#__PURE__*/ M(W, {
				size: "large",
				children: r
			})
		})]
	}) })
});
aw.Heading = ({ children: e }) => /*#__PURE__*/ M(nw, {
	asChild: !0,
	children: /*#__PURE__*/ M(Jg, {
		as: "h2",
		children: e
	})
}), aw.Body = P.div.withConfig({
	displayName: "DialogInfo__Body",
	componentId: "sc-6fae54a5-0"
})([""]);
//#endregion
//#region src/organisms/Folder/Content/Empty/Empty.tsx
var ow = ({ children: e = /*#__PURE__*/ M(j, { children: "No files uploaded" }) }) => /*#__PURE__*/ M(H, {
	margin: "9px 0 0",
	children: /*#__PURE__*/ M(B, {
		justifyCenter: !0,
		children: /*#__PURE__*/ M(V, {
			size: i.body.medium,
			color: l.text.neutral,
			children: e
		})
	})
});
ow.displayName = "Folder.Content.Empty";
//#endregion
//#region src/organisms/Folder/Content/List/Header/Header.tsx
var sw = ({ columns: e, columnItems: t }) => Ke() ? /*#__PURE__*/ M(Kg, {
	columns: e,
	alignCenter: !0,
	gap: "18px",
	children: t.map((e, t) => e === "" ? /*#__PURE__*/ M(qg, {}, `${t}_${e}`) : /*#__PURE__*/ M(qg, { children: /*#__PURE__*/ M(V, {
		size: i.body.small,
		color: l.text.neutral,
		children: e
	}) }, `${t}_${e}`))
}) : null;
sw.displayName = "Folder.Content.List.Header";
//#endregion
//#region src/organisms/Folder/Content/List/Item/Item.tsx
var cw = ({ children: e, columns: t, tabletColumns: n, desktopColumns: r }) => /*#__PURE__*/ M(Kg, {
	columns: t,
	tabletColumns: n || void 0,
	desktopColumns: r || void 0,
	alignCenter: !0,
	tabletGap: "18px",
	gap: "6px",
	children: e
});
cw.displayName = "Folder.Content.List.Item";
//#endregion
//#region src/organisms/Folder/Content/List/List.tsx
var lw = ({ children: e }) => /*#__PURE__*/ M(B, {
	column: !0,
	gap: "9px",
	justifyCenter: !0,
	children: e
});
lw.displayName = "Folder.Content.List", lw.Header = sw, lw.Item = cw;
//#endregion
//#region src/organisms/Folder/Content/Content.tsx
var uw = ({ children: e }) => /*#__PURE__*/ M(z, {
	padding: "15px 0",
	children: e
});
uw.displayName = "Folder.Content", uw.Empty = ow, uw.List = lw;
//#endregion
//#region src/organisms/Folder/Header/Title/Title.tsx
var dw = ({ children: e, fileCount: t }) => /*#__PURE__*/ N(B, {
	gap: "9px",
	children: [/*#__PURE__*/ M(V, {
		size: i.body.medium,
		children: e
	}), t !== void 0 && /*#__PURE__*/ M(S_, {
		background: l.surface.neutral,
		color: l.text.base,
		children: t
	})]
});
dw.displayName = "Folder.Header.Title";
//#endregion
//#region src/organisms/Folder/Header/Header.tsx
var fw = ({ children: e, isCompact: t }) => /*#__PURE__*/ M(pw, {
	isCompact: t,
	children: /*#__PURE__*/ M(B, {
		alignCenter: !0,
		spaceBetween: !0,
		children: e
	})
});
fw.displayName = "Folder.Header", fw.Title = dw;
var pw = P.div.withConfig({
	displayName: "Header__Container",
	componentId: "sc-a53ac1dd-0"
})([
	"padding-bottom:",
	";border-bottom:",
	";"
], ({ isCompact: e }) => e ? "0" : "15px", ({ isCompact: e }) => e ? "none" : `1px solid ${l.line.neutralSoft}`), mw = ({ children: e }) => /*#__PURE__*/ M(z, {
	padding: "15px 24px",
	background: l.surface.base,
	radius: I.large,
	border: `1px solid ${l.line.neutralSoft}`,
	children: e
});
mw.Header = fw, mw.Content = uw;
//#endregion
//#region src/organisms/List/list-context.ts
var hw = h({}), gw = (e) => e.replaceAll("\\", "\\\\").replaceAll("\"", String.raw`\"`).replaceAll(/\r\n|\r|\n/g, String.raw`\A `).replaceAll("\f", String.raw`\C `), _w = (e, t = "→") => e ? "content: counter(steps);" : `content: "${gw(t)}";`, vw = ({ children: e, background: n, bulletColor: r, isOutlined: i, icon: a }) => {
	let { itemsBackground: o, itemsMargin: s, itemsIcon: c, isNumbered: l } = b(hw), u = Ug(a ?? c ?? (l ? void 0 : "→"), r ?? t.text.primary), d = typeof u == "string", f = n || o;
	return /*#__PURE__*/ N(bw, {
		isOutlined: i,
		icon: d ? u : void 0,
		hasNodeIcon: !d && !!u,
		background: f,
		margin: s,
		isNumbered: l,
		bulletColor: r,
		children: [!d && u && /*#__PURE__*/ M(xw, {
			isOutlined: i,
			background: f,
			"aria-hidden": "true",
			children: u
		}), e]
	});
};
vw.displayName = "List.Item";
var yw = de([
	"font-size:",
	";line-height:24px;display:flex;align-items:center;justify-content:center;position:absolute;top:-2px;left:0;width:24px;height:24px;border-radius:",
	";",
	" ",
	""
], i.body.medium, I.full, ({ isOutlined: e }) => e && `
        border: 2px solid ${t.neutral.main};
        font-weight: ${i.weight.bold};
    `, ({ background: e }) => e && `
        background-color: ${e};
    `), bw = P.li.withConfig({
	displayName: "Item__Container",
	componentId: "sc-63307c6b-0"
})([
	"position:relative;padding-left:",
	";counter-increment:steps;",
	" &:not(:last-child){margin-bottom:",
	";}"
], ({ background: e, isOutlined: t }) => e || t ? "36px" : "24px", ({ hasNodeIcon: e }) => !e && de([
	"&:before{color:",
	";",
	" ",
	"}"
], ({ bulletColor: e }) => e || "inherit", yw, ({ isNumbered: e, icon: t }) => _w(e, t)), ({ margin: e }) => e || "12px"), xw = P.span.withConfig({
	displayName: "Item__NodeIcon",
	componentId: "sc-63307c6b-1"
})(["", ""], yw), Sw = ({ children: e, size: t, tabletSize: n, lineHeight: r, isNumbered: i, ...a }) => /*#__PURE__*/ M(hw.Provider, {
	value: {
		...a,
		isNumbered: i
	},
	children: /*#__PURE__*/ M(Cw, {
		as: i ? "ol" : "ul",
		isNumbered: i,
		lineHeight: r,
		size: t,
		tabletSize: n,
		children: e
	})
});
Sw.Item = vw;
var Cw = P.ul.withConfig({
	displayName: "List__Container",
	componentId: "sc-a163797f-0"
})([
	"color:",
	";font-weight:",
	";font-size:",
	";line-height:",
	";list-style:none;margin:0;padding:0;",
	""
], t.text.primary, e.typography.body.fontWeight, `${e.typography.body.fontSize.xs}px`, `${e.typography.body.lineHeight.xs}px`, ({ isNumbered: e }) => e && "counter-reset: steps;"), ww = ({ background: e, children: t }) => /*#__PURE__*/ M(Tw, {
	background: e,
	children: t
}), Tw = P.div.withConfig({
	displayName: "Body__Container",
	componentId: "sc-a7c78225-0"
})([
	"text-align:left;padding:18px;background-color:",
	";border-radius:",
	";",
	"{padding:24px 30px;}"
], ({ background: e }) => e || l.surface.neutral, I.medium, R.tablet), Ew = ({ text: e, labelText: t = "", labelBackground: n = l.surface.neutral, hasImage: r, alignLeft: i }) => /*#__PURE__*/ N(Dw, {
	hasImage: r,
	alignLeft: i,
	children: [/*#__PURE__*/ M(Ow, {
		hasImage: r,
		children: e
	}), t && /*#__PURE__*/ M(Ow, { children: /*#__PURE__*/ M(Wv, {
		background: n,
		children: t
	}) })]
}), Dw = P.div.withConfig({
	displayName: "Header__Container",
	componentId: "sc-7307db1c-0"
})([
	"font-size:",
	";margin-bottom:6px;display:flex;flex-wrap:wrap;justify-content:space-between;",
	";",
	";",
	" ",
	"{margin-bottom:9px;font-size:",
	";}",
	"{",
	"}"
], i.body.small, ({ hasImage: e, alignLeft: t }) => e && t && "margin-left: 30px;", ({ hasImage: e, alignLeft: t }) => e && !t && "margin-right: 30px;", ({ alignLeft: e }) => !e && "flex-direction: row-reverse; ", R.tablet, i.body.medium, R.desktop, ({ hasImage: e }) => e && "margin-inline: 0;"), Ow = P.div.withConfig({
	displayName: "Header__Column",
	componentId: "sc-7307db1c-1"
})([
	"white-space:pre-wrap;align-self:center;",
	"  ",
	"{",
	"}"
], ({ hasImage: e }) => e && "line-height: 24px;", R.desktop, ({ hasImage: e }) => e && "line-height: inherit;"), kw = ({ children: e }) => /*#__PURE__*/ M(Aw, { children: e });
kw.Header = Ew, kw.Body = ww;
var Aw = P.div.withConfig({
	displayName: "Content__Container",
	componentId: "sc-da2f74b1-0"
})(["width:100%;position:relative;max-width:95%;", "{max-width:83%;}"], R.tablet), jw = ({ alt: e, src: t, withBorder: n, size: r = "24px", tabletSize: i, desktopSize: a }) => /*#__PURE__*/ M(Mw, {
	size: r,
	tabletSize: i,
	desktopSize: a,
	children: /*#__PURE__*/ M(Nw, {
		alt: e,
		src: t,
		withBorder: n
	})
}), Mw = P.div.withConfig({
	displayName: "Image__Container",
	componentId: "sc-9b30179-0"
})([
	"position:absolute;",
	" ",
	" ",
	" ",
	"{position:initial;}"
], ({ size: e }) => e && `width: ${e}; height: ${e};`, ({ tabletSize: e }) => e && c`width: ${e}; height: ${e};`, ({ desktopSize: e }) => e && u`width: ${e}; height: ${e};`, R.desktop), Nw = P.img.withConfig({
	displayName: "Image__Img",
	componentId: "sc-9b30179-1"
})([
	"border-radius:",
	";width:100%;height:100%;",
	""
], I.full, ({ withBorder: e }) => e && `border: 1px solid ${l.line.neutralSoft};`), Pw = ({ alignLeft: e, children: t }) => /*#__PURE__*/ M(Fw, {
	alignLeft: e,
	children: t
});
Pw.Content = kw, Pw.Image = jw;
var Fw = P.div.withConfig({
	displayName: "Message__Container",
	componentId: "sc-7bbe2ad-0"
})(["position:relative;margin-bottom:30px;display:flex;justify-content:", ";gap:12px;"], ({ alignLeft: e }) => e ? "flex-start" : "flex-end"), Iw = P.div.withConfig({
	displayName: "Actions",
	componentId: "sc-467d576a-0"
})([
	"",
	" padding:15px;background:",
	";border-radius:",
	";p{font-size:",
	";line-height:1.5;",
	"{font-size:",
	";}&:not(:first-child){margin-top:12px;}&:not(:last-child){margin-bottom:12px;}}"
], ({ alignCenter: e }) => e ? "text-align: center;" : "", ({ background: e }) => e || "none", I.large, i.body.small, R.tablet, i.body.medium);
Iw.displayName = "Page.Actions";
//#endregion
//#region src/organisms/Page/Heading.tsx
var Lw = P.h1.withConfig({
	displayName: "Heading",
	componentId: "sc-8af76de-0"
})([
	"font-size:",
	";font-weight:",
	";line-height:1.3;margin-bottom:6px;",
	"{font-size:",
	";margin-bottom:9px;}"
], i.title.medium, i.weight.medium, R.tablet, i.title.xlarge);
Lw.displayName = "Page.Heading";
//#endregion
//#region src/organisms/Page/Main.ts
var Rw = P.main.withConfig({
	displayName: "Main",
	componentId: "sc-5203df48-0"
})([
	"position:relative;padding:18px 18px 30px 18px;",
	"{width:100%;margin:0 auto;padding:",
	";}",
	"{max-width:768px;}"
], R.desktop, ({ withPadding: e }) => e ? "0 48px" : "0", R.desktopLarge);
Rw.displayName = "Page.Main";
//#endregion
//#region src/organisms/Page/MainColumn.ts
var zw = P.div.withConfig({
	displayName: "MainColumn",
	componentId: "sc-1a33302c-0"
})([
	"background:",
	";",
	"{flex:0 0 78%;padding:48px 0 144px;}",
	"{flex:0 0 56%;}"
], l.surface.base, R.desktop, R.desktopLarge);
zw.displayName = "Page.MainColumn";
//#endregion
//#region src/organisms/Page/PreHeading/Meta.ts
var Bw = P.div.withConfig({
	displayName: "Meta",
	componentId: "sc-32746e8c-0"
})(["margin-left:auto;"]);
Bw.displayName = "Page.PreHeading.Meta";
//#endregion
//#region src/organisms/Page/PreHeading/PreHeading.tsx
var Vw = ({ children: e }) => /*#__PURE__*/ M(Hw, { children: e });
Vw.Meta = Bw;
var Hw = P.div.withConfig({
	displayName: "PreHeading__Container",
	componentId: "sc-1fe1d52f-0"
})([
	"display:flex;color:",
	";font-size:",
	";line-height:1.5;margin-bottom:3px;"
], l.text.neutral, i.body.medium), Uw = P.div.withConfig({
	displayName: "RightColumn",
	componentId: "sc-fe0c0acf-0"
})([
	"display:none;",
	"{display:block;flex:0 0 22%;background:",
	";}"
], R.desktopLarge, ({ background: e }) => e || l.surface.neutral);
Uw.displayName = "Page.RightColumn";
//#endregion
//#region src/organisms/Page/Section/Title.ts
var Ww = P.div.withConfig({
	displayName: "Title",
	componentId: "sc-8d06f625-0"
})([
	"color:",
	";font-weight:",
	";font-size:",
	";line-height:",
	";letter-spacing:",
	";text-transform:uppercase;margin-bottom:15px;",
	"{margin-bottom:24px;}",
	"{font-size:",
	";letter-spacing:",
	";}"
], t.text.secondary, e.typography.overline.fontWeight, `${e.typography.overline.fontSize.xs}px`, `${e.typography.overline.lineHeight.xs}px`, `${e.typography.overline.letterSpacing.xs}px`, R.tablet, R.desktop, `${e.typography.overline.fontSize.lg}px`, `${e.typography.overline.letterSpacing.lg}px`);
Ww.displayName = "Page.Section.Title";
//#endregion
//#region src/organisms/Page/Section/Section.tsx
var Gw = ({ background: e, children: t, isMobileNarrowMargin: n }) => /*#__PURE__*/ M(Kw, {
	background: e,
	isMobileNarrowMargin: n,
	children: t
});
Gw.Title = Ww;
var Kw = P.div.withConfig({
	displayName: "Section__Container",
	componentId: "sc-1139da4c-0"
})([
	"margin:36px 0;border-radius:",
	";&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}",
	" ",
	" ",
	"{margin:48px 0;&:first-child{margin-top:0;}",
	"}"
], I.large, ({ background: e }) => e && `
        padding: 15px 15px 18px;
        background: ${e};
    `, ({ isMobileNarrowMargin: e }) => e && "\n        margin: 24px -15px;\n    ", R.tablet, ({ background: e }) => e && "\n            padding: 30px 36px 30px;\n        "), qw = P.div.withConfig({
	displayName: "Link",
	componentId: "sc-a6c5bcee-0"
})([
	"color:",
	";font-size:",
	";line-height:1.3;text-align:center;text-decoration:none;display:block;width:100%;padding:12px 18px;white-space:nowrap;&:focus-visible{outline:2px solid ",
	";outline-offset:-2px;}",
	"{font-size:",
	";font-weight:",
	";text-align:left;padding:18px 24px;}",
	"{&:hover{color:",
	";}}"
], l.text.base, i.body.small, l.line.interactive, R.desktop, i.body.medium, i.weight.medium, R.pointer, l.text.interactive);
qw.displayName = "Page.Sidebar.Item.Link";
//#endregion
//#region src/organisms/Page/Sidebar/Item/Item.tsx
var Jw = ({ children: e, isActive: t }) => /*#__PURE__*/ M(Yw, {
	"aria-current": t,
	isActive: t,
	children: e
});
Jw.Link = qw, Jw.displayName = "Page.Sidebar.Item";
var Yw = P.div.withConfig({
	displayName: "Item__Container",
	componentId: "sc-b65067b2-0"
})([
	"position:relative;overflow:hidden;display:inline-block;align-items:center;margin:0 2px 0 0;width:auto;background:",
	";&:last-child{margin-right:72px;}",
	"{display:block;width:100%;margin:0;background:",
	";&:last-child{margin-right:0;}}"
], ({ isActive: e }) => e ? l.surface.base : l.line.neutralLight, R.desktop, ({ isActive: e }) => e ? l.line.neutralLight : "none"), Xw = ({ ariaLabel: e, children: t }) => /*#__PURE__*/ M(Zw, {
	"aria-label": e,
	children: t
});
Xw.Item = Jw;
var Zw = P.nav.withConfig({
	displayName: "Sidebar__Container",
	componentId: "sc-7d13109a-0"
})(["overflow:auto;display:block;white-space:nowrap;font-size:0;", "{white-space:normal;flex:0 0 35%;}"], R.desktop), Qw = P.aside.withConfig({
	displayName: "SidebarColumn",
	componentId: "sc-154ab829-0"
})([
	"position:relative;background:",
	";&:after{content:'';position:absolute;top:0;right:0;height:100%;width:72px;pointer-events:none;",
	"}",
	"{flex:0 0 22%;width:22%;margin:0;padding:72px 0 192px;}"
], ({ background: e }) => e || l.surface.neutral, ({ background: e }) => !e && `
            background-image: linear-gradient(
                to right,
                ${k(l.surface.neutral, 0)},
                ${k(l.surface.neutral, 1)}
            );
        `, R.desktop);
Qw.displayName = "Page.SidebarColumn";
//#endregion
//#region src/organisms/Page/SubHeading.ts
var $w = P.div.withConfig({
	displayName: "SubHeading",
	componentId: "sc-b94cff51-0"
})([
	"font-size:",
	";line-height:1.5;margin-bottom:18px;",
	"{margin-bottom:24px;}"
], i.title.small, R.tablet);
$w.displayName = "Page.SubHeading";
//#endregion
//#region src/organisms/Page/Page.tsx
var Q = ({ children: e, isMobileWide: t, isWide: n, withSidebar: r }) => /*#__PURE__*/ M(eT, {
	isMobileWide: t,
	isWide: n,
	withSidebar: r,
	children: e
});
Q.Actions = Iw, Q.Heading = Lw, Q.Main = Rw, Q.MainColumn = zw, Q.PreHeading = Vw, Q.Section = Gw, Q.RightColumn = Uw, Q.SidebarColumn = Qw, Q.Sidebar = Xw, Q.SubHeading = $w;
var eT = P.div.withConfig({
	displayName: "Page__Container",
	componentId: "sc-fb38f3e4-0"
})([
	"padding:",
	";",
	"{width:",
	";margin:0 auto;padding:",
	";}",
	"{display:",
	";width:",
	";}",
	"{width:",
	";}"
], ({ withSidebar: e, isMobileWide: t }) => {
	switch (!0) {
		case t: return "15px 9px 144px";
		case e: return "0 0 120px";
		default: return "18px 18px 144px";
	}
}, R.tablet, ({ isWide: e, withSidebar: t }) => {
	switch (!0) {
		case t: return "100%";
		case e: return "720px";
		default: return "672px";
	}
}, ({ withSidebar: e }) => e ? "0 0 144px" : "48px 0 144px", R.desktop, ({ withSidebar: e }) => e ? "flex" : "block", ({ isWide: e, withSidebar: t }) => {
	switch (!0) {
		case t: return "100%";
		case e: return "960px";
		default: return "768px";
	}
}, R.desktopLarge, ({ isWide: e, withSidebar: t }) => {
	switch (!0) {
		case t: return "100%";
		case e: return "1152px";
		default: return "768px";
	}
}), tT = P.div.withConfig({
	displayName: "Label",
	componentId: "sc-9e8e11db-0"
})(["font-size:", ";white-space:nowrap;margin-right:12px;"], i.body.medium), nT = ({ children: e }) => /*#__PURE__*/ M(rT, { children: e });
nT.Label = tT;
var rT = P.div.withConfig({
	displayName: "Actions__Container",
	componentId: "sc-aa140b25-0"
})(["flex:0 0 auto;display:flex;align-items:center;"]), iT = P.button.withConfig({
	displayName: "Item",
	componentId: "sc-7b82bc68-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";font-weight:",
	";text-decoration:none;display:flex;align-items:center;justify-content:center;min-width:36px;padding:6px;background:",
	";border:2px solid ",
	";border-radius:",
	";cursor:pointer;&:focus{border:2px solid ",
	";outline:none;}",
	"{&:hover{border:2px solid transparent;background:",
	";}}"
], t.primary.contrast, i.body.medium, i.weight.medium, ({ isActive: e }) => e ? t.primary.primaryAction : t.grey.surface1, ({ isActive: e }) => e ? t.primary.primaryAction : t.grey.surface1, I.small, l.line.interactive, R.pointer, ({ isActive: e }) => e ? t.primary.primaryAction : t.primary.secondaryAction), aT = P.div.withConfig({
	displayName: "Items",
	componentId: "sc-27fd06fd-0"
})(["display:flex;flex-wrap:wrap;justify-content:center;gap:9px;"]), oT = P.div.withConfig({
	displayName: "Separator",
	componentId: "sc-393b0582-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:flex;align-items:center;justify-content:center;width:36px;padding:6px;"
], l.text.base, i.body.medium, i.weight.medium), sT = ({ children: e }) => /*#__PURE__*/ M(cT, { children: e });
sT.Items = aT, sT.Item = iT, sT.Separator = oT, sT.Actions = nT;
var cT = P.div.withConfig({
	displayName: "Pagination__Container",
	componentId: "sc-c30a81ff-0"
})(["font-family:inherit;display:flex;align-items:center;flex-direction:column;gap:18px;", "{flex-direction:row;gap:24px;}"], R.tablet), lT = ({ alt: e = "", src: t }) => /*#__PURE__*/ M(uT, { children: /*#__PURE__*/ M(dT, {
	alt: e,
	src: t
}) });
lT.displayName = "ProductOverview.Body.Image";
var uT = P.div.withConfig({
	displayName: "Image__ImageWrapper",
	componentId: "sc-b69bd853-0"
})(["", "{position:relative;padding-bottom:24px;margin-bottom:24px;}"], R.tablet), dT = P.img.withConfig({
	displayName: "Image__Img",
	componentId: "sc-b69bd853-1"
})(["display:block;width:100%;", "{position:absolute;top:auto;bottom:-96px;left:50%;right:auto;width:100%;margin:0 auto;transform:translateX(-50%);}"], R.tablet), fT = ({ children: e }) => /*#__PURE__*/ M(qg, { children: e });
fT.displayName = "ProductOverview.Description", fT.Image = lT;
//#endregion
//#region src/organisms/ProductOverview/Main/Main.tsx
var pT = ({ children: e }) => /*#__PURE__*/ M(qg, { children: e });
pT.displayName = "ProductOverview.Main";
//#endregion
//#region src/organisms/ProductOverview/ProductOverview.tsx
var mT = ({ children: e, background: t }) => /*#__PURE__*/ M(z, {
	background: t,
	radius: I.large,
	padding: "24px 24px 30px",
	tabletPadding: "36px 48px 42px",
	relative: !0,
	children: /*#__PURE__*/ M(Kg, {
		gap: "36px",
		tabletColumns: 2,
		tabletGap: "60px",
		children: e
	})
});
mT.Main = pT, mT.Description = fT;
//#endregion
//#region src/organisms/ProductProgress/Footer/Footer.tsx
var hT = ({ children: e }) => /*#__PURE__*/ M(z, { children: e });
hT.displayName = "ProductProgress.Footer";
//#endregion
//#region src/organisms/ProductProgress/Header/Header.tsx
var gT = ({ children: e }) => /*#__PURE__*/ M(Jg, { children: e });
gT.displayName = "ProductProgress.Header";
//#endregion
//#region src/organisms/ProductProgress/List/Item/Item.tsx
var _T = ({ status: e, isActive: t, isTablet: n, background: r }) => {
	if (n && t) return e === "completed" ? l.surface.affirm : e === "requiresAction" ? l.surface.attention : e === "active" ? l.surface.highlight : e === "pending" ? l.surface.neutral : r;
}, vT = ({ status: e, isActive: t, isTablet: n, background: r }) => n && t ? l.surface.base : e === "completed" ? l.surface.affirm : e === "requiresAction" ? l.surface.attention : e === "active" ? l.surface.highlight : e === "pending" ? l.surface.neutral : r, yT = ({ status: e, textColor: t }) => e === "pending" ? l.text.neutral : t, bT = ({ status: e, icon: t }) => e === "completed" ? "✓" : e === "active" ? "⏳" : e === "pending" ? "🕑" : t, xT = ({ actions: e, background: t, children: n, description: r, textColor: i = l.text.base, icon: a = "→", isActive: o, title: s, status: c }) => {
	let u = Ge(), d = _T({
		status: c,
		isActive: o,
		isTablet: u,
		background: t
	}), f = vT({
		status: c,
		isActive: o,
		isTablet: u,
		background: t
	}), p = yT({
		status: c,
		textColor: i
	}), m = bT({
		status: c,
		icon: a
	});
	return /*#__PURE__*/ N(z, {
		background: d,
		radius: o ? I.medium : void 0,
		tabletPadding: o ? "12px 15px" : void 0,
		children: [/*#__PURE__*/ N(B, {
			gap: "12px",
			spaceBetween: !0,
			tabletAlignCenter: !0,
			alignBaseline: !0,
			children: [/*#__PURE__*/ M(S_, {
				color: p,
				background: f,
				children: Ug(m, p ?? l.text.base)
			}), /*#__PURE__*/ M(H, {
				width: "100%",
				children: /*#__PURE__*/ N(B, {
					column: !0,
					tabletRow: !0,
					gap: "6px",
					tabletGap: "9px",
					alignStart: !0,
					justifyStart: !0,
					tabletAlignCenter: !0,
					tabletSpaceBetween: !0,
					children: [/*#__PURE__*/ M(H, {
						width: "100%",
						tabletFlex: "1",
						children: /*#__PURE__*/ N(B, {
							column: !0,
							gap: "4px",
							children: [/*#__PURE__*/ M(ST, {
								color: p,
								isLarge: o,
								children: s
							}), r && /*#__PURE__*/ M(CT, { children: r })]
						})
					}), e && /*#__PURE__*/ M(H, {
						marginTop: "12px",
						tabletMargin: "0",
						children: /*#__PURE__*/ M(B, {
							alignCenter: !0,
							gap: "12px",
							rowReverse: !0,
							tabletRow: !0,
							children: e
						})
					})]
				})
			})]
		}), n]
	});
};
xT.displayName = "ProductProgress.List.Item";
var ST = P.div.withConfig({
	displayName: "Item__Title",
	componentId: "sc-17f10b4c-0"
})([
	"color:",
	";font-size:",
	";line-height:1.3;",
	"{font-size:",
	";font-weight:",
	";}"
], ({ color: e }) => e || l.text.base, i.title.small, R.tablet, i.title.medium, ({ isLarge: e }) => e ? i.weight.medium : i.weight.normal), CT = P.div.withConfig({
	displayName: "Item__Description",
	componentId: "sc-17f10b4c-1"
})([
	"color:",
	";font-size:",
	";line-height:1.4;"
], l.text.neutral, i.body.medium), wT = ({ children: e }) => /*#__PURE__*/ M(B, {
	column: !0,
	gap: "15px",
	children: e
});
wT.Item = xT, wT.displayName = "ProductProgress.List";
//#endregion
//#region src/organisms/ProductProgress/ProductProgress.tsx
var TT = ({ children: e }) => /*#__PURE__*/ M(z, {
	padding: "18px 18px 21px",
	tabletPadding: "24px 36px 30px",
	radius: I.large,
	border: `1px solid ${l.line.neutralSoft}`,
	shadow: L.high,
	background: l.surface.base,
	children: /*#__PURE__*/ M(B, {
		column: !0,
		gap: "24px",
		children: e
	})
});
TT.Header = gT, TT.List = wT, TT.Footer = hT;
//#endregion
//#region src/organisms/ProgressBar/Item/Link.ts
var $ = P.div.withConfig({
	displayName: "Link__ProgressBarItemLink",
	componentId: "sc-8db4a036-0"
})([
	"color:",
	";font-size:",
	";font-weight:",
	";text-decoration:none;display:inline-block;margin:0 12px;padding:0;&:before{color:",
	";font-size:",
	";margin-right:6px;}",
	"{position:relative;margin:0;padding:12px 24px 12px 32px;&:before{color:",
	";display:flex;align-items:center;justify-content:center;position:absolute;top:7px;left:0;width:24px;height:24px;border-radius:12px;border:1px solid ",
	";}}"
], l.text.base, i.body.medium, i.weight.medium, l.text.base, i.body.medium, R.desktop, l.text.neutral, l.line.neutralSoft);
$.displayName = "ProgressBar.Item.Link";
var ET = {
	.../* @__PURE__ */ g(({ children: e, ...t }, n) => /*#__PURE__*/ M(DT, {
		...t,
		ref: n,
		children: e
	})),
	Link: $,
	displayName: "ProgressBar.Item"
}, DT = P.div.withConfig({
	displayName: "Item__ProgressBarItemContainer",
	componentId: "sc-a4a9f0bd-0"
})([
	"color:",
	";display:flex;align-items:center;position:relative;height:100%;padding:6px 0;",
	" ",
	" ",
	" ",
	"{text-transform:none;",
	" ",
	" &:first-child{",
	"{padding-right:0;}}& ",
	"{&:before{content:counter(progress);counter-increment:progress;}}}"
], l.text.neutral, ({ isActive: e }) => e && `
            ${$} {
                color: ${l.text.interactive};
                &:before {
                    color: ${l.text.interactive};
                }
            }
    `, ({ isDisabled: e }) => e && `
        pointer-events: none;
        display: none;
        ${R.tablet} {
            display: flex;
        }

        ${$} {
            color: ${l.text.neutral};
            pointer-events: none;

            &:before {
                color: ${l.text.neutral};
            }
        }
    `, () => `
        &:first-child {
            ${$} {
                padding-right: 0;
            }
        }

        & ${$} {
            &:before {
                content: counter(progress);
                counter-increment: progress;
            }
        }
    `, R.desktop, ({ isActive: e }) => e && `
                ${$} {
                    color: ${l.text.base};
                    &:before {
                        color: ${l.text.base};
                        background: ${l.surface.affirm};
                        border-color: ${l.surface.affirm};
                    }
                }
        `, ({ isActive: e }) => !e && `
                ${$} {
                    &:hover {
                        color: ${l.text.interactive};
                    }
                }
        `, $, $), OT = ({ children: e }) => {
	let t = T(null), n = () => {
		let { current: e } = t;
		e && setTimeout(() => e.scrollIntoView({
			behavior: "smooth",
			inline: "center",
			block: "center"
		}), 0);
	}, r = (e) => {
		e.preventDefault(), e.target && e.target.scrollIntoView({
			behavior: "smooth",
			inline: "center",
			block: "center"
		});
	};
	return x(() => {
		n();
	}, []), /*#__PURE__*/ M(AT, { children: /*#__PURE__*/ N(jT, { children: [
		/*#__PURE__*/ M(kT, { children: "\xA0" }),
		p.map(e, (e) => {
			if (!e) return null;
			let n = e, { onClick: i, isActive: a } = n.props;
			return /*#__PURE__*/ m(n, {
				ref: a ? t : null,
				onClick: cx(r, i)
			});
		}),
		/*#__PURE__*/ M(kT, { children: "\xA0" })
	] }) });
};
OT.Item = ET;
var kT = P.div.withConfig({
	displayName: "ProgressBar__Padding",
	componentId: "sc-9291708e-0"
})(["flex:0 0 50vw;width:50vw;", "{display:none;}"], R.desktop), AT = P.div.withConfig({
	displayName: "ProgressBar__ProgressBarWrapper",
	componentId: "sc-9291708e-1"
})([
	"background:",
	";position:relative;&:before,&:after{content:'';position:absolute;z-index:1;top:0;width:40%;height:100%;pointer-events:none;}&:before{left:0;background:linear-gradient(to left,",
	",",
	");}&:after{right:0;background:linear-gradient(to right,",
	",",
	");}",
	"{position:fixed;top:0;left:20%;z-index:1010;width:60%;height:60px;background:none;&:before,&:after{display:none;}}"
], l.surface.base, k(l.surface.base, 0), l.surface.base, k(l.surface.base, 0), l.surface.base, R.desktop), jT = P.div.withConfig({
	displayName: "ProgressBar__ProgressBarContainer",
	componentId: "sc-9291708e-2"
})(["display:flex;overflow-x:scroll;overflow-y:hidden;position:relative;align-items:center;justify-content:flex-start;padding:9px 0;counter-reset:progress;", "{overflow:hidden;justify-content:center;max-width:960px;height:100%;margin:0 auto;padding:0;}"], R.desktop), MT = ({ children: e, height: t }) => /*#__PURE__*/ M(NT, {
	height: t,
	children: /*#__PURE__*/ M(B, {
		column: !0,
		gap: "15px",
		children: e
	})
}), NT = P.div.withConfig({
	displayName: "Dropdown__Container",
	componentId: "sc-20f15b48-0"
})([
	"position:relative;width:100%;padding:18px 21px;background-color:",
	";box-shadow:",
	";border-radius:",
	";max-height:",
	";overflow:auto;"
], l.surface.base, L.high, I.medium, ({ height: e }) => e ? `${e}px` : "auto"), PT = h(null), FT = () => {
	let e = b(PT);
	if (e === null) throw Error("`useProgressNav` must be used within a `ProgressNavContext.Provider`");
	return e;
}, IT = ({ variant: e }) => {
	switch (e) {
		case "affirm": return l.surface.affirm;
		case "active":
		case "highlight": return l.surface.highlight;
		default: return l.surface.neutral;
	}
}, LT = ({ variant: e, color: t }) => {
	switch (!0) {
		case !!t: return t;
		case e === "active": return l.text.interactive;
		case e === "highlight": return l.text.base;
		case e === "dim": return l.text.neutral;
		default: return l.text.base;
	}
}, RT = ({ children: e, variant: t, onClick: n, withoutLine: r = !1, icon: i = Mg, color: a }) => {
	let { setIsOpen: o } = FT();
	return /*#__PURE__*/ N(HT, {
		onClick: n ? () => {
			n && (n(), o(!1));
		} : void 0,
		color: LT({
			variant: t,
			color: a
		}),
		children: [/*#__PURE__*/ N(zT, { children: [!r && /*#__PURE__*/ M(BT, { variant: t }), /*#__PURE__*/ M(VT, { children: /*#__PURE__*/ M(G, {
			Component: i,
			width: "18px",
			height: "18px",
			background: IT({ variant: t }),
			color: LT({ variant: t })
		}) })] }), /*#__PURE__*/ M(UT, { children: e })]
	});
}, zT = P.div.withConfig({
	displayName: "Item__VerticalLineContainer",
	componentId: "sc-657ecf48-0"
})(["position:absolute;top:0;left:0;width:18px;height:100%;"]), BT = P.div.withConfig({
	displayName: "Item__VerticalLine",
	componentId: "sc-657ecf48-1"
})([
	"position:absolute;display:block;top:1px;bottom:0;left:9px;width:2px;height:calc(100% - 2px);background-color:",
	";transform:translateX(-50%);border-radius:",
	";"
], IT, I.small), VT = P.div.withConfig({
	displayName: "Item__IconWrapper",
	componentId: "sc-657ecf48-2"
})(["border-radius:", ";overflow:hidden;position:absolute;top:0;left:0;"], I.full), HT = P.button.withConfig({
	displayName: "Item__Container",
	componentId: "sc-657ecf48-3"
})([
	"color:",
	";position:relative;padding:0 0 18px 36px;text-align:left;cursor:",
	";",
	" &:last-child{padding-bottom:0;",
	"{display:none;}}"
], ({ color: e }) => e || "inherit", ({ onClick: e }) => e ? "pointer" : "auto", ({ onClick: e }) => e && `
        ${R.pointer} {
            &:hover {
                color: ${l.text.interactive};
            }
        }
    `, BT), UT = P.div.withConfig({
	displayName: "Item__Label",
	componentId: "sc-657ecf48-4"
})([
	"font-size:",
	";font-weight:",
	";line-height:1.3;"
], i.body.medium, i.weight.medium), WT = ({ children: e }) => /*#__PURE__*/ M(z, {
	padding: "6px 0 24px 36px",
	children: /*#__PURE__*/ M(B, {
		column: !0,
		children: e
	})
}), GT = ({ children: e }) => /*#__PURE__*/ M(z, { children: /*#__PURE__*/ M(B, {
	column: !0,
	gap: "2px",
	children: e
}) });
GT.Item = RT, GT.Sublist = WT;
//#endregion
//#region src/organisms/ProgressNav/Title/Title.tsx
var KT = ({ children: e }) => /*#__PURE__*/ M(V, {
	color: l.text.neutral,
	size: i.title.small,
	children: e
}), qT = ({ children: e, parent: t, child: n }) => {
	let [r, i] = E(!1), [a, o] = E(null), [s, c] = E(null), { refs: l, floatingStyles: u, context: d } = Pe({
		open: r,
		onOpenChange: i,
		middleware: [je({ apply({ availableHeight: e, rects: t }) {
			xe(() => {
				o(e), c(t.reference.width);
			});
		} }), Ae({ padding: 12 })],
		whileElementsMounted: ke
	}), f = Me(d), p = Ne(d), { getReferenceProps: m, getFloatingProps: h } = Ie([f, p]), g = a && a - 24, _ = w(() => ({ setIsOpen: i }), []);
	return /*#__PURE__*/ M(PT.Provider, {
		value: _,
		children: /*#__PURE__*/ N(z, { children: [/*#__PURE__*/ M(JT, {
			ref: l.setReference,
			...m(),
			children: /*#__PURE__*/ N(B, {
				alignCenter: !0,
				spaceBetween: !0,
				children: [
					/*#__PURE__*/ N(YT, { children: [M(n ? "span" : "strong", { children: t }), n ? /*#__PURE__*/ M("strong", { children: n }) : ""] }),
					" ",
					/*#__PURE__*/ M(XT, { children: "▼" })
				]
			})
		}), r && /*#__PURE__*/ M(Ee, {
			context: d,
			modal: !1,
			children: /*#__PURE__*/ M("div", {
				ref: l.setFloating,
				style: {
					...u,
					width: s || "auto"
				},
				...h(),
				children: /*#__PURE__*/ M(MT, {
					height: g,
					children: e
				})
			})
		})] })
	});
};
qT.List = GT, qT.Title = KT;
var JT = P.button.withConfig({
	displayName: "ProgressNav__Button",
	componentId: "sc-6d20764b-0"
})([
	"border:1px solid ",
	";background-color:",
	";border-radius:",
	";box-shadow:",
	";padding:9px 18px;width:100%;strong:not(:only-child){&:before{content:'/';color:",
	";margin:0 6px;}}"
], l.line.neutralSoft, l.surface.base, I.medium, L.high, l.text.neutral), YT = P.div.withConfig({
	displayName: "ProgressNav__Label",
	componentId: "sc-6d20764b-1"
})([
	"font-size:",
	";color:",
	";strong{color:",
	";}"
], i.body.medium, l.text.neutral, l.text.base), XT = P.span.withConfig({
	displayName: "ProgressNav__Arrow",
	componentId: "sc-6d20764b-2"
})(["font-size:8px;margin-left:12px;"]), ZT = 18, QT = 30, $T = 48, eE = 60, tE = 18, nE = 36, rE = 18, iE = 30, aE = 17, oE = QT, sE = 24, cE = 2, lE = {
	Collapsed: "collapsed",
	Expanded: "expanded"
}, uE = {
	Accent: "accent",
	Affirm: "affirm",
	Attention: "attention",
	Highlight: "highlight",
	Neutral: "neutral"
}, dE = ({ variant: e, state: t }) => {
	if (t === lE.Expanded) return l.surface[e];
}, fE = ({ variant: e, state: t }) => t === lE.Expanded ? l.surface.base : l.surface[e], pE = ({ variant: e, state: t }) => t === lE.Collapsed && e === uE.Neutral ? l.text.neutral : l.text.base, mE = ({ variant: e, state: t }) => t === lE.Expanded ? dE({
	variant: e,
	state: t
}) : fE({
	variant: e,
	state: t
}), hE = ({ children: e, icon: t, variant: n = uE.Neutral, state: r = lE.Collapsed, shouldDisplayStartingVerticalLine: i, shouldDisplayEndingVerticalLine: a }) => {
	let o = dE({
		variant: n,
		state: r
	}), s = fE({
		variant: n,
		state: r
	}), c = pE({
		variant: n,
		state: r
	}), l = mE({
		variant: n,
		state: r
	});
	return /*#__PURE__*/ N(yE, {
		background: o,
		"data-state": r,
		"data-starting-vertical-line": !!i,
		"data-ending-vertical-line": !!a,
		children: [/*#__PURE__*/ N(gE, { children: [/*#__PURE__*/ M(_E, { background: l }), /*#__PURE__*/ M(vE, { children: /*#__PURE__*/ M(S_, {
			background: s,
			color: c,
			children: Ug(t ?? "→", c)
		}) })] }), e]
	});
}, gE = P.div.withConfig({
	displayName: "Item__VerticalLineContainer",
	componentId: "sc-1b20a9e2-0"
})([
	"position:absolute;top:0;left:0;width:",
	"px;height:100%;",
	"{width:",
	"px;}"
], $T, R.tablet, eE), _E = P.div.withConfig({
	displayName: "Item__VerticalLine",
	componentId: "sc-1b20a9e2-1"
})([
	"position:absolute;top:0;right:",
	"px;bottom:0;width:",
	"px;background:",
	";transform:translateX(-50%);",
	"{right:",
	"px;}"
], $T / 2 - cE, cE, ({ background: e }) => e || "none", R.tablet, eE / 2 - cE), vE = P.div.withConfig({
	displayName: "Item__BadgeContainer",
	componentId: "sc-1b20a9e2-2"
})([
	"position:absolute;top:0;left:calc(50% - ",
	"px / 2);padding-top:",
	"px;",
	"{padding-top:",
	"px;}"
], sE, aE, R.tablet, oE), yE = P.div.withConfig({
	displayName: "Item__Container",
	componentId: "sc-1b20a9e2-3"
})([
	"position:relative;padding:",
	"px ",
	"px ",
	"px ",
	"px;background:",
	";border-radius:",
	";",
	"{padding:",
	"px ",
	"px ",
	"px ",
	"px;}&[data-state='collapsed'][data-starting-vertical-line='false']:first-child{padding-top:0;",
	"{padding-top:0;}}&[data-state='collapsed'] + &[data-state='collapsed']{padding-top:0;",
	"{padding-top:0;}}&[data-state='collapsed'] + &[data-state='collapsed'][data-ending-vertical-line='false']:last-child{",
	"{height:0;}}&[data-state='collapsed'][data-ending-vertical-line='false']:last-child{padding-bottom:0;",
	"{height:50%;}}"
], ZT, tE, rE, $T, ({ background: e }) => e || "none", I.large, R.tablet, QT, nE, iE, eE, vE, vE, _E, _E), bE = ({ children: e }) => /*#__PURE__*/ M(B, {
	column: !0,
	gap: "2px",
	children: e
});
bE.Item = hE;
//#endregion
//#region src/organisms/Tabs/Item/Counter.ts
var xE = P.div.withConfig({
	displayName: "Counter",
	componentId: "sc-9547f2f6-0"
})(["display:inline-block;margin-left:6px;"]), SE = ({ children: e, isActive: t, onClick: n = void 0 }) => /*#__PURE__*/ M(CE, {
	isActive: t,
	onClick: (e) => {
		e.preventDefault(), n && n();
	},
	children: e
});
SE.Counter = xE;
var CE = P.button.withConfig({
	displayName: "Item__Container",
	componentId: "sc-e6ae86b9-0"
})([
	"color:",
	";font-family:inherit;font-size:",
	";text-decoration:none;display:inline-block;width:100%;padding:7px 12px;border-radius:",
	";background:",
	";cursor:pointer;",
	"{width:auto;flex:0 0 auto;}&:focus-visible{border:",
	";outline:none;}",
	"{&:hover{background:",
	";}}"
], t.primary.contrast, i.body.medium, I.medium, ({ isActive: e }) => e ? t.primary.primaryAction : t.grey.surface1, R.tablet, s.interactive.medium, R.pointer, ({ isActive: e }) => e ? t.primary.primaryAction : t.primary.secondaryAction), wE = ({ children: e, gap: t }) => /*#__PURE__*/ M(TE, {
	gap: t,
	children: e
});
wE.Item = SE;
var TE = P.div.withConfig({
	displayName: "Tabs__Container",
	componentId: "sc-494c4eff-0"
})([
	"",
	"{display:flex;flex-wrap:wrap;gap:",
	";}"
], R.tablet, ({ gap: e }) => e ?? "2px"), EE = ({ children: e, alignRight: t, tabletAlignRight: n }) => /*#__PURE__*/ M(DE, {
	alignRight: t,
	tabletAlignRight: n,
	children: e
}), DE = P.div.withConfig({
	displayName: "Content__Container",
	componentId: "sc-eef49055-0"
})([
	"display:flex;align-items:center;padding:6px 0;",
	" ",
	" ",
	"{width:100%;height:100%;margin:0;padding:12px 0;",
	" ",
	"}"
], ({ alignRight: e }) => e && "text-align: right;", ({ alignRight: e }) => e && "justify-content: flex-end;", R.tablet, ({ tabletAlignRight: e }) => e && "text-align: right;", ({ tabletAlignRight: e }) => e && "justify-content: flex-end;"), OE = ({ children: e, alignRight: t, to: n, Link: r, tabletAlignRight: i }) => /*#__PURE__*/ M(kE, {
	as: r,
	to: n,
	children: /*#__PURE__*/ M(AE, {
		alignRight: t,
		tabletAlignRight: i,
		children: e
	})
}), kE = P.a.withConfig({
	displayName: "ContentLink__Wrapper",
	componentId: "sc-28d00fdd-0"
})([
	"color:",
	";text-decoration:none;width:100%;height:100%;cursor:pointer;",
	"{&:hover{color:",
	";}}"
], l.text.base, R.pointer, l.text.interactive), AE = P.div.withConfig({
	displayName: "ContentLink__Container",
	componentId: "sc-28d00fdd-1"
})([
	"display:flex;align-items:center;padding:6px 0;",
	" ",
	" ",
	"{width:100%;height:100%;margin:0;padding:12px 0;",
	" ",
	"}"
], ({ alignRight: e }) => e && "text-align: right;", ({ alignRight: e }) => e && "justify-content: flex-end;", R.tablet, ({ tabletAlignRight: e }) => e && "text-align: right;", ({ tabletAlignRight: e }) => e && "justify-content: flex-end;"), jE = ({ children: e, flex: t, width: n }) => /*#__PURE__*/ M(ME, {
	flex: t,
	width: n,
	children: !!e && e
});
jE.Content = EE, jE.ContentLink = OE;
var ME = le.div.withConfig({
	displayName: "Cell__Container",
	componentId: "sc-c3999b99-0"
})(["", ""], ({ flex: e, width: t }) => de([
	"min-width:0;word-break:break-word;margin:3px 0;",
	"{flex:",
	";margin:0;}"
], R.tablet, e || `0 0 ${t || "auto"}`)), NE = ({ children: e, onClick: t }) => {
	let n = !!t;
	return /*#__PURE__*/ M(PE, {
		onClick: t,
		onKeyDown: n ? O(t) : void 0,
		role: n ? "button" : void 0,
		tabIndex: n ? 0 : void 0,
		children: e
	});
}, PE = P.div.withConfig({
	displayName: "Row__Container",
	componentId: "sc-93fc9ecd-0"
})([
	"padding:12px 0;border-top:1px solid ",
	";",
	"{position:relative;display:flex;padding:0;&:hover{background:",
	";&:before,&:after{content:'';position:absolute;top:-1px;width:18px;height:calc(100% + 2px);background:",
	";}&:before{right:100%;}&:after{left:100%;}}}",
	"{",
	"}"
], l.line.neutralSoft, R.tablet, l.surface.neutral, l.surface.neutral, R.pointer, ({ onClick: e }) => e && "cursor: pointer;"), FE = ({ children: e }) => /*#__PURE__*/ M(z, { children: e });
FE.Row = NE, FE.Cell = jE;
//#endregion
//#region src/organisms/Table/Footer/Cell/Cell.tsx
var IE = ({ width: e, alignRight: t, children: n = null, action: r, tabletAlignRight: i }) => {
	let a = (e) => {
		e.preventDefault(), r && r();
	}, o = !!r;
	return /*#__PURE__*/ M(LE, {
		width: e,
		tabletAlignRight: i,
		alignRight: t,
		isAction: o,
		onClick: o ? a : void 0,
		onKeyDown: o ? O(r) : void 0,
		role: o ? "button" : void 0,
		tabIndex: o ? 0 : void 0,
		children: n
	});
}, LE = P.div.withConfig({
	displayName: "Cell__Container",
	componentId: "sc-87c1ac2f-0"
})([
	"color:",
	";font-size:",
	";flex:0 0 ",
	";padding:12px 0;",
	" ",
	" ",
	"{",
	" ",
	"}",
	""
], l.text.neutral, i.body.medium, ({ width: e }) => e || "auto", ({ alignRight: e }) => e && "text-align: right;", ({ alignRight: e }) => e && "justify-content: flex-end;", R.tablet, ({ tabletAlignRight: e }) => e && "text-align: right;", ({ tabletAlignRight: e }) => e && "justify-content: flex-end;", ({ isAction: e }) => e && `
        ${R.pointer} {
            &:hover {
                color: ${l.text.base};
                cursor: pointer;
            }
        }
    `), RE = ({ children: e }) => /*#__PURE__*/ M(B, { children: e }), zE = ({ children: e }) => /*#__PURE__*/ M(BE, { children: e });
zE.Row = RE, zE.Cell = IE;
var BE = P.div.withConfig({
	displayName: "Footer__Container",
	componentId: "sc-982aca5c-0"
})([
	"display:none;border-top:1px solid ",
	";",
	"{display:block;}"
], l.line.neutralSoft, R.tablet), VE = ({ width: e, flex: t, alignRight: n, children: r = null, action: i, tabletAlignRight: a }) => {
	let o = (e) => {
		e.preventDefault(), i && i();
	}, s = !!i;
	return /*#__PURE__*/ M(HE, {
		width: e,
		flex: t,
		tabletAlignRight: a,
		alignRight: n,
		isAction: s,
		onClick: s ? o : void 0,
		onKeyDown: s ? O(i) : void 0,
		role: s ? "button" : void 0,
		tabIndex: s ? 0 : void 0,
		children: r
	});
}, HE = P.div.withConfig({
	displayName: "Cell__Container",
	componentId: "sc-eb245382-0"
})([
	"color:",
	";font-size:",
	";flex:",
	";min-width:0;padding:12px 0;",
	" ",
	" ",
	"{",
	" ",
	"}",
	""
], l.text.neutral, i.body.medium, ({ flex: e, width: t }) => e || `0 0 ${t || "auto"}`, ({ alignRight: e }) => e && "text-align: right;", ({ alignRight: e }) => e && "justify-content: flex-end;", R.tablet, ({ tabletAlignRight: e }) => e && "text-align: right;", ({ tabletAlignRight: e }) => e && "justify-content: flex-end;", ({ isAction: e }) => e && `
        ${R.pointer} {
            &:hover {
                color: ${l.text.base};
                cursor: pointer;
            }
        }
    `), UE = ({ children: e }) => /*#__PURE__*/ M(B, { children: e }), WE = ({ children: e }) => /*#__PURE__*/ M(GE, { children: e });
WE.Row = UE, WE.Cell = VE;
var GE = P.div.withConfig({
	displayName: "Header__Container",
	componentId: "sc-601ffde1-0"
})(["display:none;", "{display:block;}"], R.tablet), KE = ({ children: e }) => /*#__PURE__*/ M(z, { children: !!e && e });
KE.Header = WE, KE.Body = FE, KE.Footer = zE;
//#endregion
//#region src/organisms/Toast/Toaster.tsx
var qE = () => {
	let e = We("(min-width: 600px)");
	return /*#__PURE__*/ M(JE, { children: /*#__PURE__*/ M(ze, {
		position: e ? "bottom-center" : "top-center",
		duration: 1e4,
		style: { zIndex: n },
		visibleToasts: 3,
		closeButton: !0,
		richColors: !0,
		expand: !0
	}) });
}, JE = P.div.withConfig({
	displayName: "Toaster__Wrapper",
	componentId: "sc-ebd75427-0"
})(["& ol[data-sonner-toaster]{--width:480px !important;}"]), YE = P.button.withConfig({
	displayName: "Toast__ToastClose",
	componentId: "sc-3b36a4cb-0"
})([
	"color:",
	";font-size:",
	";line-height:1.5;display:flex;align-items:center;justify-content:center;position:absolute;top:0;right:0;padding:12px;background:none;border:0;cursor:pointer;@media (min-width:600px){color:",
	";font-size:",
	";}"
], ({ alertType: e }) => e === "error" ? l.text.base : l.text.inverted, i.body.medium, l.text.base, i.body.large), XE = P.div.withConfig({
	displayName: "Toast",
	componentId: "sc-3b36a4cb-1"
})([
	"color:",
	";font-size:",
	";font-family:",
	";font-weight:",
	";line-height:1.5;text-align:center;word-break:break-word;background:",
	";border-radius:",
	";box-shadow:",
	";@media (min-width:600px){color:",
	";font-size:",
	";font-weight:",
	";width:480px;background:",
	";box-shadow:",
	";}"
], ({ alertType: e }) => e === "error" ? l.text.base : l.text.inverted, i.body.medium, i.family.body, i.weight.medium, ({ alertType: e }) => k(e === "error" ? l.surface.alert : l.surface.inverted, .8), I.medium, L.medium, l.text.base, i.body.large, i.weight.normal, ({ backgroundColor: e }) => e, L.low), ZE = P.div.withConfig({
	displayName: "Toast__ToastBody",
	componentId: "sc-3b36a4cb-2"
})(["max-height:240px;overflow-y:auto;padding:12px 42px;"]), QE = ({ body: e }) => Be.custom((t) => /*#__PURE__*/ N(XE, {
	backgroundColor: l.surface.alert,
	alertType: "error",
	role: "alert",
	children: [/*#__PURE__*/ M(YE, {
		alertType: "error",
		onClick: () => Be.dismiss(t),
		children: "✕"
	}), /*#__PURE__*/ M(ZE, {
		"data-sentry-unmask": "true",
		children: e
	})]
})), $E = ({ body: e }) => Be.custom((t) => /*#__PURE__*/ N(XE, {
	backgroundColor: l.surface.affirm,
	alertType: "success",
	role: "status",
	children: [/*#__PURE__*/ M(YE, {
		alertType: "success",
		onClick: () => Be.dismiss(t),
		children: "✕"
	}), /*#__PURE__*/ M(ZE, {
		"data-sentry-unmask": "true",
		children: e
	})]
})), eD = h(null), tD = h(null), nD = () => {
	let e = b(eD);
	if (e === null) throw Error("`useQuestionnaire` must be used within a `QuestionnaireStateContext.Provider`");
	return e;
}, rD = () => {
	let e = b(tD);
	if (e === null) throw Error("`useQuestionnaireApi` must be used within a `QuestionnaireApiContext.Provider`");
	return e;
}, iD = () => {
	let e = nD(), t = rD();
	return {
		...e,
		...t
	};
}, aD = ({ children: e }) => /*#__PURE__*/ M(z, { children: e });
aD.displayName = "Questionnaire.List.Item.Body";
//#endregion
//#region src/organisms/Questionnaire/List/Item/embedded-items-context.ts
var oD = h(!1), sD = () => b(oD), cD = ({ children: e }) => {
	let t = p.toArray(e).length <= 1;
	return /*#__PURE__*/ M(H, {
		marginTop: "12px",
		children: /*#__PURE__*/ M(B, {
			justifyEnd: t,
			spaceBetween: !t,
			gap: t ? void 0 : "12px",
			width: "100%",
			flexWrap: !0,
			children: e
		})
	});
};
cD.displayName = "Questionnaire.List.Item.Footer";
//#endregion
//#region src/organisms/Questionnaire/List/Item/Header/Description.tsx
var lD = ({ children: e }) => /*#__PURE__*/ M(V, {
	size: i.body.small,
	tabletSize: i.body.large,
	children: e
});
lD.displayName = "Questionnaire.List.Item.Header.Description";
//#endregion
//#region src/organisms/Questionnaire/List/Item/Header/Heading/Help.tsx
var uD = ({ children: e, modalTitle: t = "Help", label: n = "?", mobileLabel: r = "?" }) => {
	let [i, a, o] = ce(), s = Ge();
	return /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ M(H, {
		tabletMarginTop: "3px",
		children: /*#__PURE__*/ M(ov, {
			onClick: a,
			variant: "highlightSoft",
			size: "medium",
			children: s ? n : r
		})
	}), i && /*#__PURE__*/ N(Vb, {
		onClose: o,
		children: [
			/*#__PURE__*/ M($b, { children: /*#__PURE__*/ M(tx, { children: t }) }),
			/*#__PURE__*/ M(qb, { children: typeof e == "function" ? e({
				closeModal: o,
				openModal: a
			}) : e }),
			/*#__PURE__*/ M(Qb, { children: /*#__PURE__*/ M(Kb, { children: /*#__PURE__*/ M(W, {
				size: "large",
				isMobileFullWidth: !0,
				onClick: o,
				children: "Got it"
			}) }) })
		]
	})] });
};
uD.displayName = "Questionnaire.List.Item.Header.Heading.Help";
//#endregion
//#region src/organisms/Questionnaire/List/Item/Header/Heading/Title.tsx
var dD = ({ children: e }) => /*#__PURE__*/ M(Jg, { children: e });
dD.displayName = "Questionnaire.List.Item.Header.Heading.Title";
//#endregion
//#region src/organisms/Questionnaire/List/Item/Header/Heading/Heading.tsx
var fD = ({ children: e }) => /*#__PURE__*/ M(z, {
	relative: !0,
	children: /*#__PURE__*/ M(B, {
		spaceBetween: !0,
		gap: "12px",
		alignStart: !0,
		children: e
	})
});
fD.displayName = "Questionnaire.List.Item.Header.Heading", fD.Title = dD, fD.Help = uD;
//#endregion
//#region src/organisms/Questionnaire/List/Item/Header/Header.tsx
var pD = ({ children: e }) => /*#__PURE__*/ M(z, {
	relative: !0,
	children: /*#__PURE__*/ M(B, {
		column: !0,
		gap: "6px",
		children: e
	})
});
pD.displayName = "Questionnaire.List.Item.Header", pD.Heading = fD, pD.Description = lD;
//#endregion
//#region src/organisms/Questionnaire/List/Item/Item.tsx
var mD = ({ children: e, padding: t = "48px 24px 120px", id: n, tabletPadding: r = "120px 0", tabletWidth: i = "576px" }) => {
	let a = sD(), o = {
		...n ? { id: n } : void 0,
		padding: a ? "0" : t,
		tabletPadding: a ? "0" : r,
		tabletWidth: a ? "100%" : i
	};
	return /*#__PURE__*/ M(hD, {
		...o,
		children: /*#__PURE__*/ M(B, {
			column: !0,
			gap: "30px",
			width: "100%",
			style: { minWidth: 0 },
			children: e
		})
	});
}, hD = P.div.withConfig({
	displayName: "Item__Container",
	componentId: "sc-c83ac60d-0"
})([
	"width:100%;height:100%;display:grid;place-items:center;",
	" ",
	"{",
	" margin:0 auto;",
	"}"
], ({ padding: e }) => e && `padding: ${e};`, R.tablet, ({ tabletWidth: e }) => e && `width: ${e};`, ({ tabletPadding: e }) => e && `padding: ${e};`);
mD.displayName = "Questionnaire.List.Item", mD.Body = aD, mD.Header = pD, mD.Footer = cD;
//#endregion
//#region src/organisms/Questionnaire/List/Item/EmbeddedItems.tsx
var gD = ({ children: e }) => /*#__PURE__*/ M(oD.Provider, {
	value: !0,
	children: e
});
gD.displayName = "Questionnaire.List.EmbeddedItems";
//#endregion
//#region src/organisms/Questionnaire/List/List.tsx
var _D = ({ children: e, firstIncompleteItemIndex: t = 0 }) => {
	let n = we(), { indexInView: r } = iD(), { hashElement: i, scrollToHashElement: a } = se({ skipAutoScroll: !0 }), [o, s] = E(), c = e.filter((e) => e);
	return x(() => {
		if (r !== void 0) {
			let e = c[r]?.props.id;
			return s(e), a({ isSmooth: !0 });
		}
		if (i !== void 0) return a({ isSmooth: !1 });
		let e = c[t]?.props.id;
		s(e);
	}, [
		c,
		t,
		i,
		r,
		a
	]), x(() => {
		o && n.push(`#${o}`);
	}, [n, o]), /*#__PURE__*/ M(vD, { children: p.map(c, (e, t) => e && /*#__PURE__*/ M(yD, { children: /*#__PURE__*/ m(e, {
		id: e.props.id,
		nextIndex: t === c.length - 1 ? void 0 : t + 1,
		currentIndex: t,
		prevIndex: t === 0 ? void 0 : t - 1
	}) })) });
}, vD = P.div.withConfig({
	displayName: "List__ScrollContainer",
	componentId: "sc-6b20bc29-0"
})(["overflow-y:scroll;height:100%;"]), yD = P.div.withConfig({
	displayName: "List__ScrollItem",
	componentId: "sc-6b20bc29-1"
})(["min-height:100%;display:grid;place-items:center;"]);
_D.Item = mD, _D.EmbeddedItems = gD;
//#endregion
//#region src/organisms/Questionnaire/Progress/Progress.tsx
var bD = ({ lastCompletedItemIndex: e, totalItemsCount: t }) => {
	let n = e !== void 0 && t !== void 0;
	if (!n || t <= 1) return null;
	let r = n ? ((e ?? 0) + 1) / t * 100 : void 0;
	return /*#__PURE__*/ M(dy, { width: r });
}, xD = ({ children: e }) => {
	let { scrollToHashElement: t } = se({ skipAutoScroll: !0 }), [n, r] = E(), i = y((e) => {
		let i = (e ?? 0) + 1;
		r(i), i === n && t({ isSmooth: !0 });
	}, [n, t]), a = y((e) => {
		let i = Math.max((e ?? 0) - 1, 0);
		r(i), i === n && t({ isSmooth: !0 });
	}, [n, t]), o = y((e) => {
		r(e), e === n && t({ isSmooth: !0 });
	}, [n, t]), s = w(() => ({ indexInView: n }), [n]), c = w(() => ({
		scrollTo: o,
		scrollToPrevious: a,
		scrollToNext: i
	}), [
		o,
		a,
		i
	]);
	return /*#__PURE__*/ M(eD.Provider, {
		value: s,
		children: /*#__PURE__*/ M(tD.Provider, {
			value: c,
			children: e
		})
	});
};
xD.List = _D, xD.Progress = bD;
//#endregion
//#region src/organisms/Questionnaire/use-questionnaire-config.ts
var SD = (e) => {
	let { questions: t } = e, [n, r] = E([]), i = y((e) => n.includes(e), [n]), a = y((e) => {
		r((t) => t.includes(e) ? t : [...t, e]);
	}, []), o = w(() => t.map((e) => ({
		...e,
		isAnswered: i(e.id) || e.isAnswered
	})), [t, i]), s = w(() => o.filter((e) => !e.shouldHide), [o]), c = w(() => s.every((e) => e.isAnswered), [s]);
	return {
		filteredQuestions: s,
		currentQuestionIndex: w(() => {
			let e = s.findIndex((e) => !e.isAnswered);
			return Math.max(e, 0);
		}, [s]),
		hasAnsweredAllQuestions: c,
		handleSkipQuestion: a,
		getIsSkipped: i,
		getIsLastQuestion: y((e) => {
			let t = s.findIndex((t) => t.id === e);
			return t !== -1 && t === s.length - 1;
		}, [s]),
		totalQuestions: s.length,
		skippedQuestions: n
	};
}, CD = ({ questions: e, onComplete: t, onNext: n, showProgressBar: r = !1, isLoading: i = !1 }) => {
	let { filteredQuestions: a, currentQuestionIndex: o, hasAnsweredAllQuestions: s, handleSkipQuestion: c, getIsLastQuestion: l, totalQuestions: u } = SD({
		questions: e,
		onComplete: t,
		showProgressBar: r,
		isLoading: i
	});
	return i ? null : /*#__PURE__*/ M(xD, { children: /*#__PURE__*/ M(wD, {
		filteredQuestions: a,
		currentQuestionIndex: o,
		hasAnsweredAllQuestions: s,
		handleSkipQuestion: c,
		getIsLastQuestion: l,
		totalQuestions: u,
		showProgressBar: r,
		onComplete: t,
		onNext: n
	}) });
}, wD = ({ filteredQuestions: e, currentQuestionIndex: n, hasAnsweredAllQuestions: r, handleSkipQuestion: i, getIsLastQuestion: a, totalQuestions: o, showProgressBar: s, onComplete: c, onNext: l }) => {
	let { scrollToNext: u, scrollToPrevious: d, indexInView: f } = iD(), p = y((e, t) => {
		i(t), a(t) && c ? c() : u(e);
	}, [
		i,
		a,
		c,
		u
	]), m = y((e, t) => {
		let n = a(t);
		l ? l(e, t) : n && c ? c() : u(e);
	}, [
		a,
		l,
		c,
		u
	]), h = y((e) => {
		d(e);
	}, [d]), g = f ?? n, _ = Ge();
	return /*#__PURE__*/ N(j, { children: [/*#__PURE__*/ N(j, { children: [!_ && g < o && /*#__PURE__*/ N(B, {
		row: !0,
		justifyStart: !0,
		alignCenter: !0,
		gap: "6px",
		children: [/*#__PURE__*/ M(G, {
			Component: dn,
			color: t.primary.main,
			height: "20px",
			width: "20px"
		}), /*#__PURE__*/ M(L_, {
			type: "button",
			as: "a",
			onClick: (e) => {
				e.preventDefault(), h(g);
			},
			children: "Back"
		})]
	}), s && /*#__PURE__*/ M(xD.Progress, {
		lastCompletedItemIndex: n,
		totalItemsCount: o
	})] }), /*#__PURE__*/ M(xD.List, {
		firstIncompleteItemIndex: n,
		children: e.map((e, t) => {
			let { component: i, id: o, isReadOnly: s, props: c = {} } = e;
			return r || t <= n ? /*#__PURE__*/ M(i, {
				id: o,
				isLastQuestion: a(o),
				isReadOnly: s,
				onBack: () => h(t),
				onNext: () => m(t, o),
				onSkip: () => p(t, o),
				...c
			}, o) : null;
		})
	})] });
}, TD = Ve(f), ED = P.div.withConfig({
	displayName: "PopoverProvider__PopoverContent",
	componentId: "sc-3e7c6083-0"
})([
	"background:",
	";border-radius:",
	";box-shadow:",
	";padding:12px 16px;white-space:pre-line;"
], l.surface.base, I.small, L.medium), DD = P.div.withConfig({
	displayName: "PopoverProvider__PopoverProviderContainer",
	componentId: "sc-3e7c6083-1"
})([".react-hint:after{content:none;}"]), OD = /*#__PURE__*/ f.forwardRef(({ attribute: e = "data-popover-default", autoPosition: t = !0, className: n = "react-hint", events: r = { click: !0 }, delay: i = { show: 0 }, onRenderContent: a = (e, t) => /*#__PURE__*/ M(ED, { children: t }), persist: o = !0, ...s }, c) => /*#__PURE__*/ M(DD, { children: /*#__PURE__*/ M(TD, {
	ref: c,
	attribute: e,
	autoPosition: t,
	className: n,
	events: r,
	delay: i,
	onRenderContent: a,
	persist: o,
	...s
}) }));
OD.propTypes = {
	attribute: F.string,
	autoPosition: F.bool,
	className: F.string,
	events: F.object,
	delay: F.object,
	onRenderContent: F.func,
	persist: F.bool
};
//#endregion
//#region src/components/Tooltips.jsx
var kD = Ve(f), AD = P.div.withConfig({
	displayName: "Tooltips__Body",
	componentId: "sc-8f537223-0"
})([
	"color:",
	";font-size:",
	";line-height:1.3;white-space:pre-line;max-width:75vw;padding:10px;background:",
	";border-radius:5px;",
	""
], l.text.inverted, i.body.medium, l.surface.inverted, c`
        max-width: 50vw;
    `), jD = (e) => `data-hint-${e}`, MD = (e) => `data-hint-${e}-at`, ND = ({ autoPosition: e = !0, events: t = {
	focus: !0,
	hover: !0
}, delay: n = { show: 100 }, onRenderContent: r = (e, t) => /*#__PURE__*/ M(AD, { children: t }), persist: i = !1 }) => /*#__PURE__*/ M(kD, {
	attribute: jD("default"),
	autoPosition: e,
	events: t,
	delay: n,
	onRenderContent: r,
	persist: i
});
ND.propTypes = {
	autoPosition: F.bool,
	events: F.object,
	delay: F.object,
	onRenderContent: F.func,
	persist: F.bool
};
var PD = ({ children: e, content: t, position: n, shouldDisplay: r = !0 }) => {
	if (!r) return /*#__PURE__*/ M(j, { children: e });
	let i = {
		[jD("default")]: t,
		[MD("default")]: n
	};
	return /*#__PURE__*/ M("span", {
		...i,
		children: e
	});
};
PD.propTypes = {
	children: F.node,
	content: F.string.isRequired,
	position: F.string,
	shouldDisplay: F.bool
};
//#endregion
export { Y as AccountantPortalChrome, lC as AccountantPortalSearchFilter, o_ as ActionButton, h_ as ActionPill, Wg as AutoScrolled, y_ as Avatar, S_ as Badge, D_ as BadgeButton, W as Button, L_ as ButtonLink, W_ as Checkbox, $_ as Chip, ov as ChipButton, CD as ConfiguredQuestionnaire, nx as ConfirmationModal, RC as ContactWidget, z as Container, Ib as ContentTransition, WC as CrossOver, Z as CustomerChrome, mx as DatePicker, bx as DatePickerWithLabel, rw as DialogAffirm, iw as DialogConfirm, aw as DialogInfo, fv as DropdownButton, Cv as DropdownSelect, Fx as File, Ix as FileDropZone, B as Flexer, Ry as FloatingLabel, mw as Folder, X as Form, zb as GlobalSpinner, Kg as Grid, qg as GridItem, Jg as Heading, G as Icon, Je as Icon360Degrees, Ye as IconActivity2, Xe as IconActivityRec, Ze as IconAirplay, Qe as IconAlertCircle, $e as IconAlertOctagon, et as IconAlertTriangle, rt as IconAlignBottom, tt as IconAlignBottom2, nt as IconAlignBottomRec, st as IconAlignCenter, at as IconAlignCenter2, it as IconAlignCenter2Rec, ot as IconAlignCenterRec, ct as IconAlignHorizontally, ft as IconAlignJustify, ut as IconAlignJustify2, lt as IconAlignJustify2Rec, dt as IconAlignJustifyRec, _t as IconAlignLeft, mt as IconAlignLeft2, pt as IconAlignLeft2Rec, ht as IconAlignLeft3, gt as IconAlignLeftRec, yt as IconAlignMiddle, vt as IconAlignMiddleRec, wt as IconAlignRight, xt as IconAlignRight2, bt as IconAlignRight2Rec, St as IconAlignRight3, Ct as IconAlignRightRec, Dt as IconAlignTop, Tt as IconAlignTop2, Et as IconAlignTopRec, Ot as IconAlignVertically, At as IconAnchor, kt as IconAnchorRec, jt as IconAndroid, Mt as IconApperture, Nt as IconApple, Pt as IconAppstore, Ft as IconArchive, Wt as IconArrowBottom, It as IconArrowBottomCircle, zt as IconArrowBottomLeft, Lt as IconArrowBottomLeftCircle, Rt as IconArrowBottomLeftRec, Bt as IconArrowBottomRec, Ut as IconArrowBottomRight, Vt as IconArrowBottomRightCircle, Ht as IconArrowBottomRightRec, Kt as IconArrowCornerCcwLb, Gt as IconArrowCornerCcwLbRec, Jt as IconArrowCornerCcwLt, qt as IconArrowCornerCcwLtRec, Xt as IconArrowCornerCcwRb, Yt as IconArrowCornerCcwRbRec, Qt as IconArrowCornerCcwRt, Zt as IconArrowCornerCcwRtRec, en as IconArrowCornerCwLb, $t as IconArrowCornerCwLbRec, nn as IconArrowCornerCwLt, tn as IconArrowCornerCwLtRec, an as IconArrowCornerCwRb, rn as IconArrowCornerCwRbRec, sn as IconArrowCornerCwRt, on as IconArrowCornerCwRtRec, dn as IconArrowLeft, cn as IconArrowLeftCircle, ln as IconArrowLeftCurvedCircle, un as IconArrowLeftRec, hn as IconArrowRight, fn as IconArrowRightCircle, pn as IconArrowRightCurvedCircle, mn as IconArrowRightRec, _n as IconArrowSwap, gn as IconArrowSwapRec, En as IconArrowTop, vn as IconArrowTopCircle, xn as IconArrowTopLeft, yn as IconArrowTopLeftCircle, bn as IconArrowTopLeftRec, Sn as IconArrowTopRec, Tn as IconArrowTopRight, Cn as IconArrowTopRightCircle, wn as IconArrowTopRightRec, An as IconArrowsExpand, On as IconArrowsExpand2, Dn as IconArrowsExpand2Rec, kn as IconArrowsExpandRec, Pn as IconArrowsMove, Mn as IconArrowsMove2, jn as IconArrowsMove2Rec, Nn as IconArrowsMoveRec, In as IconAt, Fn as IconAtRec, Ln as IconAtom, Rn as IconAward, zn as IconBabyCarriage, Bn as IconBarchart, Kn as IconBattery, Vn as IconBattery1, Hn as IconBattery2, Un as IconBattery3, Wn as IconBatteryCharging, Gn as IconBatterySlash, qn as IconBed2, Jn as IconBed3, Yn as IconBehance, er as IconBell, Xn as IconBellCheck, Zn as IconBellMinus, Qn as IconBellPlus, $n as IconBellSlash, nr as IconBluetooth, tr as IconBluetoothRec, sr as IconBook, rr as IconBookLibrary, ir as IconBookOpen, ar as IconBookPlus, or as IconBookQueue, fr as IconBookmark, cr as IconBookmarkCheck, lr as IconBookmarkMinus, ur as IconBookmarkPlus, dr as IconBookmarkSlash, pr as IconBookmarks, mr as IconBorderBottom, hr as IconBorderClear, gr as IconBorderCommon, _r as IconBorderHorizontal, vr as IconBorderInner, yr as IconBorderLeft, br as IconBorderOuter, xr as IconBorderRight, Sr as IconBorderTop, Cr as IconBorderVertical, Tr as IconBox, wr as IconBox2, Dr as IconBrackets, Er as IconBracketsRec, kr as IconBriefcase, Or as IconBriefcase2, jr as IconBroadcast, Ar as IconBroadcastRec, Mr as IconBrush, Nr as IconBug, Fr as IconBulb, Pr as IconBulbSlash, Ax as IconButton, Gr as IconCalendar, Ir as IconCalendarArrowRight, Lr as IconCalendarCross, Rr as IconCalendarDates, zr as IconCalendarEvent, Br as IconCalendarMinus, Vr as IconCalendarNote, Hr as IconCalendarNumber, Ur as IconCalendarPerson, Wr as IconCalendarPlus, Kr as IconCallAdd, qr as IconCallCalling, Jr as IconCallDecline, Yr as IconCallEnd, Xr as IconCallIncoming, Zr as IconCallMissed, Qr as IconCallMuted, $r as IconCallOnHold, ei as IconCallOutgoing, ti as IconCallReceived, ni as IconCallRedirected, ri as IconCallRemove, ii as IconCallSlash, oi as IconCamera, ai as IconCameraSlash, ci as IconCaptions, si as IconCaptions2, li as IconCash, ui as IconCast, di as IconCd, fi as IconChartBar, pi as IconChartColumn, mi as IconChartLine, hi as IconChartPie, yi as IconCheck, _i as IconCheckCircle, gi as IconCheckCircle2, vi as IconCheckRec, bi as IconCheckboxCircle, xi as IconCheckboxRec, Ci as IconChevronDown, Si as IconChevronDownRec, Ti as IconChevronLeft, wi as IconChevronLeftRec, Di as IconChevronRight, Ei as IconChevronRightRec, ki as IconChevronUp, Oi as IconChevronUpRec, ji as IconChevronsDown, Ai as IconChevronsDownRec, Ni as IconChevronsLeft, Mi as IconChevronsLeftRec, Fi as IconChevronsRight, Pi as IconChevronsRightRec, Li as IconChevronsUp, Ii as IconChevronsUpRec, Wi as IconClipboard, Ri as IconClipboardCheck, zi as IconClipboardCross, Bi as IconClipboardMinus, Vi as IconClipboardPlus, Hi as IconClipboardSlash, Ui as IconClipboardText, Zi as IconClock, Gi as IconClockCheck, Ki as IconClockCross, qi as IconClockMinus, Ji as IconClockPlus, Yi as IconClockSlash, Xi as IconClockZzz, aa as IconCloud, Qi as IconCloudCheck, $i as IconCloudCross, ea as IconCloudDownload, ta as IconCloudDrizzle, na as IconCloudLightning, ra as IconCloudSnow, ia as IconCloudUpload, sa as IconCode, oa as IconCodeRec, ca as IconCoffee, la as IconColorFilter, da as IconColumnSpacing, ua as IconColumnSpacingRec, ja as IconComment, Sa as IconComment2, fa as IconComment2Alert, pa as IconComment2Cancel, ma as IconComment2Check, ha as IconComment2Dots, ga as IconComment2Info, _a as IconComment2Minus, va as IconComment2Plus, ya as IconComment2Question, ba as IconComment2Slash, xa as IconComment2Text, Ca as IconCommentAlert, wa as IconCommentCancel, Ta as IconCommentCheck, Ea as IconCommentDots, Da as IconCommentMinus, Oa as IconCommentPlus, ka as IconCommentSlash, Aa as IconCommentText, Na as IconComments, Ma as IconComments2, Pa as IconCompass, Fa as IconCopy, Ia as IconCopyright, Ua as IconCreditCard, La as IconCreditCardIncome, Ra as IconCreditCardMinus, za as IconCreditCardOutcome, Ba as IconCreditCardPlus, Va as IconCreditCardScan, Ha as IconCreditCardSlash, qa as IconCrop, Wa as IconCropRec, Ka as IconCropRotate, Ga as IconCropRotateRec, Za as IconCross, Ja as IconCrossCircle, Ya as IconCrossOctagon, Xa as IconCrossRec, Qa as IconCrosshair, $a as IconCut, ro as IconCutlery, eo as IconCutlery2, to as IconCutlery3, no as IconCutlery4, ao as IconDashboard, io as IconDashboard2, oo as IconDevices, so as IconDialpad, lo as IconDirection, co as IconDirection2, uo as IconDiskette, fo as IconDistributeHorizontally, po as IconDistributeVertically, ho as IconDollar, mo as IconDollarCircle, go as IconDribbble, vo as IconDroplet, _o as IconDropletSlash, yo as IconDumbell, Co as IconEdit, bo as IconEdit2, xo as IconEdit3, So as IconEditSlash, ko as IconElements, wo as IconElements2, To as IconElements3, Eo as IconElements4, Do as IconElements5, Oo as IconElementsPlus, Ao as IconEmail, jo as IconEmails, Mo as IconEmotionHappy, No as IconEmotionNeutral, Po as IconEmotionSad, Fo as IconEmotionSmile, Io as IconEmotionWow, Lo as IconEqualizer, zo as IconEuro, Ro as IconEuroCircle, Uo as IconExport, Bo as IconExport2, Vo as IconExport3, Ho as IconExport4, Ko as IconExternalLink, Wo as IconExternalLink2, Go as IconExternalLinkRec, Jo as IconEye, qo as IconEyeSlash, Xo as IconFaceId, Yo as IconFaceIdRec, Zo as IconFacebook, Qo as IconFastForward, $o as IconFastRewind, es as IconFatRows, ts as IconFigma, vs as IconFile, ns as IconFileAgreement, rs as IconFileCheck, is as IconFileCode, as as IconFileCross, os as IconFileDownload, ss as IconFileDraft, cs as IconFileHeart, ls as IconFileInvoice, us as IconFileMinus, ds as IconFileMove, fs as IconFilePlus, ps as IconFileScan, ms as IconFileShredder, hs as IconFileSlash, gs as IconFileText, _s as IconFileUpload, ys as IconFilmBoard, bs as IconFilmReel, xs as IconFilmTape, ws as IconFilter, Ss as IconFilter2, Cs as IconFilterRec, Os as IconFingerprint, Es as IconFingerprint2, Ts as IconFingerprint2Rec, Ds as IconFingerprintRec, ks as IconFire, js as IconFirstLine1, As as IconFirstLine1Rec, Ns as IconFirstLine2, Ms as IconFirstLine2Rec, Fs as IconFirstLine3, Ps as IconFirstLine3Rec, Rs as IconFlag, Is as IconFlag2, Ls as IconFlag3, zs as IconFlashcard, ec as IconFolder, Bs as IconFolderCheck, Vs as IconFolderCloud, Hs as IconFolderCompressed, Us as IconFolderCross, Ws as IconFolderDownload, Gs as IconFolderHeart, Ks as IconFolderMinus, qs as IconFolderMove, Js as IconFolderMusic, Ys as IconFolderOpen, Xs as IconFolderPhoto, Zs as IconFolderPlus, Qs as IconFolderSlash, $s as IconFolderUpload, uc as IconForward, nc as IconForward10, tc as IconForward10Rec, ic as IconForward15, rc as IconForward15Rec, oc as IconForward5, ac as IconForward5Rec, cc as IconForwardAll, sc as IconForwardAllRec, lc as IconForwardRec, pc as IconFrame, fc as IconFrameBounds, dc as IconFrameBoundsRec, mc as IconFramer, gc as IconFunctions, hc as IconFunctionsRec, _c as IconGames, yc as IconGear, vc as IconGear2, bc as IconGift, xc as IconGithub, Sc as IconGlassCocktail, Cc as IconGlassWine, Tc as IconGlasses, wc as IconGlassesVr, Dc as IconGlobe, Ec as IconGlobe2, Oc as IconGoogleplay, Ac as IconGps, kc as IconGpsSlash, Kc as IconGrid, jc as IconGrid02, Mc as IconGrid03, Nc as IconGrid04, Pc as IconGrid05, Fc as IconGrid06, Ic as IconGrid07, Lc as IconGrid08, Rc as IconGrid09, zc as IconGrid10, Bc as IconGrid11, Vc as IconGrid12, Hc as IconGrid13, Uc as IconGrid14, Wc as IconGrid15, Gc as IconGrid16, qc as IconHardDrive, Xc as IconHashtag, Jc as IconHashtagCircle, Yc as IconHashtagRec, Qc as IconHeadphones, Zc as IconHeadphones2, el as IconHeart, $c as IconHeartSlash, nl as IconHistory, tl as IconHistoryRec, ol as IconHome, rl as IconHome2, il as IconHome3, al as IconHome4, sl as IconIframe, cl as IconIllustrator, vl as IconImage, ll as IconImage2, ul as IconImage3, dl as IconImageCheck, fl as IconImageCross, pl as IconImageDownload, ml as IconImageEdit, hl as IconImagePlus, gl as IconImageSlash, _l as IconImageUpload, Sl as IconImport, yl as IconImport2, bl as IconImport3, xl as IconImport4, El as IconInbox, Cl as IconInboxFilled, wl as IconInboxIn, Tl as IconInboxOut, Ol as IconIndentDecrease, Dl as IconIndentDecreaseRec, Al as IconIndentFirstLine, kl as IconIndentFirstLineRec, Ml as IconIndentIncrease, jl as IconIndentIncreaseRec, Pl as IconInfinity, Nl as IconInfinityRec, Fl as IconInfo, Il as IconInstagram, Ll as IconInvoice, Rl as IconKanban, zl as IconKey, Hl as IconKeyboard, Bl as IconKeyboardHide, Vl as IconKeyboardShow, Ul as IconLabel4K, Wl as IconLabelExplicit, Gl as IconLabelHd, Kl as IconLabelHq, ql as IconLaptop, Jl as IconLayers, Ql as IconLetterSpacing, Xl as IconLetterSpacing2, Yl as IconLetterSpacing2Rec, Zl as IconLetterSpacingRec, $l as IconLifebuoy, tu as IconLightning, eu as IconLightningSlash, au as IconLineHeight, ru as IconLineHeight2, nu as IconLineHeight2Rec, iu as IconLineHeightRec, su as IconLink1, ou as IconLink1Rec, lu as IconLink2, cu as IconLink2Rec, uu as IconLinkedin, fu as IconListOrdered, du as IconListOrderedRec, xu as IconListUnordered, mu as IconListUnordered2, pu as IconListUnordered2Rec, hu as IconListUnordered3, _u as IconListUnordered4, gu as IconListUnordered4Rec, yu as IconListUnordered5, vu as IconListUnordered5Rec, bu as IconListUnorderedRec, Tu as IconLoader, Cu as IconLoader2, Su as IconLoader2Rec, wu as IconLoaderRec, Eu as IconLoadingTrolley, Mu as IconLock, ku as IconLock2, Du as IconLock2Opened, Ou as IconLock2Slash, Au as IconLockOpened, ju as IconLockSlash, Fu as IconLogIn, Nu as IconLogIn2, Pu as IconLogIn3, Ru as IconLogOut, Iu as IconLogOut2, Lu as IconLogOut3, zu as IconMapView, Yu as IconMaximize, Uu as IconMaximize2, Vu as IconMaximize2Flipped, Bu as IconMaximize2FlippedRec, Hu as IconMaximize2Rec, Gu as IconMaximize3, Wu as IconMaximize3Rec, qu as IconMaximizeFlipped, Ku as IconMaximizeFlippedRec, Ju as IconMaximizeRec, Xu as IconMegaphone, Zu as IconMemoryCard, td as IconMenu, $u as IconMenu2, Qu as IconMenu2Rec, ed as IconMenuRec, nd as IconMessanger, id as IconMic, rd as IconMicSlash, od as IconMinimize, ad as IconMinimizeRec, sd as IconMiniplayer, dd as IconMinus, cd as IconMinusCircle, ld as IconMinusOctagon, ud as IconMinusRec, fd as IconModules, pd as IconMonitor, md as IconMoon, gd as IconMoreHoriz, hd as IconMoreHorizRec, vd as IconMoreVert, _d as IconMoreVertRec, yd as IconMouse, bd as IconMusicLibrary, Cd as IconMusicNote, xd as IconMusicNote2, Sd as IconMusicNote3, wd as IconMusicPlus, Td as IconMusicQueue, Ed as IconNewRelease, Dd as IconNewspaper, jd as IconNote, kd as IconNote2, Od as IconNote2Text, Ad as IconNoteText, Md as IconNotebook, Nd as IconNotificationIndicator, Pd as IconNotion, Fd as IconNut, Id as IconPadding, Ld as IconPageBreak, Rd as IconPaintBucket, zd as IconPaintTool, qd as IconPaperclip, Ud as IconPaperclip2, Bd as IconPaperclip2Rec, Hd as IconPaperclip2Slash, Vd as IconPaperclip2SlashRec, Wd as IconPaperclipRec, Kd as IconPaperclipSlash, Gd as IconPaperclipSlashRec, Yd as IconPause, Jd as IconPauseCircle, Zd as IconPenTool, Xd as IconPenTool2, $d as IconPharagraphSpacing, Qd as IconPharagraphSpacingRec, ef as IconPhone, tf as IconPhotoshop, uf as IconPin, nf as IconPin2, rf as IconPin3, af as IconPinCheck, of as IconPinCross, sf as IconPinMinus, cf as IconPinPlus, lf as IconPinSlash, df as IconPinterest, ff as IconPlanet, _f as IconPlay, pf as IconPlayCircle, mf as IconPlayNext, hf as IconPlayPrevious, gf as IconPlaySlowmotion, bf as IconPlaylist, vf as IconPlaylistPlay, yf as IconPlaylistPlus, Sf as IconPlug, xf as IconPlugSlash, Tf as IconPlus, Cf as IconPlusCircle, wf as IconPlusRec, Ef as IconPos, Of as IconPower, Df as IconPowerRec, kf as IconPresentationChart, Af as IconPresentationLine, Mf as IconPrinter, jf as IconPrinterSlash, Pf as IconProcent, Nf as IconProcentCircle, Ff as IconProcessor, If as IconProducthunt, Lf as IconQuestion, zf as IconQuotes, Rf as IconQuotes2, Bf as IconRadio, Vf as IconReceipt, Hf as IconRecord, Kf as IconRedo, Wf as IconRedo2, Uf as IconRedo2Rec, Gf as IconRedoRec, Xf as IconRefreshCcw, Jf as IconRefreshCcwAlert, qf as IconRefreshCcwAlertRec, Yf as IconRefreshCcwRec, ep as IconRefreshCw, Qf as IconRefreshCwAlert, Zf as IconRefreshCwAlertRec, $f as IconRefreshCwRec, np as IconRepeat, tp as IconRepeatOn, up as IconReplay, ip as IconReplay10, rp as IconReplay10Rec, op as IconReplay15, ap as IconReplay15Rec, cp as IconReplay5, sp as IconReplay5Rec, lp as IconReplayRec, mp as IconReply, fp as IconReplyAll, dp as IconReplyAllRec, pp as IconReplyRec, gp as IconRocket, hp as IconRocket2, vp as IconRotateCcw, _p as IconRotateCcwRec, bp as IconRotateCw, yp as IconRotateCwRec, xp as IconRoute, Sp as IconRuler, Cp as IconScale, Tp as IconScan, wp as IconScanRec, Dp as IconScript, Ep as IconScriptRec, Op as IconSearch, Ap as IconSelection, kp as IconSelectionRec, Mp as IconSend, jp as IconSend2, Pp as IconServer, Np as IconServer2, Fp as IconShare, Rp as IconShield, Ip as IconShieldCheck, Lp as IconShieldCross, Bp as IconShoppingBag, zp as IconShoppingBag2, Vp as IconShoppingBasket, Up as IconShoppingCart, Hp as IconShoppingCart2, Wp as IconShuffle, Gp as IconSketch, Kp as IconSlash, Jp as IconSliderHorizontal, qp as IconSliderHorizontal2, Xp as IconSliderVertical, Yp as IconSliderVertical2, Qp as IconSlidersHoriz, Zp as IconSlidersHoriz2, em as IconSlidersVert, $p as IconSlidersVert2, im as IconSmallCaps, nm as IconSmallCaps2, tm as IconSmallCaps2Rec, rm as IconSmallCapsRec, am as IconSmartphone, lm as IconSortNumber, om as IconSortNumberRec, cm as IconSortNumberReverse, sm as IconSortNumberReverseRec, pm as IconSortText, um as IconSortTextRec, fm as IconSortTextReverse, dm as IconSortTextReverseRec, mm as IconSoundcloud, gm as IconSoundwave, hm as IconSoundwaveRec, _m as IconSpeaker, ym as IconSpecialCharachers, vm as IconSpecialCharachersRec, xm as IconSpeed, bm as IconSpeedRec, Sm as IconSpotify, Cm as IconStack, Tm as IconStar, wm as IconStarSlash, Em as IconSticker, Om as IconStop, Dm as IconStopCircle, Am as IconStopwatch, km as IconStopwatchSlash, jm as IconSun, Mm as IconSunrise, Nm as IconSunset, Pm as IconSwatchbook, Fm as IconTablet, Lm as IconTag, Im as IconTag2, zm as IconTags, Rm as IconTags2, Bm as IconTarget, Vm as IconTerminal, ah as IconText, Um as IconText2, Hm as IconText2Rec, Wm as IconTextBlock, Km as IconTextBold, Gm as IconTextBoldRec, qm as IconTextFormat, Ym as IconTextItalic, Jm as IconTextItalicRec, Xm as IconTextRec, eh as IconTextSlash, Qm as IconTextSlash2, Zm as IconTextSlash2Rec, $m as IconTextSlashRec, nh as IconTextStrikethrough, th as IconTextStrikethroughRec, ih as IconTextUnderline, rh as IconTextUnderlineRec, oh as IconThermometer, ch as IconThumbsDown, sh as IconThumbsDown2, uh as IconThumbsUp, lh as IconThumbsUp2, dh as IconTicket, fh as IconTime, hh as IconTimer, mh as IconTimer2, ph as IconTimer2Rec, Mg as IconTinyArrow, Ng as IconTinyArrowLeft, Pg as IconTinyBell, Fg as IconTinyCheck, Ig as IconTinyClock, Lg as IconTinyClose, Rg as IconTinyEdit, zg as IconTinyLock, Bg as IconTinyMinus, Vg as IconTinyPerson, Hg as IconTinyPlus, gh as IconToggleOff, _h as IconToggleOn, vh as IconTransform, bh as IconTrash, yh as IconTrash2, Sh as IconTrendDown, xh as IconTrendDownRec, wh as IconTrendUp, Ch as IconTrendUpRec, Th as IconTrophy, Eh as IconTruck, Dh as IconTv, Oh as IconTwitter, kh as IconUmbrella, Nh as IconUndo, jh as IconUndo2, Ah as IconUndo2Rec, Mh as IconUndoRec, Kh as IconUser, Ph as IconUserAlert, Fh as IconUserArrowBl, Ih as IconUserArrowBottom, Lh as IconUserArrowRight, Rh as IconUserArrowTop, zh as IconUserArrowTr, Bh as IconUserCheck, Vh as IconUserCircle, Hh as IconUserCross, Uh as IconUserMinus, Wh as IconUserPlus, Gh as IconUserSquare, qh as IconUsers, Jh as IconVector, Yh as IconVerified, Zh as IconVideoCamera, Xh as IconVideoCameraSlash, Qh as IconVideoLibrary, $h as IconVideoPlus, eg as IconVideoQueue, tg as IconVoicemail, ng as IconVolumeCross, rg as IconVolumeHigh, ig as IconVolumeLow, ag as IconVolumeMute, og as IconVolumeSlash, ug as IconWallet, sg as IconWalletMinus, cg as IconWalletMove, lg as IconWalletPlus, fg as IconWatch, dg as IconWatch2, mg as IconWebcam, pg as IconWebcamSlash, hg as IconWeight, _g as IconWeighter, gg as IconWeighter2, yg as IconWheelchair, vg as IconWheelchairRec, Cg as IconWifi, bg as IconWifiRec, Sg as IconWifiSlash, xg as IconWifiSlashRec, wg as IconWindows, Eg as IconWrapText, Tg as IconWrapTextRec, Dg as IconWrench, Og as IconYinYang, kg as IconYoutube, Ag as IconZoomIn, jg as IconZoomOut, Mv as Indicator, jv as Indicators, Yg as InlineLink, Iv as Input, Vv as InputAffix, Nx as InputWithSave, Wv as Label, V as Line, Sw as List, t_ as Loadable, Kv as Logo, Yv as Logomark, Pw as Message, Kb as ModalActionsLegacy, qb as ModalBodyLegacy, Qb as ModalFooterLegacy, $b as ModalHeaderLegacy, Vb as ModalLegacy, ex as ModalSubtitleLegacy, tx as ModalTitleLegacy, $v as MultiEmailInput, kx as MultiSelectWithLabel, iy as Notice, ay as NoticeAction, cy as OptionButton, Rx as OptionButtonGroup, Q as Page, sT as Pagination, Xg as Paragraph, OD as PopoverProvider, mT as ProductOverview, TT as ProductProgress, OT as ProgressBar, dy as ProgressLine, qT as ProgressNav, bE as ProgressSteps, xD as Questionnaire, _y as Radio, Nb as RouteTransition, Cy as Select, wy as SelectWithLabel, Dy as Skeleton, ky as SkeletonLine, Ay as SkeletonLineItem, H as Spacer, U as Spinner, Qg as StyleSheetProvider, KE as Table, wE as Tabs, Fy as TextArea, Zg as TextEllipsis, qE as Toaster, zy as Toggle, PD as Tooltip, ND as TooltipProvider, eb as TypeSelect, jb as Typography, zx as UploadButton, QE as addErrorToast, $E as addSuccessToast, s as borders, l as colors, u as desktop, o as desktopLarge, i as font, R as media, I as radius, Ug as resolveIcon, L as shadows, c as tablet, t as theme, e as themeFonts, Vx as useAccountantPortalChrome, He as useFileDragAndDrop, Ke as useIsDesktop, qe as useIsDesktopLarge, Ge as useIsTablet, We as useMediaQuery, iD as useQuestionnaire, SD as useQuestionnaireConfig };

import './index.css';
//# sourceMappingURL=index.js.map